import SunCalc from 'suncalc';

/**
 * Auto-generated school holidays from OpenHolidays API Data (Git Submodule)
 * DO NOT EDIT MANUALLY - Run: node scripts/fetch-school-holidays.mjs
 * Submodule: dd3dfa8 (2026-01-21)
 */

const ad = {
  SH: [
    {
      name: "Vacances de Nadal",
      2019: [12,23,1,6],
      2020: [12,23,1,6],
      2021: [12,23,1,7],
      2022: [12,23,1,6],
      2023: [12,25,1,5],
      2024: [12,23,1,6],
      2025: [12,22,1,6],
      2026: [12,23,1,6],
    },
    {
      name: "Vacances de Carnaval",
      2020: [2,24,2,28],
      2021: [2,15,2,18],
      2022: [2,28,3,4],
      2023: [2,20,2,24],
      2024: [2,12,2,16],
      2025: [2,24,3,3],
      2026: [2,16,2,20],
      2027: [2,8,2,12],
    },
    {
      name: "Vacances de Pasqua",
      2020: [4,6,4,17],
      2021: [3,29,4,6],
      2022: [4,11,4,22],
      2023: [4,3,4,14],
      2024: [3,28,4,5],
      2025: [4,17,5,2],
      2026: [3,30,4,10],
      2027: [3,22,4,2],
    },
    {
      name: "Vacances de Pentecosta",
      2020: [5,25,6,1],
      2021: [5,24,5,28],
      2022: [6,2,6,6],
      2023: [5,29,5,30],
      2024: [5,20,5,24],
      2025: [6,9,6,9],
      2026: [5,25,5,29],
      2027: [5,17,5,21],
    },
    {
      name: "Vacances d'estiu",
      2020: [7,2,9,8],
      2021: [7,3,9,8],
      2022: [7,2,9,8],
      2023: [7,1,9,10],
      2024: [6,29,9,8],
      2025: [7,1,9,8],
      2026: [7,4,9,8],
    },
    {
      name: "Vacances de Tots Sants",
      2020: [10,26,10,30],
      2021: [11,1,11,1],
      2022: [10,31,11,4],
      2023: [10,30,11,3],
      2024: [10,28,11,1],
      2025: [10,27,10,31],
      2026: [10,26,10,30],
    },
    {
      name: "Final de classe",
      2027: [7,2,7,2],
    },
  ]
};

const al = {
  SH: [
    {
      name: "Pushimet dimërore",
      2019: [12,21,1,5],
      2020: [12,24,1,4],
      2021: [12,24,1,4],
      2022: [12,26,1,4],
      2023: [12,26,1,5],
      2024: [12,23,1,3],
      2025: [12,22,1,2],
    },
    {
      name: "Pushimet verore",
      2020: [6,13,9,13],
      2021: [6,9,9,26],
      2022: [6,18,9,11],
      2023: [6,15,9,10],
      2024: [6,14,9,8],
      2025: [6,13,9,8],
    },
    {
      name: "Pushimet e pranveres",
      2023: [4,3,4,9],
      2024: [4,1,4,5],
      2025: [3,31,4,4],
      2026: [3,30,4,3],
    },
    {
      name: "Fundi i klasës",
      2026: [6,13,6,13],
    },
  ]
};

const ar = {
  PH: [{"name":"Año Nuevo","fixed_date":[1,1]},{"name":"Carnaval I","variable_date":"easter","offset":-48},{"name":"Carnaval II","variable_date":"easter","offset":-47},{"name":"Feriado con fines turísticos","fixed_date":[3,23]},{"name":"Día Nacional de la Memoria por la Verdad y la Justicia","fixed_date":[3,24]},{"name":"Viernes Santo","variable_date":"easter","offset":-2},{"name":"Día del Veterano y de los Caídos en la Guerra de Malvinas","fixed_date":[4,2]},{"name":"Día del Trabajador","fixed_date":[5,1]},{"name":"Día de la Revolución de Mayo","fixed_date":[5,25]},{"name":"Paso a la Inmortalidad del Gral. Don Martín Miguel de Güemes","fixed_date":[6,15]},{"name":"Paso a la Inmortalidad del General Manuel Belgrano","fixed_date":[6,20]},{"name":"Día de la Independencia","fixed_date":[7,9]},{"name":"Feriado con fines turísticos","fixed_date":[7,10]},{"name":"Paso a la Inmortalidad del Gral. José de San Martín","fixed_date":[8,17]},{"name":"Día del Respeto a la Diversidad Cultural","fixed_date":[10,12]},{"name":"Día de la Soberanía Nacional","fixed_date":[11,23]},{"name":"Feriado con fines turísticos","fixed_date":[12,7]},{"name":"Inmaculada Concepción de María","fixed_date":[12,8]},{"name":"Navidad","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-34.60377&lon=-58.38159&zoom=16&addressdetails=1&accept-language=es"
};

const at = {
  PH: [{"name":"Neujahrstag","fixed_date":[1,1]},{"name":"Heilige Drei Könige","fixed_date":[1,6]},{"name":"Ostermontag","variable_date":"easter","offset":1},{"name":"Staatsfeiertag","fixed_date":[5,1]},{"name":"Christi Himmelfahrt","variable_date":"easter","offset":39},{"name":"Pfingstmontag","variable_date":"easter","offset":50},{"name":"Fronleichnam","variable_date":"easter","offset":60},{"name":"Mariä Himmelfahrt","fixed_date":[8,15]},{"name":"Nationalfeiertag","fixed_date":[10,26]},{"name":"Allerheiligen","fixed_date":[11,1]},{"name":"Mariä Empfängnis","fixed_date":[12,8]},{"name":"Christtag","fixed_date":[12,25]},{"name":"Stefanitag","fixed_date":[12,26]}],
  SH: [
    {
      name: "Osterferien",
      2017: [4,8,4,18],
      2018: [3,24,4,3],
      2019: [4,13,4,23],
      2020: [4,4,4,14],
      2021: [3,27,4,5],
      2022: [4,9,4,18],
      2023: [4,1,4,10],
      2024: [3,23,4,1],
      2025: [4,12,4,21],
      2026: [3,28,4,6],
      2027: [3,20,3,29],
      2028: [4,8,4,17],
    },
    {
      name: "Pfingstferien",
      2017: [6,3,6,6],
      2018: [5,19,5,22],
      2019: [6,8,6,11],
      2020: [5,30,6,2],
      2021: [5,22,5,24],
      2022: [6,4,6,6],
      2023: [5,27,5,29],
      2024: [5,18,5,20],
      2025: [6,7,6,9],
      2026: [5,23,5,25],
      2027: [5,15,5,17],
      2028: [6,3,6,5],
    },
    {
      name: "Herbstferien",
      2020: [10,27,10,31],
      2021: [10,27,10,31],
      2022: [10,27,10,31],
      2023: [10,27,10,31],
      2024: [10,27,10,31],
      2025: [10,27,10,31],
      2026: [10,27,10,31],
      2027: [10,27,10,31],
      2028: [10,27,10,31],
    },
    {
      name: "Weihnachtsferien",
      2016: [12,24,1,7],
      2017: [12,24,1,6],
      2018: [12,24,1,6],
      2019: [12,23,1,6],
      2020: [12,24,1,6],
      2021: [12,24,1,6],
      2022: [12,24,1,6],
      2023: [12,23,1,6],
      2024: [12,24,1,6],
      2025: [12,24,1,6],
      2026: [12,24,1,6],
      2027: [12,24,1,6],
      2028: [12,24,1,6],
    },
    {
      name: "Allerseelen",
      2020: [11,2,11,2],
      2021: [11,2,11,2],
      2022: [11,2,11,2],
      2023: [11,2,11,2],
      2024: [11,2,11,2],
      2025: [11,2,11,2],
      2026: [11,2,11,2],
      2027: [11,2,11,2],
      2028: [11,2,11,2],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lon=16.3725042&lat=48.2083537&zoom=18&addressdetails=1&accept-language=de,en",
  "Burgenland": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,9,6],
        2021: [7,3,9,5],
        2022: [7,2,9,4],
        2023: [7,1,9,3],
        2024: [6,29,9,1],
        2025: [6,28,8,31],
        2026: [7,4,9,6],
        2027: [7,3,9,5],
        2028: [7,1,9,3],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Martin",
        2020: [11,11,11,11],
        2021: [11,11,11,11],
        2022: [11,11,11,11],
        2023: [11,11,11,11],
        2024: [11,11,11,11],
        2025: [11,11,11,11],
        2027: [11,11,11,11],
        2028: [11,11,11,11],
      },
    ]
  },
  "Kärnten": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
    ]
  },
  "Niederösterreich": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,9,6],
        2021: [7,3,9,5],
        2022: [7,2,9,4],
        2023: [7,1,9,3],
        2024: [6,29,9,1],
        2025: [6,28,8,31],
        2026: [7,4,9,6],
        2027: [7,3,9,5],
        2028: [7,1,9,3],
      },
      {
        name: "Semesterferien",
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [2,7,2,12],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [1,30,2,6],
        2028: [2,5,2,12],
      },
      {
        name: "St. Leopold",
        2020: [11,15,11,15],
        2021: [11,15,11,15],
        2022: [11,15,11,15],
        2023: [11,15,11,15],
        2024: [11,15,11,15],
        2025: [11,15,11,15],
        2027: [11,15,11,15],
        2028: [11,15,11,15],
      },
    ]
  },
  "Oberösterreich": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,17,2,22],
        2021: [2,8,2,13],
        2022: [2,21,2,26],
        2023: [2,20,2,25],
        2024: [2,19,2,24],
        2025: [2,17,2,22],
        2026: [2,16,2,21],
        2027: [2,15,2,20],
        2028: [2,21,2,26],
      },
      {
        name: "St. Florian",
        2020: [5,4,5,4],
        2021: [5,4,5,4],
        2022: [5,4,5,4],
        2023: [5,4,5,4],
        2024: [5,4,5,4],
        2025: [5,4,5,4],
        2026: [5,4,5,4],
        2027: [5,4,5,4],
        2028: [5,4,5,4],
      },
    ]
  },
  "Salzburg": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Rupert",
        2020: [9,24,9,24],
        2021: [9,24,9,24],
        2022: [9,24,9,24],
        2023: [9,24,9,24],
        2024: [9,24,9,24],
        2025: [9,24,9,24],
        2027: [9,24,9,24],
        2028: [9,24,9,24],
      },
    ]
  },
  "Steiermark": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,17,2,22],
        2021: [2,8,2,13],
        2022: [2,21,2,26],
        2023: [2,20,2,25],
        2024: [2,19,2,24],
        2025: [2,17,2,22],
        2026: [2,16,2,21],
        2027: [2,15,2,20],
        2028: [2,21,2,26],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
    ]
  },
  "Tirol": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,12,2,17],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
      {
        name: "schulfrei",
        2025: [6,20,6,20],
      },
    ]
  },
  "Vorarlberg": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,11,9,13],
        2021: [7,10,9,12],
        2022: [7,9,9,11],
        2023: [7,8,9,10],
        2024: [7,6,9,8],
        2025: [7,5,9,7],
        2026: [7,11,9,13],
        2027: [7,10,9,12],
        2028: [7,8,9,10],
      },
      {
        name: "Semesterferien",
        2020: [2,10,2,15],
        2021: [2,8,2,13],
        2022: [2,14,2,19],
        2023: [2,13,2,18],
        2024: [2,5,2,10],
        2025: [2,10,2,15],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,14,2,19],
      },
      {
        name: "St. Josef",
        2020: [3,19,3,19],
        2021: [3,19,3,19],
        2022: [3,19,3,19],
        2023: [3,19,3,19],
        2024: [3,19,3,19],
        2025: [3,19,3,19],
        2026: [3,19,3,19],
        2027: [3,19,3,19],
      },
    ]
  },
  "Wien": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,9,6],
        2021: [7,3,9,5],
        2022: [7,2,9,4],
        2023: [7,1,9,3],
        2024: [6,29,9,1],
        2025: [6,28,8,31],
        2026: [7,4,9,6],
        2027: [7,3,9,5],
        2028: [7,1,9,3],
      },
      {
        name: "Semesterferien",
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [2,7,2,12],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [1,30,2,6],
        2028: [2,5,2,12],
      },
      {
        name: "St. Leopold",
        2020: [11,15,11,15],
        2021: [11,15,11,15],
        2022: [11,15,11,15],
        2023: [11,15,11,15],
        2024: [11,15,11,15],
        2025: [11,15,11,15],
        2027: [11,15,11,15],
        2028: [11,15,11,15],
      },
    ]
  }
};

const au = {
  PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-35.2809&lon=149.1300&zoom=16&addressdetails=1&accept-language=en",
  "Australian Capital Territory": {
    "_state_code": "act",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-35.2809&lon=149.1300&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Canberra Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Reconciliation Day","variable_date":"lastMayMonday"},{"name":"Queens Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Family and Community Day","variable_date":"lastSeptemberMonday"},{"name":"Labour Day","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "New South Wales": {
    "_state_code": "nsw",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-33.8688&lon=151.2093&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Queens Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Labour Day","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Northern Territory": {
    "_state_code": "nt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-12.4634&lon=130.8456&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"May Day","variable_date":"firstMayMonday"},{"name":"Queens Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Picnic Day","variable_date":"firstAugustMonday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Queensland": {
    "_state_code": "qld",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-27.4698&lon=153.0251&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Labour Day","variable_date":"firstMayMonday"},{"name":"Queens Birthday","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "South Australia": {
    "_state_code": "sa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-34.9285&lon=138.6007&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Adelaide Cup","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Queens Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Labour Day","variable_date":"firstOctoberMonday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Tasmania": {
    "_state_code": "tas",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-42.8821&lon=147.3272&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Eight Hours Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Queens Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Victoria": {
    "_state_code": "vic",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-37.8136&lon=144.9631&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Labour Day","variable_date":"firstMarchMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Saturday","variable_date":"easter","offset":-1},{"name":"Easter Sunday","variable_date":"easter"},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Queens Birthday","variable_date":"firstJuneMonday","offset":7},{"name":"AFL Grand Final","variable_date":"lastSeptemberFriday"},{"name":"Melbourne Cup","variable_date":"firstNovemberTuesday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Western Australia": {
    "_state_code": "wa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-31.9505&lon=115.8605&zoom=16&addressdetails=1&accept-language=en",
    PH: [{"name":"New Years Day","fixed_date":[1,1]},{"name":"Australia Day","fixed_date":[1,26]},{"name":"Labour Day","variable_date":"firstMarchMonday"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"ANZAC Day","fixed_date":[4,25]},{"name":"Western Australia Day","variable_date":"firstJuneMonday"},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  }
};

const be = {
  PH: [{"name":"Nieuwjaar - Jour de l'an","fixed_date":[1,1]},{"name":"Paasmaandag - Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Dag van de Arbeid - Fête du Travail","fixed_date":[5,1]},{"name":"Onze-Lieve-Heer-Hemelvaart - Jeudi de l'Ascensionn","variable_date":"easter","offset":39},{"name":"Pinkstermaandag - Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"Nationale feestdag van België - Fête nationale","fixed_date":[7,21]},{"name":"Onze-Lieve-Vrouw-Hemelvaart - Assomption","fixed_date":[8,15]},{"name":"Allerheiligen - Toussaint","fixed_date":[11,1]},{"name":"Wapenstilstand - Armistice","fixed_date":[11,11]},{"name":"Kerstmis - Noël","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Belgium&zoom=18&addressdetails=1&limit=1&accept-language=nl,fr,de,en",
  "DE": {
    SH: [
      {
        name: "Osterferien",
        2020: [4,6,4,17],
        2021: [4,6,4,16],
        2022: [4,4,4,15],
        2023: [4,3,4,16],
        2024: [4,1,4,13],
        2025: [4,21,5,3],
        2026: [4,6,4,18],
      },
      {
        name: "Sommerferien",
        2020: [7,1,8,30],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [6,29,8,31],
        2025: [7,1,8,31],
        2026: [7,1,8,31],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,23,1,3],
        2020: [12,21,1,1],
        2021: [12,27,1,7],
        2022: [12,26,1,8],
        2023: [12,25,1,6],
        2024: [12,23,1,4],
        2025: [12,22,1,3],
      },
      {
        name: "Karnevalsferien",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [2,28,3,4],
        2023: [2,20,2,26],
        2024: [2,12,2,17],
        2025: [3,3,3,8],
        2026: [2,16,2,21],
      },
      {
        name: "Allerheiligenferien",
        2020: [11,2,11,6],
        2021: [11,1,11,5],
        2022: [10,31,11,6],
        2023: [10,30,11,4],
        2024: [10,28,11,2],
        2025: [10,27,11,1],
      },
      {
        name: "Tag der Deutschsprachigen Gemeinschaft",
        2020: [11,15,11,15],
        2021: [11,15,11,15],
        2022: [11,15,11,15],
        2023: [11,15,11,15],
        2024: [11,15,11,15],
        2025: [11,15,11,15],
      },
    ]
  },
  "FR": {
    SH: [
      {
        name: "Vacances d'hiver (Noël)",
        2019: [12,23,1,3],
        2020: [12,21,1,1],
        2021: [12,27,1,9],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,5],
        2025: [12,22,1,4],
        2026: [12,21,1,3],
      },
      {
        name: "Congé de détente (Carnaval)",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [2,28,3,4],
        2023: [2,20,3,3],
        2024: [2,26,3,8],
        2025: [2,24,3,9],
        2026: [2,16,3,1],
        2027: [2,22,3,7],
      },
      {
        name: "Vacances de printemps (Pâques)",
        2020: [4,6,4,17],
        2021: [4,5,4,16],
        2022: [4,4,4,15],
        2023: [5,1,5,12],
        2024: [4,29,5,10],
        2025: [4,28,5,11],
        2026: [4,27,5,10],
        2027: [4,26,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,28],
        2023: [7,8,8,27],
        2024: [7,6,8,25],
        2025: [7,5,8,24],
        2026: [7,4,8,23],
      },
      {
        name: "Fête de la Communauté française",
        2020: [9,27,9,27],
        2021: [9,27,9,27],
        2022: [9,27,9,27],
        2023: [9,27,9,27],
        2024: [9,27,9,27],
        2025: [9,27,9,27],
      },
      {
        name: "Congé d'automne (Toussaint)",
        2020: [11,2,11,6],
        2021: [11,1,11,5],
        2022: [10,24,11,4],
        2023: [10,23,11,3],
        2024: [10,21,11,3],
        2025: [10,20,11,2],
        2026: [10,19,11,1],
      },
      {
        name: "Début des vacances d'été",
        2027: [7,3,7,3],
      },
    ]
  },
  "NL": {
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,23,1,5],
        2020: [12,21,1,3],
        2021: [12,24,1,9],
        2022: [12,26,1,8],
        2023: [12,25,1,7],
        2024: [12,23,1,5],
        2025: [12,22,1,4],
        2026: [12,21,1,3],
        2027: [12,27,1,9],
        2028: [12,25,1,7],
      },
      {
        name: "Krokusvakantie",
        2020: [2,24,3,1],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [2,20,2,26],
        2024: [2,12,2,18],
        2025: [3,3,3,9],
        2026: [2,16,2,22],
        2027: [2,8,2,14],
        2028: [2,28,3,5],
        2029: [2,12,2,18],
      },
      {
        name: "Paasvakantie",
        2020: [4,6,4,19],
        2021: [4,5,4,18],
        2022: [4,4,4,18],
        2023: [4,3,4,16],
        2024: [4,1,4,14],
        2025: [4,7,4,21],
        2026: [4,6,4,19],
        2027: [3,29,4,11],
        2028: [4,3,4,17],
        2029: [4,2,4,15],
      },
      {
        name: "Zomervakantie",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,8,31],
        2025: [7,1,8,31],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,1,8,31],
        2029: [7,1,8,31],
      },
      {
        name: "Herfstvakantie",
        2020: [11,2,11,15],
        2021: [11,1,11,7],
        2022: [10,31,11,6],
        2023: [10,30,11,5],
        2024: [10,28,11,3],
        2025: [10,27,11,2],
        2026: [11,2,11,8],
        2027: [11,1,11,7],
        2028: [10,30,11,5],
      },
    ]
  }
};

const bg = {
  SH: [
    {
      name: "Коледна ваканция",
      2019: [12,21,1,5],
      2020: [12,22,1,3],
      2021: [12,24,1,3],
      2022: [12,24,1,2],
      2023: [12,23,1,2],
      2024: [12,21,1,2],
      2025: [12,24,1,4],
    },
    {
      name: "Междусрочна ваканция",
      2020: [2,5,2,5],
      2021: [1,30,2,3],
      2022: [2,1,2,1],
      2023: [2,1,2,5],
      2024: [2,3,2,5],
      2025: [2,5,2,5],
      2026: [1,31,2,2],
    },
    {
      name: "Пролетна ваканция",
      2020: [4,16,4,20],
      2021: [4,8,4,11],
      2022: [4,7,4,10],
      2023: [4,12,4,17],
      2024: [4,5,4,7],
      2025: [4,4,4,6],
      2026: [4,8,4,13],
    },
    {
      name: "Лятна ваканция",
      2020: [7,1,9,14],
      2021: [7,1,9,14],
      2022: [7,1,9,14],
      2023: [7,1,9,14],
      2024: [6,29,9,14],
      2025: [7,1,9,14],
      2026: [7,1,9,14],
    },
    {
      name: "Есенна ваканция",
      2020: [10,30,11,1],
      2021: [10,30,11,1],
      2022: [10,29,11,1],
      2023: [11,1,11,5],
      2024: [10,31,11,3],
      2025: [10,31,11,3],
    },
    {
      name: "Свободен от училище",
      2022: [2,2,2,4],
      2026: [3,2,3,2],
    },
  ]
};

const br = {
  PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-10&lon=-52&zoom=18&addressdetails=1&accept-language=pt,en",
  "Acre": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Dia do evangélico","fixed_date":[1,23]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Alusivo ao Dia Internacional da Mulher","fixed_date":[3,8]},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Aniversário do estado","fixed_date":[6,15]},{"name":"Dia da Amazônia","fixed_date":[9,5]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Assinatura do Tratado de Petrópolis","fixed_date":[11,17]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Alagoas": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"São João","fixed_date":[6,24]},{"name":"São Pedro","fixed_date":[6,29]},{"name":"Independência","fixed_date":[9,7]},{"name":"Emancipação política","fixed_date":[9,16]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Morte de Zumbi dos Palmares","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Amapá": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Dia de São José","fixed_date":[3,19]},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Data Magna do estado","fixed_date":[9,13]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Amazonas": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Data Magna do estado","fixed_date":[9,5]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Bahia": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Data magna do estado","fixed_date":[2,7]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Ceará": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Data magna do estado","fixed_date":[3,25]},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Distrito Federal": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia do evangélico","fixed_date":[11,30]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Espírito Santo": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Data magna do estado","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Goiás": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Maranhão": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Data magna do estado","fixed_date":[7,28]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Mato Grosso": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-10.4276788&lon=-52.0892082&zoom=18&addressdetails=1&accept-language=pt,en",
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Mato Grosso do Sul": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Criação do estado","fixed_date":[10,11]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Minas Gerais": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Data magna do estado","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Pará": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Data magna do estado","fixed_date":[8,15]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Paraíba": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Homenagem a João Pessoa","fixed_date":[7,26]},{"name":"Data magna do estado","fixed_date":[8,5]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Paraná": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Data magna do estado","fixed_date":[12,19]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Pernambuco": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Data magna do estado","variable_date":"firstMarchSunday"},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Piauí": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Data magna do estado","fixed_date":[10,19]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rio de Janeiro": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Dia da Consciência Negra","fixed_date":[11,20]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rio Grande do Norte": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"São Jorge","fixed_date":[4,23]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Mártires de Cunhaú e Uruaçu","fixed_date":[10,3]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rio Grande do Sul": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Proclamação da República Rio-Grandense","fixed_date":[9,20]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Rondônia": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Data magna do estado","fixed_date":[1,4]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Dia do evangélico","fixed_date":[6,18]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Roraima": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Data magna do estado","fixed_date":[10,5]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Santa Catarina": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Data magna do estado","fixed_date":[8,11]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Santa Catarina de Alexandria","fixed_date":[11,25]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "São Paulo": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Data magna do estado","fixed_date":[7,9]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Sergipe": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Aniversário de Aracaju","fixed_date":[3,17]},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"São João","fixed_date":[6,24]},{"name":"Data magna do estado","fixed_date":[7,8]},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Nossa Senhora da Conceição","fixed_date":[12,8]},{"name":"Natal","fixed_date":[12,25]}]
  },
  "Tocantins": {
    PH: [{"name":"Ano Novo","fixed_date":[1,1]},{"name":"Carnaval","variable_date":"easter","offset":-47},{"name":"Autonomia do estado","fixed_date":[3,18]},{"name":"Sexta-feira santa","variable_date":"easter","offset":-2},{"name":"Tiradentes","fixed_date":[4,21]},{"name":"Dia do Trabalhador","fixed_date":[5,1]},{"name":"Corpus Christi","variable_date":"easter","offset":60},{"name":"Independência","fixed_date":[9,7]},{"name":"Nossa Senhora da Natividade","fixed_date":[9,8]},{"name":"Criação do estado","fixed_date":[10,5]},{"name":"Nossa Senhora Aparecida","fixed_date":[10,12]},{"name":"Finados","fixed_date":[11,2]},{"name":"Proclamação da República","fixed_date":[11,15]},{"name":"Natal","fixed_date":[12,25]}]
  }
};

const by = {
  SH: [
    {
      name: "Зімовыя вакацыі",
      2019: [12,26,1,11],
      2020: [12,25,1,10],
      2021: [12,25,1,9],
      2022: [12,25,1,8],
      2023: [12,24,1,7],
      2024: [12,25,1,7],
      2025: [12,25,1,7],
    },
    {
      name: "Вясновыя вакацыі",
      2020: [3,30,4,18],
      2021: [3,28,4,4],
      2022: [3,27,4,3],
      2023: [3,26,4,2],
      2024: [3,24,3,31],
      2025: [3,23,3,30],
      2026: [3,22,3,29],
    },
    {
      name: "Летнія вакацыі",
      2020: [6,1,8,31],
      2021: [6,1,8,31],
      2022: [6,1,8,31],
      2023: [6,1,8,31],
      2024: [6,1,8,31],
      2025: [6,1,8,31],
      2026: [6,1,8,31],
    },
    {
      name: "Восеньскія вакацыі",
      2020: [11,1,11,8],
      2021: [10,31,11,7],
      2022: [10,30,11,7],
      2023: [10,29,11,7],
      2024: [10,27,11,5],
      2025: [11,2,11,9],
    },
  ]
};

const ca = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Christmas Day","fixed_date":[12,25]}],
  "Alberta": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Alberta Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Heritage Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "British Columbia": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":7},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"British Columbia Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Manitoba": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Louis Riel Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Civic Holiday","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "New Brunswick": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"New Brunswick Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Newfoundland and Labrador": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Saint Patrick's Day","fixed_date":[3,17]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Saint George's Day","fixed_date":[4,23]},{"name":"Discovery Day","fixed_date":[6,24]},{"name":"Memorial Day","fixed_date":[7,1]},{"name":"Orangemen's Day","fixed_date":[7,12]},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Armistice Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Northwest Territories": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"National Aboriginal Day","fixed_date":[6,21]},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Civic Holiday","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Nova Scotia": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Natal Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Nunavut": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Nunavut Day","fixed_date":[7,9]},{"name":"Civic Holiday","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Ontario": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"August Civic Public Holiday","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Prince Edward Island": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Islander Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Civic Holiday","variable_date":"firstAugustMonday"},{"name":"Gold Cup Parade Day","variable_date":"firstAugustMonday","offset":18},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Quebec": {
    PH: [{"name":"Jour de l'an","fixed_date":[1,1]},{"name":"Vendredi saint","variable_date":"easter","offset":-2},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Journée nationale des patriotes","variable_date":"victoriaDay"},{"name":"Fête nationale du Québec","fixed_date":[6,24]},{"name":"Fête du Canada","variable_date":"canadaDay"},{"name":"Fête du Travail","variable_date":"firstSeptemberMonday"},{"name":"Jour de l'Action de grâce","variable_date":"firstOctoberMonday","offset":7},{"name":"Noël","fixed_date":[12,25]}]
  },
  "Saskatchewan": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Family Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Saskatchewan Day","variable_date":"firstAugustMonday"},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Yukon": {
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Heritage Day","variable_date":"lastFebruarySunday","offset":-2},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Victoria Day","variable_date":"victoriaDay"},{"name":"Canada Day","variable_date":"canadaDay"},{"name":"Discovery Day","variable_date":"firstAugustMonday","offset":14},{"name":"Labour Day","variable_date":"firstSeptemberMonday"},{"name":"Thanksgiving","variable_date":"firstOctoberMonday","offset":7},{"name":"Remembrance Day","fixed_date":[11,11]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  }
};

const ch = {
  PH: [{"name":"Neujahrstag/Nouvel an/Capo d'anno","fixed_date":[1,1]},{"name":"Berchtoldstag/2 janvier","fixed_date":[1,2],"only_states":["Zürich","Bern","Luzern","Obwalden","Nidwalden","Glarus","Zug","Freiburg","Solothurn","Schaffhausen","Graubünden","Aargau","Thurgau","Waadt","Neuenburg","Genf","Jura","Sankt Gallen","Wallis"]},{"name":"Heilige Drei Könige/Epifania","fixed_date":[1,6],"only_states":["Uri","Schwyz","Graubünden","Tessin"]},{"name":"Instauration de la République","fixed_date":[3,1],"only_states":["Neuenburg"]},{"name":"Josefstag/Saint-Joseph/San Giuseppe","fixed_date":[3,19],"only_states":["Luzern","Uri","Schwyz","Nidwalden","Zug","Graubünden","Tessin","Wallis"]},{"name":"Karfreitag/Vendredi saint","variable_date":"easter","offset":-2,"only_states":["Zürich","Bern","Luzern","Uri","Schwyz","Obwalden","Nidwalden","Glarus","Zug","Freiburg","Solothurn","Basel-Stadt","Basel-Landschaft","Schaffhausen","Appenzell Ausserrhoden","Appenzell Innerrhoden","Sankt Gallen","Graubünden","Aargau","Thurgau","Waadt","Neuenburg","Genf","Jura"]},{"name":"Ostermontag/Lundi de Pâques/Lunedi di Pasqua","variable_date":"easter","offset":1,"only_states":["Zürich","Bern","Luzern","Uri","Schwyz","Obwalden","Nidwalden","Glarus","Zug","Freiburg","Solothurn","Basel-Stadt","Basel-Landschaft","Schaffhausen","Appenzell Ausserrhoden","Appenzell Innerrhoden","Sankt Gallen","Graubünden","Aargau","Thurgau","Tessin","Waadt","Neuenburg","Genf","Jura","Wallis"]},{"name":"Tag der Arbeit/Festa dei lavoratori","fixed_date":[5,1],"only_states":["Zürich","Freiburg","Solothurn","Basel-Stadt","Basel-Landschaft","Schaffhausen","Aargau","Thurgau","Tessin","Neuenburg","Jura"]},{"name":"Auffahrt/Ascension/Ascensione","variable_date":"easter","offset":39},{"name":"Pfingstmontag/Lundi de Pentecôte/Lunedi di Pentecoste","variable_date":"easter","offset":50,"only_states":["Zürich","Bern","Luzern","Uri","Schwyz","Obwalden","Nidwalden","Glarus","Zug","Freiburg","Solothurn","Basel-Stadt","Basel-Landschaft","Schaffhausen","Appenzell Ausserrhoden","Appenzell Innerrhoden","Sankt Gallen","Graubünden","Aargau","Thurgau","Tessin","Waadt","Neuenburg","Genf","Jura","Wallis"]},{"name":"Fronleichnam/Fête-Dieu/Corpus domini","variable_date":"easter","offset":60,"only_states":["Luzern","Uri","Schwyz","Obwalden","Nidwalden","Zug","Freiburg","Solothurn","Basel-Landschaft","Appenzell Innerrhoden","Graubünden","Aargau","Tessin","Wallis","Neuenburg","Jura"]},{"name":"Commémoration du plébiscite jurassien","fixed_date":[6,23],"only_states":["Jura"]},{"name":"San Pietro e Paolo","fixed_date":[6,29],"only_states":["Tessin"]},{"name":"Bundesfeiertag/Jour de la fête nationale/Giorno festivo federale","fixed_date":[8,1]},{"name":"Mariä Himmelfahrt/Assomption/Assunzione","fixed_date":[8,15],"only_states":["Luzern","Uri","Schwyz","Obwalden","Nidwalden","Zug","Freiburg","Solothurn","Basel-Landschaft","Appenzell Innerrhoden","Graubünden","Aargau","Tessin","Wallis","Jura"]},{"name":"Mauritiustag","fixed_date":[9,22],"only_states":["Appenzell Innerrhoden"]},{"name":"Bruderklausenfest","fixed_date":[9,25],"only_states":["Obwalden"]},{"name":"Allerheiligen/Toussaint/Ognissanti","fixed_date":[11,1],"only_states":["Luzern","Uri","Schwyz","Obwalden","Nidwalden","Glarus","Zug","Freiburg","Solothurn","Appenzell Innerrhoden","Sankt Gallen","Graubünden","Aargau","Tessin","Wallis","Jura"]},{"name":"Mariä Empfängnis/Immaculée Conception/Ognissanti","fixed_date":[12,8],"only_states":["Luzern","Uri","Schwyz","Obwalden","Nidwalden","Zug","Freiburg","Solothurn","Appenzell Innerrhoden","Graubünden","Aargau","Tessin","Wallis"]},{"name":"Weihnachtstag/Noël/Natale","fixed_date":[12,25]},{"name":"Stephanstag/Saint-Etienne/Santo Stefano","fixed_date":[12,26],"only_states":["Zürich","Bern","Luzern","Uri","Schwyz","Obwalden","Nidwalden","Glarus","Zug","Freiburg","Solothurn","Basel-Stadt","Basel-Landschaft","Schaffhausen","Appenzell Ausserrhoden","Appenzell Innerrhoden","Sankt Gallen","Graubünden","Aargau","Thurgau","Tessin","Wallis"]},{"name":"Restauration de la République","fixed_date":[12,31],"only_states":["Genf"]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
  "Aargau": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Aargau&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ag",
    SH: [
      {
        name: "Winterferien",
        2019: [12,23,1,3],
        2020: [12,21,12,31],
        2021: [12,24,1,7],
        2022: [12,27,1,6],
        2023: [12,27,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,12,31],
        2027: [12,24,1,7],
        2028: [12,27,1,5],
        2029: [12,24,1,4],
        2030: [12,23,1,3],
        2031: [12,22,12,31],
        2032: [12,24,1,7],
        2033: [12,27,1,6],
        2034: [12,27,1,5],
      },
      {
        name: "Sommerferien",
        2020: [7,20,8,7],
        2021: [7,19,8,6],
        2022: [7,18,8,5],
        2023: [7,24,8,11],
        2024: [7,22,8,9],
        2025: [7,21,8,8],
        2026: [7,20,8,7],
        2027: [7,19,8,6],
        2028: [7,24,8,11],
        2029: [7,23,8,10],
        2030: [7,22,8,9],
        2031: [7,21,8,8],
        2032: [7,19,8,6],
        2033: [7,18,8,5],
        2034: [7,24,8,11],
        2035: [7,23,8,10],
      },
      {
        name: "Herbstferien",
        2020: [9,28,10,9],
        2021: [10,4,10,15],
        2022: [10,3,10,14],
        2023: [10,2,10,13],
        2024: [9,30,10,11],
        2025: [9,29,10,10],
        2026: [9,28,10,9],
        2027: [10,4,10,15],
        2028: [10,2,10,13],
        2029: [10,1,10,12],
        2030: [9,30,10,11],
        2031: [9,29,10,10],
        2032: [9,27,10,8],
        2033: [10,3,10,14],
        2034: [10,2,10,13],
      },
      {
        name: "Frühlingsferien",
        2020: [4,6,4,17],
        2021: [4,12,4,23],
        2022: [4,11,4,21],
        2023: [4,11,4,21],
        2024: [4,8,4,19],
        2025: [4,7,4,18],
        2026: [4,7,4,17],
        2027: [4,12,4,23],
        2028: [4,10,4,21],
        2029: [4,9,4,20],
        2030: [4,6,4,18],
        2031: [4,7,4,18],
        2032: [4,5,4,16],
        2033: [4,11,4,22],
        2034: [4,11,4,21],
        2035: [4,9,4,20],
      },
    ]
  },
  "Albula": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Appenzell": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Appenzell Ausserrhoden": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Appenzell%20Ausserrhoden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ar",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,6,8,7],
        2021: [7,12,8,15],
        2022: [7,11,8,12],
        2023: [7,10,8,11],
        2024: [7,8,8,9],
        2025: [7,7,8,8],
        2026: [7,6,8,7],
        2027: [7,12,8,13],
        2028: [7,10,8,11],
      },
      {
        name: "Herbstferien",
        2020: [10,5,10,16],
        2021: [10,11,10,24],
        2022: [10,20,10,21],
        2023: [10,9,10,20],
        2024: [10,7,10,18],
        2025: [10,6,10,17],
        2026: [10,5,10,16],
        2027: [10,11,10,22],
      },
      {
        name: "Weihnachtsferien",
        2020: [12,21,1,1],
        2021: [12,26,12,31],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,1,1],
        2027: [12,20,12,31],
      },
      {
        name: "Frühlingsferien",
        2020: [4,6,4,17],
        2021: [4,12,4,23],
        2022: [4,11,4,22],
        2023: [4,10,4,21],
        2024: [4,8,4,19],
        2025: [4,7,4,18],
        2026: [4,3,4,17],
        2027: [4,12,4,23],
        2028: [4,10,4,21],
      },
    ]
  },
  "Appenzell Innerrhoden": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Appenzell%20Innerrhoden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ai",
    SH: [
      {
        name: "Weihnachtsferien",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [4,10,4,25],
        2022: [4,9,4,24],
        2023: [4,7,4,23],
        2024: [4,6,4,21],
        2025: [4,5,4,20],
        2026: [4,3,4,19],
        2027: [4,10,4,25],
        2028: [4,8,4,23],
      },
    ]
  },
  "Basel-Landschaft": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Basel-Landschaft&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "bl",
    SH: [
      {
        name: "Sommerferien",
        2020: [6,27,8,9],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,2,8,13],
        2024: [6,29,8,11],
        2025: [6,28,8,10],
        2026: [6,27,8,9],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
        2029: [6,30,8,12],
        2030: [6,29,8,11],
        2031: [6,28,8,10],
        2032: [6,26,8,8],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,9],
        2021: [10,2,10,17],
        2022: [10,2,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
        2027: [10,2,10,17],
        2028: [9,30,10,15],
        2029: [9,29,10,14],
        2030: [9,28,10,13],
        2031: [9,27,10,12],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
        2030: [12,21,1,5],
        2031: [12,20,1,4],
      },
      {
        name: "Fasnachtsferien",
        2020: [2,22,3,8],
        2021: [2,13,2,28],
        2022: [2,26,3,13],
        2023: [2,18,3,5],
        2024: [2,10,2,25],
        2025: [3,1,3,16],
        2026: [2,14,3,1],
        2027: [2,6,2,21],
        2028: [2,26,3,12],
        2029: [2,10,2,25],
        2030: [3,2,3,17],
        2031: [2,22,3,9],
        2032: [2,7,2,22],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [3,27,4,11],
        2022: [4,9,4,24],
        2023: [4,1,4,16],
        2024: [3,23,4,7],
        2025: [4,12,4,27],
        2026: [3,28,4,12],
        2027: [3,20,4,4],
        2028: [4,8,4,23],
        2029: [3,24,4,8],
        2030: [4,13,4,28],
        2031: [4,5,4,20],
        2032: [3,20,4,4],
      },
      {
        name: "Auffahrtsbrücke",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,25,5,25],
        2027: [5,7,5,7],
        2028: [6,26,6,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
        2031: [5,23,5,23],
        2032: [5,7,5,7],
      },
    ]
  },
  "Basel-Stadt": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Basel-Stadt&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "bs",
    SH: [
      {
        name: "Sommerferien",
        2020: [6,27,8,9],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [6,28,8,10],
        2026: [6,27,8,9],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
        2029: [6,30,8,12],
        2030: [6,29,8,11],
        2031: [6,28,8,10],
        2032: [6,26,8,8],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,11],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
        2027: [10,2,10,17],
        2028: [9,30,10,15],
        2029: [9,29,10,14],
        2030: [9,28,10,13],
        2031: [9,27,10,12],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
        2030: [12,21,1,5],
        2031: [12,20,1,4],
      },
      {
        name: "Fasnachtsferien",
        2020: [2,22,3,8],
        2021: [2,13,2,28],
        2022: [2,26,3,13],
        2023: [2,18,3,5],
        2024: [2,10,2,25],
        2025: [3,1,3,16],
        2026: [2,14,3,1],
        2027: [2,6,2,21],
        2028: [2,16,3,12],
        2029: [2,10,2,25],
        2030: [3,2,3,17],
        2031: [2,22,3,9],
        2032: [2,7,2,22],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [3,27,4,11],
        2022: [4,9,4,24],
        2023: [4,1,4,16],
        2024: [3,23,4,7],
        2025: [4,12,4,27],
        2026: [3,28,4,12],
        2027: [3,20,4,4],
        2028: [4,8,4,23],
        2029: [3,24,4,8],
        2030: [4,13,4,28],
        2031: [4,5,4,20],
        2032: [3,20,4,4],
      },
      {
        name: "Auffahrtsbrücke",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,25,5,25],
        2027: [5,7,5,7],
        2028: [6,26,6,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
        2031: [5,23,5,23],
        2032: [5,7,5,7],
      },
    ]
  },
  "Bern": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Bern&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "be",
    SH: [
      {
        name: "Winterferien",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,25,1,10],
        2027: [12,25,1,9],
      },
      {
        name: "Sommerferien",
        2020: [7,4,8,9],
        2021: [7,3,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,10],
        2026: [7,4,8,9],
        2027: [7,3,8,15],
      },
      {
        name: "Herbstferien",
        2020: [9,19,10,11],
        2021: [9,25,10,17],
        2022: [9,24,10,16],
        2023: [9,23,10,15],
        2024: [9,21,10,13],
        2025: [9,20,10,12],
        2026: [9,19,10,11],
        2027: [9,25,10,17],
      },
      {
        name: "Februarwoche",
        2020: [2,1,2,9],
        2021: [2,6,2,14],
        2022: [2,5,2,13],
        2023: [2,4,2,12],
        2024: [2,3,2,11],
        2025: [2,1,2,9],
        2026: [1,31,2,8],
        2027: [2,6,2,14],
      },
      {
        name: "Frühlingsferien",
        2020: [4,4,4,19],
        2021: [4,10,4,25],
        2022: [4,9,4,24],
        2023: [4,7,4,23],
        2024: [4,6,4,21],
        2025: [4,5,4,21],
        2026: [4,3,4,19],
        2027: [4,10,4,25],
      },
      {
        name: "Vacances de printemps",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,11,4,22],
        2023: [4,7,4,21],
        2024: [3,29,4,12],
        2025: [4,14,4,25],
        2026: [4,3,4,17],
        2027: [3,26,4,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,11,8,19],
        2023: [7,10,8,18],
        2024: [7,8,8,16],
        2025: [7,7,8,15],
        2026: [7,6,8,14],
        2027: [7,5,8,13],
      },
      {
        name: "Vacances d'automne",
        2020: [10,3,10,18],
        2021: [10,11,10,22],
        2022: [10,10,10,21],
        2023: [10,9,10,20],
        2024: [10,7,10,18],
        2025: [10,6,10,27],
        2026: [10,5,10,16],
        2027: [10,4,10,15],
      },
      {
        name: "Vacances d'hiver",
        2020: [12,25,1,10],
        2021: [12,27,1,7],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,25,1,8],
        2027: [12,27,1,7],
      },
    ]
  },
  "Bernina": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Engiadina Bassa/Val Müstair": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Freiburg": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Freiburg&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "fr"
  },
  "Fribourg": {
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,13,2,21],
        2022: [2,26,3,6],
        2023: [2,18,2,26],
        2024: [2,10,2,18],
        2025: [3,1,3,9],
        2026: [2,14,2,22],
      },
      {
        name: "Frühling",
        2020: [4,4,4,19],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,26],
        2021: [7,10,8,25],
        2022: [7,9,8,24],
        2023: [7,8,8,23],
        2024: [7,6,8,21],
        2025: [7,4,8,27],
        2026: [7,11,8,26],
      },
      {
        name: "Herbst",
        2020: [10,17,11,1],
        2021: [10,16,11,1],
        2022: [10,15,10,30],
        2023: [10,14,10,29],
        2024: [10,12,10,27],
        2025: [10,11,10,26],
        2026: [10,10,10,25],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,2],
        2026: [12,19,1,3],
      },
    ]
  },
  "Genève": {
    SH: [
      {
        name: "Vacances de février",
        2020: [2,8,2,16],
        2021: [2,13,2,21],
        2022: [2,12,2,20],
        2023: [2,18,2,26],
        2024: [2,17,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [2,21,2,25],
        2029: [2,19,2,23],
        2030: [2,25,3,1],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,19],
        2021: [4,1,4,11],
        2022: [4,14,4,24],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,2],
        2026: [4,3,4,17],
        2027: [3,26,4,9],
        2028: [4,13,4,21],
        2029: [3,29,4,6],
        2030: [4,18,4,26],
      },
      {
        name: "Vacances d'été",
        2020: [6,27,8,23],
        2021: [7,3,8,29],
        2022: [7,2,8,21],
        2023: [7,1,8,20],
        2024: [6,29,8,18],
        2025: [6,30,8,15],
        2026: [6,29,8,16],
        2027: [7,5,8,25],
        2028: [7,3,8,23],
        2029: [7,2,8,22],
        2030: [7,1,8,21],
      },
      {
        name: "Vacances d'automne",
        2020: [10,17,10,25],
        2021: [10,23,10,31],
        2022: [10,22,10,30],
        2023: [10,21,10,29],
        2024: [10,19,10,27],
        2025: [10,20,10,24],
        2026: [10,19,10,23],
        2027: [10,25,10,29],
        2028: [10,23,10,27],
        2029: [10,22,10,26],
      },
      {
        name: "Vacances de Noël et Nouvel An",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,24,1,8],
        2027: [12,24,1,7],
        2028: [12,25,1,5],
        2029: [12,24,1,4],
      },
      {
        name: "Pont de l'Ascension",
        2023: [5,18,5,19],
        2024: [5,9,5,10],
        2025: [5,29,5,30],
        2026: [5,14,5,15],
        2027: [5,6,5,7],
        2028: [5,25,5,26],
        2029: [5,10,5,11],
        2030: [5,30,5,31],
      },
    ]
  },
  "Genf": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Genf&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ge"
  },
  "Glarus": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Glarus&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "gl",
    SH: [
      {
        name: "Sport",
        2020: [1,25,2,2],
        2021: [1,30,2,7],
        2022: [1,29,2,6],
        2023: [1,28,2,5],
        2024: [1,27,2,4],
        2025: [1,25,2,2],
        2026: [1,24,2,1],
      },
      {
        name: "Frühling",
        2020: [4,2,4,19],
        2021: [4,2,4,18],
        2022: [4,7,4,24],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,3,4,20],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [6,27,8,9],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [6,28,8,10],
        2026: [6,27,8,9],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,24,1,10],
      },
    ]
  },
  "Gonten": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Graubünden": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Graub%C3%BCnden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "gr"
  },
  "Imboden": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Jura": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Jura&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ju",
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,23,1,3],
        2020: [12,24,1,8],
        2021: [12,24,1,7],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,24,1,8],
        2027: [12,24,1,7],
      },
      {
        name: "Semaine de relâche hivernale",
        2020: [2,17,2,21],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [2,20,2,24],
        2024: [2,19,2,23],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [2,15,2,19],
        2028: [2,21,2,25],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,10,4,24],
        2021: [4,2,4,16],
        2022: [4,11,4,22],
        2023: [4,7,4,21],
        2024: [3,29,4,12],
        2025: [3,18,5,2],
        2026: [4,3,4,17],
        2027: [3,26,4,9],
        2028: [4,14,4,28],
      },
      {
        name: "Ascension",
        2020: [4,21,4,22],
        2021: [5,13,5,14],
        2022: [5,26,5,27],
        2023: [5,18,5,19],
        2024: [5,9,5,10],
        2025: [5,29,5,30],
        2026: [5,14,5,15],
        2027: [5,6,5,7],
        2028: [5,25,5,26],
      },
      {
        name: "Vacances d'été",
        2020: [7,6,8,14],
        2021: [7,5,8,13],
        2022: [7,4,8,12],
        2023: [7,3,8,18],
        2024: [7,8,8,16],
        2025: [7,7,8,15],
        2026: [7,6,8,14],
        2027: [7,5,8,13],
        2028: [7,3,8,18],
      },
      {
        name: "Vacances d'automne",
        2020: [10,12,10,23],
        2021: [10,11,10,22],
        2022: [10,10,10,21],
        2023: [10,16,10,27],
        2024: [10,14,10,25],
        2025: [10,6,10,17],
        2026: [10,5,10,16],
        2027: [10,11,10,22],
      },
    ]
  },
  "Landquart": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Luzern": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Luzern&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "lu",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,10,8,22],
        2022: [7,9,8,21],
        2023: [7,8,8,20],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,8,8,20],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,11],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
        2027: [9,25,10,10],
      },
      {
        name: "Weihnachtsferien",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,18,1,2],
      },
      {
        name: "Fasnachtsferien",
        2020: [2,15,3,1],
        2021: [2,6,2,21],
        2022: [2,19,3,6],
        2023: [2,11,2,26],
        2024: [2,3,2,18],
        2025: [2,22,3,9],
        2026: [2,7,2,22],
        2027: [1,30,2,14],
        2028: [2,19,3,5],
      },
      {
        name: "Frühlingsferien",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
        2027: [3,26,4,11],
        2028: [4,14,4,30],
      },
    ]
  },
  "Maloja": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Moesa": {
    SH: [
      {
        name: "Herbstferien",
        2023: [10,28,11,5],
        2024: [10,26,11,3],
        2025: [11,1,11,9],
        2026: [10,31,11,8],
      },
      {
        name: "Weihnachtsferien",
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,24,1,6],
        2026: [12,24,1,6],
      },
      {
        name: "Schulbeginn",
        2023: [8,21,8,21],
        2024: [8,26,8,26],
        2025: [8,25,8,25],
        2026: [8,24,8,24],
      },
    ]
  },
  "Neuchâtel": {
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,27,3,7],
        2022: [2,26,3,6],
        2023: [2,25,3,5],
        2024: [2,24,3,3],
        2025: [2,22,3,2],
        2026: [2,21,3,1],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,9,4,24],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,12,4,27],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,14],
        2023: [7,1,8,13],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,21,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
      },
    ]
  },
  "Neuenburg": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Neuenburg&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ne"
  },
  "Nidwalden": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Nidwalden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "nw",
    SH: [
      {
        name: "Sport",
        2020: [2,15,3,1],
        2021: [2,6,2,21],
        2022: [2,19,3,6],
        2023: [2,11,2,26],
        2024: [2,3,2,18],
        2025: [2,22,3,9],
        2026: [2,7,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,23],
        2021: [7,3,8,22],
        2022: [7,9,8,28],
        2023: [7,8,8,27],
        2024: [7,6,8,25],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [9,26,10,11],
        2021: [9,25,10,10],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
      },
    ]
  },
  "Oberegg": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,15],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2026: [7,4,8,9],
        2027: [7,10,8,15],
        2028: [7,8,8,13],
      },
      {
        name: "Herbstferien",
        2020: [9,26,10,18],
        2021: [10,2,10,24],
        2022: [10,1,10,23],
        2023: [9,30,10,22],
        2024: [9,28,10,20],
        2025: [10,4,10,19],
        2026: [9,26,10,18],
        2027: [10,2,10,24],
      },
      {
        name: "Sportferien",
        2020: [1,25,2,2],
        2021: [1,30,2,7],
        2022: [1,29,2,6],
        2023: [1,28,2,5],
        2024: [1,27,2,4],
        2026: [1,24,2,1],
        2027: [1,30,2,7],
      },
    ]
  },
  "Obwalden": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Obwalden&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ow",
    SH: [
      {
        name: "Sport",
        2020: [2,15,3,1],
        2021: [2,6,2,21],
        2022: [2,19,3,6],
        2023: [2,11,2,26],
        2024: [2,3,2,18],
        2025: [2,27,3,9],
        2026: [2,12,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,18,5,4],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,16],
        2021: [7,10,8,22],
        2022: [7,2,8,15],
        2023: [7,8,8,20],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [9,26,10,11],
        2021: [10,2,10,24],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [10,4,10,26],
        2026: [10,3,10,25],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,24,1,6],
        2026: [12,24,1,6],
      },
    ]
  },
  "Plessur": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Prättigau / Davos": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Sankt Gallen": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Sankt%20Gallen&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "sg"
  },
  "Schaffhausen": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Schaffhausen&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "sh",
    SH: [
      {
        name: "Sport",
        2020: [1,25,2,9],
        2021: [1,30,2,14],
        2022: [1,29,2,13],
        2023: [1,28,2,12],
        2024: [1,27,2,11],
        2025: [1,25,2,9],
        2026: [1,24,2,8],
      },
      {
        name: "Frühling",
        2020: [4,11,4,26],
        2021: [4,17,5,2],
        2022: [4,15,5,1],
        2023: [4,15,5,1],
        2024: [4,13,4,28],
        2025: [4,12,4,27],
        2026: [4,11,4,26],
      },
      {
        name: "Sommer",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,10],
        2026: [7,4,8,9],
      },
      {
        name: "Herbst",
        2020: [9,26,10,18],
        2021: [10,2,10,24],
        2022: [10,1,10,23],
        2023: [9,30,10,22],
        2024: [9,28,10,20],
        2025: [9,27,10,19],
        2026: [9,26,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,3],
        2021: [12,24,1,2],
        2022: [12,24,1,2],
        2023: [12,23,1,2],
        2024: [12,24,1,5],
        2025: [12,24,1,4],
        2026: [12,24,1,3],
      },
    ]
  },
  "Schlatt-Haslen": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Schwende-Rüte": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,13],
        2024: [6,29,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,1,8,13],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,2,10,17],
      },
      {
        name: "Sportferien",
        2020: [2,21,3,1],
        2021: [2,12,2,21],
        2022: [2,25,3,6],
        2023: [2,17,2,26],
        2024: [2,9,2,18],
        2025: [2,22,2,28],
        2026: [2,13,2,22],
        2027: [2,5,2,14],
      },
    ]
  },
  "Schwyz": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Schwyz&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "sz",
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,27,3,7],
        2022: [2,26,3,6],
        2023: [2,25,3,5],
        2024: [2,24,3,3],
        2025: [2,22,3,2],
        2026: [2,21,3,1],
      },
      {
        name: "Frühling",
        2020: [4,25,5,10],
        2021: [5,1,5,16],
        2022: [4,30,5,15],
        2023: [4,29,5,14],
        2024: [4,27,5,12],
        2025: [4,26,5,11],
        2026: [4,25,5,10],
      },
      {
        name: "Sommer",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,17],
        2026: [7,4,8,9],
      },
      {
        name: "Herbst",
        2020: [9,26,10,11],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [9,30,10,15],
        2024: [9,28,10,13],
        2025: [9,27,10,12],
        2026: [9,26,10,11],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,25,1,6],
        2025: [12,20,1,4],
        2026: [12,25,1,6],
      },
    ]
  },
  "Solothurn": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Solothurn&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "so",
    SH: [
      {
        name: "Winterferien",
        2020: [2,3,2,14],
        2021: [2,8,2,19],
        2022: [2,7,2,18],
        2023: [2,6,2,17],
        2024: [2,5,2,16],
        2025: [2,3,2,14],
        2026: [2,2,2,13],
        2027: [2,8,2,19],
        2028: [2,7,2,18],
        2029: [2,5,2,16],
        2030: [2,4,2,15],
        2031: [2,3,2,14],
      },
      {
        name: "Sommerferien",
        2020: [7,6,8,7],
        2021: [7,10,8,15],
        2022: [7,11,8,12],
        2023: [7,10,8,15],
        2024: [7,8,8,9],
        2025: [7,7,8,8],
        2026: [7,6,8,7],
        2027: [7,12,8,13],
        2028: [7,10,8,11],
        2029: [7,9,8,10],
        2030: [7,8,8,9],
        2031: [7,7,8,8],
      },
      {
        name: "Herbstferien",
        2020: [9,28,10,16],
        2021: [10,4,10,22],
        2022: [10,3,10,21],
        2023: [10,2,10,20],
        2024: [9,30,10,18],
        2025: [9,29,10,17],
        2026: [9,28,10,16],
        2027: [10,4,10,22],
        2028: [10,2,10,20],
        2029: [10,1,10,19],
        2030: [9,30,10,18],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,23,1,3],
        2020: [12,21,1,1],
        2021: [12,27,1,7],
        2022: [12,26,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,1,1],
        2027: [12,27,1,7],
        2028: [12,25,1,5],
        2029: [12,24,1,4],
        2030: [12,23,1,3],
      },
      {
        name: "Frühlingsferien",
        2020: [4,6,4,17],
        2021: [4,12,4,23],
        2022: [4,11,4,22],
        2023: [4,10,4,21],
        2024: [4,8,4,19],
        2025: [4,7,4,21],
        2026: [4,6,4,17],
        2027: [4,2,4,23],
        2028: [4,10,4,21],
        2029: [4,9,4,20],
        2030: [4,8,4,22],
        2031: [4,7,4,18],
      },
    ]
  },
  "St. Gallen": {
    SH: [
      {
        name: "Sommerferien",
        2020: [7,5,8,9],
        2021: [7,11,8,15],
        2022: [7,10,8,14],
        2023: [7,9,8,13],
        2024: [7,7,8,11],
        2025: [7,6,8,10],
        2026: [7,5,8,9],
        2027: [7,11,8,15],
        2028: [7,9,8,13],
        2029: [7,8,8,12],
      },
      {
        name: "Herbstferien",
        2020: [9,27,10,18],
        2021: [10,3,10,24],
        2022: [10,2,10,23],
        2023: [10,1,10,22],
        2024: [9,29,10,20],
        2025: [9,28,10,19],
        2026: [9,27,10,18],
        2027: [10,3,10,24],
        2028: [10,1,10,22],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,25,1,8],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
        2027: [12,19,1,2],
        2028: [12,24,1,7],
      },
      {
        name: "Frühlingsferien",
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,9,4,23],
        2024: [4,7,4,21],
        2025: [4,6,4,20],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
        2028: [4,9,4,23],
        2029: [4,8,4,22],
      },
    ]
  },
  "Surselva": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Tessin": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Tessin&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ti"
  },
  "Thurgau": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Thurgau&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "tg",
    SH: [
      {
        name: "Sport",
        2020: [1,25,2,2],
        2021: [1,30,2,7],
        2022: [1,29,2,6],
        2023: [1,28,2,5],
        2024: [1,27,2,4],
        2025: [1,25,2,2],
        2026: [1,24,2,1],
      },
      {
        name: "Frühling",
        2020: [3,28,4,13],
        2021: [4,2,4,18],
        2022: [4,2,4,18],
        2023: [3,25,4,10],
        2024: [3,29,4,14],
        2025: [4,12,4,27],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,9],
        2021: [7,10,8,15],
        2022: [7,9,8,14],
        2023: [7,8,8,13],
        2024: [7,6,8,11],
        2025: [7,5,8,10],
        2026: [7,4,8,9],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,18,1,2],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
      },
      {
        name: "Pfingsten",
        2026: [5,14,5,25],
      },
    ]
  },
  "Ticino": {
    SH: [
      {
        name: "Sport",
        2020: [2,22,3,1],
        2021: [2,13,2,21],
        2022: [2,26,3,6],
        2023: [2,18,2,26],
        2024: [2,10,2,18],
        2025: [3,1,3,9],
        2026: [2,14,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,19],
        2021: [4,2,4,11],
        2022: [4,15,4,24],
        2023: [4,7,4,16],
        2024: [3,29,4,7],
        2025: [4,18,4,27],
        2026: [4,3,4,12],
      },
      {
        name: "Sommer",
        2020: [6,20,8,30],
        2021: [6,19,8,29],
        2022: [6,16,8,28],
        2023: [6,17,8,27],
        2024: [6,15,9,1],
        2025: [6,19,8,31],
        2026: [6,18,8,30],
      },
      {
        name: "Herbst",
        2020: [10,31,11,8],
        2021: [10,30,11,7],
        2022: [10,29,11,6],
        2023: [10,28,11,5],
        2024: [10,26,11,3],
        2025: [11,1,11,9],
        2026: [10,31,11,8],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,24,1,6],
        2026: [12,24,1,6],
      },
    ]
  },
  "Uri": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Uri&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "ur",
    SH: [
      {
        name: "Sport",
        2020: [2,15,3,1],
        2021: [2,27,3,7],
        2022: [2,19,3,6],
        2023: [3,4,3,12],
        2024: [3,2,3,10],
        2025: [2,22,3,9],
        2026: [2,28,3,8],
      },
      {
        name: "Frühling",
        2020: [4,25,5,10],
        2021: [5,1,5,16],
        2022: [4,30,5,15],
        2023: [4,22,5,7],
        2024: [4,27,5,12],
        2025: [4,26,5,11],
        2026: [5,2,5,17],
      },
      {
        name: "Sommer",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,2,8,15],
        2023: [7,1,8,20],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,4,8,16],
      },
      {
        name: "Herbst",
        2020: [10,3,10,18],
        2021: [10,2,10,17],
        2022: [10,1,10,16],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
      },
      {
        name: "Winter",
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,20,1,6],
        2026: [12,24,1,10],
      },
    ]
  },
  "Valais": {
    SH: [
      {
        name: "Sport",
        2020: [2,29,3,8],
        2021: [2,27,3,7],
        2022: [3,5,3,13],
        2023: [3,4,3,12],
        2024: [3,2,3,10],
        2025: [3,1,3,9],
        2026: [2,28,3,8],
      },
      {
        name: "Frühling",
        2020: [5,16,5,24],
        2021: [5,8,5,16],
        2022: [5,7,5,15],
        2023: [5,13,5,29],
        2024: [5,4,5,12],
        2025: [4,18,4,27],
        2026: [5,9,5,17],
      },
      {
        name: "Sommer",
        2020: [6,27,8,16],
        2021: [6,26,8,15],
        2022: [6,30,8,15],
        2023: [7,1,8,15],
        2024: [6,29,8,18],
        2025: [6,28,8,17],
        2026: [7,1,8,16],
      },
      {
        name: "Herbst",
        2020: [10,22,11,1],
        2021: [10,13,10,24],
        2022: [10,13,10,23],
        2023: [10,19,10,29],
        2024: [10,17,10,27],
        2025: [10,16,10,26],
        2026: [10,15,10,25],
      },
      {
        name: "Winter",
        2020: [12,24,1,6],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,24,1,10],
      },
    ]
  },
  "Vaud": {
    SH: [
      {
        name: "Sport",
        2020: [2,15,2,23],
        2021: [2,20,2,28],
        2022: [2,19,2,27],
        2023: [2,11,2,19],
        2024: [2,10,2,18],
        2025: [2,15,2,23],
        2026: [2,14,2,22],
      },
      {
        name: "Frühling",
        2020: [4,10,4,26],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2023: [4,7,4,23],
        2024: [3,29,4,14],
        2025: [4,12,4,27],
        2026: [4,3,4,19],
      },
      {
        name: "Sommer",
        2020: [7,4,8,23],
        2021: [7,3,8,22],
        2022: [7,2,8,21],
        2023: [7,1,8,20],
        2024: [6,29,8,18],
        2025: [6,28,8,17],
        2026: [6,27,8,16],
      },
      {
        name: "Herbst",
        2020: [10,10,10,25],
        2021: [10,16,10,31],
        2022: [10,15,10,30],
        2023: [10,14,10,29],
        2024: [10,12,10,27],
        2025: [10,11,10,26],
        2026: [10,10,10,25],
      },
      {
        name: "Winter",
        2020: [12,19,1,3],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,24,1,10],
      },
    ]
  },
  "Viamala": {
    SH: [
      {
        name: "Herbstferien",
        2020: [10,10,10,25],
        2021: [10,9,10,24],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,6,10,17],
        2026: [10,10,10,25],
        2027: [10,9,10,24],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,21,1,5],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,22,1,2],
        2026: [12,23,1,5],
        2027: [12,23,1,5],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Schulbeginn",
        2020: [8,17,8,17],
        2021: [8,16,8,16],
        2022: [8,15,8,15],
        2023: [8,14,8,14],
        2024: [8,12,8,12],
        2025: [8,11,8,11],
        2026: [8,17,8,17],
        2027: [8,16,8,16],
        2028: [8,14,8,14],
        2029: [8,13,8,13],
      },
    ]
  },
  "Waadt": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Waadt&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "vd"
  },
  "Wallis": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Wallis&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "vs"
  },
  "Zug": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Zug&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "zg",
    SH: [
      {
        name: "Winterferien",
        2020: [12,19,1,3],
        2021: [12,23,1,5],
        2022: [12,22,1,4],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,19,1,3],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Sommerferien",
        2020: [7,4,8,16],
        2021: [7,3,8,15],
        2022: [7,9,8,21],
        2023: [7,8,8,20],
        2024: [7,6,8,18],
        2025: [6,21,8,17],
        2026: [7,4,8,16],
        2027: [7,3,8,15],
        2028: [7,8,8,20],
        2029: [7,7,8,19],
        2030: [7,6,8,18],
      },
      {
        name: "Herbstferien",
        2020: [10,3,10,18],
        2021: [10,2,10,17],
        2022: [10,8,10,23],
        2023: [10,7,10,22],
        2024: [10,5,10,20],
        2025: [10,4,10,19],
        2026: [10,3,10,18],
        2027: [10,3,10,18],
        2028: [10,7,10,22],
        2029: [10,6,10,21],
      },
      {
        name: "Sportferien",
        2020: [2,1,2,16],
        2021: [2,6,2,21],
        2022: [2,5,2,20],
        2023: [2,4,2,19],
        2024: [2,3,2,18],
        2025: [2,1,2,16],
        2026: [1,31,2,15],
        2027: [2,6,2,21],
        2028: [2,5,2,20],
        2029: [2,3,2,18],
        2030: [2,2,2,17],
      },
      {
        name: "Frühlingsferien",
        2020: [4,11,4,26],
        2021: [4,17,5,2],
        2022: [4,15,5,1],
        2023: [4,15,4,30],
        2024: [4,13,4,28],
        2025: [4,12,4,27],
        2026: [4,11,4,26],
        2027: [4,17,5,2],
        2028: [4,15,4,30],
        2029: [4,4,4,29],
        2030: [4,13,4,28],
      },
      {
        name: "Auffahrtsferien",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2024: [5,9,5,12],
        2025: [5,29,6,1],
        2026: [5,14,5,17],
        2027: [5,6,5,9],
        2028: [5,25,5,28],
        2029: [5,10,5,13],
        2030: [5,30,6,2],
      },
    ]
  },
  "Zürich": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Switzerland&state=Z%C3%BCrich&zoom=18&addressdetails=1&limit=1&accept-language=de,fr,it,rm",
    "_state_code": "zh",
    SH: [
      {
        name: "Sommerferien",
        2020: [7,13,8,15],
        2021: [7,19,8,21],
        2022: [7,18,8,20],
        2023: [7,17,8,19],
        2024: [7,15,8,17],
        2025: [7,14,8,16],
        2026: [7,13,8,15],
        2027: [7,19,8,21],
        2028: [7,17,8,19],
        2029: [7,16,8,18],
        2030: [7,15,8,17],
        2031: [7,14,8,16],
        2032: [7,12,8,14],
        2033: [7,18,8,20],
      },
      {
        name: "Herbstferien",
        2020: [10,5,10,17],
        2021: [10,11,10,23],
        2022: [10,10,10,22],
        2023: [10,9,10,21],
        2024: [10,7,10,19],
        2025: [10,6,10,18],
        2026: [10,5,10,17],
        2027: [10,11,10,23],
        2028: [10,9,10,21],
        2029: [10,8,10,20],
        2030: [10,7,10,19],
        2031: [10,6,10,18],
        2032: [10,4,10,16],
      },
      {
        name: "Weihnachtsferien",
        2020: [12,21,1,2],
        2021: [12,20,1,1],
        2022: [12,26,1,7],
        2023: [12,25,1,6],
        2024: [12,23,1,4],
        2025: [12,22,1,3],
        2026: [12,21,1,2],
        2027: [12,20,1,1],
        2028: [12,25,1,6],
        2029: [12,24,1,5],
        2030: [12,23,1,5],
        2031: [12,22,1,3],
        2032: [12,20,1,1],
      },
      {
        name: "Ostern",
        2020: [4,10,4,13],
        2021: [4,2,4,5],
        2022: [4,15,4,18],
        2023: [4,7,4,10],
        2024: [3,29,4,1],
        2025: [4,18,4,21],
        2026: [4,3,4,6],
        2027: [3,26,3,29],
        2028: [4,14,4,17],
        2029: [3,30,4,2],
        2030: [4,19,4,22],
        2031: [4,11,4,14],
        2032: [3,26,3,29],
        2033: [4,15,4,18],
      },
      {
        name: "Frühlingsferien",
        2020: [4,13,4,25],
        2021: [4,26,5,8],
        2022: [4,18,4,30],
        2023: [4,24,5,6],
        2024: [4,22,5,4],
        2025: [4,21,5,3],
        2026: [4,20,5,2],
        2027: [4,26,5,8],
        2028: [4,17,4,29],
        2029: [4,23,5,5],
        2030: [4,22,5,4],
        2031: [4,14,4,26],
        2032: [4,19,5,1],
        2033: [4,18,4,30],
      },
      {
        name: "Auffahrtsbrücke",
        2020: [5,21,5,23],
        2021: [5,13,5,15],
        2022: [5,26,5,28],
        2024: [5,9,5,11],
        2025: [5,29,5,31],
        2026: [5,14,5,16],
        2027: [5,6,5,8],
        2028: [5,25,5,27],
        2029: [5,10,5,12],
        2030: [5,30,6,1],
        2031: [5,22,5,24],
        2032: [5,6,5,8],
        2033: [5,26,5,28],
      },
    ]
  }
};

const ci = {
  PH: [{"name":"Fête du 1ᵉʳ janvier","fixed_date":[1,1]},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Fête du travail","fixed_date":[5,1]},{"name":"Lendemain de la Fête du travail","variable_date":"nextMo-Sa01May"},{"name":"Jour de l’Ascension","variable_date":"easter","offset":39},{"name":"Lundi de la Pentecôte","variable_date":"easter","offset":50},{"name":"Fête nationale","fixed_date":[8,7]},{"name":"Lendemain de la Fête nationale","variable_date":"nextMo-Sa07August"},{"name":"Fête de l’Assomption","fixed_date":[8,15]},{"name":"Fête de la Toussaint","fixed_date":[11,1]},{"name":"Journée Nationale de la Paix","fixed_date":[11,15]},{"name":"Fête de Noël","fixed_date":[12,25]},{"name":"Lendemain de la Fête de Noël","variable_date":"nextMo-Sa25December"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=5.3203570&lon=-4.0161070&zoom=18&addressdetails=1&accept-language=fr"
};

const cn = {
  PH: [{"name":"元旦","fixed_date":[1,1]},{"name":"妇女节","fixed_date":[3,8]},{"name":"劳动节","fixed_date":[5,1]},{"name":"青年节","fixed_date":[5,4]},{"name":"儿童节","fixed_date":[6,1]},{"name":"国庆节","fixed_date":[10,1]},{"name":"国庆节休息日","fixed_date":[10,2]},{"name":"国庆节休息日","fixed_date":[10,3]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=%E4%B8%AD%E5%9B%BD&&zoom=18&addressdetails=1&limit=1&accept-language=zh,en",
  "西藏自治区": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&state=%E8%A5%BF%E8%97%8F%E8%87%AA%E6%B2%BB%E5%8C%BA&zoom=1&addressdetails=1&limit=1&accept-language=zh,en",
    PH: [{"name":"元旦","fixed_date":[1,1]},{"name":"西藏百万农奴解放纪念日","fixed_date":[3,28]},{"name":"妇女节","fixed_date":[3,8]},{"name":"劳动节","fixed_date":[5,1]},{"name":"青年节","fixed_date":[5,4]},{"name":"儿童节","fixed_date":[6,1]},{"name":"国庆节","fixed_date":[10,1]},{"name":"国庆节休息日","fixed_date":[10,2]},{"name":"国庆节休息日","fixed_date":[10,3]}]
  }
};

const cz = {
  PH: [{"name":"Den obnovy samostatného českého státu","fixed_date":[1,1]},{"name":"Velký pátek","variable_date":"easter","offset":-2},{"name":"Velikonoční pondělí","variable_date":"easter","offset":1},{"name":"Svátek práce","fixed_date":[5,1]},{"name":"Den vítězství","fixed_date":[5,8]},{"name":"Den slovanských věrozvěstů Cyrila a Metoděje","fixed_date":[7,5]},{"name":"Den upálení mistra Jana Husa","fixed_date":[7,6]},{"name":"Den české státnosti","fixed_date":[9,28]},{"name":"Den vzniku samostatného československého státu","fixed_date":[10,28]},{"name":"Den boje za svobodu a demokracii","fixed_date":[11,17]},{"name":"Štědrý den","fixed_date":[12,24]},{"name":"1. svátek vánoční","fixed_date":[12,25]},{"name":"2. svátek vánoční","fixed_date":[12,26]}],
  SH: [
    {
      name: "Vánoční prázdniny",
      2019: [12,23,1,3],
      2020: [12,23,1,3],
      2021: [12,23,1,2],
      2022: [12,23,1,2],
      2023: [12,23,1,2],
      2024: [12,23,1,3],
      2025: [12,22,1,2],
      2026: [12,23,1,3],
      2027: [12,23,1,2],
    },
    {
      name: "Pololetní prázdniny",
      2020: [1,31,1,31],
      2021: [1,29,1,29],
      2022: [2,4,2,4],
      2023: [2,3,2,3],
      2024: [2,2,2,2],
      2025: [1,31,1,31],
      2026: [1,30,1,30],
      2027: [1,29,1,29],
      2028: [2,4,2,4],
    },
    {
      name: "Velikonoční prázdniny",
      2020: [4,9,4,9],
      2021: [4,1,4,1],
      2022: [4,14,4,14],
      2023: [4,6,4,6],
      2024: [3,28,3,28],
      2025: [4,17,4,17],
      2026: [4,2,4,2],
      2027: [3,25,3,25],
      2028: [4,13,4,13],
    },
    {
      name: "Hlavní prázdniny",
      2020: [7,1,8,31],
      2021: [7,1,8,31],
      2022: [7,1,8,31],
      2023: [7,1,9,3],
      2024: [6,29,9,1],
      2025: [7,1,8,31],
      2026: [7,1,8,31],
      2027: [7,1,8,31],
      2028: [7,1,9,3],
    },
    {
      name: "Podzimní prázdniny",
      2020: [10,29,10,30],
      2021: [10,27,10,29],
      2022: [10,26,10,27],
      2023: [10,26,10,27],
      2024: [10,29,10,30],
      2025: [10,27,10,29],
      2026: [10,29,10,30],
      2027: [10,27,10,29],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=50.0874401&lon=14.4212556&zoom=18&addressdetails=1&accept-language=cs,en",
  "Benešov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Beroun": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Blansko": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Břeclav": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Brno-město": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Brno-venkov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Bruntál": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Česká Lípa": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "České Budějovice": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Český Krumlov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Cheb": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Chomutov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Chrudim": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Děčín": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Domažlice": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Frýdek-Místek": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Havlíčkův Brod": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Hodonín": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Hradec Králov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Jablonec nad Nisou": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Jeseník": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Jičín": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Jihlava": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Jindřichův Hradec": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Karlovy Vary": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Karviná": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Kladno": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Klatovy": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Kolín": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Kroměříž": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Kutná Hora": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Liberec": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Litoměřice": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Louny": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Mělník": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Mladá Boleslav": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Most": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Náchod": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Nový Jičín": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Nymburk": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Olomouc": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Opava": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Ostrava-město": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Pardubice": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Pelhřimov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Písek": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Plzeň-jih": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Plzeň-město": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Plzeň-sever": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Prachatice": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Praha": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [3,13,3,19],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Praha-východ": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Praha-západ": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Přerov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Příbram": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Prostějov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Rakovník": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Rokycany": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Rychnov nad Kněžnou": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Semily": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Sokolov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,24,3,1],
        2021: [3,1,3,7],
        2022: [3,14,3,20],
        2023: [2,6,2,12],
        2024: [2,12,2,18],
        2025: [2,17,2,23],
        2026: [2,23,3,1],
        2027: [3,1,3,7],
        2028: [3,13,3,19],
      },
    ]
  },
  "Strakonice": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Šumperk": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Svitavy": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Tábor": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Tachov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Teplice": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Třebíč": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Trutnov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Uherské Hradiště": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Ústí nad Labem": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,3,2,9],
        2021: [2,8,2,14],
        2022: [2,21,2,27],
        2023: [2,27,3,5],
        2024: [3,4,3,10],
        2025: [3,10,3,16],
        2026: [2,2,2,8],
        2027: [2,8,2,14],
        2028: [2,21,2,27],
      },
    ]
  },
  "Ústí nad Orlicí": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,10,2,16],
        2021: [2,15,2,21],
        2022: [2,28,3,6],
        2023: [3,6,3,12],
        2024: [3,11,3,17],
        2025: [2,3,2,9],
        2026: [2,9,2,15],
        2027: [2,15,2,21],
        2028: [2,28,3,5],
      },
    ]
  },
  "Vsetín": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Vyškov": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  },
  "Žďár nad Sázavou": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,9,3,15],
        2021: [2,1,2,7],
        2022: [2,14,2,20],
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [3,3,3,9],
        2026: [3,9,3,15],
        2027: [2,1,2,7],
        2028: [2,14,2,20],
      },
    ]
  },
  "Zlín": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [3,2,3,8],
        2021: [3,8,3,14],
        2022: [2,7,2,13],
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,24,3,2],
        2026: [3,2,3,8],
        2027: [3,8,3,14],
        2028: [2,7,2,13],
      },
    ]
  },
  "Znojmom": {
    SH: [
      {
        name: "Jarní prázdniny",
        2020: [2,17,2,23],
        2021: [2,22,2,28],
        2022: [3,7,3,13],
        2023: [3,13,3,19],
        2024: [2,5,2,11],
        2025: [2,10,2,16],
        2026: [2,16,2,22],
        2027: [2,22,2,28],
        2028: [3,6,3,12],
      },
    ]
  }
};

const de = {
  PH: [{"name":"Neujahrstag","fixed_date":[1,1]},{"name":"Heilige Drei Könige","fixed_date":[1,6],"only_states":["Baden-Württemberg","Bayern","Sachsen-Anhalt"]},{"name":"Frauentag","fixed_date":[3,8],"only_states":["Berlin","Mecklenburg-Vorpommern"]},{"name":"Tag der Arbeit","fixed_date":[5,1]},{"name":"Karfreitag","variable_date":"easter","offset":-2},{"name":"Ostersonntag","variable_date":"easter","only_states":["Brandenburg"]},{"name":"Ostermontag","variable_date":"easter","offset":1},{"name":"Christi Himmelfahrt","variable_date":"easter","offset":39},{"name":"Pfingstsonntag","variable_date":"easter","offset":49,"only_states":["Brandenburg"]},{"name":"Pfingstmontag","variable_date":"easter","offset":50},{"name":"Fronleichnam","variable_date":"easter","offset":60,"only_states":["Baden-Württemberg","Bayern","Hessen","Nordrhein-Westfalen","Rheinland-Pfalz","Saarland"]},{"name":"Mariä Himmelfahrt","fixed_date":[8,15],"only_states":["Saarland"]},{"name":"Weltkindertag","fixed_date":[9,20],"only_states":["Thüringen"]},{"name":"Tag der Deutschen Einheit","fixed_date":[10,3]},{"name":"Reformationstag","fixed_date":[10,31],"only_states":["Brandenburg","Bremen","Hamburg","Mecklenburg-Vorpommern","Niedersachsen","Sachsen","Sachsen-Anhalt","Schleswig-Holstein","Thüringen"]},{"name":"Allerheiligen","fixed_date":[11,1],"only_states":["Baden-Württemberg","Bayern","Nordrhein-Westfalen","Rheinland-Pfalz","Saarland"]},{"name":"Buß- und Bettag","variable_date":"nextWednesday16Nov","only_states":["Sachsen"]},{"name":"1. Weihnachtstag","fixed_date":[12,25]},{"name":"2. Weihnachtstag","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=49.5487&lon=9.8160&zoom=18&addressdetails=1&accept-language=de,en",
  "Baden-Württemberg": {
    SH: [
      {
        name: "Osterferien",
        2012: [4,2,4,13],
        2013: [3,25,4,5],
        2014: [4,14,4,25],
        2015: [3,30,4,10],
        2016: [3,29,4,2],
        2017: [4,10,4,21],
        2018: [3,26,4,6],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [4,6,4,10],
        2022: [4,19,4,23],
        2023: [4,11,4,15],
        2024: [3,23,4,5],
        2025: [4,14,4,26],
        2026: [3,30,4,11],
        2027: [3,30,4,3],
        2028: [4,18,4,22],
        2029: [3,26,4,7],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,6,9],
        2013: [5,21,6,1],
        2014: [6,10,6,21],
        2015: [5,26,6,6],
        2016: [5,17,5,28],
        2017: [6,6,6,16],
        2018: [5,22,6,2],
        2019: [6,11,6,21],
        2020: [6,2,6,13],
        2021: [5,25,6,5],
        2022: [6,7,6,18],
        2023: [5,30,6,9],
        2024: [5,21,5,31],
        2025: [6,10,6,20],
        2026: [5,26,6,5],
        2027: [5,18,5,29],
        2028: [6,6,6,17],
        2029: [5,22,6,1],
        2030: [6,11,6,21],
      },
      {
        name: "Sommerferien",
        2012: [7,26,9,8],
        2013: [7,25,9,7],
        2014: [7,31,9,13],
        2015: [7,30,9,12],
        2016: [7,28,9,10],
        2017: [7,27,9,9],
        2018: [7,26,9,8],
        2019: [7,29,9,10],
        2020: [7,30,9,12],
        2021: [7,29,9,11],
        2022: [7,28,9,10],
        2023: [7,27,9,9],
        2024: [7,25,9,7],
        2025: [7,31,9,13],
        2026: [7,30,9,12],
        2027: [7,29,9,11],
        2028: [7,27,9,9],
        2029: [7,26,9,8],
        2030: [7,25,9,7],
      },
      {
        name: "Herbstferien",
        2012: [10,29,11,2],
        2013: [10,28,10,30],
        2014: [10,27,10,30],
        2015: [11,2,11,6],
        2016: [11,2,11,4],
        2017: [10,30,11,3],
        2018: [10,29,11,2],
        2019: [10,28,10,30],
        2020: [10,26,10,30],
        2021: [11,2,11,6],
        2022: [11,2,11,4],
        2023: [10,30,11,3],
        2024: [10,28,10,30],
        2025: [10,27,10,30],
        2026: [10,26,10,30],
        2027: [11,2,11,6],
        2028: [10,30,11,3],
        2029: [10,29,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,5],
        2012: [12,24,1,5],
        2013: [12,23,1,4],
        2014: [12,22,1,5],
        2015: [12,23,1,9],
        2016: [12,23,1,7],
        2017: [12,22,1,5],
        2018: [12,24,1,5],
        2019: [12,23,1,4],
        2020: [12,23,1,9],
        2021: [12,23,1,8],
        2022: [12,21,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,23,1,9],
        2027: [12,23,1,8],
        2028: [12,23,1,5],
        2029: [12,22,1,5],
      },
      {
        name: "Reformationsfest",
        2022: [10,31,10,31],
        2024: [10,31,10,31],
        2025: [10,31,10,31],
        2026: [10,31,10,31],
      },
      {
        name: "Gründonnerstag",
        2023: [4,6,4,6],
        2027: [3,25,3,25],
        2028: [4,13,4,13],
      },
    ]
  },
  "Bayern": {
    SH: [
      {
        name: "Winterferien",
        2012: [2,20,2,24],
        2013: [2,11,2,15],
        2014: [3,3,3,7],
        2015: [2,16,2,20],
        2016: [2,8,2,12],
        2017: [2,27,3,3],
        2018: [2,12,2,16],
        2019: [3,4,3,8],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,21,4,1],
        2017: [4,10,4,22],
        2018: [3,26,4,7],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,15],
        2024: [3,25,4,6],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,10,4,21],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,6,9],
        2013: [5,21,5,31],
        2014: [6,10,6,21],
        2015: [5,26,6,5],
        2016: [5,17,5,28],
        2017: [6,6,6,16],
        2018: [5,22,6,2],
        2019: [6,11,6,21],
        2020: [6,2,6,13],
        2021: [5,25,6,4],
        2022: [6,7,6,18],
        2023: [5,30,6,9],
        2024: [5,21,6,1],
        2025: [6,10,6,20],
        2026: [5,26,6,5],
        2027: [5,18,5,28],
        2028: [6,6,6,16],
        2029: [5,22,6,1],
        2030: [6,11,6,21],
      },
      {
        name: "Sommerferien",
        2012: [8,1,9,12],
        2013: [7,31,9,11],
        2014: [7,30,9,15],
        2015: [8,1,9,14],
        2016: [7,30,9,12],
        2017: [7,29,9,11],
        2018: [7,30,9,10],
        2019: [7,29,9,9],
        2020: [7,27,9,7],
        2021: [7,30,9,13],
        2022: [8,1,9,12],
        2023: [7,31,9,11],
        2024: [7,29,9,9],
        2025: [8,1,9,15],
        2026: [8,3,9,14],
        2027: [8,2,9,13],
        2028: [7,31,9,11],
        2029: [7,30,9,10],
        2030: [7,29,9,9],
      },
      {
        name: "Herbstferien",
        2012: [10,29,11,3],
        2013: [10,28,10,31],
        2014: [11,19,11,19],
        2015: [11,18,11,18],
        2016: [11,16,11,16],
        2017: [11,22,11,22],
        2018: [11,21,11,21],
        2019: [11,20,11,20],
        2020: [10,31,11,6],
        2021: [11,2,11,5],
        2022: [10,31,11,4],
        2023: [10,30,11,4],
        2024: [10,28,10,31],
        2025: [11,3,11,7],
        2026: [11,2,11,6],
        2027: [11,2,11,5],
        2028: [10,30,11,3],
        2029: [10,29,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,27,1,5],
        2012: [12,24,1,5],
        2013: [12,23,1,4],
        2014: [12,24,1,5],
        2015: [12,24,1,5],
        2016: [12,24,1,5],
        2017: [12,23,1,5],
        2018: [12,22,1,5],
        2019: [12,23,1,4],
        2020: [12,23,1,9],
        2021: [12,24,1,8],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,5],
        2026: [12,24,1,8],
        2027: [12,24,1,7],
        2028: [12,23,1,5],
        2029: [12,24,1,4],
      },
      {
        name: "Frühjahrsferien",
        2020: [2,24,2,28],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [2,12,2,16],
        2025: [3,3,3,7],
        2026: [2,16,2,20],
        2027: [2,8,2,12],
        2028: [2,28,3,3],
        2029: [2,12,2,16],
        2030: [3,4,3,8],
      },
      {
        name: "Buß- und Bettag",
        2020: [11,18,11,18],
        2021: [11,17,11,17],
        2022: [11,16,11,16],
        2023: [11,22,11,22],
        2024: [11,20,11,20],
        2025: [11,19,11,19],
        2026: [11,18,11,18],
        2027: [11,17,11,17],
        2028: [11,22,11,22],
        2029: [11,21,11,21],
        2030: [11,20,11,20],
      },
    ]
  },
  "Berlin": {
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,2,4],
        2013: [2,4,2,9],
        2014: [2,3,2,8],
        2015: [2,2,2,7],
        2016: [2,1,2,6],
        2017: [1,30,2,3],
        2018: [2,5,2,10],
        2019: [2,4,2,9],
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [1,30,2,4],
        2023: [1,30,2,4],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [2,1,2,6],
        2028: [1,31,2,5],
        2029: [1,29,2,3],
        2030: [2,4,2,9],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,25,4,6],
        2014: [5,2,5,2],
        2015: [3,30,4,11],
        2016: [3,21,4,2],
        2017: [4,10,4,18],
        2018: [3,26,4,6],
        2019: [4,15,4,26],
        2020: [4,6,4,17],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,14],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,10,4,22],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,21,5,21],
        2014: [5,30,5,30],
        2015: [5,26,5,26],
        2016: [5,17,5,18],
        2017: [6,6,6,9],
        2018: [5,22,5,22],
        2019: [6,11,6,11],
        2022: [6,7,6,7],
        2023: [5,30,5,30],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,19],
        2028: [6,1,6,2],
        2029: [5,22,5,25],
        2030: [6,7,6,7],
      },
      {
        name: "Sommerferien",
        2012: [6,20,8,3],
        2013: [6,19,8,2],
        2014: [7,9,8,22],
        2015: [7,16,8,28],
        2016: [7,21,9,2],
        2017: [7,20,9,1],
        2018: [7,5,8,17],
        2019: [6,20,8,2],
        2020: [6,25,8,7],
        2021: [6,24,8,6],
        2022: [7,7,8,18],
        2023: [7,13,8,25],
        2024: [7,18,8,30],
        2025: [7,24,9,6],
        2026: [7,9,8,22],
        2027: [7,1,8,14],
        2028: [7,1,8,12],
        2029: [7,1,8,11],
        2030: [7,4,8,17],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,13],
        2013: [9,30,10,12],
        2014: [10,20,11,1],
        2015: [10,19,10,31],
        2016: [10,17,10,28],
        2017: [10,23,11,4],
        2018: [10,22,11,2],
        2019: [10,7,10,19],
        2020: [10,12,10,24],
        2021: [10,11,10,23],
        2022: [10,24,11,5],
        2023: [10,23,11,4],
        2024: [10,21,11,2],
        2025: [10,20,11,1],
        2026: [10,19,10,31],
        2027: [10,11,10,23],
        2028: [10,2,10,14],
        2029: [10,1,10,12],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,3],
        2012: [12,24,1,4],
        2013: [12,23,1,3],
        2014: [12,22,1,2],
        2015: [12,23,1,2],
        2016: [12,23,1,3],
        2017: [12,21,1,2],
        2018: [12,22,1,5],
        2019: [12,23,1,4],
        2020: [12,21,1,2],
        2021: [12,23,12,31],
        2022: [12,22,1,2],
        2023: [12,23,1,5],
        2024: [12,23,12,31],
        2025: [12,22,1,2],
        2026: [12,23,1,2],
        2027: [12,22,12,31],
        2028: [12,22,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Unterrichtsfreier Tag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [10,2,10,2],
        2024: [10,4,10,4],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  },
  "Brandenburg": {
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,2,4],
        2013: [2,4,2,9],
        2014: [2,3,2,8],
        2015: [2,2,2,7],
        2016: [2,1,2,6],
        2017: [1,30,2,4],
        2018: [2,5,2,10],
        2019: [2,4,2,9],
        2020: [2,3,2,8],
        2021: [2,1,2,6],
        2022: [1,31,2,5],
        2023: [1,30,2,3],
        2024: [2,5,2,9],
        2025: [2,3,2,8],
        2026: [2,2,2,7],
        2027: [2,1,2,6],
        2028: [1,31,2,5],
        2029: [1,29,2,3],
        2030: [2,4,2,9],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,27,4,6],
        2014: [5,2,5,2],
        2015: [4,1,4,11],
        2016: [3,23,4,2],
        2017: [4,10,4,22],
        2018: [3,26,4,6],
        2019: [4,15,4,26],
        2020: [4,6,4,17],
        2021: [3,29,4,9],
        2022: [4,11,4,24],
        2023: [4,3,4,14],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,10,5,10],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,17,5,17],
        2017: [5,26,5,26],
        2018: [5,11,5,11],
        2019: [5,31,5,31],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2029: [5,22,5,22],
      },
      {
        name: "Sommerferien",
        2012: [6,21,8,3],
        2013: [6,20,8,2],
        2014: [7,10,8,22],
        2015: [7,16,8,28],
        2016: [7,21,9,3],
        2017: [7,20,9,1],
        2018: [7,5,8,18],
        2019: [6,20,8,3],
        2020: [6,25,8,8],
        2021: [6,24,8,7],
        2022: [7,7,8,20],
        2023: [7,13,8,26],
        2024: [7,18,8,31],
        2025: [7,24,9,6],
        2026: [7,9,8,22],
        2027: [7,1,8,14],
        2028: [6,29,8,12],
        2029: [6,28,8,11],
        2030: [7,4,8,17],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,13],
        2013: [11,1,11,1],
        2014: [10,20,11,1],
        2015: [10,19,10,30],
        2016: [10,17,10,28],
        2017: [10,23,11,4],
        2018: [10,22,11,2],
        2019: [11,1,11,1],
        2020: [10,12,10,24],
        2021: [10,11,10,23],
        2022: [10,24,11,5],
        2023: [10,23,11,4],
        2024: [10,21,11,2],
        2025: [10,20,11,1],
        2026: [10,19,10,30],
        2027: [10,11,10,23],
        2028: [10,2,10,14],
        2029: [10,1,10,12],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,3],
        2012: [12,24,1,4],
        2013: [12,23,1,3],
        2014: [12,22,1,2],
        2015: [12,23,1,2],
        2016: [12,23,1,3],
        2017: [12,21,1,2],
        2018: [12,21,1,5],
        2019: [12,23,1,3],
        2020: [12,21,1,2],
        2021: [12,23,12,31],
        2022: [12,22,1,3],
        2023: [12,23,1,5],
        2024: [12,23,12,31],
        2025: [12,22,1,2],
        2026: [12,23,1,2],
        2027: [12,23,12,31],
        2028: [12,22,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Variabler Ferientag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [10,2,10,2],
        2024: [10,4,10,4],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [10,30,10,30],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  },
  "Bremen": {
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,1,31],
        2013: [1,31,2,1],
        2014: [1,30,1,31],
        2015: [2,2,2,3],
        2016: [1,28,1,29],
        2017: [1,30,1,31],
        2018: [2,1,2,2],
        2019: [1,31,2,1],
      },
      {
        name: "Halbjahresferien",
        2021: [2,1,2,2],
        2022: [1,31,2,1],
        2023: [1,30,1,31],
        2024: [2,1,2,2],
        2025: [2,3,2,4],
        2026: [2,2,2,3],
        2027: [2,1,2,2],
        2028: [1,31,2,1],
        2029: [2,1,2,2],
        2030: [1,31,2,1],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,16,4,2],
        2014: [5,2,5,2],
        2015: [3,25,4,10],
        2016: [3,18,4,2],
        2017: [4,10,4,22],
        2018: [3,19,4,3],
        2019: [4,6,4,23],
        2021: [3,27,4,10],
        2022: [4,4,4,19],
        2023: [3,27,4,11],
        2024: [3,18,3,28],
        2025: [4,7,4,19],
        2026: [3,23,4,7],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,19,4,3],
        2030: [4,8,4,23],
      },
      {
        name: "Kirchentag und Tag nach dem 1. Mai",
        2025: [4,30,5,2],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,5,29],
        2013: [5,21,5,21],
        2014: [6,10,6,10],
        2015: [5,26,5,26],
        2016: [5,17,5,17],
        2017: [6,6,6,6],
        2018: [5,22,5,22],
        2019: [6,11,6,11],
        2021: [5,25,5,25],
        2022: [6,7,6,7],
        2023: [5,30,5,30],
        2024: [5,21,5,21],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2028: [6,6,6,6],
        2029: [5,22,5,22],
        2030: [6,11,6,11],
      },
      {
        name: "Tag nach Himmelfahrt",
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [6,27,8,7],
        2014: [7,31,9,10],
        2015: [7,23,9,2],
        2016: [6,23,8,3],
        2017: [6,22,8,2],
        2018: [6,28,8,8],
        2019: [7,4,8,14],
        2020: [7,16,8,26],
        2021: [7,22,9,1],
        2022: [7,14,8,24],
        2023: [7,6,8,16],
        2024: [6,24,8,2],
        2025: [7,3,8,13],
        2026: [7,2,8,12],
        2027: [7,8,8,18],
        2028: [7,20,8,30],
        2029: [7,19,8,29],
        2030: [7,11,8,21],
      },
      {
        name: "Tag vor dem 3. Oktober",
        2023: [10,2,10,2],
        2028: [10,2,10,2],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,4,10,18],
        2014: [10,27,11,8],
        2015: [10,19,10,31],
        2016: [10,4,10,15],
        2017: [10,30,10,30],
        2018: [10,1,10,13],
        2019: [10,4,10,18],
        2020: [10,12,10,24],
        2021: [10,18,10,30],
        2022: [10,17,10,29],
        2023: [10,16,10,30],
        2024: [10,4,10,19],
        2025: [10,13,10,25],
        2026: [10,12,10,24],
        2027: [10,18,10,30],
        2028: [10,23,11,4],
        2029: [10,22,11,2],
      },
      {
        name: "Tag nach dem Reformationstag",
        2024: [11,1,11,1],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,4],
        2012: [12,24,1,5],
        2013: [12,23,1,3],
        2014: [12,22,1,5],
        2015: [12,23,1,6],
        2016: [12,21,1,6],
        2017: [12,22,1,6],
        2018: [12,24,1,4],
        2019: [12,21,1,6],
        2020: [12,23,1,8],
        2021: [12,23,1,8],
        2022: [12,23,1,6],
        2023: [12,23,1,5],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,23,1,9],
        2027: [12,23,1,8],
        2028: [12,27,1,6],
        2029: [12,21,1,5],
      },
      {
        name: "Tag vor dem 1. Mai",
        2029: [4,30,4,30],
      },
      {
        name: "Tage nach dem 3. Oktober",
        2029: [10,4,10,5],
      },
    ]
  },
  "Hamburg": {
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,1,30],
        2013: [2,1,2,1],
        2014: [1,31,1,31],
        2015: [1,30,1,30],
        2016: [1,29,1,29],
        2017: [1,30,1,30],
        2018: [2,2,2,2],
        2019: [2,1,2,1],
      },
      {
        name: "Osterferien",
        2012: [3,5,3,16],
        2013: [3,4,3,15],
        2014: [3,3,3,14],
        2015: [3,2,3,13],
        2016: [3,7,3,18],
        2017: [3,6,3,17],
        2018: [4,30,4,30],
        2019: [3,4,3,15],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,2,5,10],
        2014: [5,30,5,30],
        2015: [5,11,5,15],
        2016: [5,17,5,20],
        2017: [5,22,5,26],
        2018: [5,7,5,11],
        2019: [5,31,5,31],
        2020: [5,18,5,22],
        2021: [5,10,5,14],
        2022: [5,23,5,27],
        2023: [5,15,5,19],
        2024: [5,21,5,24],
        2025: [5,26,5,30],
        2026: [5,11,5,15],
        2027: [5,7,5,14],
        2028: [5,22,5,26],
        2029: [5,11,5,18],
        2030: [5,20,5,24],
      },
      {
        name: "Sommerferien",
        2012: [6,21,8,1],
        2013: [6,20,7,31],
        2014: [7,10,8,20],
        2015: [7,16,8,26],
        2016: [7,21,8,31],
        2017: [7,20,8,30],
        2018: [7,5,8,15],
        2019: [6,27,8,7],
        2020: [6,25,8,5],
        2021: [6,24,8,4],
        2022: [7,7,8,17],
        2023: [7,13,8,23],
        2024: [7,18,8,28],
        2025: [7,24,9,3],
        2026: [7,9,8,19],
        2027: [7,1,8,11],
        2028: [7,3,8,11],
        2029: [7,2,8,10],
        2030: [7,4,8,14],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,12],
        2013: [9,30,10,11],
        2014: [10,13,10,24],
        2015: [10,19,10,30],
        2016: [10,17,10,28],
        2017: [10,16,10,27],
        2018: [10,1,10,12],
        2019: [10,4,10,18],
        2020: [10,5,10,16],
        2021: [10,4,10,15],
        2022: [10,10,10,21],
        2023: [10,16,10,27],
        2024: [10,21,11,1],
        2025: [10,20,10,31],
        2026: [10,19,10,30],
        2027: [10,11,10,22],
        2028: [10,2,10,13],
        2029: [10,1,10,12],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,27,1,6],
        2012: [12,21,1,4],
        2013: [12,19,1,3],
        2014: [12,22,1,6],
        2015: [12,21,1,1],
        2016: [12,27,1,6],
        2017: [12,22,1,5],
        2018: [12,20,1,4],
        2019: [12,20,1,3],
        2020: [12,21,1,4],
        2021: [12,23,1,4],
        2022: [12,23,1,6],
        2023: [12,22,1,5],
        2024: [12,20,1,3],
        2025: [12,17,1,2],
        2026: [12,21,1,1],
        2027: [12,20,12,31],
        2028: [12,18,12,29],
        2029: [12,21,1,4],
      },
      {
        name: "Halbjahrespause",
        2020: [1,31,1,31],
        2021: [1,29,1,29],
        2022: [1,28,1,28],
        2023: [1,27,1,27],
        2024: [2,2,2,2],
        2025: [1,31,1,31],
        2026: [1,30,1,30],
        2027: [1,29,1,29],
        2028: [1,28,1,28],
        2029: [2,2,2,2],
        2030: [2,1,2,1],
      },
      {
        name: "Frühjahrsferien",
        2020: [3,2,3,13],
        2021: [3,1,3,12],
        2022: [3,7,3,18],
        2023: [3,6,3,17],
        2024: [3,18,3,28],
        2025: [3,10,3,21],
        2026: [3,2,3,13],
        2027: [3,1,3,12],
        2028: [3,6,3,17],
        2029: [3,5,3,16],
        2030: [3,4,3,15],
      },
      {
        name: "Brückentag",
        2023: [10,2,10,2],
        2024: [10,4,10,4],
        2025: [5,2,5,2],
        2028: [10,30,10,30],
        2030: [5,31,5,31],
      },
    ]
  },
  "Hessen": {
    SH: [
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,29,4,9],
        2017: [4,3,4,15],
        2018: [3,26,4,7],
        2019: [4,14,4,27],
        2020: [4,6,4,18],
        2021: [4,6,4,16],
        2022: [4,11,4,23],
        2023: [4,3,4,22],
        2024: [3,25,4,13],
        2025: [4,7,4,21],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,3,4,14],
        2029: [3,29,4,13],
        2030: [4,8,4,22],
      },
      {
        name: "Sommerferien",
        2012: [7,2,8,10],
        2013: [7,8,8,16],
        2014: [7,28,9,5],
        2015: [7,27,9,4],
        2016: [7,18,8,26],
        2017: [7,3,8,11],
        2018: [6,25,8,3],
        2019: [7,1,8,9],
        2020: [7,6,8,14],
        2021: [7,19,8,27],
        2022: [7,25,9,2],
        2023: [7,24,9,1],
        2024: [7,15,8,23],
        2025: [7,7,8,15],
        2026: [6,29,8,7],
        2027: [6,28,8,6],
        2028: [7,3,8,11],
        2029: [7,16,8,24],
        2030: [7,22,8,30],
      },
      {
        name: "Herbstferien",
        2012: [10,15,10,27],
        2013: [10,14,10,26],
        2014: [10,20,11,1],
        2015: [10,19,10,31],
        2016: [10,17,10,29],
        2017: [10,9,10,21],
        2018: [10,1,10,13],
        2019: [9,30,10,12],
        2020: [10,5,10,17],
        2021: [10,11,10,23],
        2022: [10,24,10,29],
        2023: [10,23,10,28],
        2024: [10,14,10,25],
        2025: [10,6,10,18],
        2026: [10,5,10,17],
        2027: [10,4,10,16],
        2028: [10,9,10,20],
        2029: [10,15,10,26],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,21,1,6],
        2012: [12,24,1,12],
        2013: [12,23,1,11],
        2014: [12,22,1,10],
        2015: [12,23,1,9],
        2016: [12,22,1,7],
        2017: [12,24,1,13],
        2018: [12,24,1,12],
        2019: [12,23,1,11],
        2020: [12,21,1,9],
        2021: [12,23,1,8],
        2022: [12,22,1,7],
        2023: [12,27,1,13],
        2024: [12,23,1,10],
        2025: [12,22,1,10],
        2026: [12,23,1,12],
        2027: [12,23,1,11],
        2028: [12,27,1,12],
        2029: [12,24,1,11],
      },
    ]
  },
  "MV-ABS": {
    SH: [
      {
        name: "Winterferien",
        2012: [2,6,2,17],
        2013: [2,4,2,15],
        2014: [2,3,2,15],
        2015: [2,2,2,14],
        2016: [2,1,2,13],
        2017: [2,6,2,18],
        2018: [2,5,2,16],
        2019: [2,4,2,15],
        2020: [2,10,2,21],
        2021: [2,6,2,18],
        2022: [2,5,2,17],
        2023: [2,6,2,18],
        2024: [2,5,2,16],
        2025: [2,3,2,14],
        2026: [2,9,2,20],
        2027: [2,8,2,19],
        2028: [2,5,2,17],
        2029: [2,5,2,16],
        2030: [2,4,2,15],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,11],
        2013: [3,25,4,3],
        2014: [4,14,4,23],
        2015: [3,30,4,8],
        2016: [3,21,3,30],
        2017: [4,10,4,19],
        2018: [3,26,4,4],
        2019: [4,15,4,24],
        2020: [4,6,4,15],
        2021: [3,29,4,7],
        2022: [4,11,4,20],
        2023: [4,3,4,12],
        2024: [3,25,4,3],
        2025: [4,14,4,23],
        2026: [3,30,4,8],
        2027: [3,24,4,2],
        2028: [4,12,4,21],
        2029: [3,28,4,6],
        2030: [4,17,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,25,5,29],
        2013: [5,17,5,21],
        2014: [6,6,6,10],
        2015: [5,22,5,26],
        2016: [5,14,5,17],
        2017: [6,2,6,6],
        2018: [5,18,5,22],
        2019: [6,7,6,11],
        2020: [5,29,6,2],
        2021: [5,21,5,25],
        2022: [6,3,6,7],
        2023: [5,26,5,30],
        2024: [5,17,5,21],
        2025: [6,6,6,10],
        2026: [5,22,5,26],
        2027: [5,14,5,18],
        2028: [6,2,6,6],
        2029: [5,18,5,22],
        2030: [6,7,6,11],
      },
      {
        name: "Sommerferien",
        2012: [6,23,8,4],
        2013: [6,22,8,3],
        2014: [7,14,8,23],
        2015: [7,20,8,29],
        2016: [7,25,9,3],
        2017: [7,24,9,2],
        2018: [7,9,8,18],
        2019: [7,1,8,10],
        2020: [6,22,8,1],
        2021: [6,21,7,31],
        2022: [7,4,8,13],
        2023: [7,17,8,26],
        2024: [7,22,8,31],
        2025: [7,28,9,6],
        2026: [7,13,8,22],
        2027: [7,5,8,14],
        2028: [6,26,8,5],
        2029: [6,18,7,28],
        2030: [7,1,8,10],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,5],
        2013: [10,14,10,19],
        2014: [10,20,10,25],
        2015: [10,24,10,30],
        2016: [10,24,10,28],
        2017: [10,23,10,30],
        2018: [11,1,11,2],
        2019: [11,1,11,1],
        2020: [10,5,10,10],
        2021: [10,2,10,9],
        2022: [10,10,10,14],
        2023: [10,9,10,14],
        2024: [10,21,10,26],
        2025: [10,20,10,24],
        2026: [10,15,10,24],
        2027: [10,14,10,23],
        2028: [10,23,10,28],
        2029: [10,22,10,27],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,3],
        2012: [12,21,1,4],
        2013: [12,23,1,3],
        2014: [12,22,1,2],
        2015: [12,21,1,2],
        2016: [12,22,1,2],
        2017: [12,21,1,3],
        2018: [12,24,1,5],
        2019: [12,23,1,4],
        2020: [12,21,1,2],
        2021: [12,22,12,31],
        2022: [12,22,1,2],
        2023: [12,21,1,3],
        2024: [12,23,1,6],
        2025: [12,20,1,3],
        2026: [12,21,1,2],
        2027: [12,22,1,4],
        2028: [12,22,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Zusätzlicher Ferientag",
        2020: [11,3,11,3],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [11,1,11,1],
        2024: [11,1,11,1],
        2025: [11,3,11,3],
        2026: [11,27,11,27],
        2027: [11,26,11,26],
        2028: [10,30,10,30],
        2029: [10,30,10,30],
        2030: [5,31,5,31],
      },
      {
        name: "Schulfrei",
        2021: [2,19,2,19],
        2022: [2,18,2,18],
        2028: [2,18,2,18],
      },
    ]
  },
  "MV-BBS": {
    SH: [
      {
        name: "Winterferien",
        2020: [2,10,2,15],
        2021: [2,5,2,13],
        2022: [2,5,2,12],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [2,3,2,8],
        2026: [2,9,2,14],
        2027: [2,8,2,13],
        2028: [2,5,2,12],
        2029: [2,5,2,10],
        2030: [2,4,2,9],
      },
      {
        name: "Osterferien",
        2020: [4,6,4,17],
        2021: [3,29,4,9],
        2022: [4,11,4,22],
        2023: [4,3,4,15],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,12,4,21],
        2029: [3,28,4,6],
        2030: [4,17,4,26],
      },
      {
        name: "Sommerferien",
        2020: [7,13,8,29],
        2021: [7,12,8,28],
        2022: [7,11,8,27],
        2023: [7,17,9,1],
        2024: [7,15,8,31],
        2025: [7,14,8,30],
        2026: [7,13,8,29],
        2027: [7,12,8,28],
        2028: [7,17,9,2],
        2029: [7,16,9,1],
        2030: [7,15,8,31],
      },
      {
        name: "Herbstferien",
        2020: [10,5,10,10],
        2021: [10,2,10,9],
        2022: [10,10,10,15],
        2023: [10,9,10,14],
        2024: [10,21,10,26],
        2025: [10,20,10,25],
        2026: [10,19,10,24],
        2027: [10,16,10,23],
        2028: [10,23,10,28],
        2029: [10,22,10,27],
      },
      {
        name: "Weihnachtsferien",
        2019: [12,23,1,4],
        2020: [12,21,1,2],
        2021: [12,22,1,3],
        2022: [12,22,1,2],
        2023: [12,21,1,3],
        2024: [12,23,1,4],
        2025: [12,22,1,3],
        2026: [12,19,1,2],
        2027: [12,22,12,31],
        2028: [12,21,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Zusätzlicher Ferientag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [10,28,10,28],
        2023: [10,30,10,30],
        2024: [11,1,11,1],
        2025: [11,3,11,3],
        2026: [11,27,11,27],
        2027: [11,26,11,26],
        2028: [10,30,10,30],
        2029: [10,30,10,30],
        2030: [5,31,5,31],
      },
    ]
  },
  "Niedersachsen": {
    SH: [
      {
        name: "Winterferien",
        2012: [1,30,1,31],
        2013: [1,31,2,1],
        2014: [1,30,1,31],
        2015: [2,2,2,3],
        2016: [1,28,1,29],
        2017: [1,30,1,31],
        2018: [2,1,2,2],
        2019: [1,31,2,1],
      },
      {
        name: "Halbjahresferien",
        2020: [2,3,2,4],
        2021: [2,1,2,2],
        2022: [1,31,2,1],
        2023: [1,30,1,31],
        2024: [2,1,2,2],
        2025: [2,3,2,4],
        2026: [2,2,2,3],
        2027: [2,1,2,2],
        2028: [1,31,2,1],
        2029: [2,1,2,2],
        2030: [1,31,2,1],
      },
      {
        name: "Osterferien",
        2012: [4,30,4,30],
        2013: [3,16,4,2],
        2014: [5,2,5,2],
        2015: [3,25,4,10],
        2016: [3,18,4,2],
        2017: [4,10,4,22],
        2018: [3,19,4,3],
        2019: [4,8,4,23],
        2020: [3,30,4,14],
        2021: [3,29,4,9],
        2022: [4,4,4,19],
        2023: [3,27,4,11],
        2024: [3,18,3,28],
        2025: [4,7,4,19],
        2026: [3,23,4,7],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,19,4,3],
        2030: [4,8,4,23],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,5,29],
        2013: [5,21,5,21],
        2014: [6,10,6,10],
        2015: [5,26,5,26],
        2016: [5,17,5,17],
        2017: [6,6,6,6],
        2018: [5,22,5,22],
        2019: [6,11,6,11],
        2020: [6,2,6,2],
        2021: [5,25,5,25],
        2022: [6,7,6,7],
        2023: [5,30,5,30],
        2024: [5,21,5,21],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2028: [6,6,6,6],
        2029: [5,22,5,22],
        2030: [6,11,6,11],
      },
      {
        name: "Tag nach Himmelfahrt",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [6,27,8,7],
        2014: [7,31,9,10],
        2015: [7,23,9,2],
        2016: [6,23,8,3],
        2017: [6,22,8,2],
        2018: [6,28,8,8],
        2019: [7,4,8,14],
        2020: [7,16,8,26],
        2021: [7,22,9,1],
        2022: [7,14,8,24],
        2023: [7,6,8,16],
        2024: [6,24,8,3],
        2025: [7,3,8,13],
        2026: [7,2,8,12],
        2027: [7,8,8,18],
        2028: [7,20,8,30],
        2029: [7,19,8,29],
        2030: [7,11,8,21],
      },
      {
        name: "Tag vor dem 3. Oktober",
        2023: [10,2,10,2],
        2028: [10,2,10,2],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,4,10,18],
        2014: [10,27,11,8],
        2015: [10,19,10,31],
        2016: [10,4,10,15],
        2017: [10,30,10,30],
        2018: [10,1,10,12],
        2019: [10,4,10,18],
        2020: [10,12,10,23],
        2021: [10,18,10,29],
        2022: [10,17,10,28],
        2023: [10,16,10,30],
        2024: [10,4,10,19],
        2025: [10,13,10,25],
        2026: [10,12,10,24],
        2027: [10,16,10,30],
        2028: [10,23,11,4],
        2029: [10,22,11,2],
      },
      {
        name: "Tag nach dem Reformationstag",
        2024: [11,1,11,1],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,4],
        2012: [12,24,1,5],
        2013: [12,23,1,3],
        2014: [12,22,1,5],
        2015: [12,23,1,6],
        2016: [12,21,1,6],
        2017: [12,22,1,5],
        2018: [12,24,1,4],
        2019: [12,23,1,6],
        2020: [12,23,1,8],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,27,1,5],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,23,1,9],
        2027: [12,23,1,8],
        2028: [12,27,1,6],
        2029: [12,21,1,5],
      },
      {
        name: "Kirchentag",
        2025: [4,30,4,30],
      },
      {
        name: "Tag nach dem 1. Mai",
        2025: [5,2,5,2],
      },
      {
        name: "Tag vor dem 1. Mai",
        2029: [4,30,4,30],
      },
      {
        name: "Tage nach dem 3. Oktober",
        2029: [10,4,10,5],
      },
    ]
  },
  "Nordrhein-Westfalen": {
    SH: [
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,21,4,2],
        2017: [4,10,4,22],
        2018: [3,26,4,7],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,15],
        2024: [3,25,4,6],
        2025: [4,14,4,26],
        2026: [3,30,4,11],
        2027: [3,22,4,3],
        2028: [4,10,4,22],
        2029: [3,26,4,7],
        2030: [4,15,4,27],
      },
      {
        name: "Pfingstferien",
        2012: [5,29,5,29],
        2013: [5,21,5,21],
        2014: [6,10,6,10],
        2015: [5,26,5,26],
        2016: [5,17,5,17],
        2017: [6,6,6,6],
        2018: [5,22,5,25],
        2019: [6,11,6,11],
        2020: [6,2,6,2],
        2021: [5,25,5,25],
        2023: [5,30,5,30],
        2024: [5,21,5,21],
        2025: [6,10,6,10],
        2026: [5,26,5,26],
        2027: [5,18,5,18],
        2029: [5,22,5,22],
      },
      {
        name: "Sommerferien",
        2012: [7,9,8,21],
        2013: [7,22,9,3],
        2014: [7,7,8,19],
        2015: [6,29,8,11],
        2016: [7,11,8,23],
        2017: [7,17,8,29],
        2018: [7,16,8,28],
        2019: [7,15,8,27],
        2020: [6,29,8,11],
        2021: [7,5,8,17],
        2022: [6,27,8,9],
        2023: [6,22,8,4],
        2024: [7,8,8,20],
        2025: [7,14,8,26],
        2026: [7,20,9,1],
        2027: [7,19,8,31],
        2028: [7,10,8,22],
        2029: [7,2,8,14],
        2030: [6,24,8,6],
      },
      {
        name: "Herbstferien",
        2012: [10,8,10,20],
        2013: [10,21,11,2],
        2014: [10,6,10,18],
        2015: [10,5,10,17],
        2016: [10,10,10,21],
        2017: [10,23,11,4],
        2018: [10,15,10,27],
        2019: [10,14,10,26],
        2020: [10,12,10,24],
        2021: [10,11,10,23],
        2022: [10,4,10,15],
        2023: [10,2,10,14],
        2024: [10,14,10,26],
        2025: [10,13,10,25],
        2026: [10,17,10,31],
        2027: [10,23,11,6],
        2028: [10,23,11,4],
        2029: [10,15,10,27],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,6],
        2012: [12,21,1,4],
        2013: [12,23,1,7],
        2014: [12,22,1,6],
        2015: [12,23,1,6],
        2016: [12,23,1,6],
        2017: [12,27,1,6],
        2018: [12,21,1,4],
        2019: [12,23,1,6],
        2020: [12,21,1,6],
        2021: [12,24,1,8],
        2022: [12,23,1,6],
        2023: [12,21,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
        2026: [12,23,1,6],
        2027: [12,24,1,8],
        2028: [12,21,1,5],
        2029: [12,20,1,4],
      },
    ]
  },
  "Rheinland-Pfalz": {
    SH: [
      {
        name: "Winterferien",
        2019: [2,25,3,1],
        2020: [2,17,2,21],
        2022: [2,21,2,25],
      },
      {
        name: "Osterferien",
        2012: [3,29,4,13],
        2013: [3,20,4,5],
        2014: [4,11,4,25],
        2015: [3,26,4,10],
        2016: [3,18,4,1],
        2017: [4,10,4,21],
        2018: [3,26,4,6],
        2019: [4,23,4,30],
        2020: [4,9,4,17],
        2021: [3,29,4,6],
        2022: [4,13,4,22],
        2023: [4,3,4,6],
        2024: [3,25,4,2],
        2025: [4,14,4,25],
        2026: [3,30,4,10],
        2027: [3,22,4,2],
        2028: [4,10,4,21],
        2029: [3,26,4,6],
        2030: [4,15,4,30],
      },
      {
        name: "Pfingstferien",
        2021: [5,25,6,2],
        2023: [5,30,6,7],
        2024: [5,21,5,29],
      },
      {
        name: "Sommerferien",
        2012: [7,2,8,10],
        2013: [7,8,8,16],
        2014: [7,28,9,5],
        2015: [7,27,9,4],
        2016: [7,18,8,26],
        2017: [7,3,8,11],
        2018: [6,25,8,3],
        2019: [7,1,8,9],
        2020: [7,6,8,14],
        2021: [7,19,8,27],
        2022: [7,25,9,2],
        2023: [7,24,9,1],
        2024: [7,15,8,23],
        2025: [7,7,8,15],
        2026: [6,29,8,7],
        2027: [6,28,8,6],
        2028: [7,3,8,11],
        2029: [7,16,8,24],
        2030: [7,22,8,30],
      },
      {
        name: "Herbstferien",
        2012: [10,1,10,12],
        2013: [10,4,10,18],
        2014: [10,20,10,31],
        2015: [10,19,10,30],
        2016: [10,10,10,21],
        2017: [10,2,10,13],
        2018: [10,1,10,12],
        2019: [9,30,10,11],
        2020: [10,12,10,23],
        2021: [10,11,10,22],
        2022: [10,17,10,31],
        2023: [10,16,10,27],
        2024: [10,14,10,25],
        2025: [10,13,10,24],
        2026: [10,5,10,16],
        2027: [10,4,10,15],
        2028: [10,9,10,20],
        2029: [10,22,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,22,1,6],
        2012: [12,20,1,4],
        2013: [12,23,1,7],
        2014: [12,22,1,7],
        2015: [12,23,1,8],
        2016: [12,22,1,6],
        2017: [12,22,1,9],
        2018: [12,20,1,4],
        2019: [12,23,1,6],
        2020: [12,21,12,31],
        2021: [12,23,12,31],
        2022: [12,23,1,2],
        2023: [12,27,1,5],
        2024: [12,23,1,8],
        2025: [12,22,1,7],
        2026: [12,23,1,8],
        2027: [12,23,1,7],
        2028: [12,21,1,8],
        2029: [12,24,1,9],
      },
    ]
  },
  "Saarland": {
    SH: [
      {
        name: "Winterferien",
        2012: [2,20,2,25],
        2013: [2,11,2,16],
        2014: [3,3,3,8],
        2015: [2,16,2,21],
        2016: [2,8,2,13],
        2017: [2,27,3,4],
        2018: [2,12,2,17],
        2019: [2,25,3,5],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,14],
        2013: [3,25,4,6],
        2014: [4,14,4,26],
        2015: [3,30,4,11],
        2016: [3,29,4,9],
        2017: [4,10,4,22],
        2018: [3,26,4,6],
        2019: [4,17,4,26],
        2020: [4,14,4,24],
        2021: [3,29,4,7],
        2022: [4,14,4,22],
        2023: [4,3,4,12],
        2024: [3,25,4,5],
        2025: [4,14,4,25],
        2026: [4,7,4,17],
        2027: [3,30,4,9],
        2028: [4,12,4,21],
        2029: [3,26,4,6],
        2030: [4,15,4,26],
      },
      {
        name: "Pfingstferien",
        2021: [5,25,5,28],
        2022: [6,7,6,10],
        2023: [5,30,6,2],
        2024: [5,21,5,24],
        2029: [5,22,5,25],
      },
      {
        name: "Sommerferien",
        2012: [7,2,8,14],
        2013: [7,8,8,17],
        2014: [7,28,9,6],
        2015: [7,27,9,5],
        2016: [7,18,8,27],
        2017: [7,3,8,14],
        2018: [6,25,8,3],
        2019: [7,1,8,9],
        2020: [7,6,8,14],
        2021: [7,19,8,27],
        2022: [7,25,9,2],
        2023: [7,24,9,1],
        2024: [7,15,8,23],
        2025: [7,7,8,14],
        2026: [6,29,8,7],
        2027: [6,28,8,6],
        2028: [7,3,8,11],
        2029: [7,16,8,24],
        2030: [7,22,8,30],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,21,11,2],
        2014: [10,20,10,31],
        2015: [10,19,10,31],
        2016: [10,10,10,22],
        2017: [10,2,10,14],
        2018: [10,1,10,12],
        2019: [10,7,10,18],
        2020: [10,12,10,23],
        2021: [10,18,10,29],
        2022: [10,24,11,4],
        2023: [10,23,11,3],
        2024: [10,14,10,25],
        2025: [10,13,10,24],
        2026: [10,5,10,16],
        2027: [10,4,10,15],
        2028: [10,9,10,20],
        2029: [10,22,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,4],
        2012: [12,24,1,5],
        2013: [12,20,1,4],
        2014: [12,22,1,7],
        2015: [12,21,1,2],
        2016: [12,19,12,31],
        2017: [12,21,1,5],
        2018: [12,20,1,4],
        2019: [12,23,1,3],
        2020: [12,21,12,31],
        2021: [12,23,1,3],
        2022: [12,22,1,4],
        2023: [12,21,1,2],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,21,12,31],
        2027: [12,20,12,31],
        2028: [12,20,1,2],
        2029: [12,21,1,4],
      },
      {
        name: "Fastnachtsferien",
        2020: [2,17,2,25],
        2021: [2,15,2,19],
        2022: [2,21,3,1],
        2023: [2,20,2,24],
        2024: [2,12,2,16],
        2025: [2,24,3,4],
        2026: [2,16,2,20],
        2027: [2,8,2,12],
        2028: [2,21,2,29],
        2029: [2,12,2,16],
        2030: [2,25,3,5],
      },
    ]
  },
  "Sachsen": {
    SH: [
      {
        name: "Winterferien",
        2012: [2,13,2,25],
        2013: [2,4,2,15],
        2014: [2,17,3,1],
        2015: [2,9,2,21],
        2016: [2,8,2,20],
        2017: [2,13,2,24],
        2018: [2,12,2,23],
        2019: [2,18,3,2],
        2020: [2,10,2,22],
        2021: [1,31,2,6],
        2022: [2,12,2,26],
        2023: [2,13,2,24],
        2024: [2,12,2,23],
        2025: [2,17,3,1],
        2026: [2,9,2,21],
        2027: [2,8,2,19],
        2028: [2,14,2,26],
        2029: [2,5,2,16],
        2030: [2,18,3,1],
      },
      {
        name: "Osterferien",
        2012: [4,6,4,14],
        2013: [3,29,4,6],
        2014: [4,18,4,26],
        2015: [4,2,4,11],
        2016: [3,25,4,2],
        2017: [4,13,4,22],
        2018: [3,29,4,6],
        2019: [4,19,4,26],
        2020: [4,10,4,18],
        2021: [3,27,4,10],
        2022: [4,15,4,23],
        2023: [4,7,4,15],
        2024: [3,28,4,5],
        2025: [4,18,4,25],
        2026: [4,3,4,10],
        2027: [3,26,4,2],
        2028: [4,14,4,22],
        2029: [3,29,4,6],
        2030: [4,19,4,26],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,18],
        2013: [5,18,5,22],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,6,5,6],
        2017: [5,26,5,26],
        2018: [5,19,5,22],
        2019: [5,31,5,31],
        2024: [5,18,5,21],
        2027: [5,15,5,18],
        2029: [5,19,5,22],
        2030: [6,8,6,11],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [7,15,8,23],
        2014: [7,21,8,29],
        2015: [7,13,8,21],
        2016: [6,27,8,5],
        2017: [6,26,8,4],
        2018: [7,2,8,10],
        2019: [7,8,8,16],
        2020: [7,20,8,28],
        2021: [7,26,9,3],
        2022: [7,18,8,26],
        2023: [7,10,8,18],
        2024: [6,20,8,2],
        2025: [6,28,8,8],
        2026: [7,4,8,14],
        2027: [7,10,8,20],
        2028: [7,22,9,1],
        2029: [7,21,8,31],
        2030: [7,13,8,23],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,2],
        2013: [10,21,11,1],
        2014: [10,20,10,31],
        2015: [10,12,10,24],
        2016: [10,3,10,15],
        2017: [10,30,10,30],
        2018: [10,8,10,20],
        2019: [10,14,10,25],
        2020: [10,19,10,31],
        2021: [10,18,10,30],
        2022: [10,17,10,29],
        2023: [10,2,10,14],
        2024: [10,7,10,19],
        2025: [10,6,10,18],
        2026: [10,12,10,24],
        2027: [10,11,10,23],
        2028: [10,23,11,3],
        2029: [10,22,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,2],
        2012: [12,22,1,2],
        2013: [12,21,1,3],
        2014: [12,22,1,3],
        2015: [12,21,1,2],
        2016: [12,23,1,2],
        2017: [12,23,1,2],
        2018: [12,22,1,4],
        2019: [12,21,1,3],
        2020: [12,19,1,2],
        2021: [12,23,1,1],
        2022: [12,22,1,2],
        2023: [12,23,1,2],
        2024: [12,23,1,3],
        2025: [12,22,1,2],
        2026: [12,23,1,2],
        2027: [12,23,1,1],
        2028: [12,23,1,3],
        2029: [12,22,1,4],
      },
      {
        name: "Unterrichtsfreier Tag",
        2022: [5,27,5,27],
        2023: [10,30,10,30],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  },
  "Sachsen-Anhalt": {
    SH: [
      {
        name: "Winterferien",
        2012: [2,4,2,11],
        2013: [2,1,2,8],
        2014: [2,1,2,12],
        2015: [2,2,2,14],
        2016: [2,1,2,10],
        2017: [2,4,2,11],
        2018: [2,5,2,9],
        2019: [2,11,2,15],
        2020: [2,10,2,14],
        2021: [2,8,2,13],
        2022: [2,12,2,19],
        2023: [2,6,2,11],
        2024: [2,5,2,10],
        2025: [1,27,1,31],
        2026: [1,31,2,6],
        2027: [2,1,2,6],
        2028: [2,7,2,12],
        2029: [2,5,2,10],
        2030: [2,4,2,8],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,7],
        2013: [3,25,3,30],
        2014: [4,14,4,17],
        2015: [4,2,4,2],
        2016: [3,24,3,24],
        2017: [4,10,4,13],
        2018: [4,30,4,30],
        2019: [4,18,4,30],
        2020: [4,6,4,11],
        2021: [3,29,4,3],
        2022: [4,11,4,16],
        2023: [4,3,4,8],
        2024: [3,25,3,30],
        2025: [4,7,4,19],
        2026: [3,30,4,4],
        2027: [3,22,3,27],
        2028: [4,10,4,22],
        2029: [3,26,3,31],
        2030: [4,8,4,20],
      },
      {
        name: "Pfingstferien",
        2012: [5,18,5,25],
        2013: [5,10,5,18],
        2014: [5,30,6,7],
        2015: [5,15,5,23],
        2016: [5,6,5,14],
        2017: [5,26,5,26],
        2018: [5,11,5,19],
        2019: [5,31,6,1],
        2020: [5,18,5,30],
        2021: [5,10,5,22],
        2022: [5,23,5,28],
        2023: [5,15,5,19],
        2024: [5,21,5,24],
        2026: [5,26,5,29],
        2027: [5,15,5,22],
        2028: [6,3,6,10],
        2029: [5,11,5,25],
        2030: [6,3,6,8],
      },
      {
        name: "Sommerferien",
        2012: [7,23,9,5],
        2013: [7,15,8,28],
        2014: [7,21,9,3],
        2015: [7,13,8,26],
        2016: [6,27,8,10],
        2017: [6,26,8,9],
        2018: [6,28,8,8],
        2019: [7,4,8,14],
        2020: [7,16,8,26],
        2021: [7,22,9,1],
        2022: [7,14,8,24],
        2023: [7,6,8,16],
        2024: [6,24,8,3],
        2025: [6,28,8,8],
        2026: [7,4,8,14],
        2027: [7,10,8,20],
        2028: [7,22,9,1],
        2029: [7,21,8,31],
        2030: [7,13,8,23],
      },
      {
        name: "Herbstferien",
        2012: [10,29,11,2],
        2013: [10,21,10,25],
        2014: [10,27,10,30],
        2015: [10,17,10,24],
        2016: [10,4,10,15],
        2017: [10,30,10,30],
        2018: [10,1,10,12],
        2019: [11,1,11,1],
        2020: [10,19,10,24],
        2021: [10,25,10,30],
        2022: [10,24,11,4],
        2023: [10,16,10,30],
        2024: [9,30,10,12],
        2025: [10,13,10,25],
        2026: [10,19,10,30],
        2027: [10,18,10,23],
        2028: [10,30,11,3],
        2029: [10,29,11,2],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,22,1,7],
        2012: [12,19,1,4],
        2013: [12,21,1,3],
        2014: [12,22,1,5],
        2015: [12,21,1,5],
        2016: [12,19,1,2],
        2017: [12,21,1,3],
        2018: [12,19,1,4],
        2019: [12,23,1,4],
        2020: [12,21,1,10],
        2021: [12,22,1,8],
        2022: [12,21,1,5],
        2023: [12,21,1,3],
        2024: [12,23,1,4],
        2025: [12,22,1,5],
        2026: [12,21,1,2],
        2027: [12,20,12,31],
        2028: [12,21,1,2],
        2029: [12,21,1,5],
      },
      {
        name: "Ferientag",
        2023: [10,2,10,2],
        2024: [11,1,11,1],
        2025: [5,30,5,30],
        2028: [10,2,10,2],
        2029: [4,30,4,30],
        2030: [5,31,5,31],
      },
    ]
  },
  "Schleswig-Holstein": {
    SH: [
      {
        name: "Osterferien",
        2011: [4,15,4,30],
        2012: [3,30,4,13],
        2013: [3,25,4,9],
        2014: [4,16,5,2],
        2015: [4,1,4,17],
        2016: [3,24,4,9],
        2017: [4,7,4,21],
        2018: [3,29,4,13],
        2019: [4,4,4,18],
        2020: [3,30,4,17],
        2021: [4,1,4,16],
        2022: [4,4,4,16],
        2023: [4,6,4,22],
        2024: [4,2,4,19],
        2025: [4,11,4,25],
        2026: [3,26,4,10],
        2027: [3,30,4,10],
        2028: [4,3,4,15],
        2029: [3,23,4,6],
        2030: [4,8,4,20],
        2031: [3,28,4,10],
      },
      {
        name: "Sommerferien",
        2011: [7,4,8,13],
        2012: [6,25,8,4],
        2013: [6,24,8,3],
        2014: [7,14,8,23],
        2015: [7,20,8,29],
        2016: [7,25,9,3],
        2017: [7,24,9,2],
        2018: [7,9,8,18],
        2019: [7,1,8,10],
        2020: [6,29,8,8],
        2021: [6,21,7,31],
        2022: [7,4,8,13],
        2023: [7,17,8,26],
        2024: [7,22,8,31],
        2025: [7,28,9,6],
        2026: [7,4,8,15],
        2027: [7,3,8,14],
        2028: [6,24,8,4],
        2029: [6,23,8,3],
        2030: [7,8,8,17],
      },
      {
        name: "Herbstferien",
        2011: [10,10,10,22],
        2012: [10,4,10,19],
        2013: [10,4,10,18],
        2014: [10,13,10,25],
        2015: [10,19,10,31],
        2016: [10,17,10,29],
        2017: [10,16,10,27],
        2018: [10,1,10,19],
        2019: [10,4,10,18],
        2020: [10,5,10,17],
        2021: [10,4,10,16],
        2022: [10,10,10,21],
        2023: [10,16,10,27],
        2024: [10,21,11,1],
        2025: [10,20,10,30],
        2026: [10,12,10,24],
        2027: [10,11,10,23],
        2028: [10,16,10,30],
        2029: [10,8,10,19],
        2030: [10,14,10,25],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,6],
        2012: [12,24,1,5],
        2013: [12,23,1,6],
        2014: [12,22,1,6],
        2015: [12,21,1,6],
        2016: [12,23,1,6],
        2017: [12,21,1,6],
        2018: [12,21,1,4],
        2019: [12,23,1,6],
        2020: [12,21,1,6],
        2021: [12,23,1,8],
        2022: [12,23,1,7],
        2023: [12,27,1,6],
        2024: [12,19,1,7],
        2025: [12,19,1,6],
        2026: [12,21,1,6],
        2027: [12,23,1,8],
        2028: [12,21,1,5],
        2029: [12,21,1,8],
        2030: [12,20,1,6],
      },
      {
        name: "Himmelfahrt",
        2011: [6,3,6,4],
        2012: [5,18,5,18],
        2013: [5,10,5,10],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,6,5,6],
        2017: [5,26,5,26],
        2018: [5,11,5,11],
        2019: [5,31,5,31],
        2020: [5,22,5,22],
        2021: [5,14,5,15],
        2022: [5,27,5,28],
        2023: [5,19,5,20],
        2024: [5,10,5,11],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
        2031: [5,23,5,23],
      },
    ]
  },
  "Thüringen": {
    SH: [
      {
        name: "Winterferien",
        2012: [2,6,2,11],
        2013: [2,18,2,23],
        2014: [2,17,2,22],
        2015: [2,2,2,7],
        2016: [2,1,2,6],
        2017: [2,6,2,11],
        2018: [2,5,2,9],
        2019: [2,11,2,15],
        2020: [2,10,2,14],
        2021: [1,25,1,30],
        2022: [2,12,2,19],
        2023: [2,13,2,17],
        2024: [2,12,2,16],
        2025: [2,3,2,8],
        2026: [2,16,2,21],
        2027: [2,1,2,6],
        2028: [2,7,2,12],
        2029: [2,12,2,17],
        2030: [2,11,2,16],
      },
      {
        name: "Osterferien",
        2012: [4,2,4,13],
        2013: [3,25,4,6],
        2014: [4,19,5,2],
        2015: [3,30,4,11],
        2016: [3,24,4,2],
        2017: [4,10,4,21],
        2018: [3,26,4,7],
        2019: [4,15,4,27],
        2020: [4,6,4,18],
        2021: [3,29,4,10],
        2022: [4,11,4,23],
        2023: [4,3,4,15],
        2024: [3,25,4,6],
        2025: [4,7,4,19],
        2026: [4,7,4,17],
        2027: [3,22,4,3],
        2028: [4,3,4,15],
        2029: [3,26,4,7],
        2030: [4,8,4,20],
      },
      {
        name: "Pfingstferien",
        2012: [5,25,5,29],
        2013: [5,10,5,10],
        2014: [5,30,5,30],
        2015: [5,15,5,15],
        2016: [5,6,5,6],
        2017: [5,26,5,26],
        2018: [5,11,5,11],
        2019: [5,31,5,31],
      },
      {
        name: "Sommerferien",
        2012: [7,23,8,31],
        2013: [7,15,8,23],
        2014: [7,21,8,29],
        2015: [7,13,8,21],
        2016: [6,27,8,10],
        2017: [6,26,8,9],
        2018: [7,2,8,11],
        2019: [7,8,8,17],
        2020: [7,20,8,29],
        2021: [7,26,9,4],
        2022: [7,18,8,27],
        2023: [7,10,8,19],
        2024: [6,20,7,31],
        2025: [6,28,8,8],
        2026: [7,4,8,14],
        2027: [7,10,8,20],
        2028: [7,22,9,1],
        2029: [7,21,8,31],
        2030: [7,13,8,23],
      },
      {
        name: "Herbstferien",
        2012: [10,22,11,3],
        2013: [10,21,11,2],
        2014: [10,6,10,18],
        2015: [10,5,10,17],
        2016: [10,10,10,22],
        2017: [10,2,10,14],
        2018: [10,1,10,13],
        2019: [10,7,10,19],
        2020: [10,17,10,30],
        2021: [10,25,11,6],
        2022: [10,17,10,29],
        2023: [10,2,10,14],
        2024: [9,30,10,12],
        2025: [10,6,10,18],
        2026: [10,12,10,24],
        2027: [10,9,10,23],
        2028: [10,23,11,3],
        2029: [10,22,11,3],
      },
      {
        name: "Weihnachtsferien",
        2011: [12,23,1,1],
        2012: [12,24,1,5],
        2013: [12,23,1,4],
        2014: [12,22,1,3],
        2015: [12,23,1,2],
        2016: [12,23,12,31],
        2017: [12,22,1,5],
        2018: [12,21,1,4],
        2019: [12,21,1,3],
        2020: [12,23,1,2],
        2021: [12,23,12,31],
        2022: [12,22,1,3],
        2023: [12,22,1,5],
        2024: [12,23,1,3],
        2025: [12,22,1,3],
        2026: [12,23,1,2],
        2027: [12,23,12,31],
        2028: [12,23,1,5],
        2029: [12,22,1,4],
      },
      {
        name: "Schulfreier Tag",
        2020: [5,22,5,22],
        2021: [5,14,5,14],
        2022: [5,27,5,27],
        2023: [5,19,5,19],
        2024: [5,10,5,10],
        2025: [5,30,5,30],
        2026: [5,15,5,15],
        2027: [5,7,5,7],
        2028: [5,26,5,26],
        2029: [5,11,5,11],
        2030: [5,31,5,31],
      },
    ]
  }
};

const dk = {
  PH: [{"name":"Nytårsdag","fixed_date":[1,1]},{"name":"Skærtorsdag","variable_date":"easter","offset":-3},{"name":"Langfredag","variable_date":"easter","offset":-2},{"name":"Påskedag","variable_date":"easter"},{"name":"2. Påskedag","variable_date":"easter","offset":1},{"name":"Store Bededag","variable_date":"easter","offset":26},{"name":"Kristi Himmelfartsdag","variable_date":"easter","offset":39},{"name":"Pinsedag","variable_date":"easter","offset":49},{"name":"2. Pinsedag","variable_date":"easter","offset":50},{"name":"Grundlovsdag","fixed_date":[6,5]},{"name":"Juleaftensdag","fixed_date":[12,24]},{"name":"Juledag","fixed_date":[12,25]},{"name":"2. Juledag","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.670249&lon=10.3333283&zoom=18&addressdetails=1&accept-language=da,en"
};

const ee = {
  SH: [
    {
      name: "jõulupühad",
      2019: [12,23,1,5],
      2020: [12,23,1,10],
      2021: [12,23,1,9],
      2022: [12,22,1,8],
      2023: [12,21,1,7],
      2024: [12,23,1,5],
      2025: [12,22,1,11],
      2026: [12,23,1,10],
    },
    {
      name: "talvepuhkus",
      2020: [2,24,3,1],
      2021: [2,22,2,28],
      2022: [2,28,3,6],
      2023: [2,27,3,5],
      2024: [2,26,3,3],
      2025: [2,24,3,2],
      2026: [2,23,3,1],
      2027: [2,22,2,28],
    },
    {
      name: "kevadpühad",
      2020: [4,20,4,26],
      2021: [4,19,4,25],
      2022: [4,25,5,1],
      2023: [4,24,4,30],
      2024: [4,22,4,28],
      2025: [4,14,4,20],
      2026: [4,13,4,19],
      2027: [4,12,4,18],
    },
    {
      name: "suvepuhkus",
      2020: [6,10,8,31],
      2021: [6,14,8,31],
      2022: [6,14,8,31],
      2023: [6,14,8,31],
      2024: [6,13,8,31],
      2025: [6,10,8,31],
      2026: [6,17,8,31],
      2027: [6,14,8,31],
    },
    {
      name: "sügispuhkus",
      2020: [10,19,10,25],
      2021: [10,25,10,31],
      2022: [10,24,10,30],
      2023: [10,23,10,29],
      2024: [10,21,10,27],
      2025: [10,20,10,26],
      2026: [10,26,11,1],
    },
  ]
};

const es = {
  PH: [{"name":"Cap d'Any","fixed_date":[1,1],"only_states":["Cataluña"]},{"name":"Año Nuevo","fixed_date":[1,1]},{"name":"Reis","fixed_date":[1,6],"only_states":["Cataluña"]},{"name":"Epifanía del Señor","fixed_date":[1,6]},{"name":"Día de Andalucía","fixed_date":[2,28],"only_states":["Andalucía"]},{"name":"Dia de les Illes Balears","fixed_date":[3,1],"only_states":["Islas Baleares"]},{"name":"Sant Josep","fixed_date":[3,19],"only_states":["Comunidad Valenciana"]},{"name":"San José","fixed_date":[3,19],"only_states":["Murcia"]},{"name":"Jueve Santo","variable_date":"easter","offset":-3,"only_states":["Andalucía","Aragón","Castilla y León","Castilla-La Mancha","Canarias","Extremadura","Galicia","Islas Baleares","La Rioja","Comunidad de Madrid","Región de Murcia","Navarra","Asturias","País Vasco","Cantabria","Ceuta","Melilla"]},{"name":"Divendres Sant","variable_date":"easter","offset":-2,"only_states":["Cataluña","Comunidad Valenciana","Islas Baleares"]},{"name":"Viernes Santo","variable_date":"easter","offset":-2},{"name":"Dilluns de Pasqua Florida","variable_date":"easter","offset":1,"only_states":["Cataluña","Comunidad Valenciana","Islas Baleares"]},{"name":"Lunes de Pascua de Resurrección","variable_date":"easter","offset":1,"only_states":["País Vasco","Navarra"]},{"name":"Día de Aragón","fixed_date":[4,23],"only_states":["Aragón"]},{"name":"Día de Castilla y León","fixed_date":[4,23],"only_states":["Castilla y León"]},{"name":"Festa del Treball","fixed_date":[5,1],"only_states":["Cataluña","Comunidad Valenciana","Islas Baleares"]},{"name":"Fiesta del Trabajo","fixed_date":[5,1]},{"name":"Fiesta de la Comunidad de Madrid","fixed_date":[5,2],"only_states":["Comunidad de Madrid"]},{"name":"Día das Letras Galegas","fixed_date":[5,2],"only_states":["Galicia"]},{"name":"Día de Canarias","fixed_date":[5,30],"only_states":["Canarias"]},{"name":"Día de la Región Castilla-La Mancha","fixed_date":[5,31],"only_states":["Castilla-La Mancha"]},{"name":"Día de la Región de Murcia","fixed_date":[6,9],"only_states":["Región de Murcia"]},{"name":"Día de la Rioja","fixed_date":[6,9],"only_states":["La Rioja"]},{"name":"San Antonio","fixed_date":[6,13],"only_states":["Ceuta"]},{"name":"Sant Joan","fixed_date":[6,24],"only_states":["Cataluña"]},{"name":"San Juan","fixed_date":[6,24],"only_states":["Ceuta"]},{"name":"Santiago Apóstol","fixed_date":[7,25],"only_states":["Galicia"]},{"name":"Santa María de África","fixed_date":[8,6],"only_states":["Ceuta"]},{"name":"l'Assumpció","fixed_date":[8,15],"only_states":["Cataluña"]},{"name":"Asunción de la Virgen","fixed_date":[8,15]},{"name":"Día de Ceuta","fixed_date":[9,2],"only_states":["Ceuta"]},{"name":"Día de Asturias","fixed_date":[9,8],"only_states":["Asturias"]},{"name":"Día de Extremadura","fixed_date":[9,8],"only_states":["Extremadura"]},{"name":"Diada Nacional de Catalunya","fixed_date":[9,11],"only_states":["Cataluña"]},{"name":"Día de Cantabria","fixed_date":[9,17],"only_states":["Cantabria"]},{"name":"Día de Melilla","fixed_date":[9,15],"only_states":["Melilla"]},{"name":"Dia de la Comunitat Valenciana","fixed_date":[10,9],"only_states":["Comunidad Valenciana"]},{"name":"Festa Nacional d'Espanya","fixed_date":[10,12],"only_states":["Cataluña"]},{"name":"Fiesta Nacional de España","fixed_date":[10,12]},{"name":"Euskadi Eguna","fixed_date":[10,25],"only_states":["País Vasco"]},{"name":"Tots Sants","fixed_date":[11,1],"only_states":["Cataluña","Comunidad Valenciana","Islas Baleares"]},{"name":"Todos los Santos","fixed_date":[11,1]},{"name":"Día de la Constitución Española","fixed_date":[12,6]},{"name":"La Puríssima","fixed_date":[12,8],"only_states":["Cataluña","Comunidad Valenciana","Islas Baleares"]},{"name":"La Immaculada Concepción","fixed_date":[12,8]},{"name":"Nadal","fixed_date":[12,25],"only_states":["Cataluña","Comunidad Valenciana","Islas Baleares"]},{"name":"Natividad del Señor","fixed_date":[12,25]},{"name":"Sant Esteve","fixed_date":[12,26],"only_states":["Cataluña"]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.60333&lon=2.18920&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,eu,gl,oc,ast",
  "Almería": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,6],
        2023: [12,23,1,7],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "Día no lectivo",
        2020: [12,23,12,23],
        2021: [12,23,12,23],
        2022: [12,7,12,7],
        2023: [12,22,12,22],
        2024: [12,23,12,23],
        2025: [12,23,12,23],
        2026: [5,4,5,4],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [2,27,2,27],
        2021: [3,2,3,2],
        2022: [3,1,3,1],
        2023: [2,27,2,27],
        2024: [2,29,2,29],
        2025: [2,27,2,27],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,5,4,12],
        2021: [3,28,4,4],
        2022: [4,10,4,17],
        2023: [4,2,4,9],
        2024: [3,23,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,23,9,11],
        2023: [6,23,9,10],
        2024: [6,22,9,9],
        2025: [6,24,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Andalucía": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=37.33999&lon=-4.58116&zoom=18&addressdetails=1&limit=1&accept-language=es,ca",
    "_state_code": "an"
  },
  "Aragón": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.37872&lon=-0.76393&zoom=18&addressdetails=1&limit=1&accept-language=es,ca",
    "_state_code": "ar",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,20,1,6],
        2020: [12,22,1,6],
        2021: [12,23,1,7],
        2022: [12,22,1,6],
        2023: [12,22,1,5],
        2024: [12,20,1,6],
        2025: [12,20,1,6],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,13],
        2021: [3,29,4,2],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,28,4,5],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,6],
        2021: [6,23,9,10],
        2022: [6,23,9,10],
        2023: [6,24,9,6],
        2024: [6,25,9,8],
        2025: [6,25,9,11],
      },
      {
        name: "Día no lectivo",
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2025: [11,3,11,3],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Asturias": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.27108&lon=-5.85414&zoom=18&addressdetails=1&limit=1&accept-language=es,ast",
    "_state_code": "as",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,8],
        2021: [12,24,1,7],
        2022: [12,27,1,5],
        2023: [12,26,1,5],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Día no lectivo",
        2020: [10,30,10,30],
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2024: [10,31,10,31],
        2025: [11,4,11,4],
        2026: [5,4,5,4],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,5],
        2022: [4,11,4,15],
        2023: [4,3,4,11],
        2024: [3,25,4,1],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,21],
        2021: [7,1,9,7],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,22,9,8],
        2025: [6,21,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Cádiz": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,24,1,10],
        2021: [12,24,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Día no lectivo",
        2020: [5,4,5,4],
        2023: [3,1,3,1],
        2024: [2,27,2,27],
        2025: [10,13,10,13],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [5,3,5,3],
        2022: [3,1,3,1],
        2023: [12,7,12,7],
        2025: [5,2,5,2],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,23,9,11],
        2023: [6,23,9,10],
        2024: [6,25,9,9],
        2025: [6,24,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Canarias": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=28.29357&lon=-16.62144&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "cn",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,25,1,5],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,10],
        2021: [3,29,4,2],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,3,29],
        2025: [4,14,4,18],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,14],
        2021: [6,24,9,8],
        2022: [6,24,9,8],
        2023: [6,24,9,10],
        2024: [6,22,9,9],
        2025: [6,21,9,8],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Cantabria": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.13583&lon=-4.26363&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "cb",
    SH: [
      {
        name: "No lectivos",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,26,1,5],
        2024: [12,23,1,7],
        2025: [12,24,1,5],
        2026: [3,30,4,1],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Castilla y León": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.80371&lon=-4.74717&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "cl",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,22,1,11],
        2021: [12,22,1,10],
        2022: [12,22,1,9],
        2023: [12,22,1,8],
        2024: [12,21,1,7],
        2025: [12,19,1,8],
      },
      {
        name: "Carnavales",
        2020: [2,24,2,25],
        2021: [2,15,2,16],
        2022: [2,28,3,1],
        2023: [2,20,2,21],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "Día no lectivo",
        2020: [10,9,10,9],
        2021: [12,7,12,7],
        2022: [12,9,12,9],
        2023: [12,7,12,7],
        2024: [10,31,10,31],
        2025: [10,31,10,31],
        2026: [4,24,4,24],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,3,4,14],
        2021: [3,25,4,6],
        2022: [4,6,4,18],
        2023: [3,29,4,10],
        2024: [3,22,4,3],
        2025: [4,12,4,22],
        2026: [3,26,4,7],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,8],
        2021: [6,24,9,9],
        2022: [6,24,9,8],
        2023: [6,24,9,6],
        2024: [6,22,9,5],
        2025: [6,24,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,24,6,24],
      },
    ]
  },
  "Castilla-La Mancha": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=39.41779&lon=-2.62323&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "cm",
    SH: [
      {
        name: "Descanso de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Días de libre disposición",
        2020: [2,24,2,25],
        2021: [2,15,2,15],
        2022: [2,28,3,1],
        2023: [2,20,2,21],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "Día no lectivo",
        2020: [11,13,11,13],
        2021: [11,19,11,19],
        2022: [11,18,11,18],
        2023: [12,7,12,7],
        2024: [11,15,11,15],
        2025: [11,14,11,14],
        2026: [5,2,5,2],
      },
      {
        name: "Descanso de Semana Santa",
        2020: [4,6,4,13],
        2021: [3,29,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,26,9,8],
        2021: [6,29,9,8],
        2022: [6,25,9,7],
        2023: [6,24,9,10],
        2024: [6,22,9,8],
        2025: [6,19,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,17,6,17],
      },
    ]
  },
  "Cataluña": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.85230&lon=1.57450&zoom=18&addressdetails=1&limit=1&accept-language=es,ca,oc",
    "_state_code": "ct"
  },
  "Catalunya": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,22,1,7],
        2021: [12,23,1,7],
        2022: [12,22,1,8],
        2023: [12,21,1,7],
        2024: [12,21,1,7],
        2025: [12,20,1,7],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,4,4,13],
        2021: [3,27,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,23,4,1],
        2025: [4,12,4,21],
        2026: [3,28,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,13],
        2021: [6,23,9,12],
        2022: [6,23,9,4],
        2023: [6,23,9,5],
        2024: [6,22,9,9],
        2025: [6,19,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Ceuta": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=35.89429&lon=-5.35568&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "ce",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,25,1,5],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Día de libre disposición",
        2020: [5,25,5,25],
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2024: [4,10,4,10],
        2025: [5,2,5,2],
      },
      {
        name: "Días de libre disposición",
        2020: [4,1,4,3],
        2022: [4,4,4,8],
        2023: [4,20,4,21],
        2024: [3,18,3,22],
        2025: [4,7,4,11],
        2026: [5,25,5,26],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,8],
        2021: [3,29,4,11],
        2022: [4,11,4,15],
        2023: [4,3,4,5],
        2024: [3,25,3,29],
        2025: [4,14,4,18],
        2026: [3,30,4,3],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,23,9,9],
        2021: [6,23,9,9],
        2022: [6,24,9,7],
        2023: [6,24,9,6],
        2024: [6,22,9,8],
        2025: [6,24,9,7],
      },
      {
        name: "Fin del Ramadán",
        2021: [5,13,5,14],
        2022: [5,3,5,3],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Comunidad de Madrid": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=40.52483&lon=-3.77156&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "md",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,6],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,6],
        2025: [12,20,1,6],
      },
      {
        name: "Día no lectivo",
        2020: [11,2,11,2],
        2021: [12,7,12,7],
        2022: [12,7,12,7],
        2023: [12,7,12,7],
        2024: [5,3,5,3],
        2025: [11,3,11,3],
        2026: [4,6,4,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,4,4,12],
        2021: [3,27,4,4],
        2022: [4,9,4,17],
        2023: [4,1,4,9],
        2024: [3,23,3,31],
        2025: [4,12,4,20],
        2026: [3,28,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,20],
        2021: [6,26,9,5],
        2022: [6,25,9,11],
        2023: [6,22,9,5],
        2024: [6,22,9,5],
        2025: [6,21,9,7],
      },
      {
        name: "Días de libre disposición",
        2020: [12,7,12,8],
        2021: [1,7,1,8],
        2024: [2,22,2,23],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Comunidad Valenciana": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=39.68195&lon=-0.76544&zoom=18&addressdetails=1&limit=1&accept-language=es,ca",
    "_state_code": "vc"
  },
  "Comunitat Valenciana": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,20],
        2021: [4,1,4,12],
        2022: [4,14,4,25],
        2023: [4,6,4,17],
        2024: [3,28,4,8],
        2025: [4,17,4,28],
        2026: [4,2,4,13],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,19,9,6],
        2021: [6,24,9,7],
        2022: [6,22,9,11],
        2023: [6,22,9,10],
        2024: [6,22,9,8],
        2025: [6,19,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Córdoba": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [2,25,2,25],
        2023: [2,27,2,27],
        2024: [2,27,2,27],
        2025: [2,27,2,27],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,5,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,23,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,23,9,1],
        2025: [6,25,8,31],
      },
      {
        name: "Día no lectivo",
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2024: [3,1,3,1],
        2025: [5,2,5,2],
        2026: [1,7,1,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Euskal Herria": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,6],
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,6],
        2023: [12,23,1,7],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,13],
        2021: [4,1,4,5],
        2022: [4,14,4,18],
        2023: [4,6,4,10],
        2024: [3,28,4,1],
        2025: [4,17,4,21],
        2026: [4,2,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,7],
        2021: [6,19,9,7],
        2022: [6,22,9,7],
        2023: [6,22,9,6],
        2024: [6,22,9,29],
        2025: [5,16,9,4],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Extremadura": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=39.17484&lon=-6.15298&zoom=18&addressdetails=1&limit=1&accept-language=es,ast",
    "_state_code": "ex",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,8],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,22,1,5],
        2024: [12,23,1,7],
        2025: [12,23,1,7],
      },
      {
        name: "Día no lectivo",
        2020: [12,7,12,7],
        2021: [11,22,11,22],
        2022: [12,9,12,9],
        2023: [12,7,12,7],
        2024: [11,25,11,25],
        2025: [11,28,11,28],
      },
      {
        name: "Carnavales",
        2020: [2,24,2,25],
        2021: [2,15,2,16],
        2022: [2,28,3,1],
        2023: [2,20,2,21],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,6,4,13],
        2021: [3,29,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,18,9,9],
        2021: [6,19,9,9],
        2022: [6,22,9,11],
        2023: [6,23,9,10],
        2024: [6,21,9,10],
        2025: [6,24,9,10],
      },
      {
        name: "Día de la Comunitat Valenciana",
        2020: [10,9,10,9],
        2023: [10,9,10,9],
      },
      {
        name: "Fin de lecciones",
        2026: [7,23,7,23],
      },
    ]
  },
  "Galicia": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.61946&lon=-7.86311&zoom=18&addressdetails=1&limit=1&accept-language=es,gl",
    "_state_code": "ga",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,23,1,7],
        2021: [12,22,1,7],
        2022: [12,23,1,6],
        2023: [12,22,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,4,4,13],
        2021: [3,27,4,5],
        2022: [4,11,4,18],
        2023: [4,3,4,10],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,9],
        2021: [6,23,9,8],
        2022: [6,23,9,7],
        2023: [6,22,9,10],
        2024: [6,22,9,10],
        2025: [6,21,9,7],
      },
      {
        name: "Día de la Educación",
        2020: [12,7,12,7],
        2021: [10,11,10,11],
        2022: [10,31,10,31],
        2023: [12,7,12,7],
        2024: [10,31,10,31],
        2025: [10,31,10,31],
      },
      {
        name: "Carnavales",
        2021: [2,24,2,26],
        2022: [2,28,3,2],
        2023: [2,20,2,22],
        2024: [2,12,2,14],
        2025: [3,3,4,5],
        2026: [2,16,2,18],
      },
      {
        name: "Día no lectivo",
        2025: [11,3,11,3],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Granada": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,24,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [3,1,3,1],
        2023: [2,27,2,27],
        2024: [2,29,2,29],
        2025: [2,27,2,27],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,10],
        2021: [3,28,4,4],
        2022: [4,10,4,17],
        2023: [4,2,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Día no lectivo",
        2020: [5,4,5,4],
        2021: [12,7,12,7],
        2022: [10,31,10,31],
        2023: [12,7,12,7],
        2024: [3,1,3,1],
        2025: [11,3,11,3],
        2026: [6,5,6,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,24,9,1],
        2025: [6,25,8,31],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Huelva": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [2,25,2,25],
        2023: [11,2,11,2],
        2025: [3,3,3,3],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,4,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,1],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,23,9,9],
        2022: [6,24,9,11],
        2023: [6,24,9,10],
        2024: [6,26,9,9],
        2025: [6,25,9,9],
      },
      {
        name: "Día no lectivo",
        2025: [1,7,1,7],
        2026: [1,7,1,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Huesca": {
    SH: [
      {
        name: "Día no lectivo",
        2020: [2,14,2,14],
        2021: [2,19,2,19],
        2022: [2,18,2,18],
        2023: [2,17,2,17],
        2024: [2,16,2,16],
        2025: [2,14,2,14],
        2026: [2,20,2,20],
      },
    ]
  },
  "Illes Balears": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,22,1,5],
        2024: [12,21,1,7],
        2025: [12,22,1,6],
      },
      {
        name: "Fiesta Escolar Unificada",
        2020: [2,28,2,28],
        2021: [2,26,2,26],
        2022: [2,28,2,28],
        2023: [2,28,2,28],
        2024: [2,29,2,29],
        2025: [2,28,2,28],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,8,4,19],
        2021: [4,1,4,11],
        2022: [4,14,4,22],
        2023: [4,6,4,14],
        2024: [3,28,4,5],
        2025: [4,17,4,27],
        2026: [4,2,4,12],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,9],
        2021: [6,23,9,9],
        2022: [6,24,9,11],
        2023: [6,24,9,10],
        2024: [6,22,9,10],
        2025: [6,28,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Islas Baleares": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=39.61340&lon=2.88043&zoom=18&addressdetails=1&limit=1&accept-language=es,ca",
    "_state_code": "ib"
  },
  "Jaén": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,23,1,10],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,25,1,7],
        2024: [12,23,1,7],
        2025: [12,23,1,7],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [5,3,5,3],
        2022: [3,1,3,1],
        2023: [2,27,2,27],
        2024: [2,29,2,29],
        2025: [3,3,3,3],
        2026: [3,2,3,2],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,4,4,12],
        2021: [3,27,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,9],
        2021: [6,24,9,9],
        2022: [6,24,9,11],
        2023: [6,23,9,10],
        2024: [6,24,9,1],
        2025: [6,25,9,1],
      },
      {
        name: "Día no lectivo",
        2023: [12,7,12,7],
        2025: [5,2,5,2],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "La Rioja": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.32855&lon=-2.46749&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "ri",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,8],
        2021: [12,23,1,7],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,23,1,6],
        2025: [12,23,1,7],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [2,24,2,24],
        2021: [2,15,2,15],
        2022: [3,11,3,11],
        2023: [3,10,3,10],
        2024: [2,17,2,17],
        2025: [2,28,2,28],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,17],
        2021: [4,1,4,9],
        2022: [4,11,4,15],
        2023: [4,1,4,10],
        2024: [3,28,4,7],
        2025: [4,17,4,25],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,23,9,6],
        2021: [6,23,9,5],
        2022: [6,25,9,7],
        2023: [6,24,9,6],
        2024: [6,22,9,5],
        2025: [6,20,9,8],
      },
      {
        name: "Día no lectivo",
        2021: [12,7,12,7],
        2022: [10,31,10,31],
        2023: [12,7,12,7],
        2025: [5,2,5,2],
        2026: [6,8,6,8],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Málaga": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,23,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,8],
        2023: [12,25,1,5],
        2024: [12,23,1,5],
        2025: [12,22,1,5],
      },
      {
        name: "Semana Blanca",
        2020: [2,24,2,28],
        2021: [2,22,2,26],
        2022: [2,28,3,4],
        2023: [2,27,3,3],
        2024: [2,26,3,1],
        2025: [2,24,2,26],
        2026: [2,23,2,26],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,3,29],
        2025: [4,14,4,20],
        2026: [3,30,4,1],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,25,9,9],
        2021: [6,25,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,25,9,9],
        2025: [6,25,9,4],
      },
      {
        name: "Día de la Comunidad Educativa",
        2022: [1,7,1,7],
        2025: [2,27,2,27],
        2026: [2,27,2,27],
      },
      {
        name: "Fin de lecciones",
        2026: [6,23,6,23],
      },
    ]
  },
  "Melilla": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=35.29186&lon=-2.94090&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "ml",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,7],
        2020: [12,23,1,5],
        2021: [12,23,1,7],
        2022: [12,23,1,5],
        2023: [12,23,1,6],
        2024: [12,23,1,7],
        2025: [12,20,1,7],
      },
      {
        name: "Días de libre disposición",
        2020: [4,1,4,3],
        2021: [3,22,3,26],
        2022: [4,4,4,8],
        2023: [3,27,3,31],
        2024: [3,18,3,22],
        2025: [4,7,4,11],
        2026: [3,23,3,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,10],
        2021: [3,29,4,2],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,3,29],
        2025: [4,14,4,18],
        2026: [3,30,4,1],
      },
      {
        name: "Día de libre disposición",
        2020: [12,7,12,7],
        2021: [12,7,12,7],
        2022: [12,5,12,5],
        2023: [12,7,12,7],
        2025: [5,2,5,2],
        2026: [5,2,5,2],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,23,9,7],
        2021: [6,19,9,6],
        2022: [6,23,9,5],
        2023: [6,22,9,6],
        2024: [6,22,9,8],
        2025: [6,24,9,9],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Nafarroako Foru Komunitatea": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,21,1,7],
        2020: [12,23,1,8],
        2021: [12,23,1,9],
        2022: [12,23,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,7],
        2025: [12,20,1,7],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,9,4,19],
        2021: [4,1,4,11],
        2022: [4,14,4,24],
        2023: [4,6,4,16],
        2024: [3,28,4,7],
        2025: [4,17,4,27],
        2026: [4,2,4,12],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,20,9,8],
        2021: [6,23,9,7],
        2022: [6,23,9,6],
        2023: [6,21,9,6],
        2024: [6,19,9,4],
        2025: [6,21,9,3],
      },
      {
        name: "Festividad patronal del nivel educativo",
        2020: [11,27,11,27],
        2022: [11,28,11,28],
        2023: [11,27,11,27],
        2024: [11,27,11,27],
        2025: [11,27,11,27],
      },
      {
        name: "Fin de lecciones",
        2026: [6,19,6,19],
      },
    ]
  },
  "Navarra": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.61254&lon=-1.83078&zoom=18&addressdetails=1&limit=1&accept-language=es,eu",
    "_state_code": "nc"
  },
  "País Vasco": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.99118&lon=-2.55430&zoom=18&addressdetails=1&limit=1&accept-language=es,eu",
    "_state_code": "pv"
  },
  "Región de Murcia": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=38.06343&lon=-1.67180&zoom=18&addressdetails=1&limit=1&accept-language=es",
    "_state_code": "mc",
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,24,1,6],
        2020: [12,24,1,6],
        2021: [12,24,1,6],
        2022: [12,24,1,6],
        2023: [12,24,1,6],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "Vacaciones de Pascua",
        2020: [4,6,4,10],
        2021: [3,29,4,2],
        2022: [4,11,4,15],
        2023: [4,3,4,7],
        2024: [3,25,4,1],
        2025: [4,14,4,21],
        2026: [3,30,4,6],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,24,9,6],
        2021: [6,24,9,6],
        2022: [6,24,9,7],
        2023: [6,24,9,6],
        2024: [6,20,9,8],
        2025: [6,25,9,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Sevilla": {
    SH: [
      {
        name: "Vacaciones de Navidad",
        2019: [12,23,1,6],
        2020: [12,23,1,6],
        2021: [12,23,1,7],
        2022: [12,23,1,6],
        2023: [12,25,1,7],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "Día de la Comunidad Educativa",
        2020: [3,2,3,2],
        2021: [2,26,2,26],
        2022: [2,25,2,25],
        2023: [2,27,2,27],
        2024: [2,27,2,27],
        2025: [2,27,2,27],
        2026: [2,27,2,27],
      },
      {
        name: "Vacaciones de Semana Santa",
        2020: [4,6,4,12],
        2021: [3,29,4,4],
        2022: [4,11,4,17],
        2023: [4,3,4,9],
        2024: [3,25,3,31],
        2025: [4,14,4,20],
        2026: [3,30,4,5],
      },
      {
        name: "Vacaciones de verano",
        2020: [6,25,9,9],
        2021: [6,22,9,9],
        2022: [6,25,9,11],
        2023: [6,24,9,10],
        2024: [6,25,9,1],
        2025: [6,25,9,2],
      },
      {
        name: "Día no lectivo",
        2025: [1,7,1,7],
        2026: [1,7,1,7],
      },
      {
        name: "Fin de lecciones",
        2026: [6,22,6,22],
      },
    ]
  },
  "Teruel": {
    SH: [
      {
        name: "Día no lectivo",
        2020: [2,21,2,21],
        2021: [2,19,2,19],
        2022: [2,18,2,18],
        2023: [2,17,2,17],
        2024: [2,16,2,16],
        2025: [2,14,2,14],
        2026: [2,20,2,20],
      },
    ]
  },
  "Zaragoza": {
    SH: [
      {
        name: "Día no lectivo",
        2020: [10,14,10,14],
        2021: [10,13,10,13],
        2022: [10,10,10,10],
        2023: [3,2,3,2],
        2024: [10,11,10,11],
        2025: [10,10,10,10],
        2026: [4,24,4,24],
      },
    ]
  }
};

const fi = {
  PH: [{"name":"uudenvuodenpäivä - nyårsdagen","fixed_date":[1,1]},{"name":"loppiainen - trettondedagen","fixed_date":[1,6]},{"name":"pitkäperjantai - långfredagen","variable_date":"easter","offset":-2},{"name":"pääsiäispäivä - påskdagen","variable_date":"easter"},{"name":"toinen pääsiäispäivä - annandag påsk","variable_date":"easter","offset":1},{"name":"vappu - första maj","fixed_date":[5,1]},{"name":"helatorstai - Kristi himmelsfärdsdag","variable_date":"easter","offset":39},{"name":"helluntai - pingst","variable_date":"easter","offset":49},{"name":"juhannuspäivä - midsommardagen","variable_date":"nextSaturday20Jun"},{"name":"pyhäinpäivä - alla helgons dag","variable_date":"nextSaturday31Oct"},{"name":"itsenäisyyspäivä - självständighetsdagen","fixed_date":[12,6]},{"name":"joulupäivä - juldagen","fixed_date":[12,25]},{"name":"toinen joulupäivä - annandag jul","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=63.4965&lon=26.8429&zoom=18&addressdetails=1&accept-language=fi,sv,en"
};

const fr = {
  PH: [{"name":"Jour de l'an","fixed_date":[1,1]},{"name":"Vendredi saint","variable_date":"easter","offset":-2,"only_states":["Moselle","Bas-Rhin","Haut-Rhin","Guadeloupe","Martinique","Polynésie française"]},{"name":"Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Abolition de l'esclavage (Mayotte)","fixed_date":[4,27],"only_states":["Mayotte"]},{"name":"Saint-Pierre-Chanel","fixed_date":[4,28],"only_states":["Wallis-et-Futuna"]},{"name":"Fête du Travail","fixed_date":[5,1]},{"name":"Fête de la Victoire","fixed_date":[5,8]},{"name":"Abolition de l'esclavage (Martinique)","fixed_date":[5,22],"only_states":["Martinique"]},{"name":"Abolition de l'esclavage (Guadeloupe)","fixed_date":[5,27],"only_states":["Guadeloupe"]},{"name":"Abolition de l'esclavage (Saint-Martin)","fixed_date":[5,28],"only_states":["Saint-Martin (France)"]},{"name":"Jeudi de l'Ascension","variable_date":"easter","offset":39},{"name":"Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"Abolition de l'esclavage (Guyane)","fixed_date":[6,10],"only_states":["Guyane"]},{"name":"Fête de l'autonomie","fixed_date":[6,29],"only_states":["Polynésie française"]},{"name":"Fête nationale","fixed_date":[7,14]},{"name":"Fête Victor Schoelcher","fixed_date":[7,21],"only_states":["Guadeloupe","Martinique"]},{"name":"Fête du Territoire","fixed_date":[7,29],"only_states":["Wallis-et-Futuna"]},{"name":"Assomption","fixed_date":[8,15]},{"name":"Fête de la citoyenneté","fixed_date":[9,24],"only_states":["Nouvelle-Calédonie"]},{"name":"Abolition de l'esclavage (Saint-Barthélemy)","fixed_date":[10,9],"only_states":["Saint-Barthélemy"]},{"name":"Toussaint","fixed_date":[11,1]},{"name":"Armistice","fixed_date":[11,11]},{"name":"Abolition de l'esclavage (Réunion)","fixed_date":[12,20],"only_states":["Réunion"]},{"name":"Noël","fixed_date":[12,25]},{"name":"Saint-Étienne ","fixed_date":[12,26],"only_states":["Moselle","Bas-Rhin","Haut-Rhin"]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=46.60333&lon=1.88920&zoom=18&addressdetails=1&accept-language=fr,en",
  "Auvergne-Rhône-Alpes": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,11,2,25],
        2019: [2,17,3,3],
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Vacances de printemps",
        2018: [4,8,4,22],
        2019: [4,14,4,28],
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Bourgogne-Franche-Comté": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,11,2,25],
        2019: [2,17,3,3],
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Vacances de printemps",
        2018: [4,8,4,22],
        2019: [4,14,4,28],
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Bretagne": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Centre-Val de Loire": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Corse": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances d'hiver",
        2020: [2,16,3,1],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,25,3,10],
        2025: [2,16,3,2],
        2026: [2,15,3,1],
      },
      {
        name: "Vacances de printemps",
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,16,5,1],
        2024: [4,28,5,12],
        2025: [4,13,4,27],
        2026: [4,12,4,26],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,9,2],
        2021: [7,9,9,2],
        2022: [7,9,8,1],
        2023: [7,8,9,4],
        2024: [7,7,9,2],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Grand Est": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Guadeloupe": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,10,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,22],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,26],
        2025: [4,18,5,4],
        2026: [4,18,5,4],
      },
      {
        name: "Semaine en Mai",
        2020: [5,22,5,23],
        2021: [5,29,5,29],
        2022: [5,23,5,25],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
        2026: [5,15,5,16],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Guyane": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2024: [2,11,2,25],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,10,4,27],
        2021: [4,2,4,18],
        2022: [4,15,5,1],
        2024: [4,21,5,2],
        2025: [4,18,5,4],
        2026: [4,2,4,15],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,23,5,24],
        2021: [5,14,5,15],
        2022: [5,27,5,28],
        2023: [5,14,5,21],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,4,9,1],
        2023: [7,9,9,3],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,25,11,8],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Vacances d'hiver",
        2023: [2,19,3,5],
      },
      {
        name: "Semaine en Mai",
        2026: [5,15,5,16],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Hauts-de-France": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Île-de-France": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,18,3,4],
        2019: [2,24,3,10],
        2020: [2,9,2,23],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,11,2,25],
        2025: [2,16,3,2],
        2026: [2,22,3,8],
        2027: [2,7,2,21],
      },
      {
        name: "Vacances de printemps",
        2018: [4,15,4,29],
        2019: [4,21,5,5],
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,23,5,8],
        2024: [4,7,4,21],
        2025: [4,13,4,27],
        2026: [4,19,5,3],
        2027: [4,4,4,18],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "La Réunion": {
    SH: [
      {
        name: "Vacances d'été austral",
        2019: [12,20,1,26],
        2020: [12,20,1,24],
        2021: [12,19,1,23],
        2022: [12,18,1,22],
        2023: [12,20,1,21],
        2024: [12,20,1,20],
        2025: [12,20,1,20],
        2026: [12,20,1,31],
      },
      {
        name: "Vacances après troisième période",
        2020: [3,9,3,22],
        2021: [3,7,3,21],
        2022: [3,13,3,27],
        2023: [3,12,3,26],
        2024: [3,3,3,17],
        2025: [3,2,3,16],
        2026: [3,1,3,15],
        2027: [3,17,3,29],
      },
      {
        name: "Vacances après quatrième période",
        2020: [5,1,5,13],
        2021: [5,5,5,16],
        2022: [5,15,5,29],
        2023: [5,14,5,29],
        2024: [5,5,5,20],
        2025: [5,4,5,18],
        2026: [5,3,5,17],
        2027: [5,6,5,18],
      },
      {
        name: "Vacances d'hiver austral",
        2020: [7,5,8,16],
        2021: [7,8,8,15],
        2022: [7,10,8,15],
        2023: [7,9,8,16],
        2024: [7,7,8,18],
        2025: [7,6,8,18],
        2026: [7,5,8,17],
        2027: [7,11,8,15],
      },
      {
        name: "Vacances après première période",
        2020: [10,11,10,25],
        2021: [10,10,10,24],
        2022: [10,9,10,23],
        2023: [10,15,10,29],
        2024: [10,13,10,27],
        2025: [10,12,10,26],
        2026: [10,11,10,24],
      },
    ]
  },
  "Martinique": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,23,3,8],
        2021: [2,7,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2024: [2,11,2,25],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,5,4,19],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,16],
        2024: [3,24,4,7],
        2025: [4,13,4,27],
        2026: [3,28,4,12],
      },
      {
        name: "Pas de cours",
        2020: [5,22,5,23],
        2021: [5,14,5,15],
        2022: [5,27,5,28],
        2023: [5,19,5,20],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
        2026: [5,15,5,16],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,25,11,8],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Mayotte": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,15,1,12],
        2020: [12,13,1,10],
        2021: [12,12,1,9],
        2022: [12,11,1,8],
        2023: [12,17,1,14],
        2024: [12,15,1,12],
        2025: [12,14,1,11],
      },
      {
        name: "Vacances de février",
        2020: [3,1,3,15],
        2021: [2,28,3,14],
        2022: [2,27,3,13],
        2023: [2,19,3,5],
        2024: [2,25,3,10],
        2025: [3,2,3,16],
        2026: [3,2,3,8],
      },
      {
        name: "Vacances de Pâques",
        2020: [5,3,5,10],
        2021: [5,2,5,16],
        2022: [5,1,5,15],
        2023: [4,23,5,7],
        2024: [4,28,5,12],
        2025: [4,27,5,11],
        2026: [4,26,5,11],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,23],
        2021: [7,7,8,23],
        2022: [7,6,8,23],
        2023: [7,8,8,22],
        2024: [7,7,8,25],
        2025: [7,5,8,22],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,11,10,25],
        2021: [10,10,10,24],
        2022: [10,9,10,23],
        2023: [10,15,10,29],
        2024: [10,13,10,27],
        2025: [10,12,10,26],
      },
      {
        name: "Fin des cours",
        2026: [7,4,8,21],
      },
    ]
  },
  "Normandie": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Nouvelle-Aquitaine": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,11,2,25],
        2019: [2,17,3,3],
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Vacances de printemps",
        2018: [4,8,4,22],
        2019: [4,14,4,28],
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Occitanie": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,18,3,4],
        2019: [2,24,3,10],
        2020: [2,9,2,23],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,11,2,25],
        2025: [2,16,3,2],
        2026: [2,22,3,8],
      },
      {
        name: "Vacances de printemps",
        2018: [4,15,4,29],
        2019: [4,21,5,5],
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,23,5,8],
        2024: [4,7,4,21],
        2025: [4,13,4,27],
        2026: [4,19,5,3],
        2027: [4,4,4,18],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Pays de la Loire": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Provence-Alpes-Côte d'Azur": {
    SH: [
      {
        name: "Vacances d'hiver",
        2018: [2,25,3,11],
        2019: [2,10,2,24],
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2018: [4,22,5,6],
        2019: [4,7,4,22],
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2018: [5,10,5,10],
        2019: [5,30,6,2],
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2018: [7,8,9,2],
        2019: [7,7,9,1],
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2018: [10,21,11,4],
        2019: [10,20,11,3],
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances de Noël",
        2018: [12,23,1,6],
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Saint-Barthélemy": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,10,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,22],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,26],
        2025: [4,18,5,4],
        2026: [4,18,5,4],
      },
      {
        name: "Semaine en Mai",
        2020: [5,22,5,23],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
        2026: [5,15,5,16],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Saint-Martin": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Vacances de Carnaval",
        2020: [2,16,3,1],
        2021: [2,10,2,21],
        2022: [2,20,3,6],
        2023: [2,12,2,26],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
      },
      {
        name: "Vacances de Pâques",
        2020: [4,9,4,22],
        2021: [3,28,4,11],
        2022: [4,10,4,24],
        2023: [4,2,4,26],
        2025: [4,18,5,4],
        2026: [4,18,5,4],
      },
      {
        name: "Semaine en Mai",
        2020: [5,22,5,23],
        2021: [5,29,5,29],
        2022: [5,23,5,25],
        2024: [5,10,5,11],
        2025: [5,30,5,31],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Saint-Pierre-et-Miquelon": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2025: [5,28,6,1],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,23,11,3],
        2025: [10,19,11,2],
      },
      {
        name: "Vacances de printemps",
        2021: [4,11,4,25],
        2025: [4,19,5,4],
      },
      {
        name: "Vacances d'hiver",
        2025: [2,23,3,9],
      },
      {
        name: "Fin des cours",
        2026: [7,4,7,4],
      },
    ]
  },
  "Zone A": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Vacances de printemps",
        2020: [4,19,5,3],
        2021: [4,11,4,25],
        2022: [4,17,5,1],
        2023: [4,9,4,23],
        2024: [4,14,4,28],
        2025: [4,20,5,4],
        2026: [4,5,4,19],
        2027: [4,11,4,25],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Vacances d'hiver",
        2021: [2,7,2,21],
        2022: [2,13,2,27],
        2023: [2,5,2,19],
        2024: [2,18,3,3],
        2025: [2,23,3,9],
        2026: [2,8,2,22],
        2027: [2,14,2,28],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Zone B": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Vacances d'hiver",
        2020: [2,16,3,1],
        2021: [2,21,3,7],
        2022: [2,6,2,20],
        2023: [2,12,2,26],
        2024: [2,25,3,10],
        2025: [2,9,2,23],
        2026: [2,15,3,1],
        2027: [2,21,3,7],
      },
      {
        name: "Vacances de printemps",
        2020: [4,12,5,26],
        2021: [4,11,4,25],
        2022: [4,10,4,24],
        2023: [4,16,5,1],
        2024: [4,21,5,5],
        2025: [4,6,4,21],
        2026: [4,12,4,26],
        2027: [4,18,5,2],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  },
  "Zone C": {
    SH: [
      {
        name: "Vacances de Noël",
        2019: [12,22,1,5],
        2020: [12,20,1,3],
        2021: [12,19,1,2],
        2022: [12,18,1,2],
        2023: [12,24,1,7],
        2024: [12,22,1,5],
        2025: [12,21,1,4],
        2026: [12,20,1,3],
      },
      {
        name: "Vacances d'hiver",
        2020: [2,9,2,23],
        2021: [2,14,2,28],
        2022: [2,20,3,6],
        2023: [2,19,3,5],
        2024: [2,11,2,25],
        2025: [2,16,3,2],
        2026: [2,22,3,8],
        2027: [2,7,2,21],
      },
      {
        name: "Vacances de printemps",
        2020: [4,5,4,19],
        2021: [4,11,4,25],
        2022: [4,24,5,8],
        2023: [4,23,5,8],
        2024: [4,7,4,21],
        2025: [4,13,4,27],
        2026: [4,19,5,3],
        2027: [4,4,4,18],
      },
      {
        name: "Pont de l'Ascension",
        2020: [5,21,5,24],
        2021: [5,13,5,16],
        2022: [5,26,5,29],
        2023: [5,18,5,21],
        2027: [5,6,5,9],
      },
      {
        name: "Vacances d'été",
        2020: [7,5,8,31],
        2021: [7,7,9,1],
        2022: [7,8,8,31],
        2023: [7,9,9,3],
        2024: [7,7,9,1],
        2025: [7,6,8,31],
        2026: [7,5,8,31],
      },
      {
        name: "Vacances de la Toussaint",
        2020: [10,18,11,1],
        2021: [10,24,11,7],
        2022: [10,23,11,6],
        2023: [10,22,11,5],
        2024: [10,20,11,3],
        2025: [10,19,11,2],
        2026: [10,18,11,1],
      },
      {
        name: "Fin des cours",
        2027: [7,3,7,3],
      },
    ]
  }
};

const gb = {
  "England": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=51.5073219&lon=-0.1276474&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"Christmas","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Northern Ireland": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=54.5950675&lon=-5.9298401&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1]},{"name":"St Patrick’s Day","variable_date":"nextMo-Fr17March"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Battle of the Boyne","variable_date":"nextMo-Fr12July"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"Christmas","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Scotland": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.9557307&lon=-3.1976026&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1]},{"name":"2nd January","fixed_date":[1,2]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"St. Andrew’s Day","variable_date":"nextMo-Fr30November"},{"name":"Christmas","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  },
  "Wales": {
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=52.2928116&lon=-3.73893&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year’s Day","fixed_date":[1,1]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Early May bank holiday","variable_date":"firstMayMonday"},{"name":"Spring bank holiday","variable_date":"lastMayMonday"},{"name":"Summer bank holiday","variable_date":"lastAugustMonday"},{"name":"Christmas","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}]
  }
};

const gr = {
  PH: [{"name":"Πρωτοχρονιά","fixed_date":[1,1]},{"name":"Θεοφάνια","fixed_date":[1,6]},{"name":"Καθαρά Δευτέρα","variable_date":"orthodox easter","offset":-48},{"name":"25η Μαρτίου","fixed_date":[3,25]},{"name":"Μεγάλη Παρασκευή","variable_date":"orthodox easter","offset":-2},{"name":"Πάσχα","variable_date":"orthodox easter","offset":0},{"name":"Δευτέρα του Πάσχα","variable_date":"orthodox easter","offset":1},{"name":"Πρωτομαγιά","fixed_date":[5,1]},{"name":"Κοίμηση της Θεοτόκου","fixed_date":[8,15]},{"name":"28η Οκτωβρίου","fixed_date":[10,28]},{"name":"Χριστούγεννα","fixed_date":[12,25]},{"name":"2η μέρα Χριστουγέννων","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Greece&&zoom=18&addressdetails=1&limit=1&accept-language=el,en"
};

const hr = {
  PH: [{"name":"Nova godina","fixed_date":[1,1]},{"name":"Sveta tri kralja","fixed_date":[1,6]},{"name":"Uskršnji ponedjeljak","variable_date":"easter","offset":1},{"name":"Praznik rada","fixed_date":[5,1]},{"name":"Tijelovo","variable_date":"easter","offset":60},{"name":"Dan antifašističke borbe","fixed_date":[6,22]},{"name":"Dan pobjede i domovinske zahvalnosti","fixed_date":[8,5]},{"name":"Velika Gospa","fixed_date":[8,15]},{"name":"Svi sveti","fixed_date":[11,1]},{"name":"Dan sjećanja na žrtve Domovinskog rata","fixed_date":[11,18]},{"name":"Božić","fixed_date":[12,25]},{"name":"Sveti Stjepan","fixed_date":[12,26]}],
  SH: [
    {
      name: "Zimski odmor",
      2019: [12,23,1,3],
      2025: [12,24,1,9],
    },
    {
      name: "Zimski odmor (prvi dio)",
      2019: [12,23,1,3],
      2020: [12,24,1,8],
      2021: [12,24,1,7],
      2022: [12,27,1,5],
      2023: [12,27,1,5],
      2024: [12,23,1,6],
    },
    {
      name: "Zimski odmor (drugi dio)",
      2020: [2,24,2,28],
      2021: [2,23,2,26],
      2022: [2,21,2,25],
      2023: [2,20,2,24],
      2024: [2,19,2,23],
      2025: [2,24,2,28],
    },
    {
      name: "Proljetni odmor",
      2020: [4,10,4,17],
      2021: [4,2,4,9],
      2022: [4,14,4,22],
      2023: [4,6,4,14],
      2024: [3,28,4,5],
      2025: [4,17,4,25],
      2026: [3,30,4,6],
    },
    {
      name: "Ljetni odmor",
      2020: [6,18,9,6],
      2021: [6,21,9,5],
      2022: [6,23,9,4],
      2023: [6,23,9,3],
      2024: [6,24,9,1],
      2025: [6,19,8,31],
      2026: [6,15,8,31],
    },
    {
      name: "Jesenski odmor",
      2020: [11,2,11,3],
      2021: [11,2,11,3],
      2022: [10,31,11,1],
      2023: [10,30,11,1],
      2024: [10,31,11,1],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lon=15.977&lat=45.813&zoom=18&addressdetails=1&accept-language=hr,en"
};

const hu = {
  PH: [{"name":"újév","fixed_date":[1,1]},{"name":"az 1848-as forradalom ünnepe","fixed_date":[3,15]},{"name":"nagypéntek","variable_date":"easter","offset":-2},{"name":"húsvétvasárnap","variable_date":"easter"},{"name":"húsvéthétfő","variable_date":"easter","offset":1},{"name":"pünkösdvasárnap","variable_date":"easter","offset":49},{"name":"pünkösdhétfő","variable_date":"easter","offset":50},{"name":"a munka ünnepe","fixed_date":[5,1]},{"name":"az államalapítás ünnepe","fixed_date":[8,20]},{"name":"az 1956-os forradalom ünnepe","fixed_date":[10,23]},{"name":"mindenszentek","fixed_date":[11,1]},{"name":"karácsony","fixed_date":[12,25]},{"name":"karácsony másnap","fixed_date":[12,26]}],
  SH: [
    {
      name: "Őszi szünet",
      2014: [10,23,11,2],
      2015: [10,23,11,1],
      2016: [10,29,11,6],
      2017: [10,28,11,5],
      2018: [10,27,11,4],
      2019: [10,26,11,3],
      2020: [10,22,11,1],
      2021: [10,23,11,1],
      2022: [10,29,11,6],
      2023: [10,28,11,5],
      2024: [10,26,11,3],
      2025: [10,23,11,2],
    },
    {
      name: "Téli szünet",
      2014: [12,20,1,4],
      2015: [12,19,1,3],
      2016: [12,22,1,2],
      2017: [12,23,1,2],
      2018: [12,22,1,2],
      2019: [12,23,1,5],
      2020: [12,18,1,3],
      2021: [12,22,1,2],
      2022: [12,22,1,8],
      2023: [12,21,1,7],
      2024: [12,21,1,5],
      2025: [12,20,1,4],
    },
    {
      name: "Tavaszi szünet",
      2015: [4,2,4,7],
      2016: [3,24,3,29],
      2017: [4,13,4,18],
      2018: [3,29,4,3],
      2019: [4,18,4,23],
      2020: [4,9,4,14],
      2021: [3,31,4,6],
      2022: [4,14,4,19],
      2023: [4,6,4,11],
      2024: [3,29,4,7],
      2025: [4,17,4,27],
      2026: [4,2,4,12],
    },
    {
      name: "Nyári szünet",
      2015: [6,16,8,31],
      2016: [6,16,8,31],
      2017: [6,16,8,31],
      2018: [6,16,9,2],
      2019: [6,15,9,1],
      2020: [6,16,8,31],
      2021: [6,16,8,31],
      2022: [6,16,8,31],
      2023: [6,16,8,31],
      2024: [6,16,8,31],
      2025: [6,21,8,31],
      2026: [6,20,8,31],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=47.4821&lon=19.0640&zoom=18&addressdetails=1&accept-language=hu,en"
};

const ie = {
  PH: [{"name":"New Year’s Day","fixed_date":[1,1]},{"name":"St Patrick’s Day","fixed_date":[3,17]},{"name":"St Patrick’s Day","variable_date":"nextMo-Fr17March"},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"May Bank Holiday","variable_date":"firstMayMonday"},{"name":"June Bank Holiday","variable_date":"firstJuneMonday"},{"name":"August Bank Holiday","variable_date":"firstAugustMonday"},{"name":"October Bank Holiday (Halloween)","variable_date":"lastOctoberMonday"},{"name":"Christmas","fixed_date":[12,25]},{"name":"St Stephen’s Day","fixed_date":[12,26]},{"name":"Bank Holiday","fixed_date":[12,27]}],
  SH: [
    {
      name: "Christmas",
      2019: [12,20,1,5],
      2020: [12,22,1,5],
      2021: [12,22,1,5],
      2022: [12,21,1,4],
      2023: [12,22,1,7],
      2024: [12,20,1,5],
      2025: [12,19,1,4],
    },
    {
      name: "February mid-term break",
      2020: [2,20,2,21],
      2021: [2,18,2,19],
      2022: [2,24,2,25],
      2023: [2,16,2,17],
      2024: [2,15,2,16],
      2025: [2,20,2,21],
      2026: [2,19,2,20],
    },
    {
      name: "Easter",
      2020: [4,3,4,19],
      2021: [3,26,4,11],
      2022: [4,8,4,24],
      2023: [3,31,4,16],
      2024: [3,22,4,7],
      2025: [4,11,4,27],
      2026: [3,27,4,12],
    },
    {
      name: "October mid-term break",
      2020: [10,26,10,30],
      2021: [10,25,10,29],
      2022: [10,31,11,4],
      2023: [10,30,11,3],
      2024: [10,28,11,1],
      2025: [10,27,10,31],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=53.1424&lon=-7.6921&zoom=18&addressdetails=1&accept-language=ga,en"
};

const it = {
  PH: [{"name":"Capodanno","fixed_date":[1,1]},{"name":"Epifania","fixed_date":[1,6]},{"name":"Liberazione dal nazifascismo (1945)","fixed_date":[4,25]},{"name":"Pasqua","variable_date":"easter"},{"name":"Lunedì di Pasqua","variable_date":"easter","offset":1},{"name":"Festa del lavoro","fixed_date":[5,1]},{"name":"Festa della Repubblica","fixed_date":[6,2]},{"name":"Assunzione di Maria","fixed_date":[8,15]},{"name":"Ognissanti","fixed_date":[11,1]},{"name":"Immacolata Concezione","fixed_date":[12,8]},{"name":"Natale di Gesù","fixed_date":[12,25]},{"name":"Santo Stefano","fixed_date":[12,26]}],
  SH: [
    {
      name: "festività pasquali",
      2020: [4,9,4,14],
      2021: [4,1,4,6],
      2022: [4,14,4,19],
    },
    {
      name: "vacanza galleggiante",
      2020: [4,24,4,24],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.9808038&lon=12.7662312&zoom=18&addressdetails=1&accept-language=it,en",
  "Abruzzo": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,9,9,24],
        2021: [6,11,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Basilicata": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,12,9,24],
        2021: [6,12,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,11,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [4,26,4,27],
        2025: [3,3,3,4],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Bolzano": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,21,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,8],
        2022: [12,24,1,5],
        2023: [12,27,1,5],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [5,29,5,29],
        2024: [5,20,5,20],
        2025: [6,9,6,9],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,17,9,7],
        2021: [6,17,9,5],
        2022: [6,17,9,4],
        2023: [6,17,9,4],
        2024: [6,14,9,4],
        2025: [6,14,9,7],
      },
      {
        name: "vacanze galleggianti",
        2020: [11,3,11,7],
        2021: [11,3,11,6],
        2022: [12,9,12,10],
        2023: [11,1,11,3],
        2024: [10,26,11,3],
        2025: [3,1,3,9],
        2026: [2,14,2,22],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,8],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,16,6,16],
      },
    ]
  },
  "Calabria": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,24,1,6],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [5,2,5,2],
      },
      {
        name: "vacanze estive",
        2020: [6,10,9,24],
        2021: [6,13,9,19],
        2022: [6,10,9,13],
        2023: [6,11,9,13],
        2024: [6,8,9,15],
        2025: [6,8,9,15],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Campania": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,21,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,8],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,24],
        2021: [6,13,9,14],
        2022: [6,9,9,12],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,12,2,13],
        2025: [5,2,5,3],
        2026: [2,16,2,17],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  },
  "Emilia-Romagna": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,5],
        2023: [12,24,1,5],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,12],
        2022: [6,5,9,14],
        2023: [6,8,9,14],
        2024: [6,6,9,15],
        2025: [6,7,9,14],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [11,2,11,2],
        2024: [11,2,11,2],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  },
  "Friuli Venezia Giulia": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,27,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [10,31,10,31],
        2023: [4,24,4,24],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,16],
        2021: [6,11,9,15],
        2022: [6,12,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,10],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,12,2,14],
        2025: [3,3,3,5],
        2026: [2,16,2,18],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Lazio": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,6],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,8,9,14],
        2021: [6,9,9,12],
        2022: [6,9,9,14],
        2023: [6,9,9,14],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
      },
      {
        name: "vacanze galleggianti",
        2021: [5,31,6,1],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Liguria": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,8],
        2022: [12,23,1,7],
        2023: [12,27,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2023: [4,24,4,24],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,10,9,14],
        2022: [6,11,9,13],
        2023: [6,11,9,13],
        2024: [6,8,9,15],
        2025: [6,11,9,14],
      },
      {
        name: "vacanze galleggianti",
        2022: [6,3,6,4],
        2024: [4,29,4,30],
        2025: [5,2,5,3],
        2026: [2,16,2,17],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,21],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,11,6,11],
      },
    ]
  },
  "Lombardia": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [2,29,2,29],
        2021: [11,2,11,2],
        2022: [3,1,3,1],
      },
      {
        name: "vacanze estive",
        2020: [6,8,9,14],
        2021: [6,9,9,12],
        2022: [6,9,9,11],
        2023: [6,9,9,11],
        2024: [6,8,9,15],
        2025: [6,8,9,11],
      },
      {
        name: "vacanze galleggianti",
        2021: [2,19,2,20],
        2022: [3,4,3,5],
        2023: [2,24,2,25],
        2024: [2,12,2,13],
        2025: [3,3,3,4],
        2026: [2,16,2,17],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,21],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Marche": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,7],
        2023: [12,24,1,6],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,14],
        2022: [6,5,9,13],
        2023: [6,11,9,12],
        2024: [6,6,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2023: [11,1,11,3],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  },
  "Molise": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,8],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [12,9,12,9],
        2024: [12,7,12,7],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,14],
        2022: [6,9,9,13],
        2023: [6,11,9,13],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,29,4,30],
        2025: [5,2,5,3],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Piemonte": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,24,1,8],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [3,1,3,1],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [3,1,3,1],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,12,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,10],
        2024: [6,8,9,15],
        2025: [6,8,9,9],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
        2026: [2,14,2,17],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Puglia": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,9],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,2,12,2],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,24],
        2021: [6,12,9,19],
        2022: [6,10,9,13],
        2023: [6,11,9,13],
        2024: [6,7,9,15],
        2025: [6,8,9,15],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [2,12,2,13],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Sardegna": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,5],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [11,2,11,2],
        2021: [11,2,11,2],
        2022: [11,2,11,2],
        2023: [11,2,11,2],
        2024: [11,2,11,2],
        2025: [4,28,4,28],
        2026: [5,2,5,2],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,22],
        2021: [6,13,9,13],
        2022: [6,9,9,13],
        2023: [6,11,9,13],
        2024: [6,7,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,13,2,13],
        2025: [3,3,3,4],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,8,6,8],
      },
    ]
  },
  "Sicilia": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,6],
        2022: [12,23,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,23,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,9,9,15],
        2022: [6,11,9,18],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "vacanza galleggiante",
        2023: [11,2,11,2],
        2024: [11,2,11,2],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Toscana": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,24,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,5],
        2022: [12,24,1,5],
        2023: [12,24,1,5],
        2024: [12,24,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,11,9,14],
        2022: [6,11,9,14],
        2023: [6,11,9,14],
        2024: [6,10,9,15],
        2025: [6,11,9,14],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Trento": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,23,1,6],
        2022: [12,23,1,5],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,11,9,14],
        2021: [6,11,9,12],
        2022: [6,11,9,11],
        2023: [6,10,9,10],
        2024: [6,11,9,8],
        2025: [6,13,9,9],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,18,4,26],
        2026: [4,2,4,8],
      },
      {
        name: "vacanze galleggianti",
        2024: [2,8,2,13],
        2025: [5,1,5,3],
        2026: [2,16,2,18],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Umbria": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,23,1,5],
        2021: [12,23,1,6],
        2022: [12,23,1,7],
        2023: [12,22,1,5],
        2024: [12,23,1,6],
        2025: [12,22,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [11,2,11,2],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,10,9,14],
        2021: [6,10,9,12],
        2022: [6,10,9,13],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,14],
      },
      {
        name: "vacanze galleggianti",
        2021: [5,31,6,1],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,9,6,9],
      },
    ]
  },
  "Valle d'Aosta": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,23,1,8],
        2022: [12,24,1,7],
        2023: [12,24,1,7],
        2024: [12,23,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [3,1,3,1],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,13,9,14],
        2021: [6,9,9,12],
        2022: [6,9,9,18],
        2023: [6,16,9,10],
        2024: [6,6,9,15],
        2025: [6,11,9,9],
      },
      {
        name: "vacanze galleggianti",
        2023: [1,30,1,31],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
        2026: [2,16,2,18],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,11],
        2024: [3,28,4,1],
        2025: [4,17,4,21],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,10,6,10],
      },
    ]
  },
  "Veneto": {
    SH: [
      {
        name: "festività natalizie",
        2019: [12,23,1,6],
        2020: [12,24,1,5],
        2021: [12,24,1,8],
        2022: [12,24,1,7],
        2023: [12,23,1,5],
        2024: [12,23,1,6],
        2025: [12,24,1,6],
      },
      {
        name: "vacanza galleggiante",
        2020: [12,7,12,7],
        2021: [2,17,2,17],
        2022: [10,31,10,31],
        2023: [12,9,12,9],
        2024: [11,2,11,2],
        2025: [4,26,4,26],
        2026: [6,1,6,1],
      },
      {
        name: "vacanze estive",
        2020: [6,7,9,14],
        2021: [6,6,9,12],
        2022: [6,9,9,11],
        2023: [6,11,9,12],
        2024: [6,8,9,15],
        2025: [6,8,9,9],
      },
      {
        name: "vacanze galleggianti",
        2022: [12,9,12,10],
        2024: [4,26,4,27],
        2025: [5,2,5,3],
        2026: [2,16,2,18],
      },
      {
        name: "festività pasquali",
        2023: [4,6,4,8],
        2024: [3,28,4,2],
        2025: [4,17,4,19],
        2026: [4,2,4,7],
      },
      {
        name: "Fine delle lezioni",
        2026: [6,6,6,6],
      },
    ]
  }
};

const jp = {
  PH: [{"name":"元日","fixed_date":[1,1]},{"name":"成人の日","variable_date":"firstJanuaryMonday","offset":7},{"name":"建国記念の日","fixed_date":[2,11]},{"name":"天皇誕生日","fixed_date":[2,23]},{"name":"昭和の日","fixed_date":[4,29]},{"name":"憲法記念日","fixed_date":[5,3]},{"name":"みどりの日","fixed_date":[5,4]},{"name":"こどもの日","fixed_date":[5,5]},{"name":"海の日","variable_date":"firstJulyMonday","offset":14},{"name":"山の日","fixed_date":[8,11]},{"name":"敬老の日","variable_date":"firstSeptemberMonday","offset":14},{"name":"スポーツの日","variable_date":"firstNovemberMonday","offset":7},{"name":"文化の日","fixed_date":[11,3]},{"name":"勤労感謝の日","fixed_date":[11,23]},{"name":"春分の日","variable_date":"springEquinox"},{"name":"秋分の日","variable_date":"autumnalEquinox"}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=35.39291572&lon=139.44288869&zoom=18&addressdetails=1&accept-language=ja,en"
};

const li = {
  SH: [
    {
      name: "Winterferien",
      2019: [12,21,1,6],
      2020: [12,24,1,6],
      2021: [12,24,1,9],
      2022: [12,24,1,8],
      2023: [12,23,1,7],
      2024: [12,21,1,6],
      2025: [12,24,1,6],
      2026: [12,24,1,6],
    },
    {
      name: "Sommerferien",
      2020: [7,4,8,16],
      2021: [7,3,8,15],
      2022: [7,2,8,16],
      2023: [7,8,8,20],
      2024: [7,6,8,18],
      2025: [7,5,8,17],
      2026: [7,4,8,16],
    },
    {
      name: "Herbstferien",
      2020: [10,3,10,18],
      2021: [10,2,10,17],
      2022: [10,1,10,16],
      2023: [10,7,10,22],
      2024: [10,5,10,20],
      2025: [10,4,10,19],
      2026: [10,3,10,18],
    },
    {
      name: "Sportferien",
      2020: [2,22,3,1],
      2021: [2,13,2,21],
      2022: [2,26,3,6],
      2023: [2,18,2,26],
      2024: [2,10,2,18],
      2025: [3,1,3,9],
      2026: [2,14,2,22],
    },
    {
      name: "Schulfrei",
      2020: [6,12,6,12],
      2021: [6,4,6,4],
      2022: [6,17,6,17],
      2023: [6,9,6,9],
      2024: [5,31,5,31],
      2025: [6,20,6,20],
      2026: [6,5,6,5],
    },
    {
      name: "Frühlingsferien",
      2020: [4,10,4,26],
      2021: [4,2,4,18],
      2022: [4,13,5,1],
      2023: [4,7,4,23],
      2024: [3,29,4,14],
      2025: [4,18,5,4],
      2026: [4,3,4,19],
    },
  ]
};

const lt = {
  SH: [
    {
      name: "Žiemos atostogos",
      2019: [12,23,1,3],
      2020: [12,23,1,5],
      2021: [12,27,1,7],
      2022: [12,27,1,6],
      2023: [12,27,1,5],
      2024: [12,27,1,3],
      2025: [12,24,1,4],
      2026: [12,23,1,3],
      2027: [2,15,2,21],
    },
    {
      name: "Pavasario atostogos",
      2020: [4,14,4,17],
      2021: [4,6,4,9],
      2022: [4,19,4,22],
      2023: [4,11,4,14],
      2024: [4,2,4,5],
      2025: [4,22,4,25],
      2026: [4,6,4,12],
      2027: [3,29,4,4],
    },
    {
      name: "Atgal į mokyklą",
      2020: [9,1,9,1],
      2021: [9,1,9,1],
      2022: [9,1,9,1],
      2023: [9,1,9,1],
      2024: [9,1,9,1],
      2025: [9,1,9,1],
      2026: [9,1,9,1],
      2027: [9,1,9,1],
    },
    {
      name: "Rudens atostogos",
      2020: [10,26,10,30],
      2021: [11,3,11,5],
      2022: [10,31,11,4],
      2023: [10,30,11,3],
      2024: [10,28,10,31],
      2025: [11,3,11,9],
      2026: [11,2,11,8],
    },
  ]
};

const lu = {
  PH: [{"name":"Neijoerschdag - Neujahr - Nouvel An","fixed_date":[1,1]},{"name":"Ouschterméindeg - Ostermontag - Lundi de Pâques","variable_date":"easter","offset":1},{"name":"Dag vun der Aarbecht - Tag der Arbeit - Premier Mai","fixed_date":[5,1]},{"name":"Europadag - Europatag - Journée de l'Europe","fixed_date":[5,1]},{"name":"Christi Himmelfaart - Christi Himmelfahrt - Ascension","variable_date":"easter","offset":39},{"name":"Péngschtméindeg - Pfingstmontag - Lundi de Pentecôte","variable_date":"easter","offset":50},{"name":"Nationalfeierdag - Nationalfeiertag - Fête nationale","fixed_date":[6,23]},{"name":"Mariä Himmelfaart - Maria Himmelfahrt - Assomption","fixed_date":[8,15]},{"name":"Allerhellgen - Weihnachten - Allerheiligen - Toussaint","fixed_date":[11,1]},{"name":"Chrëschtdag - Noël","fixed_date":[12,25]},{"name":"Stiefesdag - Zweiter Weihnachtsfeiertag - St. Etienne","fixed_date":[12,26]}],
  SH: [
    {
      name: "Vacances de Noël",
      2019: [12,21,1,5],
      2020: [12,19,1,3],
      2021: [12,18,1,2],
      2022: [12,24,1,8],
      2023: [12,23,1,7],
      2024: [12,21,1,5],
      2025: [12,20,1,4],
      2026: [12,19,1,3],
    },
    {
      name: "Congé de Carnaval",
      2020: [2,15,2,23],
      2021: [2,13,2,21],
      2022: [2,12,2,20],
      2023: [2,11,2,19],
      2024: [2,10,2,18],
      2025: [2,15,2,23],
      2026: [2,14,2,22],
      2027: [2,6,2,14],
    },
    {
      name: "Vacances de Pâques",
      2020: [4,4,4,19],
      2021: [4,3,4,22],
      2022: [4,2,4,18],
      2023: [4,1,4,16],
      2024: [3,30,4,14],
      2025: [4,5,4,20],
      2026: [3,28,4,12],
      2027: [3,27,4,11],
    },
    {
      name: "Congé de la Pentecôte",
      2020: [5,30,6,7],
      2021: [5,22,5,30],
      2022: [5,21,5,29],
      2023: [5,27,6,4],
      2024: [5,25,6,2],
      2025: [5,24,6,1],
      2026: [5,23,5,31],
      2027: [5,29,6,6],
    },
    {
      name: "Vacances d’été",
      2020: [7,16,9,14],
      2021: [7,16,9,14],
      2022: [7,16,9,14],
      2023: [7,15,9,14],
      2024: [7,16,9,15],
      2025: [7,16,9,14],
      2026: [7,16,9,14],
      2027: [7,16,9,14],
    },
    {
      name: "Congé de la Toussaint",
      2020: [10,31,11,8],
      2021: [10,30,11,7],
      2022: [10,29,11,6],
      2023: [10,28,11,5],
      2024: [10,26,11,3],
      2025: [11,1,11,9],
      2026: [10,31,11,8],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Luxembourg&zoom=18&addressdetails=1&limit=1&accept-language=lb,fr,de,en"
};

const lv = {
  SH: [
    {
      name: "Ziemas brīvdienas",
      2019: [12,23,1,3],
      2020: [12,21,1,1],
      2021: [12,22,1,4],
      2022: [12,26,1,6],
      2023: [12,25,1,5],
      2024: [12,23,1,5],
    },
    {
      name: "Pavasara brīvdienas",
      2020: [3,16,3,20],
      2021: [3,15,3,19],
      2022: [3,14,3,18],
      2023: [3,13,3,17],
      2024: [3,11,3,15],
      2025: [3,10,3,16],
    },
    {
      name: "Vasaras brīvdienas",
      2020: [6,1,8,31],
      2021: [6,1,8,31],
      2022: [6,1,8,31],
      2023: [6,1,8,31],
      2024: [6,1,8,31],
      2025: [5,31,8,31],
    },
    {
      name: "Rudens brīvdienas",
      2020: [10,19,10,23],
      2021: [10,18,10,22],
      2022: [10,24,10,28],
      2023: [10,23,10,27],
      2024: [10,21,10,27],
    },
  ]
};

const mc = {
  SH: [
    {
      name: "Vacances de Noël",
      2019: [12,21,1,5],
      2020: [12,19,1,3],
      2021: [12,18,1,2],
      2022: [12,17,1,2],
      2023: [12,23,1,7],
      2024: [12,21,1,5],
      2025: [12,20,1,4],
    },
    {
      name: "Vacances d’hiver",
      2020: [2,15,3,1],
      2021: [2,20,3,7],
      2022: [2,5,2,20],
      2023: [2,11,2,26],
      2024: [2,24,3,10],
      2025: [2,8,2,23],
      2026: [2,14,3,1],
    },
    {
      name: "Vacances de printemps",
      2020: [4,11,4,26],
      2021: [4,10,4,25],
      2022: [4,9,4,24],
      2023: [4,15,5,1],
      2024: [4,20,5,5],
      2025: [4,5,4,21],
      2026: [4,11,4,26],
    },
    {
      name: "Grand Prix historique",
      2020: [5,8,5,8],
      2022: [5,13,5,15],
    },
    {
      name: "Grand Prix de Formule 1 et Pentecôte",
      2020: [5,21,5,24],
      2021: [5,15,5,24],
      2022: [5,26,5,29],
      2023: [5,25,5,29],
      2024: [5,23,5,26],
      2025: [5,22,5,25],
      2026: [5,21,5,25],
    },
    {
      name: "Vacances d’été",
      2020: [6,27,9,6],
      2021: [7,1,9,5],
      2022: [7,2,9,4],
      2023: [7,1,9,10],
      2024: [6,29,9,8],
      2025: [6,28,9,7],
      2026: [6,27,9,6],
    },
    {
      name: "Vacances de la Toussaint",
      2020: [10,22,11,2],
      2021: [10,28,11,7],
      2022: [10,22,11,2],
      2023: [10,21,11,1],
      2024: [10,24,11,3],
      2025: [10,23,11,2],
    },
  ]
};

const md = {
  SH: [
    {
      name: "Vacanţa de iarnă",
      2019: [12,25,1,8],
      2020: [12,25,1,10],
      2021: [12,25,1,9],
      2022: [12,24,1,8],
      2023: [12,23,1,8],
      2024: [12,25,1,8],
      2025: [12,25,1,8],
    },
    {
      name: "Vacanţa de primăvară",
      2020: [3,5,3,8],
      2021: [3,5,3,8],
      2022: [3,5,3,8],
      2023: [3,8,3,12],
      2024: [3,8,3,12],
      2025: [3,3,3,9],
      2026: [3,5,3,8],
    },
    {
      name: "Vacanţa de Paşti",
      2020: [4,18,4,27],
      2021: [5,1,5,10],
      2022: [4,23,5,2],
      2023: [4,15,4,24],
      2024: [5,4,5,13],
      2025: [4,19,4,28],
      2026: [4,11,4,20],
    },
    {
      name: "Vacanţa de vară",
      2020: [6,1,8,31],
      2021: [6,1,8,31],
      2022: [6,1,8,31],
      2023: [6,1,8,31],
      2024: [6,1,8,31],
      2025: [6,1,8,31],
      2026: [5,30,8,31],
    },
    {
      name: "Vacanţa de toamnă",
      2020: [10,24,11,1],
      2021: [10,27,10,31],
      2022: [10,26,10,30],
      2023: [11,1,11,5],
      2024: [10,28,11,3],
      2025: [10,27,11,2],
    },
  ]
};

const mt = {
  SH: [
    {
      name: "Vaganzi tal-Milied",
      2019: [12,23,1,6],
      2020: [12,23,1,6],
      2021: [12,23,1,6],
      2022: [12,23,1,6],
      2023: [12,23,1,6],
      2024: [12,23,1,6],
      2025: [12,23,1,6],
    },
    {
      name: "Festi tal-Karnival",
      2020: [2,24,2,25],
      2021: [2,15,2,17],
      2022: [2,28,3,2],
      2023: [2,20,2,21],
      2024: [2,12,2,14],
      2025: [3,1,3,4],
      2026: [2,16,2,17],
    },
    {
      name: "Vaganzi tal-Għid",
      2020: [4,8,4,15],
      2021: [3,31,4,7],
      2022: [4,13,4,20],
      2023: [4,5,4,12],
      2024: [3,27,4,3],
      2025: [4,16,4,23],
      2026: [4,1,4,8],
    },
    {
      name: "Kumpens għall-vaganzi fi tmiem il-ġimgħa",
      2020: [4,16,4,17],
      2021: [4,8,4,9],
      2022: [5,2,5,2],
      2023: [4,13,4,14],
      2024: [12,12,12,12],
      2025: [5,30,5,30],
      2026: [4,9,4,10],
    },
    {
      name: "Vaganzi tas-sajf",
      2020: [6,29,9,29],
      2021: [6,29,9,28],
      2022: [6,30,9,27],
      2023: [6,28,9,26],
      2024: [6,28,9,24],
      2025: [6,27,9,23],
      2026: [7,1,9,29],
    },
    {
      name: "Btajjel ta' nofs it-terminu",
      2020: [11,2,11,4],
      2021: [11,1,11,3],
      2022: [10,31,11,2],
      2023: [11,1,11,3],
      2024: [11,1,11,5],
      2025: [11,3,11,5],
    },
  ]
};

const mx = {
  SH: [
    {
      name: "Receso de invierno",
      2019: [12,23,1,7],
      2020: [12,21,1,5],
      2021: [12,20,12,31],
      2022: [12,19,12,30],
      2023: [12,18,1,2],
      2024: [12,19,1,3],
      2025: [12,22,1,6],
    },
    {
      name: "Receso de primavera",
      2020: [4,6,4,17],
      2021: [3,29,4,9],
      2022: [4,11,4,22],
      2023: [4,3,4,14],
      2024: [3,25,4,5],
      2025: [4,14,4,25],
      2026: [3,30,4,10],
    },
    {
      name: "Receso de clases",
      2020: [7,7,8,23],
      2021: [7,10,8,29],
      2022: [7,29,8,28],
      2023: [7,27,8,27],
      2024: [7,17,8,25],
      2025: [7,16,8,31],
    },
    {
      name: "Fin de lecciones",
      2026: [7,15,7,15],
    },
  ]
};

const na = {
  PH: [{"name":"New Year’s Day","fixed_date":[1,1]},{"name":"Independence Day","fixed_date":[3,21]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Worker’s Day","fixed_date":[5,1]},{"name":"Cassinga Day","fixed_date":[5,4]},{"name":"Ascension Day","variable_date":"easter","offset":39},{"name":"Africa Day","fixed_date":[5,25]},{"name":"Heroes’ Day","fixed_date":[8,26]},{"name":"Human Rights Day","fixed_date":[12,10]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Family Day","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/search?format=json&country=Namibia&zoom=18&addressdetails=1&limit=1"
};

const nl = {
  PH: [{"name":"Nieuwjaarsdag","fixed_date":[1,1]},{"name":"Goede vrijdag","variable_date":"easter","offset":-2},{"name":"Tweede Paasdag","variable_date":"easter","offset":1},{"name":"Koningsdag","fixed_date":[4,27]},{"name":"Bevrijdingsdag","fixed_date":[5,5]},{"name":"Hemelvaartsdag","variable_date":"easter","offset":39},{"name":"Tweede Pinksterdag","variable_date":"easter","offset":50},{"name":"Eerste Kerstdag","fixed_date":[12,25]},{"name":"Tweede Kerstdag","fixed_date":[12,26]}],
  "MI": {
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,25,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,25,1,9],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Voorjaarsvakantie",
        2020: [2,22,3,1],
        2021: [2,20,2,28],
        2022: [2,26,3,6],
        2023: [2,25,3,5],
        2024: [2,17,2,25],
        2025: [2,22,3,2],
        2026: [2,14,2,22],
        2027: [2,20,2,28],
        2028: [2,26,3,5],
        2029: [2,17,2,25],
        2030: [2,23,3,3],
      },
      {
        name: "Meivakantie",
        2020: [4,25,5,3],
        2021: [5,1,5,9],
        2022: [4,30,5,8],
        2023: [4,29,5,7],
        2024: [4,27,5,5],
        2025: [4,26,5,4],
        2026: [4,25,5,3],
        2027: [4,24,5,2],
        2028: [4,29,5,7],
        2029: [4,28,5,6],
        2030: [4,27,5,5],
      },
      {
        name: "Zomervakantie",
        2020: [7,18,8,30],
        2021: [7,17,8,29],
        2022: [7,9,8,21],
        2023: [7,8,8,20],
        2024: [7,13,8,25],
        2025: [7,19,8,31],
        2026: [7,18,8,30],
        2027: [7,17,8,29],
        2028: [7,8,8,20],
        2029: [7,7,8,19],
        2030: [7,13,8,25],
      },
      {
        name: "Herfstvakantie",
        2020: [10,17,10,25],
        2021: [10,16,10,24],
        2022: [10,22,10,30],
        2023: [10,14,10,22],
        2024: [10,26,11,3],
        2025: [10,18,10,26],
        2026: [10,17,10,25],
        2027: [10,16,10,24],
        2028: [10,21,10,29],
        2029: [10,20,10,28],
      },
    ]
  },
  "NO": {
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,25,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,25,1,9],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Voorjaarsvakantie",
        2020: [2,15,2,23],
        2021: [2,20,2,28],
        2022: [2,19,2,27],
        2023: [2,25,3,5],
        2024: [2,17,2,25],
        2025: [2,15,2,23],
        2026: [2,21,3,1],
        2027: [2,20,2,28],
        2028: [2,19,2,27],
        2029: [2,17,2,25],
        2030: [2,16,2,24],
      },
      {
        name: "Meivakantie",
        2020: [4,25,5,3],
        2021: [5,1,5,9],
        2022: [4,30,5,8],
        2023: [4,29,5,7],
        2024: [4,27,5,5],
        2025: [4,26,5,4],
        2026: [4,25,5,3],
        2027: [4,24,5,2],
        2028: [4,29,5,7],
        2029: [4,28,5,6],
        2030: [4,27,5,5],
      },
      {
        name: "Zomervakantie",
        2020: [7,4,8,16],
        2021: [7,10,8,22],
        2022: [7,16,8,28],
        2023: [7,22,9,3],
        2024: [7,20,9,1],
        2025: [7,12,8,24],
        2026: [7,4,8,16],
        2027: [7,10,8,22],
        2028: [7,15,8,27],
        2029: [7,21,9,2],
        2030: [7,20,9,1],
      },
      {
        name: "Herfstvakantie",
        2020: [10,10,10,18],
        2021: [10,16,10,24],
        2022: [10,15,10,23],
        2023: [10,21,10,29],
        2024: [10,26,11,3],
        2025: [10,18,10,26],
        2026: [10,10,10,18],
        2027: [10,16,10,24],
        2028: [10,14,10,22],
        2029: [10,20,10,28],
      },
    ]
  },
  "ZU": {
    SH: [
      {
        name: "Kerstvakantie",
        2019: [12,21,1,5],
        2020: [12,19,1,3],
        2021: [12,25,1,9],
        2022: [12,24,1,8],
        2023: [12,23,1,7],
        2024: [12,21,1,5],
        2025: [12,20,1,4],
        2026: [12,19,1,3],
        2027: [12,25,1,9],
        2028: [12,23,1,7],
        2029: [12,22,1,6],
      },
      {
        name: "Voorjaarsvakantie",
        2020: [2,22,3,1],
        2021: [2,13,2,21],
        2022: [2,26,3,6],
        2023: [2,18,2,26],
        2024: [2,10,2,18],
        2025: [2,22,3,2],
        2026: [2,14,2,22],
        2027: [2,13,3,21],
        2028: [2,26,3,5],
        2029: [2,10,3,18],
        2030: [2,23,3,3],
      },
      {
        name: "Meivakantie",
        2020: [4,25,5,3],
        2021: [5,1,5,9],
        2022: [4,30,5,8],
        2023: [4,29,5,7],
        2024: [4,27,5,5],
        2025: [4,26,5,4],
        2026: [4,25,5,3],
        2027: [4,24,5,2],
        2028: [4,29,5,7],
        2029: [4,28,5,6],
        2030: [4,27,5,5],
      },
      {
        name: "Zomervakantie",
        2020: [7,11,8,23],
        2021: [7,24,9,5],
        2022: [7,23,9,4],
        2023: [7,15,8,27],
        2024: [7,6,8,18],
        2025: [7,5,8,17],
        2026: [7,11,8,23],
        2027: [7,24,9,5],
        2028: [7,22,9,3],
        2029: [7,14,8,26],
        2030: [7,6,8,18],
      },
      {
        name: "Herfstvakantie",
        2020: [10,17,10,25],
        2021: [10,23,10,31],
        2022: [10,22,10,30],
        2023: [10,14,10,22],
        2024: [10,19,10,27],
        2025: [10,11,10,19],
        2026: [10,17,10,25],
        2027: [10,23,10,31],
        2028: [10,21,10,29],
        2029: [10,13,10,21],
      },
    ]
  }
};

const no = {
  PH: [{"name":"Nyttårsdag","fixed_date":[1,1]},{"name":"Skjærtorsdag","variable_date":"easter","offset":-3},{"name":"Langfredag","variable_date":"easter","offset":-2},{"name":"Påskedag","variable_date":"easter"},{"name":"2. Påskedag","variable_date":"easter","offset":1},{"name":"1. Mai","fixed_date":[5,1]},{"name":"Grunnlovsdagen","fixed_date":[5,17]},{"name":"Kristi Himmelfartsdag","variable_date":"easter","offset":39},{"name":"Pinsedag","variable_date":"easter","offset":49},{"name":"2. Pinsedag","variable_date":"easter","offset":50},{"name":"Juledag","fixed_date":[12,25]},{"name":"2. Juledag","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=61.0&lon=8.0&zoom=8&addressdetails=1&accept-language=no,en"
};

const nz = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Day after New Year's Day","fixed_date":[1,2]},{"name":"Waitangi Day","fixed_date":[2,6]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Anzac Day","fixed_date":[4,25]},{"name":"Queen's Birthday","variable_date":"firstJuneMonday"},{"name":"Labour Day","variable_date":"firstOctoberMonday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Boxing Day","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=-41.2922255&lon=174.7763033&zoom=16&addressdetails=1&accept-language=en"
};

const pl = {
  PH: [{"name":"Nowy Rok","fixed_date":[1,1]},{"name":"Święto Trzech Króli","fixed_date":[1,6]},{"name":"Wielkanoc","variable_date":"easter"},{"name":"Lany Poniedziałek - drugi dzień Wielkiej Nocy","variable_date":"easter","offset":1},{"name":"Pierwszy Maja","fixed_date":[5,1]},{"name":"Trzeci Maja","fixed_date":[5,3]},{"name":"Zielone Świątki","variable_date":"easter","offset":49},{"name":"Boże Ciało","variable_date":"easter","offset":60},{"name":"Wniebowzięcie Najświętszej Maryi Panny","fixed_date":[8,15]},{"name":"Wszystkich Świętych","fixed_date":[11,1]},{"name":"Święto Niepodległości","fixed_date":[11,11]},{"name":"Wigilia Bożego Narodzenia","fixed_date":[12,24]},{"name":"pierwszy dzień Bożego Narodzenia","fixed_date":[12,25]},{"name":"drugi dzień Bożego Narodzenia","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=53.4825&lon=18.75823&zoom=18&addressdetails=1&accept-language=pl,en",
  "Dolnośląskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [2,2,2,15],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Kujawsko-pomorskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,2,2,15],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Łódzkie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,2,2,15],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Lubelskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,16,3,1],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Lubuskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,16,3,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Małopolskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,2,2,15],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Mazowieckie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [1,19,2,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Opolskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [2,2,2,15],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Podkarpackie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,16,3,1],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Podlaskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,20,2,2],
        2021: [1,4,1,17],
        2022: [1,24,2,6],
        2023: [1,23,2,5],
        2024: [1,22,2,4],
        2025: [1,27,2,9],
        2026: [1,19,2,1],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Pomorskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [1,19,2,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Śląskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,13,1,26],
        2021: [1,4,1,17],
        2022: [1,17,1,30],
        2023: [1,16,1,29],
        2024: [1,29,2,11],
        2025: [2,17,3,2],
        2026: [2,16,3,1],
        2027: [1,18,1,31],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Świętokrzyskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [1,19,2,1],
        2027: [2,1,2,14],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Warmińsko-mazurskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,20,2,2],
        2021: [1,4,1,17],
        2022: [1,24,2,6],
        2023: [1,23,2,5],
        2024: [1,22,2,4],
        2025: [1,27,2,9],
        2026: [1,19,2,1],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Wielkopolskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,27,2,9],
        2021: [1,4,1,17],
        2022: [1,31,2,13],
        2023: [1,30,2,12],
        2024: [2,12,2,25],
        2025: [1,20,2,2],
        2026: [2,16,3,1],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  },
  "Zachodniopomorskie": {
    SH: [
      {
        name: "Zimowa przerwa świąteczna",
        2019: [12,23,12,31],
        2020: [12,23,12,31],
        2021: [12,23,12,31],
        2022: [12,23,12,31],
        2023: [12,23,12,31],
        2024: [12,23,12,31],
        2025: [12,22,12,31],
      },
      {
        name: "Ferie zimowe",
        2020: [1,10,1,23],
        2021: [1,4,1,17],
        2022: [1,14,1,27],
        2023: [1,13,1,26],
        2024: [1,15,1,28],
        2025: [2,3,2,16],
        2026: [2,2,2,15],
        2027: [2,15,2,28],
      },
      {
        name: "Wiosenna przerwa świąteczna",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
      },
      {
        name: "Ferie letnie",
        2020: [6,27,8,31],
        2021: [6,26,8,31],
        2022: [6,25,8,31],
        2023: [6,24,8,31],
        2024: [6,22,8,31],
        2025: [6,28,8,31],
        2026: [6,27,8,31],
      },
    ]
  }
};

const pt = {
  SH: [
    {
      name: "Férias de Natal",
      2019: [12,18,1,3],
      2020: [12,21,12,31],
      2021: [12,20,1,7],
      2022: [12,19,1,2],
      2023: [12,18,1,2],
      2024: [12,18,1,3],
      2025: [12,16,1,5],
      2026: [12,16,12,31],
      2027: [12,20,12,31],
    },
    {
      name: "Férias de Carnaval",
      2020: [2,24,2,26],
      2022: [3,1,3,1],
      2023: [2,20,2,22],
      2024: [2,12,2,14],
      2025: [3,3,3,5],
      2026: [2,16,2,18],
      2027: [2,8,2,10],
      2028: [2,28,3,1],
    },
    {
      name: "Férias de Páscoa",
      2020: [3,30,4,13],
      2021: [3,29,4,1],
      2022: [4,11,4,18],
      2023: [4,3,4,14],
      2024: [3,25,4,5],
      2025: [4,7,4,21],
      2026: [3,30,4,10],
      2027: [3,22,4,2],
      2028: [4,3,4,17],
    },
    {
      name: "Férias de verão",
      2020: [6,20,9,13],
      2021: [7,9,9,13],
      2022: [7,1,9,12],
      2023: [7,1,9,11],
      2024: [6,29,9,11],
      2025: [6,28,9,10],
      2026: [7,1,9,10],
      2027: [7,1,9,12],
    },
    {
      name: "Fim das aulas",
      2028: [6,30,6,30],
    },
  ]
};

const ro = {
  PH: [{"name":"Anul Nou","fixed_date":[1,1]},{"name":"A doua zi de Anul Nou","fixed_date":[1,2]},{"name":"Ziua Unirii Principatelor Române (Ziua Unirii)","fixed_date":[1,24]},{"name":"Paștele ortodox","variable_date":"orthodox easter"},{"name":"A doua zi de Paște ortodox","variable_date":"orthodox easter","offset":1},{"name":"Ziua Muncii","fixed_date":[5,1]},{"name":"Rusaliile","variable_date":"orthodox easter","offset":50},{"name":"A doua zi de Rusalii","variable_date":"orthodox easter","offset":51},{"name":"Adormirea Maicii Domnului","fixed_date":[8,15]},{"name":"Sfântul Apostol Andrei","fixed_date":[11,30]},{"name":"Ziua Națională (Ziua Marii Uniri)","fixed_date":[12,1]},{"name":"Crăciunul","fixed_date":[12,25]},{"name":"A doua zi de Crăciun","fixed_date":[12,26]}],
  SH: [
    {
      name: "Vacanța de iarnă",
      2014: [12,20,1,4],
      2015: [12,19,1,3],
    },
    {
      name: "Vacanţa intersemestrială",
      2015: [1,31,2,8],
      2016: [1,30,2,7],
      2021: [1,30,2,7],
    },
    {
      name: "Vacanța de primăvară",
      2015: [4,11,4,19],
      2016: [4,23,5,3],
    },
    {
      name: "Vacanța de vară",
      2015: [6,20,9,13],
      2016: [6,18,9,4],
    },
    {
      name: "Vacanţa de iarnă",
      2019: [12,21,1,12],
      2020: [12,23,1,10],
      2021: [12,24,1,9],
      2022: [12,23,1,8],
      2023: [12,23,1,7],
      2024: [12,21,1,7],
      2025: [12,20,1,7],
    },
    {
      name: "Vacanţa de primăvară",
      2020: [4,4,4,21],
      2022: [4,15,5,1],
      2023: [4,7,4,18],
      2024: [4,27,5,7],
      2025: [4,18,4,27],
      2026: [4,4,4,14],
    },
    {
      name: "Vacanţa de vară",
      2020: [6,13,9,13],
      2021: [6,19,9,12],
      2022: [6,11,9,4],
      2023: [6,17,9,3],
      2024: [6,22,9,8],
      2025: [6,21,9,7],
      2026: [6,20,9,6],
    },
    {
      name: "Vacanţa de toamnă",
      2020: [10,24,11,1],
      2021: [10,23,11,7],
      2022: [10,22,10,30],
      2023: [10,28,11,5],
      2024: [10,26,11,3],
      2025: [10,25,11,1],
    },
    {
      name: "Vacanţa de primăvară 1",
      2021: [4,2,4,11],
    },
    {
      name: "Vacanţa de primăvară 2",
      2021: [4,30,5,9],
    },
    {
      name: "Vacanţa de schi",
      2024: [2,12,2,18],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=45.9852129&lon=24.6859225&zoom=18&addressdetails=1&accept-language=ro,en",
  "Alba": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Arad": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Argeș": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Bacău": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Bihor": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Bistrița-Năsăud": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,12,2,18],
        2025: [2,10,2,14],
        2026: [2,9,2,13],
      },
    ]
  },
  "Botoșani": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Brăila": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "Brașov": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "București": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Buzău": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Călărași": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Caraș-Severin": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Cluj": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,9,2,13],
      },
    ]
  },
  "Constanța": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Covasna": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Dâmbovița": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Dolj": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Galați": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Giurgiu": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "Gorj": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Harghita": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Hunedoara": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Ialomița": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Iași": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Ilfov": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,6,2,12],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Maramureș": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Mehedinți": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Mureș": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Neamț": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Olt": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Prahova": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Sălaj": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Satu Mare": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,12,2,18],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Sibiu": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Suceava": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,6,2,12],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,23,2,27],
      },
    ]
  },
  "Teleorman": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,13,2,19],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Timiș": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,17,2,21],
        2026: [2,9,2,13],
      },
    ]
  },
  "Tulcea": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  },
  "Vâlcea": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,26,3,3],
        2025: [2,17,2,21],
        2026: [2,16,2,20],
      },
    ]
  },
  "Vaslui": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "Vrancea": {
    SH: [
      {
        name: "Vacanţa de schi",
        2023: [2,20,2,26],
        2024: [2,19,2,25],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  }
};

const rs = {
  SH: [
    {
      name: "Зимски распуст",
      2019: [12,30,1,7],
      2020: [12,31,1,8],
      2021: [12,31,1,21],
      2022: [1,4,1,21],
      2023: [1,3,1,20],
      2024: [12,30,1,17],
      2025: [12,31,1,16],
    },
    {
      name: "Пролећни распуст",
      2020: [4,15,4,20],
      2021: [4,30,5,7],
      2022: [4,22,5,3],
      2023: [4,11,4,18],
      2024: [4,29,5,6],
      2025: [4,16,4,21],
      2026: [4,10,4,14],
    },
    {
      name: "Летњи распуст",
      2020: [6,22,8,31],
      2021: [6,23,8,31],
      2022: [6,22,8,31],
      2023: [6,21,8,31],
      2024: [6,24,8,30],
      2025: [6,23,8,29],
      2026: [6,22,8,31],
    },
    {
      name: "Јесењи распуст",
      2020: [11,11,11,13],
      2021: [11,12,11,12],
      2023: [11,8,11,10],
      2024: [11,11,11,12],
      2025: [11,10,11,11],
    },
    {
      name: "Сретењски распуст",
      2026: [2,16,2,20],
    },
  ]
};

const ru = {
  PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.7780&lon=49.1303&zoom=18&addressdetails=1&accept-language=ru,en",
  "Адыгея": {
    "_state_code": "adygea",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=44.60627&lon=40.10432&zoom=18&addressdetails=1&accept-language=ru,us",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]},{"name":"День образования Республики Адыгея","fixed_date":[10,5]}]
  },
  "Башкортостан": {
    "_state_code": "bashkortostan",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=54.1264&lon=56.5797&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]},{"name":"День Республики Башкирии","fixed_date":[10,11]},{"name":"День Конституции Башкортостана","fixed_date":[12,24]}]
  },
  "Брянская область": {
    "_state_code": "bryansk",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=52.952&lon=33.283&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Радоница","fixed_date":[4,29]},{"name":"День освобождения города Брянска","fixed_date":[9,17]}]
  },
  "Дагестан": {
    "_state_code": "dagestan",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.118&lon=46.959&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Конституции Республики Дагестан","fixed_date":[7,26]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"День единства народов Дагестана","fixed_date":[9,15]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Ингушетия": {
    "_state_code": "ingushetia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.1171&lon=44.8626&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День образования Республики Ингушетия","fixed_date":[6,4]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Кабардино-Балкария": {
    "_state_code": "kabardino_balkaria",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.497&lon=43.423&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День возрождения балкарского народа","fixed_date":[3,28]},{"name":"Черкесский день траура","fixed_date":[5,21]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"День государственности Кабардино-Балкарской Республики","fixed_date":[9,1]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Калмыкия": {
    "_state_code": "kalmykia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=46.524&lon=44.731&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Цаган Сар","fixed_date":[1,14]},{"name":"День принятия Степного Уложения (Конституции) Республики Калмыкия","fixed_date":[4,5]},{"name":"День рождения Будды Шакьямун","fixed_date":[6,6]},{"name":"Зул","fixed_date":[12,15]},{"name":"День памяти жертв депортации калмыцкого народа","fixed_date":[12,28]}]
  },
  "Карачаево-Черкесия": {
    "_state_code": "karachay_cherkess",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.7916&lon=41.7268&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День возрождения карачаевского народа","fixed_date":[5,3]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Приволжский федеральный округ": {
    "_state_code": "udmurtia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=56.8642&lon=53.2054&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Государственности Удмуртской Республики","fixed_date":[5,31]}]
  },
  "Республика Алтай": {
    "_state_code": "altai",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=50.900&lon=86.899&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Чага-Байрам","fixed_date":[1,14]}]
  },
  "Республика Бурятия": {
    "_state_code": "buryatia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=52.014&lon=109.366&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Сагаалган","fixed_date":[1,14]}]
  },
  "Республика Карелия": {
    "_state_code": "karelia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=63.832&lon=33.626&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Республики Карелия","fixed_date":[6,8]},{"name":"День освобождения Карелии от фашистских захватчиков","fixed_date":[9,30]}]
  },
  "Республика Коми": {
    "_state_code": "komi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=64.191&lon=55.826&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Республики Коми","fixed_date":[8,22]}]
  },
  "Республика Саха (Якутия)": {
    "_state_code": "sakha",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=62.1010&lon=129.7176&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Республики Саха","fixed_date":[4,27]},{"name":"Ысыах","fixed_date":[6,23]},{"name":"День государственности Республики Саха","fixed_date":[9,27]}]
  },
  "Республика Тыва": {
    "_state_code": "tuva",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=51.781&lon=94.033&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Народный праздник Шагаа","fixed_date":[1,14]},{"name":"День Республики Тыва","fixed_date":[8,15]}]
  },
  "Саратовская область": {
    "_state_code": "saratov",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=51.335&lon=46.668&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Радоница","fixed_date":[4,29]}]
  },
  "Татарстан": {
    "_state_code": "tatarstan",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.7780&lon=49.1303&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"День Республики Татарстан","fixed_date":[8,30]},{"name":"Курбан-байрам","fixed_date":[10,4]},{"name":"День Конституции Республики Татарстан","fixed_date":[11,6]}]
  },
  "Чечня": {
    "_state_code": "chechnya",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.451&lon=45.700&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День мира в Чеченской Республике","fixed_date":[4,16]},{"name":"Ураза-байрам","fixed_date":[7,28]},{"name":"Курбан-байрам","fixed_date":[10,4]}]
  },
  "Чувашия": {
    "_state_code": "chuvashia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=55.4871&lon=47.1659&zoom=18&addressdetails=1&accept-language=ru,en",
    PH: [{"name":"1. Новогодние каникулы","fixed_date":[1,1]},{"name":"2. Новогодние каникулы","fixed_date":[1,2]},{"name":"3. Новогодние каникулы","fixed_date":[1,3]},{"name":"4. Новогодние каникулы","fixed_date":[1,4]},{"name":"5. Новогодние каникулы","fixed_date":[1,5]},{"name":"6. Новогодние каникулы","fixed_date":[1,6]},{"name":"Рождество Христово","fixed_date":[1,7]},{"name":"8. Новогодние каникулы","fixed_date":[1,8]},{"name":"День защитника Отечества","fixed_date":[2,23]},{"name":"Международный женский день","fixed_date":[3,8]},{"name":"День Победы","fixed_date":[5,9]},{"name":"Праздник Весны и Труда","fixed_date":[5,1]},{"name":"День народного единства","fixed_date":[11,4]},{"name":"День России","fixed_date":[6,12]},{"name":"День Чувашской республики","fixed_date":[6,24]}]
  }
};

const se = {
  PH: [{"name":"nyårsdagen","fixed_date":[1,1]},{"name":"trettondedag jul","fixed_date":[1,6]},{"name":"långfredagen","variable_date":"easter","offset":-2},{"name":"påskdagen","variable_date":"easter"},{"name":"annandag påsk","variable_date":"easter","offset":1},{"name":"första maj","fixed_date":[5,1]},{"name":"Kristi himmelsfärdsdag","variable_date":"easter","offset":39},{"name":"pingstdagen","variable_date":"easter","offset":49},{"name":"nationaldagen","fixed_date":[6,6]},{"name":"midsommardagen","variable_date":"nextSaturday20Jun"},{"name":"alla helgons dag","variable_date":"nextSaturday31Oct"},{"name":"juldagen","fixed_date":[12,25]},{"name":"annandag jul","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=63.1151&lon=16.5767&zoom=18&addressdetails=1&accept-language=sv,en"
};

const si = {
  PH: [{"name":"novo leto","fixed_date":[1,1]},{"name":"Prešernov dan, slovenski kulturni praznik","fixed_date":[2,8]},{"name":"velikonočna nedelja","variable_date":"easter"},{"name":"velikonočni ponedeljek","variable_date":"easter","offset":1},{"name":"dan upora proti okupatorju","fixed_date":[4,27]},{"name":"praznik dela 1","fixed_date":[5,1]},{"name":"praznik dela 2","fixed_date":[5,2]},{"name":"binkoštna nedelja - binkošti","variable_date":"easter","offset":49},{"name":"dan državnosti","fixed_date":[6,25]},{"name":"Marijino vnebovzetje","fixed_date":[8,15]},{"name":"dan reformacije","fixed_date":[10,31]},{"name":"dan spomina na mrtve","fixed_date":[11,1]},{"name":"božič","fixed_date":[12,25]},{"name":"dan samostojnosti in enotnosti","fixed_date":[12,26]}],
  SH: [
    {
      name: "Novoletne počitnice",
      2019: [12,25,1,2],
      2020: [12,28,12,31],
      2021: [12,27,12,31],
      2022: [12,27,12,30],
      2023: [12,27,1,2],
      2024: [12,27,1,2],
      2025: [12,29,12,31],
    },
    {
      name: "Prvomajske počitnice",
      2020: [4,27,5,1],
      2021: [4,28,4,30],
      2022: [4,28,4,29],
      2023: [4,28,4,28],
      2024: [4,28,5,2],
      2025: [4,28,5,2],
      2026: [4,28,4,30],
    },
    {
      name: "Poletne počitnice",
      2020: [6,26,8,31],
      2021: [6,26,8,31],
      2022: [6,26,8,31],
      2023: [6,26,8,31],
      2024: [6,26,8,31],
      2025: [6,26,8,31],
      2026: [6,26,8,31],
    },
    {
      name: "Jesenske počitnice",
      2020: [10,26,10,30],
      2021: [10,25,11,1],
      2022: [10,31,11,4],
      2023: [10,30,11,1],
      2024: [10,28,11,1],
      2025: [10,27,10,31],
    },
    {
      name: "Pouka prost dan",
      2024: [5,3,5,3],
    },
  ],
  "vzhodne regije": {
    SH: [
      {
        name: "Zimske počitnice",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [2,28,3,4],
        2023: [1,30,2,3],
        2024: [2,26,3,1],
        2025: [2,17,2,21],
        2026: [2,23,2,27],
      },
    ]
  },
  "zahodne regije": {
    SH: [
      {
        name: "Zimske počitnice",
        2020: [2,17,2,21],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [2,6,2,10],
        2024: [2,19,2,23],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
      },
    ]
  }
};

const sk = {
  PH: [{"name":"Deň vzniku Slovenskej republiky","fixed_date":[1,1]},{"name":"Zjavenie Pána","fixed_date":[1,6]},{"name":"Veľký piatok","variable_date":"easter","offset":-2},{"name":"Veľkonočná nedeľa","variable_date":"easter"},{"name":"Veľkonočný pondelok","variable_date":"easter","offset":1},{"name":"Sviatok práce","fixed_date":[5,1]},{"name":"Deň víťazstva nad fašizmom","fixed_date":[5,8]},{"name":"Sviatok svätého Cyrila a Metoda","fixed_date":[7,5]},{"name":"Výročie Slovenského národného povstania","fixed_date":[8,29]},{"name":"Deň Ústavy Slovenskej republiky","fixed_date":[9,1]},{"name":"Sviatok Panny Márie Sedembolestnej","fixed_date":[9,15]},{"name":"Sviatok všetkých svätých","fixed_date":[11,1]},{"name":"Deň boja za slobodu a demokraciu","fixed_date":[11,17]},{"name":"Štedrý deň","fixed_date":[12,24]},{"name":"Prvý sviatok vianočný","fixed_date":[12,25]},{"name":"Druhý sviatok vianočný","fixed_date":[12,26]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=48.7411522&lon=19.4528646&zoom=18&addressdetails=1&accept-language=sk,en",
  "Banskobystrický kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [3,7,3,11],
        2023: [2,27,3,3],
        2024: [2,19,2,23],
        2025: [3,3,3,7],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [3,6,3,10],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Bratislavský kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,17,2,21],
        2021: [3,1,3,5],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [3,4,3,8],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [3,1,3,5],
        2028: [2,28,3,3],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Košický kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [3,2,3,6],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [3,6,3,10],
        2024: [2,26,3,1],
        2025: [2,17,2,21],
        2026: [3,2,3,6],
        2027: [2,22,2,26],
        2028: [2,21,2,25],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Nitriansky kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,17,2,21],
        2021: [3,1,3,5],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [3,4,3,8],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [3,1,3,5],
        2028: [2,28,3,3],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Prešovský kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [3,2,3,6],
        2021: [2,22,2,26],
        2022: [2,21,2,25],
        2023: [3,6,3,10],
        2024: [2,26,3,1],
        2025: [2,17,2,21],
        2026: [3,2,3,6],
        2027: [2,22,2,26],
        2028: [2,21,2,25],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Trenčiansky kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [3,7,3,11],
        2023: [2,27,3,3],
        2024: [2,19,2,23],
        2025: [3,3,3,7],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [3,6,3,10],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Trnavský kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,17,2,21],
        2021: [3,1,3,5],
        2022: [2,28,3,4],
        2023: [2,20,2,24],
        2024: [3,4,3,8],
        2025: [2,24,2,28],
        2026: [2,16,2,20],
        2027: [3,1,3,5],
        2028: [2,28,3,3],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  },
  "Žilinský kraj": {
    SH: [
      {
        name: "Vianočné prázdniny",
        2019: [12,23,1,7],
        2020: [12,23,1,7],
        2021: [12,23,1,7],
        2022: [12,23,1,7],
        2023: [12,23,1,7],
        2024: [12,23,1,7],
        2025: [12,22,1,7],
        2026: [12,23,1,7],
        2027: [12,23,1,7],
      },
      {
        name: "Jarné prázdniny",
        2020: [2,24,2,28],
        2021: [2,15,2,19],
        2022: [3,7,3,11],
        2023: [2,27,3,3],
        2024: [2,19,2,23],
        2025: [3,3,3,7],
        2026: [2,23,2,27],
        2027: [2,15,2,19],
        2028: [3,6,3,10],
      },
      {
        name: "Veľkonočné prázdniny",
        2020: [4,9,4,14],
        2021: [4,1,4,6],
        2022: [4,14,4,19],
        2023: [4,6,4,11],
        2024: [3,28,4,2],
        2025: [4,17,4,22],
        2026: [4,2,4,7],
        2027: [3,25,3,30],
        2028: [4,13,4,18],
      },
      {
        name: "Letné prázdniny",
        2020: [7,1,8,31],
        2021: [7,1,8,31],
        2022: [7,1,8,31],
        2023: [7,1,8,31],
        2024: [7,1,9,1],
        2025: [6,28,9,1],
        2026: [7,1,8,31],
        2027: [7,1,8,31],
        2028: [7,3,9,1],
      },
      {
        name: "Jesenné prázdniny",
        2020: [10,28,10,29],
        2021: [10,28,10,29],
        2022: [10,28,10,31],
        2023: [10,30,10,31],
        2024: [10,30,10,31],
        2025: [10,30,10,31],
        2026: [10,29,10,30],
        2027: [10,28,10,29],
      },
    ]
  }
};

const sm = {
  SH: [
    {
      name: "Vacanze Natalizie",
      2019: [12,24,1,4],
      2020: [12,24,1,5],
      2021: [12,24,1,5],
      2022: [12,24,1,7],
      2023: [12,24,1,5],
      2024: [12,23,1,5],
      2025: [12,24,1,5],
    },
    {
      name: "Vacanze Pasquali",
      2020: [4,9,4,14],
      2021: [4,2,4,6],
      2022: [4,14,4,19],
      2023: [4,3,4,10],
      2024: [3,26,4,1],
      2025: [4,17,4,22],
      2026: [4,2,4,7],
    },
    {
      name: "Vacanze Estive",
      2020: [6,11,9,6],
      2021: [6,12,9,12],
      2022: [6,12,9,14],
      2023: [6,8,9,17],
      2024: [6,8,9,17],
      2025: [6,11,9,14],
    },
    {
      name: "Termine lezioni",
      2026: [6,17,6,17],
    },
  ]
};

const ua = {
  PH: [{"name":"Новий рік","fixed_date":[1,1]},{"name":"Різдво","fixed_date":[1,7]},{"name":"Міжнародний жіночий день","fixed_date":[3,8]},{"name":"Великдень","variable_date":"orthodox easter","offset":1},{"name":"День Праці 1","fixed_date":[5,1]},{"name":"День Праці 2","fixed_date":[5,2]},{"name":"День Перемоги","fixed_date":[5,9]},{"name":"День Конституції України","fixed_date":[6,28]},{"name":"День Незалежності України","fixed_date":[8,24]}]
};

const us = {
  PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=32.3673&lon=-86.2983&zoom=18&addressdetails=1&accept-language=en",
  "Alabama": {
    "_state_code": "al",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=32.3673&lon=-86.2983&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Robert E. Lee/Martin Luther King Birthday","variable_date":"firstJanuaryMonday","offset":14},{"name":"George Washington/Thomas Jefferson Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Confederate Memorial Day","variable_date":"firstAprilMonday","offset":21},{"name":"Jefferson Davis' Birthday","variable_date":"firstJuneMonday"}]
  },
  "Alaska": {
    "_state_code": "ak",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=64.5082&lon=-165.4066&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Seward's Day","variable_date":"lastMarchMonday"},{"name":"Alaska Day","fixed_date":[10,18]}]
  },
  "Arizona": {
    "_state_code": "az",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=34.9378&lon=-109.7565&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Dr. Martin Luther King Jr./Civil Rights Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Arkansas": {
    "_state_code": "ar",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=34.74610&lon=-92.29054&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Dr. Martin Luther King Jr. and Robert E. Lee's Birthdays","variable_date":"firstJanuaryMonday","offset":14},{"name":"George Washington's Birthday and Daisy Gatson Bates Day","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "California": {
    "_state_code": "ca",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=40.8001&lon=-124.1698&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"César Chávez Day","fixed_date":[3,31]}]
  },
  "Colorado": {
    "_state_code": "co",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=39.1804&lon=-106.8218&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Connecticut": {
    "_state_code": "ct",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.9111&lon=-72.16014&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "Delaware": {
    "_state_code": "de",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=38.7113&lon=-75.0978&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Day After Thanksgiving","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "District of Columbia": {
    "_state_code": "dc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=38.8953&lon=-77.0356&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Emancipation Day","fixed_date":[4,16]}]
  },
  "Florida": {
    "_state_code": "fl",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=25.7720&lon=-80.1324&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Friday after Thanksgiving","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Georgia": {
    "_state_code": "ga",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=31.0823&lon=-81.4192&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Robert E. Lee's Birthday","variable_date":"firstNovemberThursday","offset":22},{"name":"Washington's Birthday","fixed_date":[12,24]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Confederate Memorial Day","variable_date":"lastAprilMonday"}]
  },
  "Guam": {
    "_state_code": "gu",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=13.4311&lon=144.6549&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Guam Discovery Day","fixed_date":[3,5]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Liberation Day","fixed_date":[7,21]},{"name":"All Souls' Day","fixed_date":[11,2]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Lady of Camarin Day","fixed_date":[12,8]},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Hawaii": {
    "_state_code": "hi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=19.6423&lon=-155.4837&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Prince Jonah Kuhio Kalanianaole Day","fixed_date":[3,26]},{"name":"Kamehameha Day","fixed_date":[6,11]},{"name":"Statehood Day","variable_date":"firstAugustFriday","offset":14},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "Idaho": {
    "_state_code": "id",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=47.6710&lon=-116.7671&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr.-Idaho Human Rights Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Illinois": {
    "_state_code": "il",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.05202&lon=-87.67594&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Casimir Pulaski Day","variable_date":"firstMarchMonday"},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "Indiana": {
    "_state_code": "in",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=40.4179&lon=-86.8969&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Lincoln's Birthday","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Primary Election Day","variable_date":"firstMayMonday","offset":1},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "Iowa": {
    "_state_code": "ia",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.9747&lon=-91.6760&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Lincoln's Birthday","fixed_date":[2,12]}]
  },
  "Kansas": {
    "_state_code": "ks",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=37.6888&lon=-97.3271&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Kentucky": {
    "_state_code": "ky",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=36.8446&lon=-83.3196&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"New Year's Eve","fixed_date":[12,31]},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "Louisiana": {
    "_state_code": "la",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=30.1800&lon=-90.1787&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Mardi Gras","variable_date":"easter","offset":-47},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "Maine": {
    "_state_code": "me",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=44.7903&lon=-68.7829&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Patriots' Day","variable_date":"firstAprilMonday","offset":14}]
  },
  "Maryland": {
    "_state_code": "md",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=38.3206&lon=-75.6213&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Native American Heritage Day","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Massachusetts": {
    "_state_code": "ma",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.3550&lon=-71.0645&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Patriots' Day","variable_date":"firstAprilMonday","offset":14}]
  },
  "Michigan": {
    "_state_code": "mi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.7153&lon=-84.4995&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"New Year's Eve","fixed_date":[12,31]}]
  },
  "Minnesota": {
    "_state_code": "mn",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=47.8278&lon=-90.0484&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Mississippi": {
    "_state_code": "ms",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=30.3986&lon=-88.8820&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King's and Robert E. Lee's Birthdays","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Confederate Memorial Day","variable_date":"lastAprilMonday"}]
  },
  "Missouri": {
    "_state_code": "mo",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=37.0799&lon=-94.5060&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Truman Day","fixed_date":[5,8]}]
  },
  "Montana": {
    "_state_code": "mt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=48.3866&lon=-115.5498&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"New Year's Eve","fixed_date":[12,31]}]
  },
  "Nebraska": {
    "_state_code": "ne",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.2587&lon=-95.9374&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Arbor Day","variable_date":"lastAprilFriday"}]
  },
  "Nevada": {
    "_state_code": "nv",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=36.1215&lon=-115.1704&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Nevada Day","variable_date":"lastOctoberFriday"},{"name":"Family Day","variable_date":"firstNovemberThursday","offset":22}]
  },
  "New Hampshire": {
    "_state_code": "nh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.5628&lon=-71.9447&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Civil Rights Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Day after Thanksgiving","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "New Jersey": {
    "_state_code": "nj",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=39.9475&lon=-75.1066&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "New Mexico": {
    "_state_code": "nm",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=34.0790&lon=-107.6179&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Day after Thanksgiving","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "New York": {
    "_state_code": "ny",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.8126&lon=-73.9379&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Lincoln's Birthday","fixed_date":[2,12]},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "North Carolina": {
    "_state_code": "nc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=35.7802&lon=-78.6394&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Day after Thanksgiving","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Day after Christmas","fixed_date":[12,26]},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "North Dakota": {
    "_state_code": "nd",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=48.1459&lon=-103.6232&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Ohio": {
    "_state_code": "oh",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.4846&lon=-82.6852&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Oklahoma": {
    "_state_code": "ok",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=36.0514&lon=-95.7892&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Day after Thanksgiving","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Oregon": {
    "_state_code": "or",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=45.3732&lon=-121.6959&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Pennsylvania": {
    "_state_code": "pa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=40.3340&lon=-75.9300&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Flag Day","fixed_date":[6,14]}]
  },
  "Puerto Rico": {
    "_state_code": "pr",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=18.4364&lon=-66.1188&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"Día de Año Nuevo","fixed_date":[1,1]},{"name":"Día de Reyes","fixed_date":[1,6]},{"name":"Natalicio de Eugenio María de Hostos","variable_date":"firstJanuaryMonday","offset":7},{"name":"Natalicio de Martin Luther King, Jr.","variable_date":"firstJanuaryMonday","offset":14},{"name":"Día de los Presidentes","variable_date":"firstFebruaryMonday","offset":14},{"name":"Día de la Abolición de Esclavitud","fixed_date":[3,22]},{"name":"Viernes Santo","variable_date":"easter","offset":-2},{"name":"Natalicio de José de Diego","variable_date":"firstAprilMonday","offset":14},{"name":"Recordación de los Muertos de la Guerra","variable_date":"lastMayMonday"},{"name":"Día de la Independencia","fixed_date":[7,4]},{"name":"Constitución de Puerto Rico","fixed_date":[7,25]},{"name":"Natalicio de Dr. José Celso Barbosa","fixed_date":[7,27]},{"name":"Día del Trabajo","variable_date":"firstSeptemberMonday"},{"name":"Día de la Raza Descubrimiento de América","variable_date":"firstOctoberMonday","offset":7},{"name":"Día del Veterano","fixed_date":[11,11]},{"name":"Día del Descubrimiento de Puerto Rico","fixed_date":[11,19]},{"name":"Día de Acción de Gracias","variable_date":"firstNovemberThursday","offset":21},{"name":"Noche Buena","fixed_date":[12,24]},{"name":"Día de Navidad","fixed_date":[12,25]}]
  },
  "Rhode Island": {
    "_state_code": "ri",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=41.8251&lon=-71.4194&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Victory Day","variable_date":"firstAugustMonday","offset":7}]
  },
  "South Carolina": {
    "_state_code": "sc",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=32.7878&lon=-79.9392&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Confederate Memorial Day","fixed_date":[5,10]}]
  },
  "South Dakota": {
    "_state_code": "sd",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=43.7148&lon=-98.0249&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Native American Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Tennessee": {
    "_state_code": "tn",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=35.1438&lon=-90.0231&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Good Friday","variable_date":"easter","offset":-2}]
  },
  "Texas": {
    "_state_code": "tx",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=30.2655&lon=-97.7559&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Friday after Thanksgiving","variable_date":"firstNovemberThursday","offset":22},{"name":"Christmas Eve","fixed_date":[12,24]},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Day after Christmas","fixed_date":[12,26]}]
  },
  "United States Virgin Islands": {
    "_state_code": "vi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=18.3433&lon=-64.9347&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Virgin Islands-Puerto Rico Friendship Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Three Kings Day","fixed_date":[1,6]},{"name":"Transfer Day","fixed_date":[3,31]},{"name":"Holy Thursday","variable_date":"easter","offset":-3},{"name":"Good Friday","variable_date":"easter","offset":-2},{"name":"Easter Monday","variable_date":"easter","offset":1},{"name":"Emancipation Day","fixed_date":[7,3]},{"name":"Hurricane Supplication Day","variable_date":"firstJulyMonday","offset":21},{"name":"Hurricane Thanksgiving","fixed_date":[10,25]},{"name":"Liberty Day","fixed_date":[11,1]},{"name":"Christmas Second Day","fixed_date":[12,26]},{"name":"New Year's Eve","fixed_date":[12,31]}]
  },
  "Utah": {
    "_state_code": "ut",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=40.5888&lon=-111.6378&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Pioneer Day","fixed_date":[7,24]}]
  },
  "Vermont": {
    "_state_code": "vt",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=44.2597&lon=-72.5800&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Town Meeting Day","variable_date":"firstMarchTuesday"},{"name":"Battle of Bennington","variable_date":"firstAugustMonday","offset":14}]
  },
  "Virginia": {
    "_state_code": "va",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=36.9454&lon=-76.2888&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "Washington": {
    "_state_code": "wa",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=46.8598&lon=-121.7256&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  },
  "West Virginia": {
    "_state_code": "wv",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=38.3686&lon=-81.6070&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"West Virginia Day","fixed_date":[6,20]},{"name":"Lincoln's Day","variable_date":"firstNovemberThursday","offset":22}]
  },
  "Wisconsin": {
    "_state_code": "wi",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=45.8719&lon=-89.6930&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]},{"name":"Primary Election Day","variable_date":"firstAugustTuesday","offset":7},{"name":"Election Day","variable_date":"firstNovemberMonday","offset":1}]
  },
  "Wyoming": {
    "_state_code": "wy",
    "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=42.8590&lon=-106.3126&zoom=18&addressdetails=1&accept-language=en",
    PH: [{"name":"New Year's Day","fixed_date":[1,1]},{"name":"Martin Luther King, Jr. Day","variable_date":"firstJanuaryMonday","offset":14},{"name":"Washington's Birthday","variable_date":"firstFebruaryMonday","offset":14},{"name":"Memorial Day","variable_date":"lastMayMonday"},{"name":"Independence Day","fixed_date":[7,4]},{"name":"Labor Day","variable_date":"firstSeptemberMonday"},{"name":"Columbus Day","variable_date":"firstOctoberMonday","offset":7},{"name":"Veterans Day","fixed_date":[11,11]},{"name":"Thanksgiving","variable_date":"firstNovemberThursday","offset":21},{"name":"Christmas Day","fixed_date":[12,25]}]
  }
};

const vn = {
  PH: [{"name":"Tết Dương Lịch","fixed_date":[1,1]},{"name":"Ngày Quốc tế Phụ nữ","fixed_date":[3,8]},{"name":"Ngày thành lập Đoàn Thanh niên Cộng sản Hồ Chí Minh","fixed_date":[3,26]},{"name":"Ngày Quốc tế Thiếu nhi","fixed_date":[6,1]},{"name":"Ngày Nhà giáo Việt Nam","fixed_date":[11,20]},{"name":"Ngày Giải phóng miền Nam, Thống nhất Đất nước","fixed_date":[4,30]},{"name":"Ngày Quốc tế lao động","fixed_date":[5,1]},{"name":"Quốc Khánh","fixed_date":[9,2]},{"name":"Lễ Giáng Sinh","fixed_date":[12,25]}],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=10.77374&lon=106.70094&zoom=16&addressdetails=1&accept-language=en"
};

const xa = {
  PH: [{"name":"New Year","fixed_date":[1,1]}],
  SH: [
    {
      name: "Summer",
      2020: [6,21,9,23],
      2021: [6,21,9,23],
      2022: [6,21,9,23],
      2023: [6,21,9,23],
      2024: [6,21,9,23],
      2025: [6,21,9,23],
      2026: [6,21,9,23],
      2027: [6,21,9,23],
      2028: [6,21,9,23],
      2029: [6,21,9,23],
      2030: [6,21,9,23],
      2031: [6,21,9,23],
      2032: [6,21,9,23],
    },
  ],
  "_nominatim_url": "https://nominatim.openstreetmap.org/reverse?format=json&lat=0.0&lon=0.0&zoom=18&addressdetails=1&accept-language=en"
};

const za = {
  SH: [
    {
      name: "Summer Break",
      2019: [12,7,1,12],
      2020: [12,17,1,10],
      2021: [12,11,1,9],
      2022: [12,17,1,8],
      2023: [12,16,1,14],
      2024: [12,14,1,12],
      2025: [12,13,1,11],
      2026: [12,12,1,10],
      2027: [12,11,1,9],
    },
    {
      name: "Autumn Break",
      2020: [3,19,5,31],
      2021: [3,27,4,12],
      2022: [3,18,4,4],
      2023: [3,25,4,11],
      2024: [3,22,4,2],
      2025: [3,29,4,7],
      2026: [3,28,4,7],
      2027: [3,20,4,5],
    },
    {
      name: "Winter Break",
      2020: [8,11,8,11],
      2021: [6,26,7,19],
      2022: [6,25,7,18],
      2023: [6,24,7,17],
      2024: [6,15,7,8],
      2025: [6,28,7,21],
      2026: [6,27,7,20],
      2027: [6,26,7,19],
    },
    {
      name: "Spring Break",
      2020: [9,25,10,4],
      2021: [10,2,10,11],
      2022: [10,1,10,10],
      2023: [9,30,10,9],
      2024: [9,21,9,30],
      2025: [10,4,10,12],
      2026: [10,3,10,12],
      2027: [10,2,10,10],
    },
    {
      name: "Special School Holiday",
      2021: [4,26,4,26],
      2022: [8,8,8,8],
      2023: [4,28,4,28],
      2024: [4,26,4,26],
      2025: [6,2,6,2],
      2026: [9,25,9,25],
      2027: [4,26,4,26],
    },
  ]
};

/**
 * Holiday definitions for opening_hours.js
 *
 * All countries are now sourced from generated-openholidays.js
 * - Countries with OpenHolidays API: School holidays 2020-2027
 * - YAML-only countries: Public holidays + legacy school holidays
 *
 * To update: Run `node scripts/fetch-school-holidays.mjs`
 */

var holiday_definitions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ad: ad,
  al: al,
  ar: ar,
  at: at,
  au: au,
  be: be,
  bg: bg,
  br: br,
  by: by,
  ca: ca,
  ch: ch,
  ci: ci,
  cn: cn,
  cz: cz,
  de: de,
  dk: dk,
  ee: ee,
  es: es,
  fi: fi,
  fr: fr,
  gb: gb,
  gr: gr,
  hr: hr,
  hu: hu,
  ie: ie,
  it: it,
  jp: jp,
  li: li,
  lt: lt,
  lu: lu,
  lv: lv,
  mc: mc,
  md: md,
  mt: mt,
  mx: mx,
  na: na,
  nl: nl,
  no: no,
  nz: nz,
  pl: pl,
  pt: pt,
  ro: ro,
  rs: rs,
  ru: ru,
  se: se,
  si: si,
  sk: sk,
  sm: sm,
  ua: ua,
  us: us,
  vn: vn,
  xa: xa,
  za: za
});

var data$2 = { "assuming ok for ko":{ daytime:"sunrise-sunset",
    spring:"Mar-May",
    summer:"Jun-Aug",
    autumn:"Sep-Nov",
    winter:"Dec-Feb",
    _:"-",
    "=":"-",
    "frühling":"Mar-May",
    "frühjahr":"Mar-May",
    sommer:"Jun-Aug",
    herbst:"Sep-Nov",
    gesloten:"off",
    feestdag:"PH",
    feestdagen:"PH",
    m:"Mo",
    w:"We",
    f:"Fr",
    primavera:"Mar-May",
    estate:"Jun-Aug",
    autunno:"Sep-Nov",
    inverno:"Dec-Feb" },
  "please use English written ok for ko":{ "(?:an )?feiertag(?:s|en?)?":"PH" },
  "please use off for ko":{ "ruhetage?":"off",
    geschlossen:"off",
    geschl:"off",
    except:"off" },
  "please use ok for workday":{ wd:"Mo-Fr",
    "on work days?":"Mo-Fr",
    "weekdays?":"Mo-Fr",
    "werktags?":"Mo-Sa",
    vardagar:"Mo-Fr" },
  "omit hour keyword":{ h:"" },
  "omit ko":{ season:"",
    hs:"",
    hrs:"",
    hours:"",
    uhr:"",
    "geöffnet":"",
    zwischen:"",
    ist:"",
    durchgehend:"",
    "öffnungszeit(?:en)?:?":"" },
  "omit tag key":{ "opening_hours\\s*=":"" },
  "omit wrong keyword open end":{ from:"",
    ab:"",
    von:"" },
  "assuming open end for ko":{ "(?:bis|till?|-|–)? ?(?:open ?end|late)":"+" },
  "please use ok for uncertainty":{ "~":"-",
    "～":"-" },
  "please use fallback rule":{ otherwise:"||" },
  "please use ok for missing data":{ "\\?":"" },
  "please use ok for ko":{ "→":"-",
    "−":"-",
    "—":"-",
    "ー":"-",
    to:"-",
    "до":"-",
    a:"-",
    as:"-",
    "á":"-",
    "ás":"-",
    "às":"-",
    ate:"-",
    "till?":"-",
    until:"-",
    through:"-",
    and:",",
    "&":",",
    "：":":",
    "'":"\"",
    always:"24/7",
    "always open":"24/7",
    "always closed":"closed",
    nonstop:"24/7",
    "24x7":"24/7",
    anytime:"24/7",
    "all day":"24/7",
    daily:"Mo-Su",
    everyday:"Mo-Su",
    "every day":"Mo-Su",
    "all days":"Mo-Su",
    "7j/7":"Mo-Su",
    "7/7":"Mo-Su",
    "7days":"Mo-Su",
    "7 days":"Mo-Su",
    "7 days a week":"Mo-Su",
    "7 days/week":"Mo-Su",
    "24 hours 7 days a week":"24/7",
    "24 hours":"00:00-24:00",
    midday:"12:00",
    midnight:"00:00",
    "(?:public )?holidays?":"PH",
    "(?:one )?day after public holiday":"PH +1 day",
    "(?:one )?day before public holiday":"PH -1 day",
    "school ?holidays?":"SH",
    "weekends?":"Sa,Su",
    daylight:"sunrise-sunset",
    "on(?:_| )?appointments?":"\"on appointment\"",
    "by(?:_| )?appointments?":"\"by appointment\"",
    "nach(?: |_)vereinbarung":"\"Nach Vereinbarung\"",
    "nach(?: |_)absprache":"\"Nach Absprache\"",
    bis:"-",
    "täglich":"Mo-Su",
    "(?:schul)?ferien":"SH",
    "(?:an|nur)? ?sonn-?(?: und |/)feiertag(?:s|en?)?":"PH,Su",
    und:",",
    u:",",
    auch:",",
    "fermé":"off",
    et:",",
    "à":"-",
    "jours fériés":"PH",
    sundown:"sunset",
    "morgendämmerung":"dawn",
    "abenddämmerung":"dusk",
    sonnenaufgang:"sunrise",
    sonnenuntergang:"sunset",
    ostern:"easter" },
  "please use English abbreviation ok for so":{ so:"Su" },
  "please use English abbreviation ok for ko":{ sun:"Su",
    "sundays?":"Su",
    mon:"Mo",
    "mondays?":"Mo",
    "tues?":"Tu",
    "tuesdays?":"Tu",
    "weds?":"We",
    "wednesdays?":"We",
    thu:"Th",
    "thurs?":"Th",
    "thursdays?":"Th",
    fri:"Fr",
    "fridays?":"Fr",
    sat:"Sa",
    "saturdays?":"Sa",
    son:"Su",
    "sonn-":"Su",
    "sonntags?":"Su",
    "montags?":"Mo",
    di:"Tu",
    "die?":"Tu",
    "dienstags?":"Tu",
    mi:"We",
    "mit?":"We",
    "mittwochs?":"We",
    "don?":"Th",
    "donnerstags?":"Th",
    fre:"Fr",
    "freitags?":"Fr",
    sam:"Sa",
    "samstags?":"Sa",
    dim:"Su",
    "lun?":"Mo",
    mer:"We",
    "jeu?":"Th",
    "ven?":"Fr",
    "zon?":"Su",
    zontag:"Su",
    din:"Tu",
    "woe?":"We",
    "vri?":"Fr",
    "zat?":"Sa",
    ne:"Su",
    po:"Mo",
    "út":"Tu",
    st:"We",
    "čt":"Th",
    "pá":"Fr",
    selasa:"Su",
    rabu:"Mo",
    kami:"Tu",
    jumat:"We",
    sabtu:"Th",
    minggu:"Fr",
    senin:"Sa",
    "söndagar":"Su",
    ma:"Mo",
    "lördagar":"Sa",
    niedz:"Su",
    n:"Su",
    ndz:"Su",
    poniedzialek:"Mo",
    pon:"Mo",
    pn:"Mo",
    wt:"Tu",
    sroda:"We",
    "śr":"We",
    sr:"We",
    czw:"Th",
    cz:"Th",
    piatek:"Fr",
    pt:"Fr",
    sob:"Sa",
    "Вс":"Su",
    "voskresen'ye":"Su",
    "Пн":"Mo",
    "ponedel'nik":"Mo",
    vtornik:"Tu",
    chetverk:"Th",
    pyatnitsa:"Fr",
    subbota:"Sa",
    dom:"Su",
    "domenica?":"Su",
    "domeniche?":"Su",
    "lunedì?":"Mo",
    "mar?":"Tu",
    "martedì?":"Tu",
    "mer?":"We",
    "mercoledì?":"We",
    gio:"Th",
    "giovedì?":"Th",
    ven:"Fr",
    "venerdì?":"Fr",
    sab:"Sa",
    "sabato?":"Sa",
    "jänner":"Jan",
    "june?":"Jun",
    "july?":"Jul",
    sept:"Sep",
    "märz?":"Mar",
    maerz:"Mar",
    okt:"Oct",
    dez:"Dec",
    "fév":"Feb",
    avr:"Apr",
    "aoû":"Aug",
    "giugno?":"Jun",
    "luglio?":"Jul",
    saterdag:"Sa",
    sondag:"Su",
    maandag:"Mo",
    dinsdag:"Tu",
    woensdag:"We",
    donderdag:"Th",
    vrydag:"Fr",
    "sa\\.":"Sa",
    "so\\.":"Su",
    "ma\\.":"Mo",
    "di\\.":"Tu",
    "wo\\.":"We",
    "do\\.":"Th",
    "vr\\.":"Fr",
    januarie:"Jan",
    februarie:"Feb",
    maart:"Mar",
    april:"Apr",
    mei:"May",
    junie:"Jun",
    julie:"Jul",
    augustus:"Aug",
    september:"Sep",
    oktober:"Oct",
    november:"Nov",
    desember:"Dec",
    "jan\\.":"Jan",
    "feb\\.":"Feb",
    "mrt\\.":"Mar",
    "apr\\.":"Apr",
    "jun\\.":"Jun",
    "jul\\.":"Jul",
    "aug\\.":"Aug",
    "sep\\.":"Sep",
    "okt\\.":"Oct",
    "nov\\.":"Nov",
    "des\\.":"Dec",
    memeneda:"Sa",
    kwasiada:"Su",
    dwoada:"Mo",
    benada:"Tu",
    wukuada:"We",
    yawoada:"Th",
    fiada:"Fr",
    mem:"Sa",
    dwo:"Mo",
    ben:"Tu",
    wuk:"We",
    yaw:"Th",
    fia:"Fr",
    "ɔpɛpɔn":"Jan",
    "ɔgyefoɔ":"Feb",
    "ɔbɛnem":"Mar",
    oforisuo:"Apr",
    "kɔtɔnimma":"May",
    "ayɛwohomumu":"Jun",
    kutawonsa:"Jul",
    "ɔsanaa":"Aug",
    "ɛbɔ":"Sep",
    ahinime:"Oct",
    obubuo:"Nov",
    "ɔpɛnimma":"Dec",
    "ቅዳሜ":"Sa",
    "እሑድ":"Su",
    "ሰኞ":"Mo",
    "ማክሰኞ":"Tu",
    "ረቡዕ":"We",
    "ሐሙስ":"Th",
    "ዓርብ":"Fr",
    "ማክሰ":"Tu",
    "ጃንዋሪ":"Jan",
    "ፌብሩዋሪ":"Feb",
    "ማርች":"Mar",
    "ኤፕሪል":"Apr",
    "ሜይ":"May",
    "ጁን":"Jun",
    "ጁላይ":"Jul",
    "ኦገስት":"Aug",
    "ሴፕቴምበር":"Sep",
    "ኦክቶበር":"Oct",
    "ኖቬምበር":"Nov",
    "ዲሴምበር":"Dec",
    "ጃን":"Jan",
    "ፌብ":"Feb",
    "ኤፕሪ":"Apr",
    "ኦገስ":"Aug",
    "ሴፕቴ":"Sep",
    "ኦክቶ":"Oct",
    "ኖቬም":"Nov",
    "ዲሴም":"Dec",
    "السبت":"Sa",
    "الأحد":"Su",
    "الاثنين":"Mo",
    "الثلاثاء":"Tu",
    "الأربعاء":"We",
    "الخميس":"Th",
    "الجمعة":"Fr",
    "يناير":"Jan",
    "فبراير":"Feb",
    "مارس":"Mar",
    "أبريل":"Apr",
    "مايو":"May",
    "يونيو":"Jun",
    "يوليو":"Jul",
    "أغسطس":"Aug",
    "سبتمبر":"Sep",
    "أكتوبر":"Oct",
    "نوفمبر":"Nov",
    "ديسمبر":"Dec",
    "শনিবাৰ":"Sa",
    "দেওবাৰ":"Su",
    "সোমবাৰ":"Mo",
    "মঙ্গলবাৰ":"Tu",
    "বুধবাৰ":"We",
    "বৃহস্পতিবাৰ":"Th",
    "শুক্ৰবাৰ":"Fr",
    "শনি":"Sa",
    "দেও":"Su",
    "সোম":"Mo",
    "মঙ্গল":"Tu",
    "বুধ":"We",
    "বৃহ":"Th",
    "শুক্ৰ":"Fr",
    "জানুৱাৰী":"Jan",
    "ফেব্ৰুৱাৰী":"Feb",
    "মাৰ্চ":"Mar",
    "এপ্ৰিল":"Apr",
    "মে’":"May",
    "জুন":"Jun",
    "জুলাই":"Jul",
    "আগষ্ট":"Aug",
    "ছেপ্তেম্বৰ":"Sep",
    "অক্টোবৰ":"Oct",
    "নৱেম্বৰ":"Nov",
    "ডিচেম্বৰ":"Dec",
    "জানু":"Jan",
    "ফেব্ৰু":"Feb",
    "আগ":"Aug",
    "ছেপ্তে":"Sep",
    "অক্টো":"Oct",
    "নৱে":"Nov",
    "ডিচে":"Dec",
    "şənbə":"Sa",
    bazar:"Su",
    "bazar ertəsi":"Mo",
    "çərşənbə axşamı":"Tu",
    "çərşənbə":"We",
    "cümə axşamı":"Th",
    "cümə":"Fr",
    "ş\\.":"Sa",
    "b\\.":"Su",
    "b\\.e\\.":"Mo",
    "ç\\.a\\.":"Tu",
    "ç\\.":"We",
    "c\\.a\\.":"Th",
    "c\\.":"Fr",
    yanvar:"Jan",
    fevral:"Feb",
    mart:"Mar",
    aprel:"Apr",
    iyun:"Jun",
    iyul:"Jul",
    avqust:"Aug",
    sentyabr:"Sep",
    oktyabr:"Oct",
    noyabr:"Nov",
    dekabr:"Dec",
    fev:"Feb",
    iyn:"Jun",
    iyl:"Jul",
    avq:"Aug",
    noy:"Nov",
    dek:"Dec",
    "субота":"Sa",
    "нядзеля":"Su",
    "панядзелак":"Mo",
    "аўторак":"Tu",
    "серада":"We",
    "чацвер":"Th",
    "пятніца":"Fr",
    "сб":"Sa",
    "нд":"Su",
    "аў":"Tu",
    "ср":"We",
    "чц":"Th",
    "пт":"Fr",
    "студзень":"Jan",
    "люты":"Feb",
    "сакавік":"Mar",
    "красавік":"Apr",
    "май":"May",
    "чэрвень":"Jun",
    "ліпень":"Jul",
    "жнівень":"Aug",
    "верасень":"Sep",
    "кастрычнік":"Oct",
    "лістапад":"Nov",
    "снежань":"Dec",
    "сту":"Jan",
    "лют":"Feb",
    "сак":"Mar",
    "кра":"Apr",
    "чэр":"Jun",
    "ліп":"Jul",
    "жні":"Aug",
    "вер":"Sep",
    "кас":"Oct",
    "ліс":"Nov",
    "сне":"Dec",
    "събота":"Sa",
    "неделя":"Su",
    "понеделник":"Mo",
    "вторник":"Tu",
    "сряда":"We",
    "четвъртък":"Th",
    "петък":"Fr",
    "вт":"Tu",
    "чт":"Th",
    "януари":"Jan",
    "февруари":"Feb",
    "март":"Mar",
    "април":"Apr",
    "юни":"Jun",
    "юли":"Jul",
    "август":"Aug",
    "септември":"Sep",
    "октомври":"Oct",
    "ноември":"Nov",
    "декември":"Dec",
    sibiri:"Sa",
    kari:"Su",
    "ntɛnɛ":"Mo",
    tarata:"Tu",
    araba:"We",
    alamisa:"Th",
    juma:"Fr",
    "ntɛ":"Mo",
    tar:"Tu",
    zanwuye:"Jan",
    feburuye:"Feb",
    marisi:"Mar",
    awirili:"Apr",
    "mɛ":"May",
    "zuwɛn":"Jun",
    zuluye:"Jul",
    uti:"Aug",
    "sɛtanburu":"Sep",
    "ɔkutɔburu":"Oct",
    nowanburu:"Nov",
    desanburu:"Dec",
    zan:"Jan",
    awi:"Apr",
    zuw:"Jun",
    zul:"Jul",
    "sɛt":"Sep",
    "ɔku":"Oct",
    now:"Nov",
    des:"Dec",
    "শনিবার":"Sa",
    "রবিবার":"Su",
    "সোমবার":"Mo",
    "মঙ্গলবার":"Tu",
    "বুধবার":"We",
    "বৃহস্পতিবার":"Th",
    "শুক্রবার":"Fr",
    "রবি":"Su",
    "বৃহস্পতি":"Th",
    "শুক্র":"Fr",
    "জানুয়ারী":"Jan",
    "ফেব্রুয়ারী":"Feb",
    "মার্চ":"Mar",
    "এপ্রিল":"Apr",
    "মে":"May",
    "আগস্ট":"Aug",
    "সেপ্টেম্বর":"Sep",
    "অক্টোবর":"Oct",
    "নভেম্বর":"Nov",
    "ডিসেম্বর":"Dec",
    "ফেব":"Feb",
    "སྤེན་པ་":"Sa",
    "ཉི་མ་":"Su",
    "ཟླ་བ་":"Mo",
    "མིག་དམར་":"Tu",
    "ལྷག་པ་":"We",
    "ཕུར་བུ་":"Th",
    "པ་སངས་":"Fr",
    "ཟླ་བ་དང་པོ་":"Jan",
    "ཟླ་བ་གཉིས་པ་":"Feb",
    "ཟླ་བ་གསུམ་པ་":"Mar",
    "ཟླ་བ་བཞི་པ་":"Apr",
    "ཟླ་བ་ལྔ་པ་":"May",
    "ཟླ་བ་དྲུག་པ་":"Jun",
    "ཟླ་བ་བདུན་པ་":"Jul",
    "ཟླ་བ་བརྒྱད་པ་":"Aug",
    "ཟླ་བ་དགུ་པ་":"Sep",
    "ཟླ་བ་བཅུ་པ་":"Oct",
    "ཟླ་བ་བཅུ་གཅིག་པ་":"Nov",
    "ཟླ་བ་བཅུ་གཉིས་པ་":"Dec",
    "ཟླ་༡":"Jan",
    "ཟླ་༢":"Feb",
    "ཟླ་༣":"Mar",
    "ཟླ་༤":"Apr",
    "ཟླ་༥":"May",
    "ཟླ་༦":"Jun",
    "ཟླ་༧":"Jul",
    "ཟླ་༨":"Aug",
    "ཟླ་༩":"Sep",
    "ཟླ་༡༠":"Oct",
    "ཟླ་༡༡":"Nov",
    "ཟླ་༡༢":"Dec",
    sadorn:"Sa",
    "mercʼher":"We",
    yaou:"Th",
    gwener:"Fr",
    "sad\\.":"Sa",
    "meu\\.":"Tu",
    "mer\\.":"We",
    "gwe\\.":"Fr",
    genver:"Jan",
    "cʼhwevrer":"Feb",
    ebrel:"Apr",
    mae:"May",
    mezheven:"Jun",
    gouere:"Jul",
    eost:"Aug",
    gwengolo:"Sep",
    here:"Oct",
    kerzu:"Dec",
    "gen\\.":"Jan",
    "cʼhwe\\.":"Feb",
    "meur\\.":"Mar",
    "ebr\\.":"Apr",
    "mezh\\.":"Jun",
    "goue\\.":"Jul",
    "gwen\\.":"Sep",
    "kzu\\.":"Dec",
    subota:"Sa",
    nedjelja:"Su",
    ponedjeljak:"Mo",
    utorak:"Tu",
    srijeda:"We",
    "četvrtak":"Th",
    petak:"Fr",
    sub:"Sa",
    ned:"Su",
    uto:"Tu",
    sri:"We",
    "čet":"Th",
    pet:"Fr",
    januar:"Jan",
    februar:"Feb",
    juni:"Jun",
    juli:"Jul",
    august:"Aug",
    septembar:"Sep",
    oktobar:"Oct",
    novembar:"Nov",
    decembar:"Dec",
    dissabte:"Sa",
    diumenge:"Su",
    dilluns:"Mo",
    dimarts:"Tu",
    dimecres:"We",
    dijous:"Th",
    divendres:"Fr",
    "ds\\.":"Sa",
    "dg\\.":"Su",
    "dl\\.":"Mo",
    "dt\\.":"Tu",
    "dc\\.":"We",
    "dj\\.":"Th",
    "dv\\.":"Fr",
    gener:"Jan",
    febrer:"Feb",
    "març":"Mar",
    abril:"Apr",
    maig:"May",
    juny:"Jun",
    juliol:"Jul",
    agost:"Aug",
    setembre:"Sep",
    octubre:"Oct",
    novembre:"Nov",
    desembre:"Dec",
    "febr\\.":"Feb",
    "abr\\.":"Apr",
    "ag\\.":"Aug",
    "set\\.":"Sep",
    "oct\\.":"Oct",
    "шуот":"Sa",
    "кӏира":"Su",
    "оршот":"Mo",
    "шинара":"Tu",
    "кхаара":"We",
    "еара":"Th",
    "пӏераска":"Fr",
    "шуо":"Sa",
    "кӏи":"Su",
    "ор":"Mo",
    "ши":"Tu",
    "кха":"We",
    "еа":"Th",
    "пӏе":"Fr",
    "январь":"Jan",
    "февраль":"Feb",
    "апрель":"Apr",
    "июнь":"Jun",
    "июль":"Jul",
    "сентябрь":"Sep",
    "октябрь":"Oct",
    "ноябрь":"Nov",
    "декабрь":"Dec",
    "янв":"Jan",
    "фев":"Feb",
    "мар":"Mar",
    "апр":"Apr",
    "июн":"Jun",
    "июл":"Jul",
    "авг":"Aug",
    "сен":"Sep",
    "окт":"Oct",
    "ноя":"Nov",
    "дек":"Dec",
    sobota:"Sa",
    "neděle":"Su",
    "pondělí":"Mo",
    "úterý":"Tu",
    "středa":"We",
    "čtvrtek":"Th",
    "pátek":"Fr",
    leden:"Jan",
    "únor":"Feb",
    "březen":"Mar",
    duben:"Apr",
    "květen":"May",
    "červen":"Jun",
    "červenec":"Jul",
    srpen:"Aug",
    "září":"Sep",
    "říjen":"Oct",
    prosinec:"Dec",
    led:"Jan",
    "úno":"Feb",
    "bře":"Mar",
    dub:"Apr",
    "kvě":"May",
    "čvn":"Jun",
    "čvc":"Jul",
    "zář":"Sep",
    "říj":"Oct",
    pro:"Dec",
    "шӑматкун":"Sa",
    "вырсарникун":"Su",
    "тунтикун":"Mo",
    "ытларикун":"Tu",
    "юнкун":"We",
    "кӗҫнерникун":"Th",
    "эрнекун":"Fr",
    "шӑм\\.":"Sa",
    "выр\\.":"Su",
    "тун\\.":"Mo",
    "ытл\\.":"Tu",
    "юн\\.":"We",
    "кӗҫ\\.":"Th",
    "эр\\.":"Fr",
    "кӑрлач":"Jan",
    "нарӑс":"Feb",
    "пуш":"Mar",
    "ака":"Apr",
    "ҫу":"May",
    "ҫӗртме":"Jun",
    "утӑ":"Jul",
    "ҫурла":"Aug",
    "авӑн":"Sep",
    "юпа":"Oct",
    "чӳк":"Nov",
    "раштав":"Dec",
    "кӑр\\.":"Jan",
    "нар\\.":"Feb",
    "ҫӗр\\.":"Jun",
    "ҫур\\.":"Aug",
    "раш\\.":"Dec",
    "dydd sadwrn":"Sa",
    "dydd sul":"Su",
    "dydd llun":"Mo",
    "dydd mawrth":"Tu",
    "dydd mercher":"We",
    "dydd iau":"Th",
    "dydd gwener":"Fr",
    sad:"Sa",
    llun:"Mo",
    iau:"Th",
    gwe:"Fr",
    ionawr:"Jan",
    chwefror:"Feb",
    mawrth:"Mar",
    ebrill:"Apr",
    mai:"May",
    mehefin:"Jun",
    gorffennaf:"Jul",
    awst:"Aug",
    medi:"Sep",
    hydref:"Oct",
    tachwedd:"Nov",
    rhagfyr:"Dec",
    ion:"Jan",
    chw:"Feb",
    ebr:"Apr",
    meh:"Jun",
    gor:"Jul",
    hyd:"Oct",
    tach:"Nov",
    rhag:"Dec",
    "lørdag":"Sa",
    "søndag":"Su",
    mandag:"Mo",
    tirsdag:"Tu",
    onsdag:"We",
    torsdag:"Th",
    fredag:"Fr",
    "lør\\.":"Sa",
    "søn\\.":"Su",
    "man\\.":"Mo",
    "tirs\\.":"Tu",
    "ons\\.":"We",
    "tors\\.":"Th",
    "fre\\.":"Fr",
    marts:"Mar",
    december:"Dec",
    "dec\\.":"Dec",
    samstag:"Sa",
    sonntag:"Su",
    montag:"Mo",
    dienstag:"Tu",
    mittwoch:"We",
    donnerstag:"Th",
    freitag:"Fr",
    "do":"Th",
    "märz":"Mar",
    dezember:"Dec",
    "mär":"Mar",
    "ཉི་":"Sa",
    "ཟླ་":"Su",
    "མིར་":"Mo",
    "ལྷག་":"Tu",
    "ཕུར་":"We",
    "སངས་":"Th",
    "སྤེན་":"Fr",
    "སྤྱི་སྤྱི་ཟླ་དངཔ་":"Jan",
    "སྤྱི་སྤྱི་ཟླ་གཉིས་པ་":"Feb",
    "སྤྱི་སྤྱི་ཟླ་གསུམ་པ་":"Mar",
    "སྤྱི་སྤྱི་ཟླ་བཞི་པ":"Apr",
    "སྤྱི་སྤྱི་ཟླ་ལྔ་པ་":"May",
    "སྤྱི་སྤྱི་ཟླ་དྲུག་པ":"Jun",
    "སྤྱི་སྤྱི་ཟླ་བདུན་པ་":"Jul",
    "སྤྱི་སྤྱི་ཟླ་བརྒྱད་པ་":"Aug",
    "སྤྱི་སྤྱི་ཟླ་དགུ་པ་":"Sep",
    "སྤྱི་སྤྱི་ཟླ་བཅུ་པ་":"Oct",
    "སྤྱི་སྤྱི་ཟླ་བཅུ་གཅིག་པ་":"Nov",
    "སྤྱི་སྤྱི་ཟླ་བཅུ་གཉིས་པ་":"Dec",
    "སྤྱི་ཟླ་༡":"Jan",
    "སྤྱི་ཟླ་༢":"Feb",
    "སྤྱི་ཟླ་༣":"Mar",
    "སྤྱི་ཟླ་༤":"Apr",
    "སྤྱི་ཟླ་༥":"May",
    "སྤྱི་ཟླ་༦":"Jun",
    "སྤྱི་ཟླ་༧":"Jul",
    "སྤྱི་ཟླ་༨":"Aug",
    "སྤྱི་ཟླ་༩":"Sep",
    "སྤྱི་ཟླ་༡༠":"Oct",
    "སྤྱི་ཟླ་༡༡":"Nov",
    "སྤྱི་ཟླ་༡༢":"Dec",
    "memleɖa":"Sa",
    "kɔsiɖa":"Su",
    "dzoɖa":"Mo",
    "blaɖa":"Tu",
    "kuɖa":"We",
    "yawoɖa":"Th",
    "fiɖa":"Fr",
    "kɔs":"Su",
    dzo:"Mo",
    bla:"Tu",
    "kuɖ":"We",
    "fiɖ":"Fr",
    dzove:"Jan",
    dzodze:"Feb",
    tedoxe:"Mar",
    "afɔfĩe":"Apr",
    dame:"May",
    masa:"Jun",
    "siamlɔm":"Jul",
    deasiamime:"Aug",
    "anyɔnyɔ":"Sep",
    kele:"Oct",
    "adeɛmekpɔxe":"Nov",
    dzome:"Dec",
    dzv:"Jan",
    dzd:"Feb",
    ted:"Mar",
    "afɔ":"Apr",
    dam:"May",
    sia:"Jul",
    dea:"Aug",
    any:"Sep",
    ade:"Nov",
    dzm:"Dec",
    "σάββατο":"Sa",
    "κυριακή":"Su",
    "δευτέρα":"Mo",
    "τρίτη":"Tu",
    "τετάρτη":"We",
    "πέμπτη":"Th",
    "παρασκευή":"Fr",
    "σάβ":"Sa",
    "κυρ":"Su",
    "δευ":"Mo",
    "τρί":"Tu",
    "τετ":"We",
    "πέμ":"Th",
    "παρ":"Fr",
    "ιανουαρίου":"Jan",
    "φεβρουαρίου":"Feb",
    "μαρτίου":"Mar",
    "απριλίου":"Apr",
    "μαΐου":"May",
    "ιουνίου":"Jun",
    "ιουλίου":"Jul",
    "αυγούστου":"Aug",
    "σεπτεμβρίου":"Sep",
    "οκτωβρίου":"Oct",
    "νοεμβρίου":"Nov",
    "δεκεμβρίου":"Dec",
    "ιαν":"Jan",
    "φεβ":"Feb",
    "μαρ":"Mar",
    "απρ":"Apr",
    "μαΐ":"May",
    "ιουν":"Jun",
    "ιουλ":"Jul",
    "αυγ":"Aug",
    "σεπ":"Sep",
    "οκτ":"Oct",
    "νοε":"Nov",
    "δεκ":"Dec",
    saturday:"Sa",
    sunday:"Su",
    monday:"Mo",
    tuesday:"Tu",
    wednesday:"We",
    thursday:"Th",
    friday:"Fr",
    tue:"Tu",
    wed:"We",
    january:"Jan",
    february:"Feb",
    march:"Mar",
    june:"Jun",
    july:"Jul",
    october:"Oct",
    "dimanĉo":"Su",
    lundo:"Mo",
    mardo:"Tu",
    merkredo:"We",
    "ĵaŭdo":"Th",
    vendredo:"Fr",
    lu:"Mo",
    "ĵa":"Th",
    ve:"Fr",
    januaro:"Jan",
    februaro:"Feb",
    marto:"Mar",
    aprilo:"Apr",
    majo:"May",
    junio:"Jun",
    julio:"Jul",
    "aŭgusto":"Aug",
    septembro:"Sep",
    oktobro:"Oct",
    novembro:"Nov",
    decembro:"Dec",
    "aŭg":"Aug",
    "sábado":"Sa",
    domingo:"Su",
    lunes:"Mo",
    martes:"Tu",
    "miércoles":"We",
    jueves:"Th",
    viernes:"Fr",
    "sáb":"Sa",
    "mié":"We",
    jue:"Th",
    vie:"Fr",
    enero:"Jan",
    febrero:"Feb",
    marzo:"Mar",
    mayo:"May",
    agosto:"Aug",
    septiembre:"Sep",
    noviembre:"Nov",
    diciembre:"Dec",
    ene:"Jan",
    abr:"Apr",
    ago:"Aug",
    "laupäev":"Sa",
    "pühapäev":"Su",
    "esmaspäev":"Mo",
    "teisipäev":"Tu",
    "kolmapäev":"We",
    "neljapäev":"Th",
    reede:"Fr",
    l:"Sa",
    e:"Mo",
    t:"Tu",
    r:"Fr",
    jaanuar:"Jan",
    veebruar:"Feb",
    "märts":"Mar",
    aprill:"Apr",
    juuni:"Jun",
    juuli:"Jul",
    oktoober:"Oct",
    detsember:"Dec",
    larunbata:"Sa",
    igandea:"Su",
    astelehena:"Mo",
    asteartea:"Tu",
    asteazkena:"We",
    osteguna:"Th",
    ostirala:"Fr",
    "lr\\.":"Sa",
    "ig\\.":"Su",
    "al\\.":"Mo",
    "ar\\.":"Tu",
    "az\\.":"We",
    "og\\.":"Th",
    "or\\.":"Fr",
    urtarrila:"Jan",
    otsaila:"Feb",
    martxoa:"Mar",
    apirila:"Apr",
    maiatza:"May",
    ekaina:"Jun",
    uztaila:"Jul",
    abuztua:"Aug",
    iraila:"Sep",
    urria:"Oct",
    azaroa:"Nov",
    abendua:"Dec",
    "urt\\.":"Jan",
    "ots\\.":"Feb",
    "api\\.":"Apr",
    "mai\\.":"May",
    "eka\\.":"Jun",
    "uzt\\.":"Jul",
    "abu\\.":"Aug",
    "ira\\.":"Sep",
    "urr\\.":"Oct",
    "aza\\.":"Nov",
    "abe\\.":"Dec",
    "شنبه":"Sa",
    "یکشنبه":"Su",
    "دوشنبه":"Mo",
    "سه‌شنبه":"Tu",
    "چهارشنبه":"We",
    "پنجشنبه":"Th",
    "جمعه":"Fr",
    "دی":"Jan",
    "بهمن":"Feb",
    "اسفند":"Mar",
    "فروردین":"Apr",
    "اردیبهشت":"May",
    "خرداد":"Jun",
    "تیر":"Jul",
    "مرداد":"Aug",
    "شهریور":"Sep",
    "مهر":"Oct",
    "آبان":"Nov",
    "آذر":"Dec",
    "hoore-biir":"Sa",
    dewo:"Su",
    "aaɓnde":"Mo",
    mawbaare:"Tu",
    njeslaare:"We",
    naasaande:"Th",
    mawnde:"Fr",
    hbi:"Sa",
    dew:"Su",
    "aaɓ":"Mo",
    naa:"Th",
    mwd:"Fr",
    siilo:"Jan",
    colte:"Feb",
    mbooy:"Mar",
    "seeɗto":"Apr",
    duujal:"May",
    korse:"Jun",
    morso:"Jul",
    juko:"Aug",
    siilto:"Sep",
    yarkomaa:"Oct",
    jolal:"Nov",
    bowte:"Dec",
    sii:"Jan",
    col:"Feb",
    mbo:"Mar",
    duu:"May",
    kor:"Jun",
    juk:"Aug",
    slt:"Sep",
    yar:"Oct",
    bow:"Dec",
    lauantai:"Sa",
    sunnuntai:"Su",
    maanantai:"Mo",
    tiistai:"Tu",
    keskiviikko:"We",
    torstai:"Th",
    perjantai:"Fr",
    ti:"Tu",
    ke:"We",
    pe:"Fr",
    tammikuu:"Jan",
    helmikuu:"Feb",
    maaliskuu:"Mar",
    huhtikuu:"Apr",
    toukokuu:"May",
    "kesäkuu":"Jun",
    "heinäkuu":"Jul",
    elokuu:"Aug",
    syyskuu:"Sep",
    lokakuu:"Oct",
    marraskuu:"Nov",
    joulukuu:"Dec",
    tammi:"Jan",
    helmi:"Feb",
    maalis:"Mar",
    huhti:"Apr",
    touko:"May",
    "kesä":"Jun",
    "heinä":"Jul",
    elo:"Aug",
    syys:"Sep",
    loka:"Oct",
    marras:"Nov",
    joulu:"Dec",
    leygardagur:"Sa",
    sunnudagur:"Su",
    "mánadagur":"Mo",
    "týsdagur":"Tu",
    mikudagur:"We",
    "hósdagur":"Th",
    "fríggjadagur":"Fr",
    ley:"Sa",
    "mán":"Mo",
    "týs":"Tu",
    mik:"We",
    "hós":"Th",
    "frí":"Fr",
    mars:"Mar",
    "apríl":"Apr",
    samedi:"Sa",
    dimanche:"Su",
    lundi:"Mo",
    mardi:"Tu",
    mercredi:"We",
    jeudi:"Th",
    vendredi:"Fr",
    "sam\\.":"Sa",
    "dim\\.":"Su",
    "lun\\.":"Mo",
    "jeu\\.":"Th",
    "ven\\.":"Fr",
    janvier:"Jan",
    "février":"Feb",
    avril:"Apr",
    juin:"Jun",
    juillet:"Jul",
    "août":"Aug",
    septembre:"Sep",
    octobre:"Oct",
    "décembre":"Dec",
    "janv\\.":"Jan",
    "févr\\.":"Feb",
    "avr\\.":"Apr",
    "juil\\.":"Jul",
    "sept\\.":"Sep",
    "déc\\.":"Dec",
    sneon:"Sa",
    snein:"Su",
    moandei:"Mo",
    tiisdei:"Tu",
    woansdei:"We",
    tongersdei:"Th",
    freed:"Fr",
    si:"Su",
    wo:"We",
    jannewaris:"Jan",
    febrewaris:"Feb",
    maaie:"May",
    septimber:"Sep",
    novimber:"Nov",
    desimber:"Dec",
    mrt:"Mar",
    "dé sathairn":"Sa",
    "dé domhnaigh":"Su",
    "dé luain":"Mo",
    "dé máirt":"Tu",
    "dé céadaoin":"We",
    "déardaoin":"Th",
    "dé haoine":"Fr",
    sath:"Sa",
    domh:"Su",
    luan:"Mo",
    "máirt":"Tu",
    "céad":"We",
    "déar":"Th",
    aoine:"Fr",
    "eanáir":"Jan",
    feabhra:"Feb",
    "márta":"Mar",
    "aibreán":"Apr",
    bealtaine:"May",
    meitheamh:"Jun",
    "iúil":"Jul",
    "lúnasa":"Aug",
    "meán fómhair":"Sep",
    "deireadh fómhair":"Oct",
    samhain:"Nov",
    nollaig:"Dec",
    ean:"Jan",
    feabh:"Feb",
    aib:"Apr",
    beal:"May",
    meith:"Jun",
    "lún":"Aug",
    "mfómh":"Sep",
    "dfómh":"Oct",
    samh:"Nov",
    noll:"Dec",
    disathairne:"Sa",
    "didòmhnaich":"Su",
    diluain:"Mo",
    "dimàirt":"Tu",
    diciadain:"We",
    diardaoin:"Th",
    dihaoine:"Fr",
    did:"Su",
    dia:"Th",
    dih:"Fr",
    "am faoilleach":"Jan",
    "an gearran":"Feb",
    "am màrt":"Mar",
    "an giblean":"Apr",
    "an cèitean":"May",
    "an t-ògmhios":"Jun",
    "an t-iuchar":"Jul",
    "an lùnastal":"Aug",
    "an t-sultain":"Sep",
    "an dàmhair":"Oct",
    "an t-samhain":"Nov",
    "an dùbhlachd":"Dec",
    faoi:"Jan",
    gearr:"Feb",
    "màrt":"Mar",
    gibl:"Apr",
    "cèit":"May",
    "ògmh":"Jun",
    iuch:"Jul",
    "lùna":"Aug",
    sult:"Sep",
    "dàmh":"Oct",
    "dùbh":"Dec",
    luns:"Mo",
    "mércores":"We",
    xoves:"Th",
    venres:"Fr",
    "sáb\\.":"Sa",
    "dom\\.":"Su",
    "mér\\.":"We",
    "xov\\.":"Th",
    xaneiro:"Jan",
    febreiro:"Feb",
    maio:"May",
    "xuño":"Jun",
    xullo:"Jul",
    setembro:"Sep",
    outubro:"Oct",
    "xan\\.":"Jan",
    "xul\\.":"Jul",
    "ago\\.":"Aug",
    "out\\.":"Oct",
    "શનિવાર":"Sa",
    "રવિવાર":"Su",
    "સોમવાર":"Mo",
    "મંગળવાર":"Tu",
    "બુધવાર":"We",
    "ગુરુવાર":"Th",
    "શુક્રવાર":"Fr",
    "શનિ":"Sa",
    "રવિ":"Su",
    "સોમ":"Mo",
    "મંગળ":"Tu",
    "બુધ":"We",
    "ગુરુ":"Th",
    "શુક્ર":"Fr",
    "જાન્યુઆરી":"Jan",
    "ફેબ્રુઆરી":"Feb",
    "માર્ચ":"Mar",
    "એપ્રિલ":"Apr",
    "મે":"May",
    "જૂન":"Jun",
    "જુલાઈ":"Jul",
    "ઑગસ્ટ":"Aug",
    "સપ્ટેમ્બર":"Sep",
    "ઑક્ટોબર":"Oct",
    "નવેમ્બર":"Nov",
    "ડિસેમ્બર":"Dec",
    "જાન્યુ":"Jan",
    "ફેબ્રુ":"Feb",
    "સપ્ટે":"Sep",
    "ઑક્ટો":"Oct",
    "નવે":"Nov",
    "ડિસે":"Dec",
    jesarn:"Sa",
    jedoonee:"Su",
    jelhein:"Mo",
    jemayrt:"Tu",
    jercean:"We",
    jerdein:"Th",
    jeheiney:"Fr",
    jes:"Sa",
    jed:"Su",
    jel:"Mo",
    jem:"Tu",
    jerc:"We",
    jerd:"Th",
    jeh:"Fr",
    "jerrey-geuree":"Jan",
    "toshiaght-arree":"Feb",
    mayrnt:"Mar",
    averil:"Apr",
    boaldyn:"May",
    "mean-souree":"Jun",
    "jerrey-souree":"Jul",
    luanistyn:"Aug",
    "mean-fouyir":"Sep",
    "jerrey-fouyir":"Oct",
    "mee houney":"Nov",
    "mee ny nollick":"Dec",
    "j-guer":"Jan",
    "t-arree":"Feb",
    avrril:"Apr",
    "m-souree":"Jun",
    "j-souree":"Jul",
    "m-fouyir":"Sep",
    "j-fouyir":"Oct",
    "m-houney":"Nov",
    "m-nollick":"Dec",
    asabar:"Sa",
    lahadi:"Su",
    litinin:"Mo",
    talata:"Tu",
    laraba:"We",
    alhamis:"Th",
    "jummaʼa":"Fr",
    lah:"Su",
    lit:"Mo",
    lar:"We",
    janairu:"Jan",
    faburairu:"Feb",
    maris:"Mar",
    afirilu:"Apr",
    mayu:"May",
    yuni:"Jun",
    yuli:"Jul",
    agusta:"Aug",
    satumba:"Sep",
    oktoba:"Oct",
    nuwamba:"Nov",
    disamba:"Dec",
    fab:"Feb",
    afi:"Apr",
    yun:"Jun",
    yul:"Jul",
    agu:"Aug",
    nuw:"Nov",
    "יום שבת":"Sa",
    "יום ראשון":"Su",
    "יום שני":"Mo",
    "יום שלישי":"Tu",
    "יום רביעי":"We",
    "יום חמישי":"Th",
    "יום שישי":"Fr",
    "שבת":"Sa",
    "יום א׳":"Su",
    "יום ב׳":"Mo",
    "יום ג׳":"Tu",
    "יום ד׳":"We",
    "יום ה׳":"Th",
    "יום ו׳":"Fr",
    "ינואר":"Jan",
    "פברואר":"Feb",
    "מרץ":"Mar",
    "אפריל":"Apr",
    "מאי":"May",
    "יוני":"Jun",
    "יולי":"Jul",
    "אוגוסט":"Aug",
    "ספטמבר":"Sep",
    "אוקטובר":"Oct",
    "נובמבר":"Nov",
    "דצמבר":"Dec",
    "ינו׳":"Jan",
    "פבר׳":"Feb",
    "אפר׳":"Apr",
    "אוג׳":"Aug",
    "ספט׳":"Sep",
    "אוק׳":"Oct",
    "נוב׳":"Nov",
    "דצמ׳":"Dec",
    "शनिवार":"Sa",
    "रविवार":"Su",
    "सोमवार":"Mo",
    "मंगलवार":"Tu",
    "बुधवार":"We",
    "गुरुवार":"Th",
    "शुक्रवार":"Fr",
    "शनि":"Sa",
    "रवि":"Su",
    "सोम":"Mo",
    "मंगल":"Tu",
    "बुध":"We",
    "गुरु":"Th",
    "शुक्र":"Fr",
    "जनवरी":"Jan",
    "फ़रवरी":"Feb",
    "मार्च":"Mar",
    "अप्रैल":"Apr",
    "मई":"May",
    "जून":"Jun",
    "जुलाई":"Jul",
    "अगस्त":"Aug",
    "सितंबर":"Sep",
    "अक्तूबर":"Oct",
    "नवंबर":"Nov",
    "दिसंबर":"Dec",
    "जन॰":"Jan",
    "फ़र॰":"Feb",
    "जुल॰":"Jul",
    "अग॰":"Aug",
    "सित॰":"Sep",
    "अक्तू॰":"Oct",
    "नव॰":"Nov",
    "दिस॰":"Dec",
    "siječanj":"Jan",
    "veljača":"Feb",
    "ožujak":"Mar",
    travanj:"Apr",
    svibanj:"May",
    lipanj:"Jun",
    srpanj:"Jul",
    kolovoz:"Aug",
    rujan:"Sep",
    studeni:"Nov",
    prosinac:"Dec",
    sij:"Jan",
    velj:"Feb",
    "ožu":"Mar",
    tra:"Apr",
    svi:"May",
    ruj:"Sep",
    stu:"Nov",
    szombat:"Sa",
    "vasárnap":"Su",
    "hétfő":"Mo",
    kedd:"Tu",
    szerda:"We",
    "csütörtök":"Th",
    "péntek":"Fr",
    szo:"Sa",
    v:"Su",
    sze:"We",
    cs:"Th",
    "január":"Jan",
    "február":"Feb",
    "március":"Mar",
    "április":"Apr",
    "május":"May",
    "június":"Jun",
    "július":"Jul",
    augusztus:"Aug",
    szeptember:"Sep",
    "október":"Oct",
    "márc\\.":"Mar",
    "ápr\\.":"Apr",
    "máj\\.":"May",
    "jún\\.":"Jun",
    "júl\\.":"Jul",
    "szept\\.":"Sep",
    "շաբաթ":"Sa",
    "կիրակի":"Su",
    "երկուշաբթի":"Mo",
    "երեքշաբթի":"Tu",
    "չորեքշաբթի":"We",
    "հինգշաբթի":"Th",
    "ուրբաթ":"Fr",
    "շբթ":"Sa",
    "կիր":"Su",
    "երկ":"Mo",
    "երք":"Tu",
    "չրք":"We",
    "հնգ":"Th",
    "ուր":"Fr",
    "հունվար":"Jan",
    "փետրվար":"Feb",
    "մարտ":"Mar",
    "ապրիլ":"Apr",
    "մայիս":"May",
    "հունիս":"Jun",
    "հուլիս":"Jul",
    "օգոստոս":"Aug",
    "սեպտեմբեր":"Sep",
    "հոկտեմբեր":"Oct",
    "նոյեմբեր":"Nov",
    "դեկտեմբեր":"Dec",
    "հնվ":"Jan",
    "փտվ":"Feb",
    "մրտ":"Mar",
    "ապր":"Apr",
    "մյս":"May",
    "հնս":"Jun",
    "հլս":"Jul",
    "օգս":"Aug",
    "սեպ":"Sep",
    "հոկ":"Oct",
    "նոյ":"Nov",
    "դեկ":"Dec",
    sabbato:"Sa",
    dominica:"Su",
    lunedi:"Mo",
    martedi:"Tu",
    mercuridi:"We",
    jovedi:"Th",
    venerdi:"Fr",
    jov:"Th",
    januario:"Jan",
    februario:"Feb",
    martio:"Mar",
    augusto:"Aug",
    decembre:"Dec",
    kamis:"Th",
    sel:"Tu",
    rab:"We",
    kam:"Th",
    januari:"Jan",
    februari:"Feb",
    maret:"Mar",
    agustus:"Aug",
    "saturdí":"Sa",
    "soledí":"Su",
    "lunedí":"Mo",
    "mardí":"Tu",
    "mercurdí":"We",
    "jovedí":"Th",
    "venerdí":"Fr",
    "sat\\.":"Sa",
    "sol\\.":"Su",
    "jov\\.":"Th",
    marte:"Mar",
    "julí":"Jul",
    "satọdee":"Sa",
    "sọndee":"Su",
    "mọnde":"Mo",
    tiuzdee:"Tu",
    wenezdee:"We",
    "tọọzdee":"Th",
    "fraịdee":"Fr",
    "sọn":"Su",
    "mọn":"Mo",
    tiu:"Tu",
    "tọọ":"Th",
    "fraị":"Fr",
    "jenụwarị":"Jan",
    "febrụwarị":"Feb",
    "maachị":"Mar",
    epreel:"Apr",
    mee:"May",
    "julaị":"Jul",
    "ọgọọst":"Aug",
    septemba:"Sep",
    "ọktoba":"Oct",
    novemba:"Nov",
    disemba:"Dec",
    jen:"Jan",
    epr:"Apr",
    juu:"Jun",
    "ọgọ":"Aug",
    "ọkt":"Oct",
    "ꆏꊂꃘ":"Sa",
    "ꑬꆏꑍ":"Su",
    "ꆏꊂꋍ":"Mo",
    "ꆏꊂꑍ":"Tu",
    "ꆏꊂꌕ":"We",
    "ꆏꊂꇖ":"Th",
    "ꆏꊂꉬ":"Fr",
    "ꆏꃘ":"Sa",
    "ꑬꆏ":"Su",
    "ꆏꋍ":"Mo",
    "ꆏꑍ":"Tu",
    "ꆏꌕ":"We",
    "ꆏꇖ":"Th",
    "ꆏꉬ":"Fr",
    "ꋍꆪ":"Jan",
    "ꑍꆪ":"Feb",
    "ꌕꆪ":"Mar",
    "ꇖꆪ":"Apr",
    "ꉬꆪ":"May",
    "ꃘꆪ":"Jun",
    "ꏃꆪ":"Jul",
    "ꉆꆪ":"Aug",
    "ꈬꆪ":"Sep",
    "ꊰꆪ":"Oct",
    "ꊯꊪꆪ":"Nov",
    "ꊰꑋꆪ":"Dec",
    laugardagur:"Sa",
    "mánudagur":"Mo",
    "þriðjudagur":"Tu",
    "miðvikudagur":"We",
    fimmtudagur:"Th",
    "föstudagur":"Fr",
    "lau\\.":"Sa",
    "sun\\.":"Su",
    "mán\\.":"Mo",
    "þri\\.":"Tu",
    "mið\\.":"We",
    "fim\\.":"Th",
    "fös\\.":"Fr",
    "janúar":"Jan",
    "febrúar":"Feb",
    "maí":"May",
    "júní":"Jun",
    "júlí":"Jul",
    "ágúst":"Aug",
    "nóvember":"Nov",
    "ágú\\.":"Aug",
    "nóv\\.":"Nov",
    domenica:"Su",
    "lunedì":"Mo",
    "martedì":"Tu",
    "mercoledì":"We",
    "giovedì":"Th",
    "venerdì":"Fr",
    gennaio:"Jan",
    febbraio:"Feb",
    aprile:"Apr",
    maggio:"May",
    giugno:"Jun",
    luglio:"Jul",
    settembre:"Sep",
    ottobre:"Oct",
    dicembre:"Dec",
    gen:"Jan",
    mag:"May",
    giu:"Jun",
    lug:"Jul",
    set:"Sep",
    ott:"Oct",
    "土曜日":"Sa",
    "日曜日":"Su",
    "月曜日":"Mo",
    "火曜日":"Tu",
    "水曜日":"We",
    "木曜日":"Th",
    "金曜日":"Fr",
    "土":"Sa",
    "日":"Su",
    "月":"Mo",
    "火":"Tu",
    "水":"We",
    "木":"Th",
    "金":"Fr",
    "1月":"Jan",
    "2月":"Feb",
    "3月":"Mar",
    "4月":"Apr",
    "5月":"May",
    "6月":"Jun",
    "7月":"Jul",
    "8月":"Aug",
    "9月":"Sep",
    "10月":"Oct",
    "11月":"Nov",
    "12月":"Dec",
    "זונטיק":"Su",
    "מאָנטיק":"Mo",
    "דינסטיק":"Tu",
    "מיטוואך":"We",
    "דאנערשטיק":"Th",
    "פֿרײַטיק":"Fr",
    "יאַנואַר":"Jan",
    "פֿעברואַר":"Feb",
    "מערץ":"Mar",
    "אַפּריל":"Apr",
    "מיי":"May",
    "אויגוסט":"Aug",
    "סעפּטעמבער":"Sep",
    "אקטאבער":"Oct",
    "נאוועמבער":"Nov",
    "דעצעמבער":"Dec",
    "יאַנ":"Jan",
    "פֿעב":"Feb",
    "אַפּר":"Apr",
    "אויג":"Aug",
    "סעפּ":"Sep",
    "אקט":"Oct",
    "נאוו":"Nov",
    "דעצ":"Dec",
    ahad:"Su",
    agt:"Aug",
    "შაბათი":"Sa",
    "კვირა":"Su",
    "ორშაბათი":"Mo",
    "სამშაბათი":"Tu",
    "ოთხშაბათი":"We",
    "ხუთშაბათი":"Th",
    "პარასკევი":"Fr",
    "შაბ":"Sa",
    "კვი":"Su",
    "ორშ":"Mo",
    "სამ":"Tu",
    "ოთხ":"We",
    "ხუთ":"Th",
    "პარ":"Fr",
    "იანვარი":"Jan",
    "თებერვალი":"Feb",
    "მარტი":"Mar",
    "აპრილი":"Apr",
    "მაისი":"May",
    "ივნისი":"Jun",
    "ივლისი":"Jul",
    "აგვისტო":"Aug",
    "სექტემბერი":"Sep",
    "ოქტომბერი":"Oct",
    "ნოემბერი":"Nov",
    "დეკემბერი":"Dec",
    "იან":"Jan",
    "თებ":"Feb",
    "მარ":"Mar",
    "აპრ":"Apr",
    "მაი":"May",
    "ივნ":"Jun",
    "ივლ":"Jul",
    "აგვ":"Aug",
    "სექ":"Sep",
    "ოქტ":"Oct",
    "ნოე":"Nov",
    "დეკ":"Dec",
    njumamothi:"Sa",
    kiumia:"Su",
    "njumatatũ":"Mo",
    njumaine:"Tu",
    njumatana:"We",
    aramithi:"Th",
    njumaa:"Fr",
    nmm:"Sa",
    kma:"Su",
    ntt:"Mo",
    nmn:"Tu",
    nmt:"We",
    art:"Th",
    nma:"Fr",
    "njenuarĩ":"Jan",
    "mwere wa kerĩ":"Feb",
    "mwere wa gatatũ":"Mar",
    "mwere wa kana":"Apr",
    "mwere wa gatano":"May",
    "mwere wa gatandatũ":"Jun",
    "mwere wa mũgwanja":"Jul",
    "mwere wa kanana":"Aug",
    "mwere wa kenda":"Sep",
    "mwere wa ikũmi":"Oct",
    "mwere wa ikũmi na ũmwe":"Nov",
    ndithemba:"Dec",
    wkr:"Feb",
    wgt:"Mar",
    wtd:"Jun",
    wmj:"Jul",
    wnn:"Aug",
    wkd:"Sep",
    wik:"Oct",
    wmw:"Nov",
    dit:"Dec",
    "сенбі":"Sa",
    "жексенбі":"Su",
    "дүйсенбі":"Mo",
    "сейсенбі":"Tu",
    "сәрсенбі":"We",
    "бейсенбі":"Th",
    "жұма":"Fr",
    "жс":"Su",
    "дс":"Mo",
    "сс":"Tu",
    "жм":"Fr",
    "қаңтар":"Jan",
    "ақпан":"Feb",
    "наурыз":"Mar",
    "сәуір":"Apr",
    "мамыр":"May",
    "маусым":"Jun",
    "шілде":"Jul",
    "тамыз":"Aug",
    "қыркүйек":"Sep",
    "қазан":"Oct",
    "қараша":"Nov",
    "желтоқсан":"Dec",
    "қаң\\.":"Jan",
    "ақп\\.":"Feb",
    "нау\\.":"Mar",
    "сәу\\.":"Apr",
    "мам\\.":"May",
    "мау\\.":"Jun",
    "шіл\\.":"Jul",
    "там\\.":"Aug",
    "қыр\\.":"Sep",
    "қаз\\.":"Oct",
    "қар\\.":"Nov",
    "жел\\.":"Dec",
    arfininngorneq:"Sa",
    sapaat:"Su",
    ataasinngorneq:"Mo",
    marlunngorneq:"Tu",
    pingasunngorneq:"We",
    sisamanngorneq:"Th",
    tallimanngorneq:"Fr",
    arf:"Sa",
    pin:"We",
    sis:"Th",
    januaari:"Jan",
    februaari:"Feb",
    marsi:"Mar",
    apriili:"Apr",
    maaji:"May",
    aggusti:"Aug",
    septembari:"Sep",
    oktobari:"Oct",
    novembari:"Nov",
    decembari:"Dec",
    febr:"Feb",
    "សៅរ៍":"Sa",
    "អាទិត្យ":"Su",
    "ចន្ទ":"Mo",
    "អង្គារ":"Tu",
    "ពុធ":"We",
    "ព្រហស្បតិ៍":"Th",
    "សុក្រ":"Fr",
    "ព្រហ":"Th",
    "មករា":"Jan",
    "កុម្ភៈ":"Feb",
    "មីនា":"Mar",
    "មេសា":"Apr",
    "ឧសភា":"May",
    "មិថុនា":"Jun",
    "កក្កដា":"Jul",
    "សីហា":"Aug",
    "កញ្ញា":"Sep",
    "តុលា":"Oct",
    "វិច្ឆិកា":"Nov",
    "ធ្នូ":"Dec",
    "ಶನಿವಾರ":"Sa",
    "ಭಾನುವಾರ":"Su",
    "ಸೋಮವಾರ":"Mo",
    "ಮಂಗಳವಾರ":"Tu",
    "ಬುಧವಾರ":"We",
    "ಗುರುವಾರ":"Th",
    "ಶುಕ್ರವಾರ":"Fr",
    "ಶನಿ":"Sa",
    "ಭಾನು":"Su",
    "ಸೋಮ":"Mo",
    "ಮಂಗಳ":"Tu",
    "ಬುಧ":"We",
    "ಗುರು":"Th",
    "ಶುಕ್ರ":"Fr",
    "ಜನವರಿ":"Jan",
    "ಫೆಬ್ರವರಿ":"Feb",
    "ಮಾರ್ಚ್":"Mar",
    "ಏಪ್ರಿಲ್":"Apr",
    "ಮೇ":"May",
    "ಜೂನ್":"Jun",
    "ಜುಲೈ":"Jul",
    "ಆಗಸ್ಟ್":"Aug",
    "ಸೆಪ್ಟೆಂಬರ್":"Sep",
    "ಅಕ್ಟೋಬರ್":"Oct",
    "ನವೆಂಬರ್":"Nov",
    "ಡಿಸೆಂಬರ್":"Dec",
    "ಜನ":"Jan",
    "ಫೆಬ್ರ":"Feb",
    "ಏಪ್ರಿ":"Apr",
    "ಆಗ":"Aug",
    "ಸೆಪ್ಟೆಂ":"Sep",
    "ಅಕ್ಟೋ":"Oct",
    "ನವೆಂ":"Nov",
    "ಡಿಸೆಂ":"Dec",
    "토요일":"Sa",
    "일요일":"Su",
    "월요일":"Mo",
    "화요일":"Tu",
    "수요일":"We",
    "목요일":"Th",
    "금요일":"Fr",
    "토":"Sa",
    "일":"Su",
    "월":"Mo",
    "화":"Tu",
    "수":"We",
    "목":"Th",
    "금":"Fr",
    "1월":"Jan",
    "2월":"Feb",
    "3월":"Mar",
    "4월":"Apr",
    "5월":"May",
    "6월":"Jun",
    "7월":"Jul",
    "8월":"Aug",
    "9월":"Sep",
    "10월":"Oct",
    "11월":"Nov",
    "12월":"Dec",
    "بٹوار":"Sa",
    "اَتھوار":"Su",
    "ژٔندرٕروار":"Mo",
    "بۆموار":"Tu",
    "بودوار":"We",
    "برؠسوار":"Th",
    "جُمہ":"Fr",
    "آتھوار":"Su",
    "ژٔندٕروار":"Mo",
    "جنؤری":"Jan",
    "فرؤری":"Feb",
    "مارٕچ":"Mar",
    "اپریل":"Apr",
    "مئی":"May",
    "جوٗن":"Jun",
    "جوٗلایی":"Jul",
    "اگست":"Aug",
    "ستمبر":"Sep",
    "اکتوٗبر":"Oct",
    "نومبر":"Nov",
    "دسمبر":"Dec",
    "şemî":"Sa",
    "yekşem":"Su",
    "duşem":"Mo",
    "sêşem":"Tu",
    "çarşem":"We",
    "pêncşem":"Th",
    "înî":"Fr",
    "şem":"Sa",
    "yşm":"Su",
    "dşm":"Mo",
    "sşm":"Tu",
    "çşm":"We",
    "pşm":"Th",
    "rêbendan":"Jan",
    sibat:"Feb",
    adar:"Mar",
    "nîsan":"Apr",
    gulan:"May",
    "hezîran":"Jun",
    "tîrmeh":"Jul",
    tebax:"Aug",
    "îlon":"Sep",
    cotmeh:"Oct",
    mijdar:"Nov",
    berfanbar:"Dec",
    rbn:"Jan",
    sbt:"Feb",
    adr:"Mar",
    nsn:"Apr",
    gln:"May",
    hzr:"Jun",
    trm:"Jul",
    tbx:"Aug",
    "îln":"Sep",
    cot:"Oct",
    mjd:"Nov",
    brf:"Dec",
    "dy sadorn":"Sa",
    "dy sul":"Su",
    "dy lun":"Mo",
    "dy meurth":"Tu",
    "dy merher":"We",
    "dy yow":"Th",
    "dy gwener":"Fr",
    mth:"Tu",
    mhr:"We",
    yow:"Th",
    "mis genver":"Jan",
    "mis hwevrer":"Feb",
    "mis meurth":"Mar",
    "mis ebrel":"Apr",
    "mis me":"May",
    "mis metheven":"Jun",
    "mis gortheren":"Jul",
    "mis est":"Aug",
    "mis gwynngala":"Sep",
    "mis hedra":"Oct",
    "mis du":"Nov",
    "mis kevardhu":"Dec",
    hwe:"Feb",
    meu:"Mar",
    met:"Jun",
    gwn:"Sep",
    hed:"Oct",
    kev:"Dec",
    "ишемби":"Sa",
    "жекшемби":"Su",
    "дүйшөмбү":"Mo",
    "шейшемби":"Tu",
    "шаршемби":"We",
    "бейшемби":"Th",
    "жума":"Fr",
    "ишм\\.":"Sa",
    "жек\\.":"Su",
    "дүй\\.":"Mo",
    "шейш\\.":"Tu",
    "шарш\\.":"We",
    "бейш\\.":"Th",
    samschdeg:"Sa",
    sonndeg:"Su",
    "méindeg":"Mo",
    "dënschdeg":"Tu",
    "mëttwoch":"We",
    donneschdeg:"Th",
    freideg:"Fr",
    "dën":"Tu",
    "mët":"We",
    don:"Th",
    "mäerz":"Mar",
    "abrëll":"Apr",
    "mäe":"Mar",
    lwamukaaga:"Sa",
    sabbiiti:"Su",
    balaza:"Mo",
    lwakubiri:"Tu",
    lwakusatu:"We",
    lwakuna:"Th",
    lwakutaano:"Fr",
    lw6:"Sa",
    bal:"Mo",
    lw2:"Tu",
    lw3:"We",
    lw4:"Th",
    lw5:"Fr",
    janwaliyo:"Jan",
    febwaliyo:"Feb",
    apuli:"Apr",
    maayi:"May",
    julaayi:"Jul",
    agusito:"Aug",
    sebuttemba:"Sep",
    okitobba:"Oct",
    desemba:"Dec",
    apu:"Apr",
    seb:"Sep",
    oki:"Oct",
    "mpɔ́sɔ":"Sa",
    eyenga:"Su",
    "mokɔlɔ mwa yambo":"Mo",
    "mokɔlɔ mwa míbalé":"Tu",
    "mokɔlɔ mwa mísáto":"We",
    "mokɔlɔ ya mínéi":"Th",
    "mokɔlɔ ya mítáno":"Fr",
    mps:"Sa",
    eye:"Su",
    ybo:"Mo",
    mbl:"Tu",
    mst:"We",
    mtn:"Fr",
    "sánzá ya yambo":"Jan",
    "sánzá ya míbalé":"Feb",
    "sánzá ya mísáto":"Mar",
    "sánzá ya mínei":"Apr",
    "sánzá ya mítáno":"May",
    "sánzá ya motóbá":"Jun",
    "sánzá ya nsambo":"Jul",
    "sánzá ya mwambe":"Aug",
    "sánzá ya libwa":"Sep",
    "sánzá ya zómi":"Oct",
    "sánzá ya zómi na mɔ̌kɔ́":"Nov",
    "sánzá ya zómi na míbalé":"Dec",
    fbl:"Feb",
    msi:"Mar",
    apl:"Apr",
    stb:"Sep",
    "ɔtb":"Oct",
    nvb:"Nov",
    dsb:"Dec",
    "ວັນເສົາ":"Sa",
    "ວັນອາທິດ":"Su",
    "ວັນຈັນ":"Mo",
    "ວັນອັງຄານ":"Tu",
    "ວັນພຸດ":"We",
    "ວັນພະຫັດ":"Th",
    "ວັນສຸກ":"Fr",
    "ເສົາ":"Sa",
    "ອາທິດ":"Su",
    "ຈັນ":"Mo",
    "ອັງຄານ":"Tu",
    "ພຸດ":"We",
    "ພະຫັດ":"Th",
    "ສຸກ":"Fr",
    "ມັງກອນ":"Jan",
    "ກຸມພາ":"Feb",
    "ມີນາ":"Mar",
    "ເມສາ":"Apr",
    "ພຶດສະພາ":"May",
    "ມິຖຸນາ":"Jun",
    "ກໍລະກົດ":"Jul",
    "ສິງຫາ":"Aug",
    "ກັນຍາ":"Sep",
    "ຕຸລາ":"Oct",
    "ພະຈິກ":"Nov",
    "ທັນວາ":"Dec",
    "ມ\\.ກ\\.":"Jan",
    "ກ\\.ພ\\.":"Feb",
    "ມ\\.ນ\\.":"Mar",
    "ມ\\.ສ\\.":"Apr",
    "ພ\\.ພ\\.":"May",
    "ມິ\\.ຖ\\.":"Jun",
    "ກ\\.ລ\\.":"Jul",
    "ສ\\.ຫ\\.":"Aug",
    "ກ\\.ຍ\\.":"Sep",
    "ຕ\\.ລ\\.":"Oct",
    "ພ\\.ຈ\\.":"Nov",
    "ທ\\.ວ\\.":"Dec",
    "šeštadienis":"Sa",
    sekmadienis:"Su",
    pirmadienis:"Mo",
    antradienis:"Tu",
    "trečiadienis":"We",
    ketvirtadienis:"Th",
    penktadienis:"Fr",
    sk:"Su",
    pr:"Mo",
    an:"Tu",
    tr:"We",
    kt:"Th",
    sausis:"Jan",
    vasaris:"Feb",
    kovas:"Mar",
    balandis:"Apr",
    "gegužė":"May",
    "birželis":"Jun",
    liepa:"Jul",
    "rugpjūtis":"Aug",
    "rugsėjis":"Sep",
    spalis:"Oct",
    lapkritis:"Nov",
    gruodis:"Dec",
    lubingu:"Sa",
    lumingu:"Su",
    nkodya:"Mo",
    "ndàayà":"Tu",
    "ndangù":"We",
    "njòwa":"Th",
    "ngòvya":"Fr",
    lub:"Sa",
    nko:"Mo",
    ndy:"Tu",
    ndg:"We",
    njw:"Th",
    ngv:"Fr",
    ciongo:"Jan",
    "lùishi":"Feb",
    "lusòlo":"Mar",
    "mùuyà":"Apr",
    "lumùngùlù":"May",
    lufuimi:"Jun",
    "kabàlàshìpù":"Jul",
    "lùshìkà":"Aug",
    lutongolo:"Sep",
    "lungùdi":"Oct",
    "kaswèkèsè":"Nov",
    "ciswà":"Dec",
    cio:"Jan",
    lus:"Mar",
    muu:"Apr",
    luf:"Jun",
    kab:"Jul",
    lush:"Aug",
    cis:"Dec",
    sestdiena:"Sa",
    "svētdiena":"Su",
    pirmdiena:"Mo",
    otrdiena:"Tu",
    "trešdiena":"We",
    ceturtdiena:"Th",
    piektdiena:"Fr",
    "sestd\\.":"Sa",
    "svētd\\.":"Su",
    "pirmd\\.":"Mo",
    "otrd\\.":"Tu",
    "trešd\\.":"We",
    "ceturtd\\.":"Th",
    "piektd\\.":"Fr",
    "janvāris":"Jan",
    "februāris":"Feb",
    "aprīlis":"Apr",
    maijs:"May",
    "jūnijs":"Jun",
    "jūlijs":"Jul",
    augusts:"Aug",
    septembris:"Sep",
    oktobris:"Oct",
    novembris:"Nov",
    decembris:"Dec",
    "jūn\\.":"Jun",
    "jūl\\.":"Jul",
    asabotsy:"Sa",
    alahady:"Su",
    alatsinainy:"Mo",
    alarobia:"We",
    alakamisy:"Th",
    zoma:"Fr",
    asab:"Sa",
    alah:"Su",
    alats:"Mo",
    alar:"We",
    alak:"Th",
    zom:"Fr",
    janoary:"Jan",
    febroary:"Feb",
    martsa:"Mar",
    aprily:"Apr",
    mey:"May",
    jona:"Jun",
    jolay:"Jul",
    aogositra:"Aug",
    septambra:"Sep",
    oktobra:"Oct",
    novambra:"Nov",
    desambra:"Dec",
    aog:"Aug",
    "rāhoroi":"Sa",
    "rātapu":"Su",
    mane:"Mo",
    "tūrei":"Tu",
    wenerei:"We",
    "tāite":"Th",
    paraire:"Fr",
    "rāh":"Sa",
    "rāt":"Su",
    man:"Mo",
    "tūr":"Tu",
    "tāi":"Th",
    par:"Fr",
    "hānuere":"Jan",
    "pēpuere":"Feb",
    "māehe":"Mar",
    "āperira":"Apr",
    hune:"Jun",
    "hūrae":"Jul",
    "ākuhata":"Aug",
    hepetema:"Sep",
    oketopa:"Oct",
    noema:"Nov",
    "tīhema":"Dec",
    "hān":"Jan",
    "pēp":"Feb",
    "māe":"Mar",
    "āpe":"Apr",
    hun:"Jun",
    "hūr":"Jul",
    "āku":"Aug",
    hep:"Sep",
    oke:"Oct",
    noe:"Nov",
    "tīh":"Dec",
    "сабота":"Sa",
    "недела":"Su",
    "среда":"We",
    "четврток":"Th",
    "петок":"Fr",
    "саб\\.":"Sa",
    "нед\\.":"Su",
    "пон\\.":"Mo",
    "вто\\.":"Tu",
    "сре\\.":"We",
    "чет\\.":"Th",
    "пет\\.":"Fr",
    "јануари":"Jan",
    "мај":"May",
    "јуни":"Jun",
    "јули":"Jul",
    "јан\\.":"Jan",
    "фев\\.":"Feb",
    "мар\\.":"Mar",
    "апр\\.":"Apr",
    "јун\\.":"Jun",
    "јул\\.":"Jul",
    "авг\\.":"Aug",
    "сеп\\.":"Sep",
    "окт\\.":"Oct",
    "ное\\.":"Nov",
    "дек\\.":"Dec",
    "ശനിയാഴ്‌ച":"Sa",
    "ഞായറാഴ്‌ച":"Su",
    "തിങ്കളാഴ്‌ച":"Mo",
    "ചൊവ്വാഴ്‌ച":"Tu",
    "ബുധനാഴ്‌ച":"We",
    "വ്യാഴാഴ്‌ച":"Th",
    "വെള്ളിയാഴ്‌ച":"Fr",
    "ശനി":"Sa",
    "ഞായർ":"Su",
    "തിങ്കൾ":"Mo",
    "ചൊവ്വ":"Tu",
    "ബുധൻ":"We",
    "വ്യാഴം":"Th",
    "വെള്ളി":"Fr",
    "ജനുവരി":"Jan",
    "ഫെബ്രുവരി":"Feb",
    "മാർച്ച്":"Mar",
    "ഏപ്രിൽ":"Apr",
    "മേയ്":"May",
    "ജൂൺ":"Jun",
    "ജൂലൈ":"Jul",
    "ഓഗസ്റ്റ്":"Aug",
    "സെപ്റ്റംബർ":"Sep",
    "ഒക്‌ടോബർ":"Oct",
    "നവംബർ":"Nov",
    "ഡിസംബർ":"Dec",
    "ജനു":"Jan",
    "ഫെബ്രു":"Feb",
    "മാർ":"Mar",
    "ഏപ്രി":"Apr",
    "ഓഗ":"Aug",
    "സെപ്റ്റം":"Sep",
    "ഒക്ടോ":"Oct",
    "നവം":"Nov",
    "ഡിസം":"Dec",
    "бямба":"Sa",
    "ням":"Su",
    "даваа":"Mo",
    "мягмар":"Tu",
    "лхагва":"We",
    "пүрэв":"Th",
    "баасан":"Fr",
    "бя":"Sa",
    "ня":"Su",
    "да":"Mo",
    "мя":"Tu",
    "лх":"We",
    "пү":"Th",
    "ба":"Fr",
    "нэгдүгээр сар":"Jan",
    "хоёрдугаар сар":"Feb",
    "гуравдугаар сар":"Mar",
    "дөрөвдүгээр сар":"Apr",
    "тавдугаар сар":"May",
    "зургаадугаар сар":"Jun",
    "долоодугаар сар":"Jul",
    "наймдугаар сар":"Aug",
    "есдүгээр сар":"Sep",
    "аравдугаар сар":"Oct",
    "арван нэгдүгээр сар":"Nov",
    "арван хоёрдугаар сар":"Dec",
    "1-р сар":"Jan",
    "2-р сар":"Feb",
    "3-р сар":"Mar",
    "4-р сар":"Apr",
    "5-р сар":"May",
    "6-р сар":"Jun",
    "7-р сар":"Jul",
    "8-р сар":"Aug",
    "9-р сар":"Sep",
    "10-р сар":"Oct",
    "11-р сар":"Nov",
    "12-р сар":"Dec",
    "sâmbătă":"Sa",
    "duminică":"Su",
    luni:"Mo",
    "marți":"Tu",
    miercuri:"We",
    joi:"Th",
    vineri:"Fr",
    "sâm\\.":"Sa",
    "dum\\.":"Su",
    "mie\\.":"We",
    "vin\\.":"Fr",
    ianuarie:"Jan",
    martie:"Mar",
    aprilie:"Apr",
    iunie:"Jun",
    iulie:"Jul",
    septembrie:"Sep",
    octombrie:"Oct",
    noiembrie:"Nov",
    decembrie:"Dec",
    "ian\\.":"Jan",
    "iun\\.":"Jun",
    "iul\\.":"Jul",
    "मंगळवार":"Tu",
    "मंगळ":"Tu",
    "जानेवारी":"Jan",
    "फेब्रुवारी":"Feb",
    "एप्रिल":"Apr",
    "मे":"May",
    "जुलै":"Jul",
    "ऑगस्ट":"Aug",
    "सप्टेंबर":"Sep",
    "ऑक्टोबर":"Oct",
    "नोव्हेंबर":"Nov",
    "डिसेंबर":"Dec",
    "जाने":"Jan",
    "फेब्रु":"Feb",
    "एप्रि":"Apr",
    "ऑग":"Aug",
    "सप्टें":"Sep",
    "ऑक्टो":"Oct",
    "नोव्हें":"Nov",
    "डिसें":"Dec",
    isnin:"Mo",
    khamis:"Th",
    jumaat:"Fr",
    ahd:"Su",
    isn:"Mo",
    kha:"Th",
    julai:"Jul",
    ogos:"Aug",
    disember:"Dec",
    ogo:"Aug",
    "is-sibt":"Sa",
    "il-ħadd":"Su",
    "it-tnejn":"Mo",
    "it-tlieta":"Tu",
    "l-erbgħa":"We",
    "il-ħamis":"Th",
    "il-ġimgħa":"Fr",
    "ħad":"Su",
    tne:"Mo",
    tli:"Tu",
    erb:"We",
    "ħam":"Th",
    "ġim":"Fr",
    jannar:"Jan",
    frar:"Feb",
    marzu:"Mar",
    mejju:"May",
    "ġunju":"Jun",
    lulju:"Jul",
    awwissu:"Aug",
    settembru:"Sep",
    ottubru:"Oct",
    novembru:"Nov",
    "diċembru":"Dec",
    fra:"Feb",
    mej:"May",
    "ġun":"Jun",
    lul:"Jul",
    aww:"Aug",
    "diċ":"Dec",
    "စနေ":"Sa",
    "တနင်္ဂနွေ":"Su",
    "တနင်္လာ":"Mo",
    "အင်္ဂါ":"Tu",
    "ဗုဒ္ဓဟူး":"We",
    "ကြာသပတေး":"Th",
    "သောကြာ":"Fr",
    "ဇန်နဝါရီ":"Jan",
    "ဖေဖော်ဝါရီ":"Feb",
    "မတ်":"Mar",
    "ဧပြီ":"Apr",
    "မေ":"May",
    "ဇွန်":"Jun",
    "ဇူလိုင်":"Jul",
    "ဩဂုတ်":"Aug",
    "စက်တင်ဘာ":"Sep",
    "အောက်တိုဘာ":"Oct",
    "နိုဝင်ဘာ":"Nov",
    "ဒီဇင်ဘာ":"Dec",
    "ဇန်":"Jan",
    "ဖေ":"Feb",
    "ဧ":"Apr",
    "ဇူ":"Jul",
    "ဩ":"Aug",
    "စက်":"Sep",
    "အောက်":"Oct",
    "နို":"Nov",
    "ဒီ":"Dec",
    "tir\\.":"Tu",
    mgqibelo:"Sa",
    sonto:"Su",
    mvulo:"Mo",
    sibili:"Tu",
    sithathu:"We",
    sine:"Th",
    sihlanu:"Fr",
    mgq:"Sa",
    sin:"Th",
    sih:"Fr",
    zibandlela:"Jan",
    nhlolanja:"Feb",
    mbimbitho:"Mar",
    mabasa:"Apr",
    nkwenkwezi:"May",
    nhlangula:"Jun",
    ntulikazi:"Jul",
    ncwabakazi:"Aug",
    mpandula:"Sep",
    mfumfu:"Oct",
    lwezi:"Nov",
    mpalakazi:"Dec",
    zib:"Jan",
    nhlo:"Feb",
    mab:"Apr",
    nkw:"May",
    nhla:"Jun",
    ntu:"Jul",
    ncw:"Aug",
    mpan:"Sep",
    mpal:"Dec",
    "शनिबार":"Sa",
    "आइतबार":"Su",
    "सोमबार":"Mo",
    "मङ्गलबार":"Tu",
    "बुधबार":"We",
    "बिहिबार":"Th",
    "शुक्रबार":"Fr",
    "आइत":"Su",
    "मङ्गल":"Tu",
    "बिहि":"Th",
    "फेब्रुअरी":"Feb",
    "अप्रिल":"Apr",
    "जुन":"Jun",
    "अगस्ट":"Aug",
    "सेप्टेम्बर":"Sep",
    "अक्टोबर":"Oct",
    "नोभेम्बर":"Nov",
    "डिसेम्बर":"Dec",
    zaterdag:"Sa",
    zondag:"Su",
    vrijdag:"Fr",
    za:"Sa",
    zo:"Su",
    vr:"Fr",
    laurdag:"Sa",
    "måndag":"Mo",
    tysdag:"Tu",
    lau:"Sa",
    "søn":"Su",
    "mån":"Mo",
    tys:"Tu",
    ons:"We",
    tor:"Th",
    dimenge:"Su",
    diluns:"Mo",
    dimars:"Tu",
    "dimècres":"We",
    "dijòus":"Th",
    "de genièr":"Jan",
    "de febrièr":"Feb",
    "de març":"Mar",
    "d’abril":"Apr",
    "de mai":"May",
    "de junh":"Jun",
    "de julhet":"Jul",
    "d’agost":"Aug",
    "de setembre":"Sep",
    "d’octòbre":"Oct",
    "de novembre":"Nov",
    "de decembre":"Dec",
    sanbata:"Sa",
    dilbata:"Su",
    wiixata:"Mo",
    kibxata:"Tu",
    roobii:"We",
    kamisa:"Th",
    jimaata:"Fr",
    wix:"Mo",
    kib:"Tu",
    rob:"We",
    amajjii:"Jan",
    guraandhala:"Feb",
    bitootessa:"Mar",
    eebila:"Apr",
    caamsaa:"May",
    waxabajjii:"Jun",
    adoolessa:"Jul",
    hagayya:"Aug",
    fulbaana:"Sep",
    onkoloolessa:"Oct",
    sadaasa:"Nov",
    mudde:"Dec",
    ama:"Jan",
    gur:"Feb",
    elb:"Apr",
    cam:"May",
    wax:"Jun",
    ado:"Jul",
    hag:"Aug",
    onk:"Oct",
    mud:"Dec",
    "ଶନିବାର":"Sa",
    "ରବିବାର":"Su",
    "ସୋମବାର":"Mo",
    "ମଙ୍ଗଳବାର":"Tu",
    "ବୁଧବାର":"We",
    "ଗୁରୁବାର":"Th",
    "ଶୁକ୍ରବାର":"Fr",
    "ଶନି":"Sa",
    "ରବି":"Su",
    "ସୋମ":"Mo",
    "ମଙ୍ଗଳ":"Tu",
    "ବୁଧ":"We",
    "ଗୁରୁ":"Th",
    "ଶୁକ୍ର":"Fr",
    "ଜାନୁଆରୀ":"Jan",
    "ଫେବୃଆରୀ":"Feb",
    "ମାର୍ଚ୍ଚ":"Mar",
    "ଅପ୍ରେଲ":"Apr",
    "ମଇ":"May",
    "ଜୁନ":"Jun",
    "ଜୁଲାଇ":"Jul",
    "ଅଗଷ୍ଟ":"Aug",
    "ସେପ୍ଟେମ୍ବର":"Sep",
    "ଅକ୍ଟୋବର":"Oct",
    "ନଭେମ୍ବର":"Nov",
    "ଡିସେମ୍ବର":"Dec",
    "сабат":"Sa",
    "хуыцаубон":"Su",
    "къуырисӕр":"Mo",
    "дыццӕг":"Tu",
    "ӕртыццӕг":"We",
    "цыппӕрӕм":"Th",
    "майрӕмбон":"Fr",
    "сбт":"Sa",
    "хцб":"Su",
    "крс":"Mo",
    "дцг":"Tu",
    "ӕрт":"We",
    "цпр":"Th",
    "мрб":"Fr",
    "мартъи":"Mar",
    "янв\\.":"Jan",
    "февр\\.":"Feb",
    "март\\.":"Mar",
    "сент\\.":"Sep",
    "нояб\\.":"Nov",
    "ਸ਼ਨਿੱਚਰਵਾਰ":"Sa",
    "ਐਤਵਾਰ":"Su",
    "ਸੋਮਵਾਰ":"Mo",
    "ਮੰਗਲਵਾਰ":"Tu",
    "ਬੁੱਧਵਾਰ":"We",
    "ਵੀਰਵਾਰ":"Th",
    "ਸ਼ੁੱਕਰਵਾਰ":"Fr",
    "ਸ਼ਨਿੱਚਰ":"Sa",
    "ਐਤ":"Su",
    "ਸੋਮ":"Mo",
    "ਮੰਗਲ":"Tu",
    "ਬੁੱਧ":"We",
    "ਵੀਰ":"Th",
    "ਸ਼ੁੱਕਰ":"Fr",
    "ਜਨਵਰੀ":"Jan",
    "ਫ਼ਰਵਰੀ":"Feb",
    "ਮਾਰਚ":"Mar",
    "ਅਪ੍ਰੈਲ":"Apr",
    "ਮਈ":"May",
    "ਜੂਨ":"Jun",
    "ਜੁਲਾਈ":"Jul",
    "ਅਗਸਤ":"Aug",
    "ਸਤੰਬਰ":"Sep",
    "ਅਕਤੂਬਰ":"Oct",
    "ਨਵੰਬਰ":"Nov",
    "ਦਸੰਬਰ":"Dec",
    "ਜਨ":"Jan",
    "ਫ਼ਰ":"Feb",
    "ਅਪ੍ਰੈ":"Apr",
    "ਜੁਲਾ":"Jul",
    "ਅਗ":"Aug",
    "ਸਤੰ":"Sep",
    "ਅਕਤੂ":"Oct",
    "ਨਵੰ":"Nov",
    "ਦਸੰ":"Dec",
    niedziela:"Su",
    "poniedziałek":"Mo",
    wtorek:"Tu",
    "środa":"We",
    czwartek:"Th",
    "piątek":"Fr",
    "sob\\.":"Sa",
    "niedz\\.":"Su",
    "pon\\.":"Mo",
    "wt\\.":"Tu",
    "śr\\.":"We",
    "czw\\.":"Th",
    "pt\\.":"Fr",
    "styczeń":"Jan",
    luty:"Feb",
    marzec:"Mar",
    "kwiecień":"Apr",
    czerwiec:"Jun",
    lipiec:"Jul",
    "sierpień":"Aug",
    "wrzesień":"Sep",
    "październik":"Oct",
    "grudzień":"Dec",
    sty:"Jan",
    kwi:"Apr",
    sie:"Aug",
    wrz:"Sep",
    "paź":"Oct",
    gru:"Dec",
    "اونۍ":"Sa",
    "يونۍ":"Su",
    "دونۍ":"Mo",
    "درېنۍ":"Tu",
    "څلرنۍ":"We",
    "پينځنۍ":"Th",
    "مرغومی":"Jan",
    "سلواغه":"Feb",
    "کب":"Mar",
    "وری":"Apr",
    "غویی":"May",
    "غبرگولی":"Jun",
    "چنگاښ":"Jul",
    "زمری":"Aug",
    "وږی":"Sep",
    "تله":"Oct",
    "لړم":"Nov",
    "لیندۍ":"Dec",
    "segunda-feira":"Mo",
    "terça-feira":"Tu",
    "quarta-feira":"We",
    "quinta-feira":"Th",
    "sexta-feira":"Fr",
    "seg\\.":"Mo",
    "ter\\.":"Tu",
    "qua\\.":"We",
    "qui\\.":"Th",
    "sex\\.":"Fr",
    janeiro:"Jan",
    fevereiro:"Feb",
    "março":"Mar",
    junho:"Jun",
    julho:"Jul",
    dezembro:"Dec",
    "fev\\.":"Feb",
    "dez\\.":"Dec",
    setiembre:"Sep",
    sonda:"Sa",
    dumengia:"Su",
    glindesdi:"Mo",
    mesemna:"We",
    gievgia:"Th",
    venderdi:"Fr",
    gli:"Mo",
    gie:"Th",
    schaner:"Jan",
    favrer:"Feb",
    avrigl:"Apr",
    matg:"May",
    zercladur:"Jun",
    fanadur:"Jul",
    avust:"Aug",
    settember:"Sep",
    "schan\\.":"Jan",
    "favr\\.":"Feb",
    "zercl\\.":"Jun",
    "fan\\.":"Jul",
    "sett\\.":"Sep",
    "ku wa gatandatu":"Sa",
    "ku w’indwi":"Su",
    "ku wa mbere":"Mo",
    "ku wa kabiri":"Tu",
    "ku wa gatatu":"We",
    "ku wa kane":"Th",
    "ku wa gatanu":"Fr",
    "gnd\\.":"Sa",
    "cu\\.":"Su",
    "mbe\\.":"Mo",
    "kab\\.":"Tu",
    "gtu\\.":"We",
    "gnu\\.":"Fr",
    nzero:"Jan",
    ruhuhuma:"Feb",
    ntwarante:"Mar",
    ndamukiza:"Apr",
    rusama:"May",
    ruheshi:"Jun",
    mukakaro:"Jul",
    nyandagaro:"Aug",
    gitugutu:"Oct",
    munyonyo:"Nov",
    kigarama:"Dec",
    "mut\\.":"Jan",
    "gas\\.":"Feb",
    "wer\\.":"Mar",
    "mat\\.":"Apr",
    "gic\\.":"May",
    "kam\\.":"Jun",
    "nya\\.":"Jul",
    "nze\\.":"Sep",
    "ukw\\.":"Oct",
    "ugu\\.":"Nov",
    "uku\\.":"Dec",
    "суббота":"Sa",
    "воскресенье":"Su",
    "понедельник":"Mo",
    "четверг":"Th",
    "пятница":"Fr",
    "kuwa gatandatu":"Sa",
    "ku cyumweru":"Su",
    "kuwa mbere":"Mo",
    "kuwa kabiri":"Tu",
    "kuwa gatatu":"We",
    "kuwa kane":"Th",
    "kuwa gatanu":"Fr",
    "cyu\\.":"Su",
    mutarama:"Jan",
    gashyantare:"Feb",
    werurwe:"Mar",
    mata:"Apr",
    gicurasi:"May",
    kamena:"Jun",
    kanama:"Aug",
    nzeri:"Sep",
    ukwakira:"Oct",
    ugushyingo:"Nov",
    ukuboza:"Dec",
    "शनिवासरः":"Sa",
    "रविवासरः":"Su",
    "सोमवासरः":"Mo",
    "मंगलवासरः":"Tu",
    "बुधवासरः":"We",
    "गुरुवासर:":"Th",
    "शुक्रवासरः":"Fr",
    "जनवरीमासः":"Jan",
    "फरवरीमासः":"Feb",
    "मार्चमासः":"Mar",
    "अप्रैलमासः":"Apr",
    "मईमासः":"May",
    "जूनमासः":"Jun",
    "जुलाईमासः":"Jul",
    "अगस्तमासः":"Aug",
    "सितंबरमासः":"Sep",
    "अक्तूबरमासः":"Oct",
    "नवंबरमासः":"Nov",
    "दिसंबरमासः":"Dec",
    "जनवरी:":"Jan",
    "फरवरी:":"Feb",
    "मार्च:":"Mar",
    "अप्रैल:":"Apr",
    "जून:":"Jun",
    "जुलाई:":"Jul",
    "अगस्त:":"Aug",
    "सितंबर:":"Sep",
    "अक्तूबर:":"Oct",
    "नवंबर:":"Nov",
    "दिसंबर:":"Dec",
    "sàbadu":"Sa",
    "domìniga":"Su",
    lunis:"Mo",
    martis:"Tu",
    "mèrcuris":"We",
    "giòbia":"Th",
    "chenàbura":"Fr",
    "sàb":"Sa",
    "mèr":"We",
    "giò":"Th",
    "ghennàrgiu":"Jan",
    "freàrgiu":"Feb",
    martzu:"Mar",
    abrile:"Apr",
    maju:"May",
    "làmpadas":"Jun",
    "trìulas":"Jul",
    austu:"Aug",
    cabudanni:"Sep",
    santugaine:"Oct",
    santandria:"Nov",
    nadale:"Dec",
    ghe:"Jan",
    "làm":"Jun",
    "trì":"Jul",
    aus:"Aug",
    cab:"Sep",
    stg:"Oct",
    sta:"Nov",
    nad:"Dec",
    "ڇنڇر":"Sa",
    "آچر":"Su",
    "سومر":"Mo",
    "اڱارو":"Tu",
    "اربع":"We",
    "خميس":"Th",
    "جمعو":"Fr",
    "جنوري":"Jan",
    "فيبروري":"Feb",
    "مارچ":"Mar",
    "اپريل":"Apr",
    "مئي":"May",
    "جون":"Jun",
    "جولاءِ":"Jul",
    "آگسٽ":"Aug",
    "سيپٽمبر":"Sep",
    "آڪٽوبر":"Oct",
    "ڊسمبر":"Dec",
    "lávvardat":"Sa",
    sotnabeaivi:"Su",
    "vuossárga":"Mo",
    "maŋŋebárga":"Tu",
    gaskavahkku:"We",
    duorasdat:"Th",
    bearjadat:"Fr",
    "láv":"Sa",
    sotn:"Su",
    vuos:"Mo",
    "maŋ":"Tu",
    gask:"We",
    duor:"Th",
    bear:"Fr",
    "ođđajagemánnu":"Jan",
    "guovvamánnu":"Feb",
    "njukčamánnu":"Mar",
    "cuoŋománnu":"Apr",
    "miessemánnu":"May",
    "geassemánnu":"Jun",
    "suoidnemánnu":"Jul",
    "borgemánnu":"Aug",
    "čakčamánnu":"Sep",
    "golggotmánnu":"Oct",
    "skábmamánnu":"Nov",
    "juovlamánnu":"Dec",
    "ođđj":"Jan",
    guov:"Feb",
    njuk:"Mar",
    cuo:"Apr",
    mies:"May",
    geas:"Jun",
    suoi:"Jul",
    borg:"Aug",
    "čakč":"Sep",
    golg:"Oct",
    "skáb":"Nov",
    juov:"Dec",
    "lâyenga":"Sa",
    "bikua-ôko":"Su",
    "bïkua-ûse":"Mo",
    "bïkua-ptâ":"Tu",
    "bïkua-usïö":"We",
    "bïkua-okü":"Th",
    "lâpôsö":"Fr",
    "lây":"Sa",
    bk1:"Su",
    bk2:"Mo",
    bk3:"Tu",
    bk4:"We",
    bk5:"Th",
    "lâp":"Fr",
    nyenye:"Jan",
    "fulundïgi":"Feb",
    "mbängü":"Mar",
    "ngubùe":"Apr",
    "bêläwü":"May",
    "föndo":"Jun",
    lengua:"Jul",
    "kükürü":"Aug",
    mvuka:"Sep",
    ngberere:"Oct",
    "nabändüru":"Nov",
    kakauka:"Dec",
    nye:"Jan",
    "mbä":"Mar",
    "bêl":"May",
    "fön":"Jun",
    len:"Jul",
    "kük":"Aug",
    nab:"Nov",
    kak:"Dec",
    nedelja:"Su",
    ponedeljak:"Mo",
    sreda:"We",
    sre:"We",
    avgust:"Aug",
    avg:"Aug",
    "සෙනසුරාදා":"Sa",
    "ඉරිදා":"Su",
    "සඳුදා":"Mo",
    "අඟහරුවාදා":"Tu",
    "බදාදා":"We",
    "බ්‍රහස්පතින්දා":"Th",
    "සිකුරාදා":"Fr",
    "සෙන":"Sa",
    "අඟහ":"Tu",
    "බ්‍රහස්":"Th",
    "සිකු":"Fr",
    "ජනවාරි":"Jan",
    "පෙබරවාරි":"Feb",
    "මාර්තු":"Mar",
    "අප්‍රේල්":"Apr",
    "මැයි":"May",
    "ජූනි":"Jun",
    "ජූලි":"Jul",
    "අගෝස්තු":"Aug",
    "සැප්තැම්බර්":"Sep",
    "ඔක්තෝබර්":"Oct",
    "නොවැම්බර්":"Nov",
    "දෙසැම්බර්":"Dec",
    "ජන":"Jan",
    "පෙබ":"Feb",
    "මාර්":"Mar",
    "අගෝ":"Aug",
    "සැප්":"Sep",
    "ඔක්":"Oct",
    "නොවැ":"Nov",
    "දෙසැ":"Dec",
    "nedeľa":"Su",
    pondelok:"Mo",
    utorok:"Tu",
    streda:"We",
    "štvrtok":"Th",
    piatok:"Fr",
    marec:"Mar",
    "máj":"May",
    "jún":"Jun",
    "júl":"Jul",
    ponedeljek:"Mo",
    torek:"Tu",
    "četrtek":"Th",
    petek:"Fr",
    "ned\\.":"Su",
    "sre\\.":"We",
    "čet\\.":"Th",
    "pet\\.":"Fr",
    junij:"Jun",
    julij:"Jul",
    "avg\\.":"Aug",
    mugovera:"Sa",
    svondo:"Su",
    muvhuro:"Mo",
    chipiri:"Tu",
    chitatu:"We",
    china:"Th",
    chishanu:"Fr",
    svo:"Su",
    muv:"Mo",
    chp:"Tu",
    cht:"We",
    chn:"Th",
    chs:"Fr",
    ndira:"Jan",
    kukadzi:"Feb",
    kurume:"Mar",
    kubvumbi:"Apr",
    chivabvu:"May",
    chikumi:"Jun",
    chikunguru:"Jul",
    nyamavhuvhu:"Aug",
    gunyana:"Sep",
    gumiguru:"Oct",
    mbudzi:"Nov",
    zvita:"Dec",
    ndi:"Jan",
    kuk:"Feb",
    kub:"Apr",
    chv:"May",
    chk:"Jun",
    chg:"Jul",
    nya:"Aug",
    gun:"Sep",
    gum:"Oct",
    mbu:"Nov",
    zvi:"Dec",
    sabti:"Sa",
    axad:"Su",
    isniin:"Mo",
    talaado:"Tu",
    arbaco:"We",
    khamiis:"Th",
    jimco:"Fr",
    sbti:"Sa",
    axd:"Su",
    tldo:"Tu",
    arbc:"We",
    khms:"Th",
    jmc:"Fr",
    jannaayo:"Jan",
    febraayo:"Feb",
    maarso:"Mar",
    abriil:"Apr",
    maayo:"May",
    juun:"Jun",
    luulyo:"Jul",
    ogosto:"Aug",
    sebteembar:"Sep",
    oktoobar:"Oct",
    noofeembar:"Nov",
    diseembar:"Dec",
    ogs:"Aug",
    nof:"Nov",
    "e shtunë":"Sa",
    "e diel":"Su",
    "e hënë":"Mo",
    "e martë":"Tu",
    "e mërkurë":"We",
    "e enjte":"Th",
    "e premte":"Fr",
    die:"Su",
    "hën":"Mo",
    "mër":"We",
    enj:"Th",
    pre:"Fr",
    janar:"Jan",
    shkurt:"Feb",
    prill:"Apr",
    qershor:"Jun",
    korrik:"Jul",
    gusht:"Aug",
    shtator:"Sep",
    tetor:"Oct",
    "nëntor":"Nov",
    dhjetor:"Dec",
    shk:"Feb",
    pri:"Apr",
    qer:"Jun",
    korr:"Jul",
    gush:"Aug",
    tet:"Oct",
    "nën":"Nov",
    dhj:"Dec",
    "недеља":"Su",
    "понедељак":"Mo",
    "уторак":"Tu",
    "четвртак":"Th",
    "петак":"Fr",
    "суб":"Sa",
    "нед":"Su",
    "пон":"Mo",
    "уто":"Tu",
    "сре":"We",
    "чет":"Th",
    "пет":"Fr",
    "јануар":"Jan",
    "фебруар":"Feb",
    "јун":"Jun",
    "јул":"Jul",
    "септембар":"Sep",
    "октобар":"Oct",
    "новембар":"Nov",
    "децембар":"Dec",
    "јан":"Jan",
    "феб":"Feb",
    "сеп":"Sep",
    "нов":"Nov",
    "дец":"Dec",
    moqebelo:"Sa",
    sontaha:"Su",
    mantaha:"Mo",
    labobedi:"Tu",
    laboraro:"We",
    labone:"Th",
    labohlano:"Fr",
    moq:"Sa",
    mma:"Mo",
    bed:"Tu",
    hla:"Fr",
    pherekgong:"Jan",
    hlakola:"Feb",
    hlakubele:"Mar",
    mmesa:"Apr",
    motsheanong:"May",
    phupjane:"Jun",
    phupu:"Jul",
    phato:"Aug",
    lwetse:"Sep",
    mphalane:"Oct",
    pudungwana:"Nov",
    tshitwe:"Dec",
    phe:"Jan",
    ube:"Mar",
    mme:"Apr",
    mot:"May",
    jan:"Jun",
    upu:"Jul",
    pha:"Aug",
    leo:"Sep",
    mph:"Oct",
    pun:"Nov",
    saptu:"Sa",
    "senén":"Mo",
    salasa:"Tu",
    rebo:"We",
    kemis:"Th",
    jumaah:"Fr",
    mng:"Su",
    sal:"Tu",
    reb:"We",
    kem:"Th",
    "pébruari":"Feb",
    "séptémber":"Sep",
    "nopémber":"Nov",
    "désémber":"Dec",
    "péb":"Feb",
    ags:"Aug",
    "sép":"Sep",
    nop:"Nov",
    "dés":"Dec",
    "lördag":"Sa",
    "söndag":"Su",
    tisdag:"Tu",
    "lör":"Sa",
    "sön":"Su",
    tors:"Th",
    augusti:"Aug",
    jumamosi:"Sa",
    jumapili:"Su",
    jumatatu:"Mo",
    jumanne:"Tu",
    jumatano:"We",
    alhamisi:"Th",
    ijumaa:"Fr",
    machi:"Mar",
    aprili:"Apr",
    agosti:"Aug",
    "சனி":"Sa",
    "ஞாயிறு":"Su",
    "திங்கள்":"Mo",
    "செவ்வாய்":"Tu",
    "புதன்":"We",
    "வியாழன்":"Th",
    "வெள்ளி":"Fr",
    "ஞாயி\\.":"Su",
    "திங்\\.":"Mo",
    "செவ்\\.":"Tu",
    "புத\\.":"We",
    "வியா\\.":"Th",
    "வெள்\\.":"Fr",
    "ஜனவரி":"Jan",
    "பிப்ரவரி":"Feb",
    "மார்ச்":"Mar",
    "ஏப்ரல்":"Apr",
    "மே":"May",
    "ஜூன்":"Jun",
    "ஜூலை":"Jul",
    "ஆகஸ்ட்":"Aug",
    "செப்டம்பர்":"Sep",
    "அக்டோபர்":"Oct",
    "நவம்பர்":"Nov",
    "டிசம்பர்":"Dec",
    "ஜன\\.":"Jan",
    "பிப்\\.":"Feb",
    "மார்\\.":"Mar",
    "ஏப்\\.":"Apr",
    "ஆக\\.":"Aug",
    "செப்\\.":"Sep",
    "அக்\\.":"Oct",
    "நவ\\.":"Nov",
    "டிச\\.":"Dec",
    "శనివారం":"Sa",
    "ఆదివారం":"Su",
    "సోమవారం":"Mo",
    "మంగళవారం":"Tu",
    "బుధవారం":"We",
    "గురువారం":"Th",
    "శుక్రవారం":"Fr",
    "శని":"Sa",
    "ఆది":"Su",
    "సోమ":"Mo",
    "మంగళ":"Tu",
    "బుధ":"We",
    "గురు":"Th",
    "శుక్ర":"Fr",
    "జనవరి":"Jan",
    "ఫిబ్రవరి":"Feb",
    "మార్చి":"Mar",
    "ఏప్రిల్":"Apr",
    "మే":"May",
    "జూన్":"Jun",
    "జులై":"Jul",
    "ఆగస్టు":"Aug",
    "సెప్టెంబర్":"Sep",
    "అక్టోబర్":"Oct",
    "నవంబర్":"Nov",
    "డిసెంబర్":"Dec",
    "జన":"Jan",
    "ఫిబ్ర":"Feb",
    "ఏప్రి":"Apr",
    "ఆగ":"Aug",
    "సెప్టెం":"Sep",
    "అక్టో":"Oct",
    "నవం":"Nov",
    "డిసెం":"Dec",
    "шанбе":"Sa",
    "якшанбе":"Su",
    "душанбе":"Mo",
    "сешанбе":"Tu",
    "чоршанбе":"We",
    "панҷшанбе":"Th",
    "ҷумъа":"Fr",
    "шнб":"Sa",
    "яшб":"Su",
    "дшб":"Mo",
    "сшб":"Tu",
    "чшб":"We",
    "пшб":"Th",
    "ҷмъ":"Fr",
    "январ":"Jan",
    "феврал":"Feb",
    "апрел":"Apr",
    "сентябр":"Sep",
    "октябр":"Oct",
    "ноябр":"Nov",
    "декабр":"Dec",
    "วันเสาร์":"Sa",
    "วันอาทิตย์":"Su",
    "วันจันทร์":"Mo",
    "วันอังคาร":"Tu",
    "วันพุธ":"We",
    "วันพฤหัสบดี":"Th",
    "วันศุกร์":"Fr",
    "ส\\.":"Sa",
    "อา\\.":"Su",
    "จ\\.":"Mo",
    "อ\\.":"Tu",
    "พ\\.":"We",
    "พฤ\\.":"Th",
    "ศ\\.":"Fr",
    "มกราคม":"Jan",
    "กุมภาพันธ์":"Feb",
    "มีนาคม":"Mar",
    "เมษายน":"Apr",
    "พฤษภาคม":"May",
    "มิถุนายน":"Jun",
    "กรกฎาคม":"Jul",
    "สิงหาคม":"Aug",
    "กันยายน":"Sep",
    "ตุลาคม":"Oct",
    "พฤศจิกายน":"Nov",
    "ธันวาคม":"Dec",
    "ม\\.ค\\.":"Jan",
    "ก\\.พ\\.":"Feb",
    "มี\\.ค\\.":"Mar",
    "เม\\.ย\\.":"Apr",
    "พ\\.ค\\.":"May",
    "มิ\\.ย\\.":"Jun",
    "ก\\.ค\\.":"Jul",
    "ส\\.ค\\.":"Aug",
    "ก\\.ย\\.":"Sep",
    "ต\\.ค\\.":"Oct",
    "พ\\.ย\\.":"Nov",
    "ธ\\.ค\\.":"Dec",
    "ቀዳም":"Sa",
    "ሰንበት":"Su",
    "ሰኑይ":"Mo",
    "ሰሉስ":"Tu",
    "ሓሙስ":"Th",
    "ዓርቢ":"Fr",
    "ቀዳ":"Sa",
    "ሰን":"Su",
    "ሰኑ":"Mo",
    "ሰሉ":"Tu",
    "ረቡ":"We",
    "ሓሙ":"Th",
    "ዓር":"Fr",
    "ጥሪ":"Jan",
    "ለካቲት":"Feb",
    "መጋቢት":"Mar",
    "ሚያዝያ":"Apr",
    "ጉንበት":"May",
    "ሰነ":"Jun",
    "ሓምለ":"Jul",
    "ነሓሰ":"Aug",
    "መስከረም":"Sep",
    "ጥቅምቲ":"Oct",
    "ሕዳር":"Nov",
    "ታሕሳስ":"Dec",
    "ለካ":"Feb",
    "መጋ":"Mar",
    "ሚያ":"Apr",
    "ግን":"May",
    "ሓም":"Jul",
    "ነሓ":"Aug",
    "መስ":"Sep",
    "ጥቅ":"Oct",
    "ሕዳ":"Nov",
    "ታሕ":"Dec",
    "şenbe":"Sa",
    "ýekşenbe":"Su",
    "duşenbe":"Mo",
    "sişenbe":"Tu",
    "çarşenbe":"We",
    "penşenbe":"Th",
    anna:"Fr",
    "şen":"Sa",
    "ýek":"Su",
    "duş":"Mo",
    "siş":"Tu",
    "çar":"We",
    pen:"Th",
    ann:"Fr",
    "ýanwar":"Jan",
    fewral:"Feb",
    "maý":"May",
    "iýun":"Jun",
    "iýul":"Jul",
    awgust:"Aug",
    "sentýabr":"Sep",
    "oktýabr":"Oct",
    "noýabr":"Nov",
    "ýan":"Jan",
    few:"Feb",
    awg:"Aug",
    "noý":"Nov",
    sabado:"Sa",
    linggo:"Su",
    miyerkules:"We",
    huwebes:"Th",
    biyernes:"Fr",
    miy:"We",
    huw:"Th",
    biy:"Fr",
    pebrero:"Feb",
    marso:"Mar",
    hunyo:"Jun",
    hulyo:"Jul",
    setyembre:"Sep",
    oktubre:"Oct",
    nobyembre:"Nov",
    disyembre:"Dec",
    peb:"Feb",
    hul:"Jul",
    nob:"Nov",
    matlhatso:"Sa",
    tshipi:"Su",
    mosupologo:"Mo",
    labotlhano:"Fr",
    mos:"Mo",
    labb:"Tu",
    labr:"We",
    labn:"Th",
    labt:"Fr",
    ferikgong:"Jan",
    tlhakole:"Feb",
    mopitlo:"Mar",
    moranang:"Apr",
    motsheganang:"May",
    seetebosigo:"Jun",
    phukwi:"Jul",
    phatwe:"Aug",
    diphalane:"Oct",
    ngwanatsele:"Nov",
    sedimonthole:"Dec",
    fer:"Jan",
    tlh:"Feb",
    mop:"Mar",
    phu:"Jul",
    ngw:"Nov",
    sed:"Dec",
    tokonaki:"Sa",
    "sāpate":"Su",
    "mōnite":"Mo",
    "tūsite":"Tu",
    pulelulu:"We",
    "tuʻapulelulu":"Th",
    falaite:"Fr",
    tok:"Sa",
    "sāp":"Su",
    "mōn":"Mo",
    "tūs":"Tu",
    pul:"We",
    "tuʻa":"Th",
    fal:"Fr",
    "sānuali":"Jan",
    "fēpueli":"Feb",
    "maʻasi":"Mar",
    "ʻepeleli":"Apr",
    "mē":"May",
    sune:"Jun",
    siulai:"Jul",
    "ʻaokosi":"Aug",
    sepitema:"Sep",
    "ʻokatopa":"Oct",
    "nōvema":"Nov",
    "tīsema":"Dec",
    "sān":"Jan",
    "fēp":"Feb",
    "maʻa":"Mar",
    "ʻepe":"Apr",
    siu:"Jul",
    "ʻaok":"Aug",
    "sēp":"Sep",
    "ʻoka":"Oct",
    "nōv":"Nov",
    "tīs":"Dec",
    cumartesi:"Sa",
    pazar:"Su",
    pazartesi:"Mo",
    "salı":"Tu",
    "çarşamba":"We",
    "perşembe":"Th",
    cuma:"Fr",
    paz:"Su",
    pzt:"Mo",
    per:"Th",
    cum:"Fr",
    ocak:"Jan",
    "şubat":"Feb",
    nisan:"Apr",
    "mayıs":"May",
    haziran:"Jun",
    temmuz:"Jul",
    "ağustos":"Aug",
    "eylül":"Sep",
    ekim:"Oct",
    "kasım":"Nov",
    "aralık":"Dec",
    oca:"Jan",
    "şub":"Feb",
    nis:"Apr",
    haz:"Jun",
    tem:"Jul",
    "ağu":"Aug",
    eyl:"Sep",
    eki:"Oct",
    "шимбә":"Sa",
    "якшәмбе":"Su",
    "дүшәмбе":"Mo",
    "сишәмбе":"Tu",
    "чәршәмбе":"We",
    "пәнҗешәмбе":"Th",
    "җомга":"Fr",
    "шим\\.":"Sa",
    "якш\\.":"Su",
    "дүш\\.":"Mo",
    "сиш\\.":"Tu",
    "чәр\\.":"We",
    "пәнҗ\\.":"Th",
    "җом\\.":"Fr",
    "гыйнвар":"Jan",
    "гыйн\\.":"Jan",
    "شەنبە":"Sa",
    "يەكشەنبە":"Su",
    "دۈشەنبە":"Mo",
    "سەيشەنبە":"Tu",
    "چارشەنبە":"We",
    "پەيشەنبە":"Th",
    "جۈمە":"Fr",
    "شە":"Sa",
    "يە":"Su",
    "دۈ":"Mo",
    "سە":"Tu",
    "چا":"We",
    "پە":"Th",
    "جۈ":"Fr",
    "يانۋار":"Jan",
    "فېۋرال":"Feb",
    "مارت":"Mar",
    "ئاپرېل":"Apr",
    "ماي":"May",
    "ئىيۇن":"Jun",
    "ئىيۇل":"Jul",
    "ئاۋغۇست":"Aug",
    "سېنتەبىر":"Sep",
    "ئۆكتەبىر":"Oct",
    "نويابىر":"Nov",
    "دېكابىر":"Dec",
    "неділя":"Su",
    "понеділок":"Mo",
    "вівторок":"Tu",
    "середа":"We",
    "четвер":"Th",
    "пʼятниця":"Fr",
    "січень":"Jan",
    "лютий":"Feb",
    "березень":"Mar",
    "квітень":"Apr",
    "травень":"May",
    "червень":"Jun",
    "липень":"Jul",
    "серпень":"Aug",
    "вересень":"Sep",
    "жовтень":"Oct",
    "листопад":"Nov",
    "грудень":"Dec",
    "січ\\.":"Jan",
    "лют\\.":"Feb",
    "бер\\.":"Mar",
    "квіт\\.":"Apr",
    "трав\\.":"May",
    "черв\\.":"Jun",
    "лип\\.":"Jul",
    "серп\\.":"Aug",
    "вер\\.":"Sep",
    "жовт\\.":"Oct",
    "лист\\.":"Nov",
    "груд\\.":"Dec",
    "ہفتہ":"Sa",
    "اتوار":"Su",
    "پیر":"Mo",
    "منگل":"Tu",
    "بدھ":"We",
    "جمعرات":"Th",
    "جمعہ":"Fr",
    "جنوری":"Jan",
    "فروری":"Feb",
    "جولائی":"Jul",
    "اکتوبر":"Oct",
    shanba:"Sa",
    yakshanba:"Su",
    dushanba:"Mo",
    seshanba:"Tu",
    chorshanba:"We",
    payshanba:"Th",
    shan:"Sa",
    yak:"Su",
    dush:"Mo",
    sesh:"Tu",
    chor:"We",
    sentabr:"Sep",
    oktabr:"Oct",
    "thứ bảy":"Sa",
    "chủ nhật":"Su",
    "thứ hai":"Mo",
    "thứ ba":"Tu",
    "thứ tư":"We",
    "thứ năm":"Th",
    "thứ sáu":"Fr",
    "th 7":"Sa",
    cn:"Su",
    "th 2":"Mo",
    "th 3":"Tu",
    "th 4":"We",
    "th 5":"Th",
    "th 6":"Fr",
    "tháng 1":"Jan",
    "tháng 2":"Feb",
    "tháng 3":"Mar",
    "tháng 4":"Apr",
    "tháng 5":"May",
    "tháng 6":"Jun",
    "tháng 7":"Jul",
    "tháng 8":"Aug",
    "tháng 9":"Sep",
    "tháng 10":"Oct",
    "tháng 11":"Nov",
    "tháng 12":"Dec",
    aseer:"Sa",
    "dibéer":"Su",
    altine:"Mo",
    talaata:"Tu",
    "àlarba":"We",
    alxamis:"Th",
    "àjjuma":"Fr",
    ase:"Sa",
    dib:"Su",
    alt:"Mo",
    "àla":"We",
    alx:"Th",
    "àjj":"Fr",
    samwiyee:"Jan",
    fewriyee:"Feb",
    awril:"Apr",
    suwe:"Jun",
    sulet:"Jul",
    "sàttumbar":"Sep",
    "nowàmbar":"Nov",
    "desàmbar":"Dec",
    awr:"Apr",
    suw:"Jun",
    "sàt":"Sep",
    cawe:"Su",
    lwesibini:"Tu",
    lwesithathu:"We",
    lwesine:"Th",
    lwesihlanu:"Fr",
    caw:"Su",
    bin:"Tu",
    janyuwari:"Jan",
    februwari:"Feb",
    matshi:"Mar",
    epreli:"Apr",
    meyi:"May",
    julayi:"Jul",
    agasti:"Aug",
    okthoba:"Oct",
    aga:"Aug",
    "àbámẹ́ta":"Sa",
    "àìkú":"Su",
    "ajé":"Mo",
    "ìsẹ́gun":"Tu",
    "ọjọ́rú":"We",
    "ọjọ́bọ":"Th",
    "ẹtì":"Fr",
    "oṣù ṣẹ́rẹ́":"Jan",
    "oṣù èrèlè":"Feb",
    "oṣù ẹrẹ̀nà":"Mar",
    "oṣù ìgbé":"Apr",
    "oṣù ẹ̀bibi":"May",
    "oṣù òkúdu":"Jun",
    "oṣù agẹmọ":"Jul",
    "oṣù ògún":"Aug",
    "oṣù owewe":"Sep",
    "oṣù ọ̀wàrà":"Oct",
    "oṣù bélú":"Nov",
    "oṣù ọ̀pẹ̀":"Dec",
    singhgizroek:"Sa",
    ngoenzsinghgiz:"Su",
    singhgizit:"Mo",
    singhgizngeih:"Tu",
    singhgizsam:"We",
    singhgizseiq:"Th",
    singhgizhaj:"Fr",
    ndwenit:"Jan",
    ndwenngeih:"Feb",
    ndwensam:"Mar",
    ndwenseiq:"Apr",
    ndwenngux:"May",
    ndwenloeg:"Jun",
    ndwencaet:"Jul",
    ndwenbet:"Aug",
    ndwengouj:"Sep",
    ndwencib:"Oct",
    "ndwencib’it":"Nov",
    ndwencibngeih:"Dec",
    "星期六":"Sa",
    "星期日":"Su",
    "星期一":"Mo",
    "星期二":"Tu",
    "星期三":"We",
    "星期四":"Th",
    "星期五":"Fr",
    "周六":"Sa",
    "周日":"Su",
    "周一":"Mo",
    "周二":"Tu",
    "周三":"We",
    "周四":"Th",
    "周五":"Fr",
    "一月":"Jan",
    "二月":"Feb",
    "三月":"Mar",
    "四月":"Apr",
    "五月":"May",
    "六月":"Jun",
    "七月":"Jul",
    "八月":"Aug",
    "九月":"Sep",
    "十月":"Oct",
    "十一月":"Nov",
    "十二月":"Dec",
    umgqibelo:"Sa",
    isonto:"Su",
    umsombuluko:"Mo",
    ulwesibili:"Tu",
    ulwesithathu:"We",
    ulwesine:"Th",
    ulwesihlanu:"Fr",
    mso:"Mo",
    bil:"Tu",
    januwari:"Jan",
    mashi:"Mar",
    ephreli:"Apr",
    septhemba:"Sep",
    eph:"Apr",
    "tsuʔndzɨkɔʔɔ":"Sa",
    "tsuʔntsɨ":"Su",
    "tsuʔukpà":"Mo",
    "tsuʔughɔe":"Tu",
    "tsuʔutɔ̀mlò":"We",
    "tsuʔumè":"Th",
    "tsuʔughɨ̂m":"Fr",
    dzk:"Sa",
    nts:"Su",
    "ghɔ":"Tu",
    "tɔm":"We",
    ume:"Th",
    "ghɨ":"Fr",
    "ndzɔ̀ŋɔ̀nùm":"Jan",
    "ndzɔ̀ŋɔ̀kɨ̀zùʔ":"Feb",
    "ndzɔ̀ŋɔ̀tɨ̀dʉ̀ghà":"Mar",
    "ndzɔ̀ŋɔ̀tǎafʉ̄ghā":"Apr",
    "ndzɔ̀ŋèsèe":"May",
    "ndzɔ̀ŋɔ̀nzùghò":"Jun",
    "ndzɔ̀ŋɔ̀dùmlo":"Jul",
    "ndzɔ̀ŋɔ̀kwîfɔ̀e":"Aug",
    "ndzɔ̀ŋɔ̀tɨ̀fʉ̀ghàdzughù":"Sep",
    "ndzɔ̀ŋɔ̀ghǔuwelɔ̀m":"Oct",
    "ndzɔ̀ŋɔ̀chwaʔàkaa wo":"Nov",
    "ndzɔ̀ŋèfwòo":"Dec",
    "nùm":"Jan",
    "kɨz":"Feb",
    "tɨd":"Mar",
    nzu:"Jun",
    "fɔe":"Aug",
    dzu:"Sep",
    "lɔm":"Oct",
    kaa:"Nov",
    fwo:"Dec",
    jmo:"Sa",
    jpi:"Su",
    jtt:"Mo",
    jnn:"Tu",
    jtn:"We",
    "sábadu":"Sa",
    domingu:"Su",
    llunes:"Mo",
    xueves:"Th",
    vienres:"Fr",
    llu:"Mo",
    xue:"Th",
    xineru:"Jan",
    febreru:"Feb",
    xunu:"Jun",
    xunetu:"Jul",
    agostu:"Aug",
    ochobre:"Oct",
    payares:"Nov",
    avientu:"Dec",
    xin:"Jan",
    xun:"Jun",
    xnt:"Jul",
    och:"Oct",
    avi:"Dec",
    "ŋgwà jôn":"Sa",
    "ŋgwà nɔ̂y":"Su",
    "ŋgwà njaŋgumba":"Mo",
    "ŋgwà ûm":"Tu",
    "ŋgwà ŋgê":"We",
    "ŋgwà mbɔk":"Th",
    "ŋgwà kɔɔ":"Fr",
    "nɔy":"Su",
    nja:"Mo",
    uum:"Tu",
    "ŋge":"We",
    "mbɔ":"Th",
    "kɔɔ":"Fr",
    "kɔndɔŋ":"Jan",
    "màcɛ̂l":"Feb",
    "màtùmb":"Mar",
    "màtop":"Apr",
    "m̀puyɛ":"May",
    "hìlòndɛ̀":"Jun",
    "njèbà":"Jul",
    "hìkaŋ":"Aug",
    "dìpɔ̀s":"Sep",
    "bìòôm":"Oct",
    "màyɛsèp":"Nov",
    "lìbuy li ńyèe":"Dec",
    "kɔn":"Jan",
    mto:"Apr",
    mpu:"May",
    hil:"Jun",
    hik:"Aug",
    bio:"Oct",
    "liɓ":"Dec",
    pachibelushi:"Sa",
    "pa mulungu":"Su",
    palichimo:"Mo",
    palichibuli:"Tu",
    palichitatu:"We",
    palichine:"Th",
    palichisano:"Fr",
    epreo:"Apr",
    ogasti:"Aug",
    oga:"Aug",
    "pa shahulembela":"Sa",
    "pa shahuviluha":"Mo",
    "pa hivili":"Tu",
    "pa hidatu":"We",
    "pa hitayi":"Th",
    "pa hihanu":"Fr",
    lem:"Sa",
    hiv:"Tu",
    hid:"We",
    hit:"Th",
    hih:"Fr",
    "pa mwedzi gwa hutala":"Jan",
    "pa mwedzi gwa wuvili":"Feb",
    "pa mwedzi gwa wudatu":"Mar",
    "pa mwedzi gwa wutai":"Apr",
    "pa mwedzi gwa wuhanu":"May",
    "pa mwedzi gwa sita":"Jun",
    "pa mwedzi gwa saba":"Jul",
    "pa mwedzi gwa nane":"Aug",
    "pa mwedzi gwa tisa":"Sep",
    "pa mwedzi gwa kumi":"Oct",
    "pa mwedzi gwa kumi na moja":"Nov",
    "pa mwedzi gwa kumi na mbili":"Dec",
    hut:"Jan",
    dat:"Mar",
    tai:"Apr",
    han:"May",
    nan:"Aug",
    kum:"Oct",
    kmj:"Nov",
    kmb:"Dec",
    "ऐतवार":"Su",
    "बृहस्पतवार":"Th",
    "फरवरी":"Feb",
    "सितम्बर":"Sep",
    "अक्टूबर":"Oct",
    "नवम्बर":"Nov",
    "सनीचर":"Sa",
    "रबीबार":"Su",
    "मंगलबार":"Tu",
    "बृहस्पतिबार":"Th",
    asiibi:"Sa",
    "alahaɖɩ":"Su",
    "aɖɩtɛnɛɛ":"Mo",
    atalaata:"Tu",
    alaarba:"We",
    "alaamɩshɩ":"Th",
    "arɩsǝma":"Fr",
    asib:"Sa",
    "aɖɩt":"Mo",
    atal:"Tu",
    alam:"Th",
    "arɩs":"Fr",
    "ɩjikawǝrka kaŋɔrɔ":"Jan",
    "ɩjikpaka kaŋɔrɔ":"Feb",
    "arɛ́cika kaŋɔrɔ":"Mar",
    "njɩbɔ nɖʊka kaŋɔrɔ":"Apr",
    "acafʊnɖuka kaŋɔrɔ":"May",
    "anɔɔɖuka kaŋɔrɔ":"Jun",
    "alàlaka kaŋɔrɔ":"Jul",
    "ɩjikǝuka kaŋɔrɔ":"Aug",
    "abofʊmka kaŋɔrɔ":"Sep",
    "ɩjicimka kaŋɔrɔ":"Oct",
    "acapomka kaŋɔrɔ":"Nov",
    "anɔɔbʊnka kaŋɔrɔ":"Dec",
    ci:"Mar",
    "ɖʊ":"Apr",
    "ɖu5":"May",
    "ɖu6":"Jun",
    "kǝu":"Aug",
    "fʊm":"Sep",
    cim:"Oct",
    pom:"Nov",
    "bʊn":"Dec",
    "सनिबार":"Sa",
    "रबिबार":"Su",
    "समबार":"Mo",
    "बिस्थिबार":"Th",
    "सुुखुरबार":"Fr",
    "सनि":"Sa",
    "रबि":"Su",
    "सम":"Mo",
    "बिस्थि":"Th",
    "सुखुर":"Fr",
    "जानुवारी":"Jan",
    "फेब्रूवारी":"Feb",
    "आगष्ट":"Aug",
    "सेप्थेम्बर":"Sep",
    "अक्ट’बर":"Oct",
    "नवेम्बर":"Nov",
    "जान":"Jan",
    "फेब":"Feb",
    "जुल":"Jul",
    "आग":"Aug",
    "सेप":"Sep",
    "अक्ट’":"Oct",
    "नवे":"Nov",
    "डिसे":"Dec",
    jumapiri:"Su",
    "murwa wa kanne":"Th",
    "murwa wa katano":"Fr",
    j1:"Sa",
    j2:"Su",
    j3:"Mo",
    j4:"Tu",
    j5:"We",
    al:"Th",
    ij:"Fr",
    "𑄥𑄧𑄚𑄨𑄝𑄢𑄴":"Sa",
    "𑄢𑄧𑄝𑄨𑄝𑄢𑄴":"Su",
    "𑄥𑄧𑄟𑄴𑄝𑄢𑄴":"Mo",
    "𑄟𑄧𑄁𑄉𑄧𑄣𑄴𑄝𑄢𑄴":"Tu",
    "𑄝𑄪𑄖𑄴𑄝𑄢𑄴":"We",
    "𑄝𑄳𑄢𑄨𑄥𑄪𑄛𑄴𑄝𑄢𑄴":"Th",
    "𑄥𑄪𑄇𑄴𑄇𑄮𑄢𑄴𑄝𑄢𑄴":"Fr",
    "𑄥𑄧𑄚𑄨":"Sa",
    "𑄢𑄧𑄝𑄨":"Su",
    "𑄥𑄧𑄟𑄴":"Mo",
    "𑄟𑄧𑄁𑄉𑄧𑄣𑄴":"Tu",
    "𑄝𑄪𑄖𑄴":"We",
    "𑄝𑄳𑄢𑄨𑄥𑄪𑄛𑄴":"Th",
    "𑄥𑄪𑄇𑄴𑄇𑄮𑄢𑄴":"Fr",
    "𑄎𑄚𑄪𑄠𑄢𑄨":"Jan",
    "𑄜𑄬𑄛𑄴𑄝𑄳𑄢𑄪𑄠𑄢𑄨":"Feb",
    "𑄟𑄢𑄴𑄌𑄧":"Mar",
    "𑄃𑄬𑄛𑄳𑄢𑄨𑄣𑄴":"Apr",
    "𑄟𑄬":"May",
    "𑄎𑄪𑄚𑄴":"Jun",
    "𑄎𑄪𑄣𑄭":"Jul",
    "𑄃𑄉𑄧𑄌𑄴𑄑𑄴":"Aug",
    "𑄥𑄬𑄛𑄴𑄑𑄬𑄟𑄴𑄝𑄧𑄢𑄴":"Sep",
    "𑄃𑄧𑄇𑄴𑄑𑄮𑄝𑄧𑄢𑄴":"Oct",
    "𑄚𑄧𑄞𑄬𑄟𑄴𑄝𑄧𑄢𑄴":"Nov",
    "𑄓𑄨𑄥𑄬𑄟𑄴𑄝𑄧𑄢𑄴":"Dec",
    septyembre:"Sep",
    orwamukaaga:"Sa",
    sande:"Su",
    orwokubanza:"Mo",
    orwakabiri:"Tu",
    orwakashatu:"We",
    orwakana:"Th",
    orwakataano:"Fr",
    omk:"Sa",
    ork:"Mo",
    okb:"Tu",
    oks:"We",
    okn:"Th",
    okwokubanza:"Jan",
    okwakabiri:"Feb",
    okwakashatu:"Mar",
    okwakana:"Apr",
    okwakataana:"May",
    okwamukaaga:"Jun",
    okwamushanju:"Jul",
    okwamunaana:"Aug",
    okwamwenda:"Sep",
    okwaikumi:"Oct",
    "okwaikumi na kumwe":"Nov",
    "okwaikumi na ibiri":"Dec",
    kbz:"Jan",
    kbr:"Feb",
    kst:"Mar",
    kkn:"Apr",
    ktn:"May",
    kmk:"Jun",
    kms:"Jul",
    kmn:"Aug",
    kmw:"Sep",
    kkm:"Oct",
    knk:"Nov",
    knb:"Dec",
    "ꭴꮎꮩꮣꮘꮥꮎ":"Sa",
    "ꭴꮎꮩꮣꮖꮝꭼ":"Su",
    "ꭴꮎꮩꮣꮙꮕꭿ":"Mo",
    "ꮤꮅꮑꭲꭶ":"Tu",
    "ꮶꭲꮑꭲꭶ":"We",
    "ꮕꭹꮑꭲꭶ":"Th",
    "ꮷꮎꭹꮆꮝꮧ":"Fr",
    "ꮘꮥꮎ":"Sa",
    "ꮖꮝꭼ":"Su",
    "ꮙꮕꭿ":"Mo",
    "ꮤꮅꮑ":"Tu",
    "ꮶꭲꮑ":"We",
    "ꮕꭹꮑ":"Th",
    "ꮷꮎꭹ":"Fr",
    "ꭴꮓꮈꮤꮕ":"Jan",
    "ꭷꭶꮅ":"Feb",
    "ꭰꮕᏹ":"Mar",
    "ꭷꮼꮒ":"Apr",
    "ꭰꮒꮝꭼꮨ":"May",
    "ꮥꭽꮇᏹ":"Jun",
    "ꭻᏸꮙꮒ":"Jul",
    "ꭶꮆꮒ":"Aug",
    "ꮪꮅꮝꮧ":"Sep",
    "ꮪꮒꮕꮧ":"Oct",
    "ꮕꮣꮥꮖ":"Nov",
    "ꭵꮝꭹᏹ":"Dec",
    "ꭴꮓ":"Jan",
    "ꭷꭶ":"Feb",
    "ꭰꮕ":"Mar",
    "ꭷꮼ":"Apr",
    "ꭰꮒ":"May",
    "ꮥꭽ":"Jun",
    "ꭻᏸ":"Jul",
    "ꭶꮆ":"Aug",
    "ꮪꮅ":"Sep",
    "ꮪꮒ":"Oct",
    "ꮕꮣ":"Nov",
    "ꭵꮝ":"Dec",
    "شەممە":"Sa",
    "یەکشەممە":"Su",
    "دووشەممە":"Mo",
    "سێشەممە":"Tu",
    "چوارشەممە":"We",
    "پێنجشەممە":"Th",
    "ھەینی":"Fr",
    "کانوونی دووەم":"Jan",
    "شوبات":"Feb",
    "ئازار":"Mar",
    "نیسان":"Apr",
    "ئایار":"May",
    "حوزەیران":"Jun",
    "تەمووز":"Jul",
    "ئاب":"Aug",
    "ئەیلوول":"Sep",
    "تشرینی یەکەم":"Oct",
    "تشرینی دووەم":"Nov",
    "کانونی یەکەم":"Dec",
    "ܫܒܬܐ":"Sa",
    "ܚܕܒܫܒܐ":"Su",
    "ܬܪܝܢܒܫܒܐ":"Mo",
    "ܬܠܬܒܫܒܐ":"Tu",
    "ܐܪܒܥܒܫܒܐ":"We",
    "ܚܡܫܒܫܒܐ":"Th",
    "ܥܪܘܒܬܐ":"Fr",
    "ܚܕ":"Su",
    "ܬܪܝܢ":"Mo",
    "ܬܠܬ":"Tu",
    "ܐܪܒܥ":"We",
    "ܚܡܫ":"Th",
    "ܥܪܘ":"Fr",
    "ܟܢܘܢ ܐܚܪܝܐ":"Jan",
    "ܫܒܛ":"Feb",
    "ܐܕܪ":"Mar",
    "ܢܝܣܢ":"Apr",
    "ܐܝܪ":"May",
    "ܚܙܝܪܢ":"Jun",
    "ܬܡܘܙ":"Jul",
    "ܐܒ":"Aug",
    "ܐܝܠܘܠ":"Sep",
    "ܬܫܪܝܢ ܩܕܡܝܐ":"Oct",
    "ܬܫܪܝܢ ܐܚܪܝܐ":"Nov",
    "ܟܢܘܢ ܩܕܡܝܐ":"Dec",
    "ܟܢܘܢ ܒ":"Jan",
    "ܬܫܪܝܢ ܐ":"Oct",
    "ܬܫܪܝܢ ܒ":"Nov",
    "ܟܢܘܢ ܐ":"Dec",
    "ᒫᑎᓇᐍᑮᓯᑳᐤ":"Sa",
    "ᐊᔭᒥᐦᐁᑮᓯᑳᐤ":"Su",
    "ᐴᓂ ᐊᔭᒥᐦᐁᑮᓯᑳᐤ":"Mo",
    "ᓃᓱᑮᓯᑳᐤ":"Tu",
    "ᐋᐱᐦᑕᐘᐣ":"We",
    "ᐴᓂᐋᐱᐦᑕᐘᐣ":"Th",
    "ᑫᑳᐨ ᒫᑎᓇᐍᑮᓯᑳᐤ":"Fr",
    "ᐅᒉᒥᑮᓯᑳᐏᐲᓯᒼ":"Jan",
    "ᐸᐚᐦᒐᑭᓇᓰᐢ":"Feb",
    "ᒥᑭᓯᐏᐲᓯᒼ":"Mar",
    "ᓂᐢᑭᐲᓯᒼ":"Apr",
    "ᐊᓃᑭᐲᓯᒼ":"May",
    "ᐚᐏᐲᓯᒼ":"Jun",
    "ᐹᐢᑲᐦᐋᐏᐲᓯᒼ":"Jul",
    "ᐅᐸᐦᐅᐏᐲᓯᒼ":"Aug",
    "ᓄᒌᑐᐏᐲᓯᒼ":"Sep",
    "ᐱᓈᐢᑯᐏᐲᓯᒼ":"Oct",
    "ᐋᕽᐘᑎᓄᐏᐲᓯᒼ":"Nov",
    "ᒪᑯᓭᑮᓭᑳᐏᐲᓯᒼ":"Dec",
    "kifula nguwo":"Sa",
    "ituku ja jumwa":"Su",
    "kuramuka jimweri":"Mo",
    "kuramuka kawi":"Tu",
    "kuramuka kadadu":"We",
    "kuramuka kana":"Th",
    "kuramuka kasanu":"Fr",
    "mori ghwa imbiri":"Jan",
    "mori ghwa kawi":"Feb",
    "mori ghwa kadadu":"Mar",
    "mori ghwa kana":"Apr",
    "mori ghwa kasanu":"May",
    "mori ghwa karandadu":"Jun",
    "mori ghwa mfungade":"Jul",
    "mori ghwa wunyanya":"Aug",
    "mori ghwa ikenda":"Sep",
    "mori ghwa ikumi":"Oct",
    "mori ghwa ikumi na imweri":"Nov",
    "mori ghwa ikumi na iwi":"Dec",
    imb:"Jan",
    wun:"Aug",
    ike:"Sep",
    iku:"Oct",
    imw:"Nov",
    iwi:"Dec",
    "ऐतबार":"Su",
    "बीरबार":"Th",
    "ऐत":"Su",
    "बीर":"Th",
    "मेई":"May",
    "जन\\.":"Jan",
    "फर\\.":"Feb",
    "अग\\.":"Aug",
    "सित\\.":"Sep",
    "अक्तू\\.":"Oct",
    "नव\\.":"Nov",
    "दिस\\.":"Dec",
    asibti:"Sa",
    alhadi:"Su",
    atinni:"Mo",
    alarba:"We",
    alzuma:"Fr",
    asi:"Sa",
    ati:"Mo",
    alm:"Th",
    alz:"Fr",
    "žanwiye":"Jan",
    feewiriye:"Feb",
    awiril:"Apr",
    "žuweŋ":"Jun",
    "žuyye":"Jul",
    sektanbur:"Sep",
    oktoobur:"Oct",
    noowanbur:"Nov",
    deesanbur:"Dec",
    "žan":"Jan",
    fee:"Feb",
    "žuw":"Jun",
    "žuy":"Jul",
    sek:"Sep",
    noo:"Nov",
    dee:"Dec",
    "جدی":"Jan",
    "دلو":"Feb",
    "حوت":"Mar",
    "حمل":"Apr",
    "ثور":"May",
    "جوزا":"Jun",
    "سرطان":"Jul",
    "اسد":"Aug",
    "سنبلهٔ":"Sep",
    "میزان":"Oct",
    "عقرب":"Nov",
    "قوس":"Dec",
    "njeźela":"Su",
    "pónjeźele":"Mo",
    "wałtora":"Tu",
    srjoda:"We",
    "stwórtk":"Th",
    "pětk":"Fr",
    "pón":"Mo",
    "wał":"Tu",
    srj:"We",
    stw:"Th",
    "pět":"Fr",
    "měrc":"Mar",
    apryl:"Apr",
    nowember:"Nov",
    "měr":"Mar",
    "esaɓasú":"Sa",
    "éti":"Su",
    "mɔ́sú":"Mo",
    "kwasú":"Tu",
    "mukɔ́sú":"We",
    "ŋgisú":"Th",
    "ɗónɛsú":"Fr",
    esa:"Sa",
    "ét":"Su",
    "mɔ́s":"Mo",
    "ŋgi":"Th",
    "ɗón":"Fr",
    "dimɔ́di":"Jan",
    "ŋgɔndɛ":"Feb",
    "sɔŋɛ":"Mar",
    "diɓáɓá":"Apr",
    emiasele:"May",
    "esɔpɛsɔpɛ":"Jun",
    "madiɓɛ́díɓɛ́":"Jul",
    "diŋgindi":"Aug",
    "nyɛtɛki":"Sep",
    "mayésɛ́":"Oct",
    "tiníní":"Nov",
    "eláŋgɛ́":"Dec",
    "ŋgɔn":"Feb",
    "sɔŋ":"Mar",
    "diɓ":"Apr",
    emi:"May",
    "esɔ":"Jun",
    "diŋ":"Aug",
    "nyɛt":"Sep",
    tin:"Nov",
    "elá":"Dec",
    sibiti:"Sa",
    dimas:"Su",
    "teneŋ":"Mo",
    alarbay:"We",
    aramisay:"Th",
    arjuma:"Fr",
    ten:"Mo",
    arj:"Fr",
    sanvie:"Jan",
    "fébirie":"Feb",
    aburil:"Apr",
    "sueŋ":"Jun",
    "súuyee":"Jul",
    settembar:"Sep",
    disambar:"Dec",
    sa:"Jan",
    fe:"Feb",
    su:"Jun",
    "sú":"Jul",
    se:"Sep",
    ok:"Oct",
    no:"Nov",
    njumamothii:"Sa",
    njumatatu:"Mo",
    njumatano:"We",
    arm:"Th",
    "mweri wa mbere":"Jan",
    "mweri wa kaĩri":"Feb",
    "mweri wa kathatũ":"Mar",
    "mweri wa kana":"Apr",
    "mweri wa gatano":"May",
    "mweri wa gatantatũ":"Jun",
    "mweri wa mũgwanja":"Jul",
    "mweri wa kanana":"Aug",
    "mweri wa kenda":"Sep",
    "mweri wa ikũmi":"Oct",
    "mweri wa ikũmi na ũmwe":"Nov",
    "mweri wa ikũmi na kaĩrĩ":"Dec",
    mbe:"Jan",
    kai:"Feb",
    kat:"Mar",
    gat:"May",
    gan:"Jun",
    knn:"Aug",
    ken:"Sep",
    igi:"Dec",
    "séradé":"Sa",
    "sɔ́ndɔ":"Su",
    "mɔ́ndi":"Mo",
    "sɔ́ndɔ məlú mə́bɛ̌":"Tu",
    "sɔ́ndɔ məlú mə́lɛ́":"We",
    "sɔ́ndɔ məlú mə́nyi":"Th",
    "fúladé":"Fr",
    "sér":"Sa",
    "sɔ́n":"Su",
    "mɔ́n":"Mo",
    smb:"Tu",
    sml:"We",
    smn:"Th",
    "fúl":"Fr",
    "ngɔn osú":"Jan",
    "ngɔn bɛ̌":"Feb",
    "ngɔn lála":"Mar",
    "ngɔn nyina":"Apr",
    "ngɔn tána":"May",
    "ngɔn saməna":"Jun",
    "ngɔn zamgbála":"Jul",
    "ngɔn mwom":"Aug",
    "ngɔn ebulú":"Sep",
    "ngɔn awóm":"Oct",
    "ngɔn awóm ai dziá":"Nov",
    "ngɔn awóm ai bɛ̌":"Dec",
    ngo:"Jan",
    ngl:"Mar",
    ngn:"Apr",
    ngt:"May",
    ngz:"Jul",
    ngm:"Aug",
    nga:"Oct",
    ngad:"Nov",
    ngab:"Dec",
    sabide:"Sa",
    domenie:"Su",
    martars:"Tu",
    miercus:"We",
    joibe:"Th",
    vinars:"Fr",
    mie:"We",
    vin:"Fr",
    "zenâr":"Jan",
    "fevrâr":"Feb",
    "avrîl":"Apr",
    jugn:"Jun",
    avost:"Aug",
    setembar:"Sep",
    otubar:"Oct",
    dicembar:"Dec",
    zen:"Jan",
    jug:"Jun",
    avo:"Aug",
    otu:"Oct",
    "hɔɔ":"Sa",
    "hɔgbaa":"Su",
    ju:"Mo",
    "jufɔ":"Tu",
    "shɔ":"We",
    soo:"Th",
    sohaa:"Fr",
    aharabata:"Jan",
    "oflɔ":"Feb",
    otsokrikri:"Mar",
    "abɛibe":"Apr",
    "agbiɛnaa":"May",
    "otukwajaŋ":"Jun",
    "maawɛ":"Jul",
    manyawale:"Aug",
    gbo:"Sep",
    "antɔŋ":"Oct",
    alemle:"Nov",
    afuabe:"Dec",
    "शेनवार":"Sa",
    "आयतार":"Su",
    "सोमार":"Mo",
    "मंगळार":"Tu",
    "बिरेस्तार":"Th",
    "शुक्रार":"Fr",
    "एप्रील":"Apr",
    "जुलय":"Jul",
    "एप्री":"Apr",
    "नो":"Nov",
    samschtig:"Sa",
    sunntig:"Su",
    "määntig":"Mo",
    ziischtig:"Tu",
    mittwuch:"We",
    dunschtig:"Th",
    friitig:"Fr",
    "su\\.":"Su",
    "mä\\.":"Mo",
    "zi\\.":"Tu",
    "mi\\.":"We",
    "du\\.":"Th",
    "fr\\.":"Fr",
    auguscht:"Aug",
    "septämber":"Sep",
    "novämber":"Nov",
    "dezämber":"Dec",
    esabato:"Sa",
    chumapiri:"Su",
    chumatato:"Mo",
    chumaine:"Tu",
    chumatano:"We",
    aramisi:"Th",
    ichuma:"Fr",
    cpr:"Su",
    ctt:"Mo",
    cmn:"Tu",
    ars:"Th",
    icm:"Fr",
    chanuari:"Jan",
    feburari:"Feb",
    apiriri:"Apr",
    chulai:"Jul",
    okitoba:"Oct",
    nobemba:"Nov",
    can:"Jan",
    cul:"Jul",
    "poʻaono":"Sa",
    "lāpule":"Su",
    "poʻakahi":"Mo",
    "poʻalua":"Tu",
    "poʻakolu":"We",
    "poʻahā":"Th",
    "poʻalima":"Fr",
    p6:"Sa",
    lp:"Su",
    p1:"Mo",
    p2:"Tu",
    p3:"We",
    p4:"Th",
    p5:"Fr",
    ianuali:"Jan",
    pepeluali:"Feb",
    malaki:"Mar",
    "ʻapelila":"Apr",
    iune:"Jun",
    iulai:"Jul",
    "ʻaukake":"Aug",
    kepakemapa:"Sep",
    "ʻokakopa":"Oct",
    nowemapa:"Nov",
    kekemapa:"Dec",
    "pep\\.":"Feb",
    "mal\\.":"Mar",
    "ʻap\\.":"Apr",
    "ʻau\\.":"Aug",
    "kep\\.":"Sep",
    "ʻok\\.":"Oct",
    "now\\.":"Nov",
    "kek\\.":"Dec",
    "njedźela":"Su",
    "póndźela":"Mo",
    wutora:"Tu",
    srjeda:"We",
    "štwórtk":"Th",
    pjatk:"Fr",
    "štw":"Th",
    pja:"Fr",
    meja:"May",
    "sásidɛ":"Sa",
    "sɔ́ndi":"Su",
    "ápta mɔ́ndi":"Tu",
    "wɛ́nɛsɛdɛ":"We",
    "tɔ́sɛdɛ":"Th",
    "fɛlâyɛdɛ":"Fr",
    "nduŋmbi saŋ":"Jan",
    "pɛsaŋ pɛ́pá":"Feb",
    "pɛsaŋ pɛ́tát":"Mar",
    "pɛsaŋ pɛ́nɛ́kwa":"Apr",
    "pɛsaŋ pataa":"May",
    "pɛsaŋ pɛ́nɛ́ntúkú":"Jun",
    "pɛsaŋ saambá":"Jul",
    "pɛsaŋ pɛ́nɛ́fɔm":"Aug",
    "pɛsaŋ pɛ́nɛ́pfúꞌú":"Sep",
    "pɛsaŋ nɛgɛ́m":"Oct",
    "pɛsaŋ ntsɔ̌pmɔ́":"Nov",
    "pɛsaŋ ntsɔ̌ppá":"Dec",
    jumapilyi:"Su",
    jumatatuu:"Mo",
    jumatanu:"We",
    iju:"Fr",
    aprilyi:"Apr",
    junyi:"Jun",
    julyai:"Jul",
    agusti:"Aug",
    sayass:"Sa",
    yanass:"Su",
    sanass:"Mo",
    "kraḍass":"Tu",
    "kuẓass":"We",
    samass:"Th",
    "sḍisass":"Fr",
    say:"Sa",
    "kraḍ":"Tu",
    "kuẓ":"We",
    "sḍis":"Fr",
    yennayer:"Jan",
    "fuṛar":"Feb",
    "meɣres":"Mar",
    yebrir:"Apr",
    mayyu:"May",
    yunyu:"Jun",
    yulyu:"Jul",
    "ɣuct":"Aug",
    "ctembeṛ":"Sep",
    "tubeṛ":"Oct",
    "nunembeṛ":"Nov",
    "duǧembeṛ":"Dec",
    yen:"Jan",
    fur:"Feb",
    "meɣ":"Mar",
    "ɣuc":"Aug",
    cte:"Sep",
    tub:"Oct",
    nun:"Nov",
    "duǧ":"Dec",
    "wa thanthatũ":"Sa",
    "wa kyumwa":"Su",
    "wa kwambĩlĩlya":"Mo",
    "wa kelĩ":"Tu",
    "wa katatũ":"We",
    "wa kana":"Th",
    "wa katano":"Fr",
    wth:"Sa",
    wky:"Su",
    wkw:"Mo",
    wkl:"Tu",
    "wtũ":"We",
    "mwai wa mbee":"Jan",
    "mwai wa kelĩ":"Feb",
    "mwai wa katatũ":"Mar",
    "mwai wa kana":"Apr",
    "mwai wa katano":"May",
    "mwai wa thanthatũ":"Jun",
    "mwai wa muonza":"Jul",
    "mwai wa nyaanya":"Aug",
    "mwai wa kenda":"Sep",
    "mwai wa ĩkumi":"Oct",
    "mwai wa ĩkumi na ĩmwe":"Nov",
    "mwai wa ĩkumi na ilĩ":"Dec",
    "ktũ":"Mar",
    moo:"Jul",
    knd:"Sep",
    "ĩku":"Oct",
    "ĩkm":"Nov",
    "ĩkl":"Dec",
    "liduva litandi":"Sa",
    "liduva lyapili":"Su",
    "liduva lyatatu":"Mo",
    "liduva lyanchechi":"Tu",
    "liduva lyannyano":"We",
    "liduva lyannyano na linji":"Th",
    "liduva lyannyano na mavili":"Fr",
    ll1:"Sa",
    ll2:"Su",
    ll3:"Mo",
    ll4:"Tu",
    ll5:"We",
    ll6:"Th",
    ll7:"Fr",
    "mwedi ntandi":"Jan",
    "mwedi wa pili":"Feb",
    "mwedi wa tatu":"Mar",
    "mwedi wa nchechi":"Apr",
    "mwedi wa nnyano":"May",
    "mwedi wa nnyano na umo":"Jun",
    "mwedi wa nnyano na mivili":"Jul",
    "mwedi wa nnyano na mitatu":"Aug",
    "mwedi wa nnyano na nchechi":"Sep",
    "mwedi wa nnyano na nnyano":"Oct",
    "mwedi wa nnyano na nnyano na u":"Nov",
    "mwedi wa nnyano na nnyano na m":"Dec",
    dumingu:"Su",
    "sigunda-fera":"Mo",
    "tersa-fera":"Tu",
    "kuarta-fera":"We",
    "kinta-fera":"Th",
    "sesta-fera":"Fr",
    sig:"Mo",
    ter:"Tu",
    kua:"We",
    kin:"Th",
    ses:"Fr",
    janeru:"Jan",
    marsu:"Mar",
    maiu:"May",
    junhu:"Jun",
    julhu:"Jul",
    setenbru:"Sep",
    otubru:"Oct",
    nuvenbru:"Nov",
    dizenbru:"Dec",
    nuv:"Nov",
    diz:"Dec",
    savnu:"Sa",
    "numĩggu":"Su",
    "pir-kurã-há":"Mo",
    "régre-kurã-há":"Tu",
    "tẽgtũ-kurã-há":"We",
    "vẽnhkãgra-kurã-há":"Th",
    "pénkar-kurã-há":"Fr",
    "sav\\.":"Sa",
    "num\\.":"Su",
    "pir\\.":"Mo",
    "rég\\.":"Tu",
    "tẽg\\.":"We",
    "vẽn\\.":"Th",
    "pén\\.":"Fr",
    "1-kysã":"Jan",
    "2-kysã":"Feb",
    "3-kysã":"Mar",
    "4-kysã":"Apr",
    "5-kysã":"May",
    "6-kysã":"Jun",
    "7-kysã":"Jul",
    "8-kysã":"Aug",
    "9-kysã":"Sep",
    "10-kysã":"Oct",
    "11-kysã":"Nov",
    "12-kysã":"Dec",
    "1ky\\.":"Jan",
    "2ky\\.":"Feb",
    "3ky\\.":"Mar",
    "4ky\\.":"Apr",
    "5ky\\.":"May",
    "6ky\\.":"Jun",
    "7ky\\.":"Jul",
    "8ky\\.":"Aug",
    "9ky\\.":"Sep",
    "10ky\\.":"Oct",
    "11ky\\.":"Nov",
    "12ky\\.":"Dec",
    assabdu:"Sa",
    atini:"Mo",
    atalata:"Tu",
    alhamiisa:"Th",
    aljuma:"Fr",
    ass:"Sa",
    alj:"Fr",
    "mɔnɔ sɔndi":"Sa",
    "sɔndi":"Su",
    "mɛrkɛrɛdi":"We",
    yedi:"Th",
    "vaŋdɛrɛdi":"Fr",
    pamba:"Jan",
    wanja:"Feb",
    "mbiyɔ mɛndoŋgɔ":"Mar",
    "nyɔlɔmbɔŋgɔ":"Apr",
    "mɔnɔ ŋgbanja":"May",
    "nyaŋgwɛ ŋgbanja":"Jun",
    "kuŋgwɛ":"Jul",
    "fɛ":"Aug",
    njapi:"Sep",
    nyukul:"Oct",
    m11:"Nov",
    "ɓulɓusɛ":"Dec",
    kolo:"Sa",
    kotisap:"Su",
    kotaai:"Mo",
    "koaeng’":"Tu",
    kosomok:"We",
    "koang’wan":"Th",
    komuut:"Fr",
    kts:"Su",
    kot:"Mo",
    koo:"Tu",
    kos:"We",
    koa:"Th",
    kom:"Fr",
    mulgul:"Jan",
    "ng’atyaato":"Feb",
    kiptaamo:"Mar",
    iwootkuut:"Apr",
    mamuut:"May",
    paagi:"Jun",
    "ng’eiyeet":"Jul",
    rooptui:"Aug",
    bureet:"Sep",
    epeeso:"Oct",
    "kipsuunde ne taai":"Nov",
    "kipsuunde nebo aeng’":"Dec",
    ngat:"Feb",
    iwo:"Apr",
    paa:"Jun",
    roo:"Aug",
    bur:"Sep",
    epe:"Oct",
    kpt:"Nov",
    jumaamosi:"Sa",
    jumaapii:"Su",
    jumaatatu:"Mo",
    jumaane:"Tu",
    jumaatano:"We",
    jmn:"Tu",
    januali:"Jan",
    febluali:"Feb",
    aplili:"Apr",
    "samdí":"Sa",
    "sɔ́ndǝ":"Su",
    "lǝndí":"Mo",
    "maadí":"Tu",
    "mɛkrɛdí":"We",
    "jǝǝdí":"Th",
    "júmbá":"Fr",
    "lǝn":"Mo",
    "mɛk":"We",
    "jǝǝ":"Th",
    "júm":"Fr",
    "ŋwíí a ntɔ́ntɔ":"Jan",
    "ŋwíí akǝ bɛ́ɛ":"Feb",
    "ŋwíí akǝ ráá":"Mar",
    "ŋwíí akǝ nin":"Apr",
    "ŋwíí akǝ táan":"May",
    "ŋwíí akǝ táafɔk":"Jun",
    "ŋwíí akǝ táabɛɛ":"Jul",
    "ŋwíí akǝ táaraa":"Aug",
    "ŋwíí akǝ táanin":"Sep",
    "ŋwíí akǝ ntɛk":"Oct",
    "ŋwíí akǝ ntɛk di bɔ́k":"Nov",
    "ŋwíí akǝ ntɛk di bɛ́ɛ":"Dec",
    "ŋ1":"Jan",
    "ŋ2":"Feb",
    "ŋ3":"Mar",
    "ŋ4":"Apr",
    "ŋ5":"May",
    "ŋ6":"Jun",
    "ŋ7":"Jul",
    "ŋ8":"Aug",
    "ŋ9":"Sep",
    "ŋ10":"Oct",
    "ŋ11":"Nov",
    "ŋ12":"Dec",
    samsdaach:"Sa",
    sunndaach:"Su",
    mohndaach:"Mo",
    dinnsdaach:"Tu",
    metwoch:"We",
    dunnersdaach:"Th",
    friidaach:"Fr",
    "mo\\.":"Mo",
    "me\\.":"We",
    jannewa:"Jan",
    "fäbrowa":"Feb",
    "määz":"Mar",
    aprell:"Apr",
    "oujoß":"Aug",
    oktohber:"Oct",
    "fäb\\.":"Feb",
    "mäz\\.":"Mar",
    "ouj\\.":"Aug",
    "säp\\.":"Sep",
    "sani vara":"Sa",
    "aadi vara":"Su",
    smbara:"Mo",
    "mangaḍa":"Tu",
    pudara:"We",
    "laki vara":"Th",
    "sukru vara":"Fr",
    sani:"Sa",
    aadi:"Su",
    smba:"Mo",
    manga:"Tu",
    puda:"We",
    laki:"Th",
    sukru:"Fr",
    "pusu lenju":"Jan",
    "maha lenju":"Feb",
    "pagu lenju":"Mar",
    "hire lenju":"Apr",
    "bese lenju":"May",
    "jaṭṭa lenju":"Jun",
    "aasaḍi lenju":"Jul",
    "srabĩ lenju":"Aug",
    "bado lenju":"Sep",
    "dasara lenju":"Oct",
    "divi lenju":"Nov",
    "pande lenju":"Dec",
    pusu:"Jan",
    maha:"Feb",
    pagu:"Mar",
    hire:"Apr",
    bese:"May",
    "jaṭṭa":"Jun",
    "aasaḍi":"Jul",
    "srabĩ":"Aug",
    bado:"Sep",
    dasara:"Oct",
    divi:"Nov",
    pande:"Dec",
    "jumamóosi":"Sa",
    "jumapíiri":"Su",
    "jumatátu":"Mo",
    "jumaíne":"Tu",
    "jumatáano":"We",
    "alamíisi":"Th",
    "ijumáa":"Fr",
    "móosi":"Sa",
    "píili":"Su",
    "táatu":"Mo",
    "íne":"Tu",
    "táano":"We",
    "kʉfúngatɨ":"Jan",
    "kʉnaanɨ":"Feb",
    "kʉkeenda":"Mar",
    kwiikumi:"Apr",
    "kwiinyambála":"May",
    kwiidwaata:"Jun",
    "kʉmʉʉnchɨ":"Jul",
    "kʉvɨɨrɨ":"Aug",
    "kʉsaatʉ":"Sep",
    kwiinyi:"Oct",
    "kʉsaano":"Nov",
    "kʉsasatʉ":"Dec",
    "fúngatɨ":"Jan",
    "naanɨ":"Feb",
    keenda:"Mar",
    "ikúmi":"Apr",
    inyambala:"May",
    idwaata:"Jun",
    "mʉʉnchɨ":"Jul",
    "vɨɨrɨ":"Aug",
    "saatʉ":"Sep",
    inyi:"Oct",
    saano:"Nov",
    "sasatʉ":"Dec",
    sabbo:"Sa",
    domenega:"Su",
    "lunesdì":"Mo",
    "mätesdì":"Tu",
    "mäcordì":"We",
    zeuggia:"Th",
    "venardì":"Fr",
    "de zenâ":"Jan",
    "de frevâ":"Feb",
    "de marso":"Mar",
    "d’arvî":"Apr",
    "de mazzo":"May",
    "de zugno":"Jun",
    "de luggio":"Jul",
    "d’agosto":"Aug",
    "de settembre":"Sep",
    "d’ottobre":"Oct",
    "de dexembre":"Dec",
    "owáŋgyužažapi":"Sa",
    "aŋpétuwakȟaŋ":"Su",
    "aŋpétuwaŋži":"Mo",
    "aŋpétunuŋpa":"Tu",
    "aŋpétuyamni":"We",
    "aŋpétutopa":"Th",
    "aŋpétuzaptaŋ":"Fr",
    "wiótheȟika wí":"Jan",
    "thiyóȟeyuŋka wí":"Feb",
    "ištáwičhayazaŋ wí":"Mar",
    "pȟežítȟo wí":"Apr",
    "čhaŋwápetȟo wí":"May",
    "wípazukȟa-wašté wí":"Jun",
    "čhaŋpȟásapa wí":"Jul",
    "wasútȟuŋ wí":"Aug",
    "čhaŋwápeǧi wí":"Sep",
    "čhaŋwápe-kasná wí":"Oct",
    "waníyetu wí":"Nov",
    "tȟahékapšuŋ wí":"Dec",
    sabet:"Sa",
    "lundì":"Mo",
    "mardì":"Tu",
    "mercoldì":"We",
    "sgiovedì":"Th",
    sginer:"Jan",
    fevrer:"Feb",
    marz:"Mar",
    masg:"May",
    sgiugn:"Jun",
    luj:"Jul",
    setember:"Sep",
    otover:"Oct",
    dicember:"Dec",
    dey:"Jan",
    bahman:"Feb",
    esfand:"Mar",
    farvardin:"Apr",
    ordibehesht:"May",
    khordad:"Jun",
    tir:"Jul",
    mordad:"Aug",
    shahrivar:"Sep",
    mehr:"Oct",
    aban:"Nov",
    azar:"Dec",
    ngeso:"Sa",
    jumapil:"Su",
    "wuok tich":"Mo",
    "tich ariyo":"Tu",
    "tich adek":"We",
    "tich ang’wen":"Th",
    "tich abich":"Fr",
    jmp:"Su",
    tad:"We",
    tab:"Fr",
    "dwe mar achiel":"Jan",
    "dwe mar ariyo":"Feb",
    "dwe mar adek":"Mar",
    "dwe mar ang’wen":"Apr",
    "dwe mar abich":"May",
    "dwe mar auchiel":"Jun",
    "dwe mar abiriyo":"Jul",
    "dwe mar aboro":"Aug",
    "dwe mar ochiko":"Sep",
    "dwe mar apar":"Oct",
    "dwe mar gi achiel":"Nov",
    "dwe mar apar gi ariyo":"Dec",
    dac:"Jan",
    dar:"Feb",
    dad:"Mar",
    dan:"Apr",
    dah:"May",
    dau:"Jun",
    dao:"Jul",
    dab:"Aug",
    doc:"Sep",
    dap:"Oct",
    dgi:"Nov",
    dag:"Dec",
    "शनि दिन":"Sa",
    "रवि दिन":"Su",
    "सोम दिन":"Mo",
    "मंगल दिन":"Tu",
    "बुध दिन":"We",
    "बृहस्पति दिन":"Th",
    "शुक्र दिन":"Fr",
    "फर॰":"Feb",
    "jumamósi":"Sa",
    "jumapílí":"Su",
    jumane:"Tu",
    "jumatánɔ":"We",
    "alaámisi":"Th",
    "jumáa":"Fr",
    "oladalʉ́":"Jan",
    "arát":"Feb",
    "ɔɛnɨ́ɔɨŋɔk":"Mar",
    "olodoyíóríê inkókúâ":"Apr",
    "oloilépūnyīē inkókúâ":"May",
    "kújúɔrɔk":"Jun",
    "mórusásin":"Jul",
    "ɔlɔ́ɨ́bɔ́rárɛ":"Aug",
    "kúshîn":"Sep",
    "olgísan":"Oct",
    "pʉshʉ́ka":"Nov",
    "ntʉ́ŋʉ́s":"Dec",
    dal:"Jan",
    "ará":"Feb",
    "ɔɛn":"Mar",
    doy:"Apr",
    "lép":"May",
    rok:"Jun",
    "sás":"Jul",
    "bɔ́r":"Aug",
    "kús":"Sep",
    "gís":"Oct",
    "shʉ́":"Nov",
    "ntʉ́":"Dec",
    muramuko:"Mo",
    wairi:"Tu",
    wethatu:"We",
    wena:"Th",
    wetano:"Fr",
    kiu:"Su",
    mra:"Mo",
    wai:"Tu",
    wet:"We",
    "januarĩ":"Jan",
    "feburuarĩ":"Feb",
    "ĩpurũ":"Apr",
    "mĩĩ":"May",
    njuni:"Jun",
    "njuraĩ":"Jul",
    "oktũba":"Oct",
    dicemba:"Dec",
    "ĩpu":"Apr",
    nju:"Jun",
    njr:"Jul",
    spt:"Sep",
    samdi:"Sa",
    dimans:"Su",
    lindi:"Mo",
    merkredi:"We",
    zedi:"Th",
    vandredi:"Fr",
    ze:"Th",
    van:"Fr",
    zanvie:"Jan",
    fevriye:"Feb",
    zin:"Jun",
    zilye:"Jul",
    out:"Aug",
    septam:"Sep",
    oktob:"Oct",
    novam:"Nov",
    desam:"Dec",
    zil:"Jul",
    arahamisi:"Th",
    "mweri wo kwanza":"Jan",
    "mweri wo unayeli":"Feb",
    "mweri wo uneraru":"Mar",
    "mweri wo unecheshe":"Apr",
    "mweri wo unethanu":"May",
    "mweri wo thanu na mocha":"Jun",
    "mweri wo saba":"Jul",
    "mweri wo nane":"Aug",
    "mweri wo tisa":"Sep",
    "mweri wo kumi":"Oct",
    "mweri wo kumi na moja":"Nov",
    "mweri wo kumi na yel’li":"Dec",
    una:"Feb",
    moc:"Jun",
    moj:"Nov",
    yel:"Dec",
    "aneg 7":"Sa",
    "aneg 1":"Su",
    "aneg 2":"Mo",
    "aneg 3":"Tu",
    "aneg 4":"We",
    "aneg 5":"Th",
    "aneg 6":"Fr",
    "iməg mbegtug":"Jan",
    "imeg àbùbì":"Feb",
    "imeg mbəŋchubi":"Mar",
    "iməg ngwə̀t":"Apr",
    "iməg fog":"May",
    "iməg ichiibɔd":"Jun",
    "iməg àdùmbə̀ŋ":"Jul",
    "iməg ichika":"Aug",
    "iməg kud":"Sep",
    "iməg tèsiʼe":"Oct",
    "iməg zò":"Nov",
    "iməg krizmed":"Dec",
    mbegtug:"Jan",
    "থাংজ":"Sa",
    "নোংমাইজিং":"Su",
    "নিংথৌকাবা":"Mo",
    "লৈবাকপোকপা":"Tu",
    "য়ুমশকৈশা":"We",
    "শগোলশেন":"Th",
    "ইরাই":"Fr",
    "জানুৱারি":"Jan",
    "ফেব্রুৱারি":"Feb",
    "ওগষ্ট":"Aug",
    "ওক্টোবর":"Oct",
    "নবেম্বর":"Nov",
    "ফেব্রু":"Feb",
    "মার":"Mar",
    "এপ্রি":"Apr",
    "জুলা":"Jul",
    "সেপ্ট":"Sep",
    "ওক্টো":"Oct",
    "নভে":"Nov",
    "ডিসে":"Dec",
    "comzyeɓsuu":"Sa",
    "com’yakke":"Su",
    "comlaaɗii":"Mo",
    "comzyiiɗii":"Tu",
    comkolle:"We",
    "comkaldǝɓlii":"Th",
    comgaisuu:"Fr",
    cya:"Su",
    czi:"Tu",
    cko:"We",
    cka:"Th",
    cga:"Fr",
    "fĩi loo":"Jan",
    "cokcwaklaŋne":"Feb",
    cokcwaklii:"Mar",
    "fĩi marfoo":"Apr",
    "madǝǝuutǝbijaŋ":"May",
    "mamǝŋgwãafahbii":"Jun",
    "mamǝŋgwãalii":"Jul",
    "madǝmbii":"Aug",
    "fĩi dǝɓlii":"Sep",
    "fĩi mundaŋ":"Oct",
    "fĩi gwahlle":"Nov",
    "fĩi yuru":"Dec",
    flo:"Jan",
    cki:"Mar",
    fmf:"Apr",
    mli:"Jul",
    fde:"Sep",
    fmu:"Oct",
    fgw:"Nov",
    fyu:"Dec",
    satertaxtsees:"Sa",
    sontaxtsees:"Su",
    mantaxtsees:"Mo",
    denstaxtsees:"Tu",
    wunstaxtsees:"We",
    dondertaxtsees:"Th",
    fraitaxtsees:"Fr",
    wu:"We",
    "ǃkhanni":"Jan",
    "ǃkhanǀgôab":"Feb",
    "ǀkhuuǁkhâb":"Mar",
    "ǃhôaǂkhaib":"Apr",
    "ǃkhaitsâb":"May",
    "gamaǀaeb":"Jun",
    "ǂkhoesaob":"Jul",
    "aoǁkhuumûǁkhâb":"Aug",
    "taraǀkhuumûǁkhâb":"Sep",
    "ǂnûǁnâiseb":"Oct",
    "ǀhooǂgaeb":"Nov",
    "hôasoreǁkhâb":"Dec",
    "sünnavend":"Sa",
    "sünndag":"Su",
    dingsdag:"Tu",
    middeweken:"We",
    dunnersdag:"Th",
    freedag:"Fr",
    januaar:"Jan",
    februaar:"Feb",
    oktover:"Oct",
    "sásadi":"Sa",
    "mɔ́ndɔ":"Mo",
    "sɔ́ndɔ mafú mába":"Tu",
    "sɔ́ndɔ mafú málal":"We",
    "sɔ́ndɔ mafú mána":"Th",
    "mabágá má sukul":"Fr",
    sas:"Sa",
    mbs:"Fr",
    "ngwɛn matáhra":"Jan",
    "ngwɛn ńmba":"Feb",
    "ngwɛn ńlal":"Mar",
    "ngwɛn ńna":"Apr",
    "ngwɛn ńtan":"May",
    "ngwɛn ńtuó":"Jun",
    "ngwɛn hɛmbuɛrí":"Jul",
    "ngwɛn lɔmbi":"Aug",
    "ngwɛn rɛbvuâ":"Sep",
    "ngwɛn wum":"Oct",
    "ngwɛn wum navǔr":"Nov",
    "krísimin":"Dec",
    ng1:"Jan",
    ng2:"Feb",
    ng3:"Mar",
    ng4:"Apr",
    ng5:"May",
    ng6:"Jun",
    ng7:"Jul",
    ng8:"Aug",
    ng9:"Sep",
    ng10:"Oct",
    ng11:"Nov",
    kris:"Dec",
    "màga lyɛ̌ʼ":"Sa",
    "lyɛʼɛ́ sẅíŋtè":"Su",
    "mvfò lyɛ̌ʼ":"Mo",
    "mbɔ́ɔntè mvfò lyɛ̌ʼ":"Tu",
    "tsètsɛ̀ɛ lyɛ̌ʼ":"We",
    "mbɔ́ɔntè tsetsɛ̀ɛ lyɛ̌ʼ":"Th",
    "mvfò màga lyɛ̌ʼ":"Fr",
    "saŋ tsetsɛ̀ɛ lùm":"Jan",
    "saŋ kàg ngwóŋ":"Feb",
    "saŋ lepyè shúm":"Mar",
    "saŋ cÿó":"Apr",
    "saŋ tsɛ̀ɛ cÿó":"May",
    "saŋ njÿoláʼ":"Jun",
    "saŋ tyɛ̀b tyɛ̀b mbʉ̀ŋ":"Jul",
    "saŋ mbʉ̀ŋ":"Aug",
    "saŋ ngwɔ̀ʼ mbÿɛ":"Sep",
    "saŋ tàŋa tsetsáʼ":"Oct",
    "saŋ mejwoŋó":"Nov",
    "saŋ lùm":"Dec",
    "ߞߍ߲ߘߍߟߏ߲":"Sa",
    "ߞߊ߯ߙߌߟߏ߲":"Su",
    "ߞߐ߬ߓߊ߬ߟߏ߲":"Mo",
    "ߞߐ߬ߟߏ߲":"Tu",
    "ߞߎߣߎ߲ߟߏ߲":"We",
    "ߓߌߟߏ߲":"Th",
    "ߛߌ߬ߣߌ߲߬ߟߏ߲":"Fr",
    "ߞߍ߲ߘ":"Sa",
    "ߞߊ߯ߙ":"Su",
    "ߞߐ߬ߓ":"Mo",
    "ߞߐ߬ߟ":"Tu",
    "ߞߎߣ":"We",
    "ߓߌߟ":"Th",
    "ߛߌ߬ߣ":"Fr",
    "ߓߌ߲ߠߊߥߎߟߋ߲":"Jan",
    "ߞߏ߲ߞߏߜߍ":"Feb",
    "ߕߙߊߓߊ":"Mar",
    "ߞߏ߲ߞߏߘߌ߬ߓߌ":"Apr",
    "ߘߓߊ߬ߕߊ":"May",
    "ߥߊ߬ߛߌ߬ߥߙߊ":"Jun",
    "ߞߊ߬ߙߌߝߐ߭":"Jul",
    "ߘߓߊ߬ߓߌߟߊ":"Aug",
    "ߕߎߟߊߝߌ߲":"Sep",
    "ߞߏ߲ߓߌߕߌ߮":"Oct",
    "ߣߍߣߍߓߊ":"Nov",
    "ߞߏߟߌ߲ߞߏߟߌ߲":"Dec",
    "ߓߌ߲ߠ":"Jan",
    "ߞߏ߲ߞ":"Feb",
    "ߕߙߊ":"Mar",
    "ߞߏ߲ߘ":"Apr",
    "ߘߓߊ߬ߕ":"May",
    "ߥߊ߬ߛ":"Jun",
    "ߞߊ߬ߙ":"Jul",
    "ߘߓߊ߬ߓ":"Aug",
    "ߞߏ߲ߓ":"Oct",
    "ߣߍߣ":"Nov",
    "ߞߏߟ":"Dec",
    mokibelo:"Sa",
    lamorena:"Su",
    "mošupologo":"Mo",
    lam:"Su",
    janeware:"Jan",
    febereware:"Feb",
    "matšhe":"Mar",
    aporele:"Apr",
    julae:"Jul",
    agosetose:"Aug",
    setemere:"Sep",
    oktobore:"Oct",
    nofemere:"Nov",
    disemere:"Dec",
    phere:"Jan",
    dibo:"Feb",
    hlak:"Mar",
    mora:"Apr",
    mose:"Jul",
    lewe:"Sep",
    dipha:"Oct",
    diba:"Nov",
    manth:"Dec",
    "bäkɛl lätni":"Sa",
    "cäŋ kuɔth":"Su",
    "jiec la̱t":"Mo",
    "rɛw lätni":"Tu",
    "diɔ̱k lätni":"We",
    "ŋuaan lätni":"Th",
    "dhieec lätni":"Fr",
    "bäkɛl":"Sa",
    "cäŋ":"Su",
    jiec:"Mo",
    "rɛw":"Tu",
    "diɔ̱k":"We",
    "ŋuaan":"Th",
    dhieec:"Fr",
    "tiop thar pɛt":"Jan",
    "pɛt":"Feb",
    "duɔ̱ɔ̱ŋ":"Mar",
    guak:"Apr",
    "duät":"May",
    kornyoot:"Jun",
    "pay yie̱tni":"Jul",
    "tho̱o̱r":"Aug",
    "tɛɛr":"Sep",
    laath:"Oct",
    "tio̱p in di̱i̱t":"Dec",
    tiop:"Jan",
    "duɔ̱ɔ̱":"Mar",
    "duä":"May",
    thoo:"Aug",
    "tɛɛ":"Sep",
    laa:"Oct",
    tid:"Dec",
    "sátọdè":"Sa",
    "sọ́ndè":"Su",
    "mọ́ndè":"Mo",
    "tiúzdè":"Tu",
    "wẹ́nẹ́zdè":"We",
    "tọ́zdè":"Th",
    "fraídè":"Fr",
    "sát":"Sa",
    "sọ́n":"Su",
    "mọ́n":"Mo",
    "tiú":"Tu",
    "wẹ́n":"We",
    "tọ́z":"Th",
    "fraí":"Fr",
    "jénúári":"Jan",
    "fẹ́búári":"Feb",
    mach:"Mar",
    "éprel":"Apr",
    "ọgọst":"Aug",
    "sẹptẹ́mba":"Sep",
    "ọktóba":"Oct",
    "nọvẹ́mba":"Nov",
    "disẹ́mba":"Dec",
    "jén":"Jan",
    "fẹ́b":"Feb",
    "épr":"Apr",
    "ọ́gọ":"Aug",
    "sẹp":"Sep",
    "nọv":"Nov",
    sabattika:"Sa",
    "nadīli":"Su",
    "panadīli":"Mo",
    "wisasīdis":"Tu",
    pussisawaiti:"We",
    ketwirtiks:"Th",
    "pēntniks":"Fr",
    rags:"Jan",
    wassarins:"Feb",
    "pūlis":"Mar",
    sakkis:"Apr",
    zallaws:"May",
    "sīmenis":"Jun",
    "līpa":"Jul",
    daggis:"Aug",
    sillins:"Sep",
    spallins:"Oct",
    "lapkrūtis":"Nov",
    sallaws:"Dec",
    ijumamosi:"Sa",
    ijumapili:"Su",
    ijumatatu:"Mo",
    ijumanne:"Tu",
    ijumatano:"We",
    ijp:"Su",
    ijt:"Mo",
    ijn:"Tu",
    ijtn:"We",
    "mweri wa kwanza":"Jan",
    "mweri wa kaili":"Feb",
    "mweri wa katatu":"Mar",
    "mweri wa kaana":"Apr",
    "mweri wa tanu":"May",
    "mweri wa sita":"Jun",
    "mweri wa saba":"Jul",
    "mweri wa nane":"Aug",
    "mweri wa tisa":"Sep",
    "mweri wa ikumi":"Oct",
    "mweri wa ikumi na moja":"Nov",
    "mweri wa ikumi na mbili":"Dec",
    m1:"Jan",
    m2:"Feb",
    m3:"Mar",
    m4:"Apr",
    m5:"May",
    m6:"Jun",
    m7:"Jul",
    m8:"Aug",
    m9:"Sep",
    m10:"Oct",
    m12:"Dec",
    "субуота":"Sa",
    "баскыһыанньа":"Su",
    "бэнидиэнньик":"Mo",
    "оптуорунньук":"Tu",
    "сэрэдэ":"We",
    "чэппиэр":"Th",
    "бээтиҥсэ":"Fr",
    "бн":"Mo",
    "оп":"Tu",
    "сэ":"We",
    "чп":"Th",
    "бэ":"Fr",
    "тохсунньу":"Jan",
    "олунньу":"Feb",
    "кулун тутар":"Mar",
    "муус устар":"Apr",
    "ыам ыйа":"May",
    "бэс ыйа":"Jun",
    "от ыйа":"Jul",
    "атырдьых ыйа":"Aug",
    "балаҕан ыйа":"Sep",
    "алтынньы":"Oct",
    "сэтинньи":"Nov",
    "ахсынньы":"Dec",
    "тохс":"Jan",
    "олун":"Feb",
    "клн":"Mar",
    "мсу":"Apr",
    "ыам":"May",
    "бэс":"Jun",
    "отй":"Jul",
    "атр":"Aug",
    "блҕ":"Sep",
    "алт":"Oct",
    "сэт":"Nov",
    "ахс":"Dec",
    "mderot ee kwe":"Sa",
    "mderot ee are":"Su",
    "mderot ee kuni":"Mo",
    "mderot ee ong’wan":"Tu",
    "mderot ee inet":"We",
    "mderot ee ile":"Th",
    "mderot ee sapa":"Fr",
    are:"Su",
    kun:"Mo",
    "lapa le obo":"Jan",
    "lapa le waare":"Feb",
    "lapa le okuni":"Mar",
    "lapa le ong’wan":"Apr",
    "lapa le imet":"May",
    "lapa le ile":"Jun",
    "lapa le sapa":"Jul",
    "lapa le isiet":"Aug",
    "lapa le saal":"Sep",
    "lapa le tomon":"Oct",
    "lapa le tomon obo":"Nov",
    "lapa le tomon waare":"Dec",
    obo:"Jan",
    waa:"Feb",
    oku:"Mar",
    ime:"May",
    isi:"Aug",
    saa:"Sep",
    tom:"Oct",
    tob:"Nov",
    tow:"Dec",
    "ᱧᱩᱦᱩᱢ":"Sa",
    "ᱥᱤᱸᱜᱮ":"Su",
    "ᱚᱛᱮ":"Mo",
    "ᱵᱟᱞᱮ":"Tu",
    "ᱥᱟᱹᱜᱩᱱ":"We",
    "ᱥᱟᱹᱨᱫᱤ":"Th",
    "ᱡᱟᱹᱨᱩᱢ":"Fr",
    "ᱧᱩ":"Sa",
    "ᱥᱤᱸ":"Su",
    "ᱚᱛ":"Mo",
    "ᱵᱟ":"Tu",
    "ᱥᱟᱹ":"We",
    "ᱥᱟᱹᱨ":"Th",
    "ᱡᱟᱹ":"Fr",
    "ᱡᱟᱱᱣᱟᱨᱤ":"Jan",
    "ᱯᱷᱟᱨᱣᱟᱨᱤ":"Feb",
    "ᱢᱟᱨᱪ":"Mar",
    "ᱟᱯᱨᱮᱞ":"Apr",
    "ᱢᱮ":"May",
    "ᱡᱩᱱ":"Jun",
    "ᱡᱩᱞᱟᱭ":"Jul",
    "ᱟᱜᱟᱥᱛ":"Aug",
    "ᱥᱮᱯᱴᱮᱢᱵᱟᱨ":"Sep",
    "ᱚᱠᱴᱚᱵᱟᱨ":"Oct",
    "ᱱᱟᱣᱟᱢᱵᱟᱨ":"Nov",
    "ᱫᱤᱥᱟᱢᱵᱟᱨ":"Dec",
    "ᱡᱟᱱ":"Jan",
    "ᱯᱷᱟ":"Feb",
    "ᱢᱟᱨ":"Mar",
    "ᱟᱯᱨ":"Apr",
    "ᱡᱩᱞ":"Jul",
    "ᱟᱜᱟ":"Aug",
    "ᱥᱮᱯ":"Sep",
    "ᱚᱠᱴ":"Oct",
    "ᱱᱟᱣ":"Nov",
    "ᱫᱤᱥ":"Dec",
    mulungu:"Su",
    alahamisi:"Th",
    mupalangulwa:"Jan",
    mwitope:"Feb",
    mushende:"Mar",
    munyi:"Apr",
    "mushende magali":"May",
    mujimbi:"Jun",
    mushipepo:"Jul",
    mupuguto:"Aug",
    munyense:"Sep",
    mokhu:"Oct",
    musongandembwe:"Nov",
    muhaano:"Dec",
    mup:"Jan",
    mwi:"Feb",
    msh:"Mar",
    mun:"Apr",
    muj:"Jun",
    msp:"Jul",
    mpg:"Aug",
    mye:"Sep",
    mus:"Nov",
    muh:"Dec",
    sabudu:"Sa",
    dimingu:"Su",
    chiposi:"Mo",
    chinai:"Th",
    pos:"Mo",
    pir:"Tu",
    nai:"Th",
    sha:"Fr",
    fevreiro:"Feb",
    marco:"Mar",
    otubro:"Oct",
    "ⴰⵙⵉⴹⵢⴰⵙ":"Sa",
    "ⴰⵙⴰⵎⴰⵙ":"Su",
    "ⴰⵢⵏⴰⵙ":"Mo",
    "ⴰⵙⵉⵏⴰⵙ":"Tu",
    "ⴰⴽⵕⴰⵙ":"We",
    "ⴰⴽⵡⴰⵙ":"Th",
    "ⵙⵉⵎⵡⴰⵙ":"Fr",
    "ⴰⵙⵉⴹ":"Sa",
    "ⴰⵙⴰ":"Su",
    "ⴰⵢⵏ":"Mo",
    "ⴰⵙⵉ":"Tu",
    "ⴰⴽⵕ":"We",
    "ⴰⴽⵡ":"Th",
    "ⴰⵙⵉⵎ":"Fr",
    "ⵉⵏⵏⴰⵢⵔ":"Jan",
    "ⴱⵕⴰⵢⵕ":"Feb",
    "ⵎⴰⵕⵚ":"Mar",
    "ⵉⴱⵔⵉⵔ":"Apr",
    "ⵎⴰⵢⵢⵓ":"May",
    "ⵢⵓⵏⵢⵓ":"Jun",
    "ⵢⵓⵍⵢⵓⵣ":"Jul",
    "ⵖⵓⵛⵜ":"Aug",
    "ⵛⵓⵜⴰⵏⴱⵉⵔ":"Sep",
    "ⴽⵜⵓⴱⵔ":"Oct",
    "ⵏⵓⵡⴰⵏⴱⵉⵔ":"Nov",
    "ⴷⵓⵊⴰⵏⴱⵉⵔ":"Dec",
    "ⵉⵏⵏ":"Jan",
    "ⴱⵕⴰ":"Feb",
    "ⵎⴰⵕ":"Mar",
    "ⵉⴱⵔ":"Apr",
    "ⵎⴰⵢ":"May",
    "ⵢⵓⵏ":"Jun",
    "ⵢⵓⵍ":"Jul",
    "ⵖⵓⵛ":"Aug",
    "ⵛⵓⵜ":"Sep",
    "ⴽⵜⵓ":"Oct",
    "ⵏⵓⵡ":"Nov",
    "ⴷⵓⵊ":"Dec",
    "lávurdâh":"Sa",
    pasepeivi:"Su",
    "vuossargâ":"Mo",
    "majebargâ":"Tu",
    koskokko:"We",
    "tuorâstâh":"Th",
    "vástuppeivi":"Fr",
    pas:"Su",
    vuo:"Mo",
    tuo:"Th",
    "vás":"Fr",
    "uđđâivemáánu":"Jan",
    "kuovâmáánu":"Feb",
    "njuhčâmáánu":"Mar",
    "cuáŋuimáánu":"Apr",
    "vyesimáánu":"May",
    "kesimáánu":"Jun",
    "syeinimáánu":"Jul",
    "porgemáánu":"Aug",
    "čohčâmáánu":"Sep",
    "roovvâdmáánu":"Oct",
    "skammâmáánu":"Nov",
    "juovlâmáánu":"Dec",
    "uđiv":"Jan",
    "kuovâ":"Feb",
    "njuhčâ":"Mar",
    "cuáŋui":"Apr",
    vyesi:"May",
    kesi:"Jun",
    syeini:"Jul",
    porge:"Aug",
    "čohčâ":"Sep",
    "roovvâd":"Oct",
    "skammâ":"Nov",
    "juovlâ":"Dec",
    niydziela:"Su",
    "pyńdziałek":"Mo",
    strzoda:"We",
    sztwortek:"Th",
    "piōntek":"Fr",
    stycznia:"Jan",
    lutego:"Feb",
    marca:"Mar",
    kwietnia:"Apr",
    moja:"May",
    czyrwca:"Jun",
    lipca:"Jul",
    siyrpnia:"Aug",
    "września":"Sep",
    "października":"Oct",
    listopada:"Nov",
    grudnia:"Dec",
    nakasabiti:"Sa",
    nakaejuma:"Su",
    nakaebarasa:"Mo",
    nakaare:"Tu",
    nakauni:"We",
    "nakaung’on":"Th",
    nakakany:"Fr",
    bar:"Mo",
    aar:"Tu",
    uni:"We",
    ung:"Th",
    orara:"Jan",
    omuk:"Feb",
    "okwamg’":"Mar",
    "odung’el":"Apr",
    omaruk:"May",
    "omodok’king’ol":"Jun",
    ojola:"Jul",
    opedel:"Aug",
    osokosokoma:"Sep",
    otibar:"Oct",
    olabor:"Nov",
    opoo:"Dec",
    dun:"Apr",
    mod:"Jun",
    ped:"Aug",
    sok:"Sep",
    tib:"Oct",
    lab:"Nov",
    poo:"Dec",
    "suno esun #6":"Sa",
    "suno esun #7":"Su",
    "suno esun #1":"Mo",
    "suno esun #2":"Tu",
    "suno esun #3":"We",
    "suno esun #4":"Th",
    "suno esun #5":"Fr",
    "mun #1":"Jan",
    "mun #2":"Feb",
    "mun #3":"Mar",
    "mun #4":"Apr",
    "mun #5":"May",
    "mun #6":"Jun",
    "mun #7":"Jul",
    "mun #8":"Aug",
    "mun #9":"Sep",
    "mun #10":"Oct",
    "mun #11":"Nov",
    "mun #12":"Dec",
    "asiḍyas":"Sa",
    asamas:"Su",
    aynas:"Mo",
    asinas:"Tu",
    akras:"We",
    akwas:"Th",
    asimwas:"Fr",
    "asḍ":"Sa",
    ayn:"Mo",
    asn:"Tu",
    akr:"We",
    akw:"Th",
    asm:"Fr",
    yebrayer:"Feb",
    ibrir:"Apr",
    yulyuz:"Jul",
    cutanbir:"Sep",
    "kṭuber":"Oct",
    nwanbir:"Nov",
    dujanbir:"Dec",
    ibr:"Apr",
    cut:"Sep",
    "kṭu":"Oct",
    nwa:"Nov",
    duj:"Dec",
    "ꔻꔬꔳ":"Sa",
    "ꕞꕌꔵ":"Su",
    "ꗳꗡꘉ":"Mo",
    "ꕚꕞꕚ":"Tu",
    "ꕉꕞꕒ":"We",
    "ꕉꔤꕆꕢ":"Th",
    "ꕉꔤꕀꕮ":"Fr",
    "ꖨꖕ ꕪꕴ ꔞꔀꕮꕊ":"Jan",
    "ꕒꕡꖝꖕ":"Feb",
    "ꕾꖺ":"Mar",
    "ꖢꖕ":"Apr",
    "ꖑꕱ":"May",
    "ꖱꘋ":"Jun",
    "ꖱꕞꔤ":"Jul",
    "ꗛꔕ":"Aug",
    "ꕢꕌ":"Sep",
    "ꕭꖃ":"Oct",
    "ꔞꘋꕔꕿ ꕸꖃꗏ":"Nov",
    "ꖨꖕ ꕪꕴ ꗏꖺꕮꕊ":"Dec",
    "ꖨꖕꔞ":"Jan",
    "ꕒꕡ":"Feb",
    "ꖱꕞ":"Jul",
    "ꔞꘋ":"Nov",
    "ꖨꖕꗏ":"Dec",
    sabo:"Sa",
    "doménega":"Su",
    marti:"Tu",
    "mèrcore":"We",
    zoba:"Th",
    "vènare":"Fr",
    zob:"Th",
    "vèn":"Fr",
    jenaro:"Jan",
    febraro:"Feb",
    jugno:"Jun",
    lujo:"Jul",
    setenbre:"Sep",
    otobre:"Oct",
    novenbre:"Nov",
    dezenbre:"Dec",
    oto:"Oct",
    esaabadu:"Sa",
    ettiminku:"Su",
    "nihiku noolempwa":"Mo",
    namaanli:"Tu",
    namararu:"We",
    namaxexe:"Th",
    namathanu:"Fr",
    janeiru:"Jan",
    fevereiru:"Feb",
    junyu:"Jun",
    julyu:"Jul",
    setembru:"Sep",
    outubru:"Oct",
    dezembru:"Dec",
    "samštag":"Sa",
    sunntag:"Su",
    "mäntag":"Mo",
    "zištag":"Tu",
    "mittwuč":"We",
    "fróntag":"Th",
    fritag:"Fr",
    "män":"Mo",
    "ziš":"Tu",
    "fró":"Th",
    jenner:"Jan",
    hornig:"Feb",
    "märze":"Mar",
    abrille:"Apr",
    meije:"May",
    "bráčet":"Jun",
    heiwet:"Jul",
    "öigšte":"Aug",
    "herbštmánet":"Sep",
    "wímánet":"Oct",
    "wintermánet":"Nov",
    "chrištmánet":"Dec",
    hor:"Feb",
    "brá":"Jun",
    hei:"Jul",
    "öig":"Aug",
    her:"Sep",
    "wím":"Oct",
    win:"Nov",
    chr:"Dec",
    "शनिच्चरवार":"Sa",
    "तोआर":"Su",
    "सोआर":"Mo",
    "वीरवार":"Th",
    "शुक्करवार":"Fr",
    "वीर":"Th",
    "शुक्कर":"Fr",
    olomukaaga:"Sa",
    sabiiti:"Su",
    owokubili:"Tu",
    owokusatu:"We",
    olokuna:"Th",
    olokutaanu:"Fr",
    muka:"Sa",
    sabi:"Su",
    bala:"Mo",
    kubi:"Tu",
    kusa:"We",
    kuna:"Th",
    kuta:"Fr",
    "séselé":"Sa",
    "sɔ́ndiɛ":"Su",
    "móndie":"Mo",
    "muányáŋmóndie":"Tu",
    "metúkpíápɛ":"We",
    "kúpélimetúkpiapɛ":"Th",
    "feléte":"Fr",
    ss:"Sa",
    sd:"Su",
    md:"Mo",
    mw:"Tu",
    kl:"Th",
    fl:"Fr",
    "pikítíkítie, oólí ú kutúan":"Jan",
    "siɛyɛ́, oóli ú kándíɛ":"Feb",
    "ɔnsúmbɔl, oóli ú kátátúɛ":"Mar",
    "mesiŋ, oóli ú kénie":"Apr",
    "ensil, oóli ú kátánuɛ":"May",
    "ɔsɔn":"Jun",
    efute:"Jul",
    "pisuyú":"Aug",
    "imɛŋ i puɔs":"Sep",
    "imɛŋ i putúk,oóli ú kátíɛ":"Oct",
    "makandikɛ":"Nov",
    "pilɔndɔ́":"Dec",
    "o\\.1":"Jan",
    "o\\.2":"Feb",
    "o\\.3":"Mar",
    "o\\.4":"Apr",
    "o\\.5":"May",
    "o\\.6":"Jun",
    "o\\.7":"Jul",
    "o\\.8":"Aug",
    "o\\.9":"Sep",
    "o\\.10":"Oct",
    "o\\.11":"Nov",
    "o\\.12":"Dec",
    "saurú":"Sa",
    "mituú":"Su",
    "murakipí":"Mo",
    "murakí-mukũi":"Tu",
    "murakí-musapíri":"We",
    "supapá":"Th",
    "yukuakú":"Fr",
    sau:"Sa",
    mur:"Mo",
    mmk:"Tu",
    mms:"We",
    sup:"Th",
    yuk:"Fr",
    "yepé":"Jan",
    "mukũi":"Feb",
    "musapíri":"Mar",
    "irũdí":"Apr",
    "pú":"May",
    "pú-yepé":"Jun",
    "pú-mukũi":"Jul",
    "pú-musapíri":"Aug",
    "pú-irũdí":"Sep",
    "yepé-putimaã":"Oct",
    "yepé-yepé":"Nov",
    "yepé-mukũi":"Dec",
    ye:"Jan",
    mk:"Feb",
    ms:"Mar",
    id:"Apr",
    pu:"May",
    py:"Jun",
    ps:"Aug",
    yp:"Oct",
    yy:"Nov",
    ym:"Dec",
    "ⴰⵙⵉⵎⵡⴰⵙ":"Fr" },
  "please use ok for similar looking ko":{ "оff":"off" },
  "please use 24 hours time for ko":{ pm:"pm",
    "p.m.":"pm",
    "рм":"pm",
    am:"am",
    "a.m.":"am",
    "ам":"am" },
  "please use restriction comment time for ko":{ damen:"open \"Damen\"",
    herren:"open \"Herren\"" },
  "please use ok for typographically correct":{ "–":"-",
    "„":"\"",
    "“":"\"",
    "”":"\"",
    "«":"\"",
    "»":"\"",
    "‚":"\"",
    "‘":"\"",
    "’":"\"",
    "「":"\"",
    "」":"\"",
    "『":"\"",
    "』":"\"" },
  "Ambiguous words":{ "གཟའ་སྤེན་པ་":"Word \"གཟའ་སྤེན་པ་\" is ambiguous: Sa (Tibetan) or Fr (Dzongkha). Please specify language context or use English weekday name.",
    "གཟའ་ཉི་མ་":"Word \"གཟའ་ཉི་མ་\" is ambiguous: Su (Tibetan) or Sa (Dzongkha). Please specify language context or use English weekday name.",
    "གཟའ་ཟླ་བ་":"Word \"གཟའ་ཟླ་བ་\" is ambiguous: Mo (Tibetan) or Su (Dzongkha). Please specify language context or use English weekday name.",
    "གཟའ་མིག་དམར་":"Word \"གཟའ་མིག་དམར་\" is ambiguous: Tu (Tibetan) or Mo (Dzongkha). Please specify language context or use English weekday name.",
    "གཟའ་ལྷག་པ་":"Word \"གཟའ་ལྷག་པ་\" is ambiguous: We (Tibetan) or Tu (Dzongkha). Please specify language context or use English weekday name.",
    "གཟའ་ཕུར་བུ་":"Word \"གཟའ་ཕུར་བུ་\" is ambiguous: Th (Tibetan) or We (Dzongkha). Please specify language context or use English weekday name.",
    "གཟའ་པ་སངས་":"Word \"གཟའ་པ་སངས་\" is ambiguous: Fr (Tibetan) or Th (Dzongkha). Please specify language context or use English weekday name.",
    meurzh:"Word \"meurzh\" is ambiguous: Mar (Breton) or Tu (Breton). Please specify language context or use English month name.",
    listopad:"Word \"listopad\" is ambiguous: Nov (Czech) or Oct (Croatian) or Nov (Polish). Please specify language context or use English month name.",
    sabato:"Word \"sabato\" is ambiguous: Sa (Esperanto) or Sa (Italian) or Su (Makhuwa-Meetto). Please specify language context or use English weekday name.",
    nyakanga:"Word \"nyakanga\" is ambiguous: Sep (Rundi) or Jul (Kinyarwanda). Please specify language context or use English month name." } };

var data$1 = { "unexpected token":"Unexpected token: \"{{token}}\" This means that the syntax is not valid at that point or it is currently not supported.",
  "no string":"The value (first parameter) is not a string.",
  nothing:"The value contains nothing meaningful which can be parsed.",
  "nothing useful":"This rule does not contain anything useful. Please remove this empty rule.",
  "combine rules":"Separate rules detected each of which only consists of a time selector. These rules should be written as one rule by combining them using \"{{ok}}\".",
  "value ends with token":"The value ends with \"{{token}}\". Please either continue after \"{{token}}\" or remove \"{{token}}\".",
  "programmers joke":"Might it be possible that you are a programmer and adding a semicolon after each statement is hardwired in your muscle memory ;) ? The thing is that the semicolon in the opening_hours syntax is defined as rule separator. So for compatibility reasons you should omit this last semicolon.",
  "interpreted as year":"The number {{number}} will be interpreted as year. This is probably not intended. Times can be specified as \"12:00\".",
  "rule before fallback empty":"Rule before fallback rule does not contain anything useful",
  "hour min separator":"Please use \":\" as hour/minute-separator",
  "warnings severity":"The parameter optional_conf_parm[\"warnings_severity\"] must be an integer number between 0 and 7 (inclusive). Given {{severity}}, expected one of the following numbers: {{allowed}}.",
  "optional conf parm type":"The optional_conf_parm parameter is of unknown type. Given {{given}}",
  "conf param tag key missing":"The optional_conf_parm[\"tag_key\"] is missing, required by optional_conf_parm[\"map_value\"].",
  "conf param mode invalid":"The optional_conf_parm[\"mode\"] parameter is a invalid number. Gave {{given}}, expected one of the following numbers: {{allowed}}.",
  "conf param unknown type":"The optional_conf_parm[\"{{key}}\"] parameter is of unknown type. Given {{given}}, expected {{expected}}.",
  "library bug":"An error occurred during evaluation of the value \"{{value}}\". Please file a bug report or pull request: {{url}}.{{message}}",
  "library bug PR only":"An error occurred during evaluation of the value \"{{value}}\". Please submit a pull request: {{url}}.{{message}}",
  "use multi":"You have used {{count}} {{part2}} Rules can be separated by \";\".",
  "selector multi 2a":"{{what}} in one rule. You may only use one in one rule.",
  "selector multi 2b":"not connected {{what}} in one rule. This is probably an error. Equal selector types can (and should) always be written in conjunction separated by comma. Example for time ranges \"12:00-13:00,15:00-18:00\". Example for weekdays \"Mo-We,Fr\".",
  "selector state":"state keywords",
  comments:"comments",
  "holiday ranges":"holiday ranges",
  months:"months",
  weekdays:"weekdays",
  ranges:"ranges",
  "default state":"This rule which changes the default state (which is closed) for all following rules is not the first rule. The rule will overwrite all previous rules. It can be legitimate to change the default state to open for example and then only specify for which times the facility is closed.",
  vague:"This rule is not very explicit because there is no time selector being used. A time selector is the part specifying hours when the object is opened, for example \"10:00-19:00\". Please add a time selector to this rule or use a comment to make it more explicit.",
  "empty comment":"You have used an empty comment. Please either write something in the comment or use the keyword unknown instead.",
  separator_for_readability:"You have used the optional symbol <separator_for_readability> in the wrong place. Please check the syntax specification to see where it could be used or remove it.",
  "strange 24/7":"You used 24/7 in a way that is probably not interpreted as \"24 hours 7 days a week\". For correctness you might want to use \"open\" or \"closed\" for this rule and then write your exceptions which should achieve the same goal and is more clear e.g. \"open; Mo 12:00-14:00 off\".",
  "public holiday":"There was no PH (public holiday) specified. This is not very explicit.{{part2}} Please either append a \"PH off\" rule if the amenity is closed on all public holidays or use something like \"Sa,Su,PH 12:00-16:00\" to say that on Saturdays, Sundays and on public holidays the amenity is open 12:00-16:00. Be careful with opening hours like \"Fr-Sa 18:00-06:00\" because \"PH off\" applies to 00:00-24:00. So \"Fr-Sa 18:00-06:00; PH 18:00-06:00 off\" is probably what you want. If the amenity is open everyday including public holidays then you can make this explicit by writing \"Mo-Su,PH\". If you are not certain try to find it out. If you can’t then do not add PH to the value and ignore this warning.",
  "public holiday part2":" Unfortunately the tag key (e.g. \"opening_hours\", or \"lit\") is unknown to opening_hours.js. This warning only applies to the key {{keys}}. If your value is for that key than read on. If not you can ignore the following.",
  "additional_rule_separator not used after time wrapping midnight":"This rule overwrites parts of the previous rule. This happens because normal rules apply to the whole day and overwrite any definition made by previous rules. You can make this rule an additional rule by using a \",\" instead of the normal \";\" to separate the rules. Note that the overwriting can also be desirable in which case you can ignore this warning.",
  "additional rule which evaluates to closed":"This rule will be evaluated as closed but it was specified as additional rule. It should be specified as normal rule using \";\" as rule separator. See https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#explain:rule_modifier:closed.",
  switched:"The selector \"{{first}}\" was switched with the selector \"{{second}}\" for readability and compatibility reasons.",
  "no colon after":"Please don’t use \":\" after {{token}}.",
  "number -5 to 5":"Number between -5 and 5 (except 0) expected.",
  "one weekday constraint":"You can not use more than one constrained weekday in a month range",
  "range constrained weekdays":"You can not use a range of constrained weekdays in a month range",
  expected:"\"{{symbol}}\" expected.",
  "range zero":"You can not use {{type}} ranges with period equals zero.",
  "period one year+":"Please don’t use {{type}} ranges with period equals one. If you want to express that a facility is open starting from a year without limit use \"<year>+\".",
  "period one":"Please don’t use {{type}} ranges with period equals one.",
  "month 31":"The day for {{month}} must be between 1 and 31.",
  "month 30":"Month {{month}} doesn't have 31 days. The last day of {{month}} is day 30.",
  "month feb":"Month {{month}} either has 28 or 29 days (leap years).",
  "point in time":"hyphen (-) or open end (+) in time range {{calc}}expected. For working with points in time, the mode for {{libraryname}} has to be altered. Maybe wrong tag?",
  calculation:"calculation",
  "time range continue":"Time range does not continue as expected",
  "period continue":"Time period does not continue as expected. Example \"/01:30\".",
  "time range mode":"{{libraryname}} is running in \"time range mode\". Found point in time.",
  "point in time mode":"{{libraryname}} is running in \"points in time mode\". Found time range.",
  "outside current day":"Time range starts outside of the current day",
  "two midnights":"Time spanning more than two midnights not supported",
  "without minutes":"Time range without minutes specified. Not very explicit! Please use this syntax instead \"{{syntax}}\".",
  "outside day":"Time range starts outside of the current day",
  "zero calculation":"Adding zero in a variable time calculation does not change the variable time. Please omit the calculation (example: \"sunrise-(sunset-00:00)\").",
  "calculation syntax":"Calculation with variable time is not in the right syntax",
  "time offset hours only":"Time offset must be in format HH:MM, not just hours. Did you mean \"{{suggestion}}\"?",
  missing:"Missing \"{{symbol}}\"",
  "(time)":"(time)",
  "bad range":"Bad range: {{from}}-{{to}}",
  "] or more numbers":"\"]\" or more numbers expected.",
  "additional rule no sense":"An additional rule does not make sense here. Just use a \";\" as rule separator. See https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#explain:additional_rule_separator",
  "unexpected token weekday range":"Unexpected token in weekday range: {{token}}",
  "max differ":"There should be no reason to differ more than {{maxdiffer}} days from a {{name}}. If so tell us …",
  "adding 0":"Adding 0 does not change the date. Please omit this.",
  "unexpected token holiday":"Unexpected token (holiday parser): {{token}}",
  "no holiday definition":"There are no holidays ({{name}}) defined for country {{cc}}.",
  "no holiday definition state":"There are no holidays ({{name}}) defined for country {{cc}} and state {{state}}.",
  "no country code":"Country code missing which is needed to select the correct holidays (see README how to provide it)",
  "no SH definition":"School holiday {{name}}not defined for the year {{year}}.",
  "movable no formula":"Movable day {{name}} can not not be calculated. Please add the formula how to calculate it.",
  "movable not in year":"The movable day {{name}} plus {{days}} days is not in the year of the movable day anymore. Currently not supported.",
  "year range one year":"A year range in which the start year is equal to the end year does not make sense. Please remove the end year. E.g. \"{{year}} May 23\"",
  "year range reverse":"A year range in which the start year is greater than the end year does not make sense. Please turn it over.",
  "year past":"The year is in the past.",
  "unexpected token year range":"Unexpected token in year range: {{token}}",
  "week range reverse":"You have specified a week range in reverse order or leaping over a year. This is (currently) not supported.",
  "week negative":"You have specified a week date less then one. A valid week date range is 1-53.",
  "week exceed":"You have specified a week date greater then 53. A valid week date range is 1-53.",
  "week period less than 2":"You have specified a week period which is less than two. If you want to select the whole range from week {{weekfrom}} to week {{weekto}} then just omit the \"/{{period}}\".",
  "week period greater than 26":"You have specified a week period which is greater than 26. 26.5 is the half of the maximum 53 week dates per year so a week date period greater than 26 would only apply once per year. Please specify the week selector as \"week {{weekfrom}}\" if that is what you want to express.",
  "unexpected token week range":"Unexpected token in week range: {{token}}",
  "unexpected token month range":"Unexpected token in month range: {{token}}",
  "day range reverse":"Range in wrong order. From day is greater than to day.",
  "open end":"Specified as open end. Closing time was guessed.",
  "date parameter needed":"Date parameter needed.",
  "assuming ok for ko":"Assuming \"{{ok}}\" for \"{{ko}}\".",
  "please use ok for ko":"Please use notation \"{{ok}}\" for \"{{ko}}\".",
  "please use ok for similar looking ko":"Please use notation \"{{ok}}\" for \"{{ko}}\". Those characters look very similar but are not the same!",
  "rant degree sign used for zero":"Note that this is not a (superscript) zero but a degree sign which is misused as zero. A superscript zero is defined in Unicode (°) and would have been more appropriate/uniform here. But note that the use of none-ASCII digits is not allowed.",
  "please use English written ok for ko":"Please use the English written \"{{ok}}\" for \"{{ko}}\".",
  "please use English abbreviation ok for ko":"Please use the English abbreviation \"{{ok}}\" for \"{{ko}}\".",
  "please use English abbreviation ok for so":"Please use the English abbreviation \"{{ok}}\" for \"{{ko}}\". Note that it might also mean Saturday in Polish.",
  "please use off for ko":"Please use \"{{ok}}\" for \"{{ko}}\". Example: \"Mo-Fr 08:00-12:00; Tu off\".",
  "please use ok for workday":"Assuming \"{{ok}}\" for \"{{ko}}\". Please avoid using \"workday\": https://wiki.openstreetmap.org/wiki/Talk:Key:opening_hours#need_syntax_for_holidays_and_workingdays",
  "omit hour keyword":"Please omit \"{{ko}}\" or use a colon instead. Example: \"12:00-14:00\".",
  "omit ko":"Please omit \"{{ko}}\".",
  "omit tag key":"Please omit \"{{ko}}\". The tag key must not be in the tag value.",
  "omit wrong keyword open end":"Please omit \"{{ko}}\". The tag key must not be in the tag value.",
  "assuming open end for ko":"Assuming \"{{ok}}\" (open end time) for \"{{ko}}\". Example: \"12:00+\".",
  "please use ok for uncertainty":"Please use notation \"{{ok}}\" for \"{{ko}}\". If there is reason to suspect uncertainty consider adding a comment. Example: 12:00-14:00 \"only on sunshine\".",
  "please use fallback rule":"Please use notation \"{{ok}}\" (Fallback rule) for \"{{ko}}\". Example: Mo-Fr 12:00-14:00; PH off || \"by appointment\"",
  "please use ok for missing data":"Please consider adding a FIXME tag instead.",
  "please use 24 hours time for ko":"Please use time format in 24 hours notation instead of the legacy 12 hours variant. If the 12 hours variant is used you might have to convert the hours to the 24 hours notation.",
  "please use restriction comment time for ko":"It looks like you might want to define additional restrictions. If that is the case and they can not be expressed by other syntax elements then you could use a comment together with the `open` keyword. Example: open \"female only\"",
  "please use ok for typographically correct":"Please use notation \"{{ok}}\" for \"{{ko}}\". Although using \"{{ko}}\" is typographical correct, it is not defined in the opening_hours syntax. Correct typography should be done on application level …" };

var data = { en:{ opening_hours:{ pretty:{ off:"closed",
        SH:"school holidays",
        PH:"public holidays" } } },
  de:{ opening_hours:{ texts:{ "unexpected token":"Unerwartetes Zeichen: \"{{token}}\" Das bedeutet, dass die Syntax an dieser Stelle nicht erkannt werden konnte.",
        "no string":"Der Wert (erster Parameter) ist kein String",
        nothing:"Der Wert enthält nichts, was ausgewertet werden könnte.",
        "nothing useful":"Diese Regel enthält nichts nützliches. Bitte entferne diese leere Regel.",
        "combine rules":"Getrennte Regeln erkannt welche jeweils nur aus einer Zeit Bereichsdefinition bestehen. Diese Regeln sollten mittels \"{{ok}}\" zu einer Regel kombiniert werden.",
        "value ends with token":"Der Wert endet mit \"{{token}}\". Bitte ergänze den Wert nach \"{{token}}\" oder lösche \"{{token}}\".",
        "programmers joke":"Kann es sein, dass du ein Programmierer bist und das Hinzufügen eines Semikolons nach jedem Statement ist zwanghaft ;) ? Es ist so, dass das Semikolon in der opening_hours-Syntax als Trenner für Regeln definiert ist. Bitte verzichte an dieser Stelle auf ein Semikolon.",
        "interpreted as year":"Die Zahl {{number}} wird als Jahr interpretiert. Vermutlich ist das nicht beabsichtigt. Uhrzeiten werden als \"12:00\" angegeben.",
        "rule before fallback empty":"Die Regel vor der Fallback-Regel enthält nichts nützliches",
        "hour min separator":"Bitte benutze \":\" als Stunden/Minuten-Trenner",
        "warnings severity":"Der Parameter optional_conf_parm[\"warnings_severity\"] muss eine ganze Zahl zwischen (einschließlich) 0 und (einschließlich) 7 sein. Gegeben: {{severity}}, erwartet: Eine der Zahlen: {{allowed}}.",
        "optional conf parm type":"Der optional_conf_parm Parameter hat einen unbekannten Typ. Gegeben: {{given}}",
        "conf param tag key missing":"Der optional_conf_parm[\"tag_key\"] fehlt, ist aber notwendig wegen optional_conf_parm[\"map_value\"].",
        "conf param mode invalid":"Der optional_conf_parm[\"mode\"]-Parameter ist eine ungültige Zahl. Gegeben: {{given}}, erwartet: Eine der Zahlen: {{allowed}}.",
        "conf param unknown type":"Der optional_conf_parm[\"{{key}}\"] Parameter hat einen unbekannten Typ. Gegeben: {{given}}, erwartet: {{expected}}.",
        "library bug":"Bei der Auswertung des Wertes \"{{value}}\" ist ein Fehler aufgetreten. Bitte melde diesen Fehler oder korrigiere diesen mittels eines Pull Requests oder Patches: {{-url}}.{{message}}",
        "library bug PR only":"Bei der Auswertung des Wertes \"{{value}}\" ist ein Fehler aufgetreten. Du kannst dies korrigieren, indem du das Problem löst und in Form eines Pull Requests oder Patches zum Projekt beiträgst: {{-url}}.{{message}}",
        "use multi":"Du hast {{count}} {{-part2}} Einzelne Regeln können mit \";\" getrennt werden.",
        "selector multi 2a":"{{what}} in einer Regel benutzt. Du kannst nur einen davon je Regel verwenden",
        "selector multi 2b":"nicht verbundene {{what}} in einer Regel benutzt. Das ist vermutlich ein Fehler. Gleiche Selektoren können (und sollten) immer zusammen und durch Kommas getrennt geschrieben werden. Beispiel für Zeitspannen \"12:00-13:00,15:00-18:00\". Beispiel für Wochentage \"Mo-We,Fr\".",
        "selector state":"Status-Schlüsselwörter (offen, geschlossen)",
        comments:"Kommentare",
        months:"Monate",
        weekdays:"Wochentage",
        ranges:"Zeitspannen",
        "default state":"Diese Regel, welche den Standard-Status (d.h. geschlossen) für alle folgenden Regeln ändert, ist nicht die erste Regel. Diese Regel überschreibt alle vorherigen Regeln. Es kann legitim sein, den Standard-Status z.B. auf geöffnet festzulegen und dann nur die Zeiten, zu denen geschlossen ist, anzugeben.",
        vague:"Diese Regel ist nicht sehr aussagekräftig, da kein Zeit Selektor angegeben wurde. Ein Zeit Selektor ist die Komponente die angibt, zu welcher Tageszeit ein Objekt geöffnet hat, zum Beispiel \"10:00-19:00\". Bitte füge eine Zeitangabe oder einen Kommentar hinzu, um dies zu verbessern.",
        "empty comment":"Du hast einen leeren Kommentar verwendet.\" Bitte schreibe entweder einen Kommentar-Text oder benutze stattdessen das Schlüsselwort \"unknown\".",
        separator_for_readability:"Du hast das optionale Symbol <separator_for_readability> an der falschen Stelle benutzt. Bitte lies die Syntax-Spezifikation um zu sehen, wo es verwendet werden kann, oder entferne es.",
        "strange 24/7":"Du hast 24/7 in einer Art verwendet, welche wahrscheinlich nicht als \"24 Stunden, 7 Tage die Woche\" interpretiert wird. Der Richtigkeit halber solltest du \"open\" oder \"closed\" für diese Regel verwenden und dann die Ausnahmen angeben um das selbe Ziel zu erreichen. So ist es klarer – zum Beispiel \"open; Mo 12:00-14:00 off\".",
        "public holiday":"Es wurde keine Regel für \"PH\" (feiertags) angegeben. Dies ist nicht sehr aussagekräftig.{{-part2}} Bitte füge die Regel \"PH off\" an, wenn die Einrichtung an allen Feiertagen geschlossen ist oder schreibe \"Sa,Su,PH 12:00-16:00\" um auszudrücken, dass Samstags, Sonntags und feiertags von 12:00-16:00 geöffnet ist. Bei einer Öffnungszeit wie \"Fr-Sa 18:00-06:00\" ist Vorsicht geboten, da \"PH off\" auf 00:00-24:00 zutrifft. Hier kann \"Fr-Sa 18:00-06:00; PH 18:00-06:00 off\" verwendet werden. Falls die Einrichtung täglich und an Feiertagen geöffnet ist, kann dies explizit mittels \"Mo-Su,PH\" ausgedrückt werden. Wenn du dir im Unklaren bist, versuche die Öffnungszeit zu klären. Falls das nicht möglich ist, lass die Angabe weg und ignoriere diese Warnung.",
        "public holiday part2":" Leider ist der \"tag key\" (beispielsweise \"opening_hours\", oder \"lit\") in opening_hours.js nicht bekannt. Diese Warnung betrifft nur die Keys: {{keys}}. Falls deine Angabe nicht für einen dieser ist, ignoriere bitte folgenden Hinweis:",
        "additional_rule_separator not used after time wrapping midnight":"Diese Regel überschreibt Teile der vorherigen Regel. Der Grund dafür ist, dass normale Regeln auf den ganzen Tag zutreffen und alle Definitionen von vorhergehenden Regeln für diesen Tag überschreiben. Du kannst diese Regel als additive Regel deklarieren indem du ein \",\" anstelle des üblichen \";\" für diese Regel verwendest. Beachte das die Überschreibung auch gewünscht sein kann und in so einem Fall diese Warnung ignoriert werden kann.",
        "additional rule which evaluates to closed":"Diese Regel wird als geschlossen ausgewertet aber wurde als additive Regel angegeben. Sie sollte als normale Regel mittels \";\" definiert sein. Siehe https://wiki.openstreetmap.org/wiki/DE:Key:opening_hours/specification#explain:rule_modifier:closed.",
        switched:"Der Selektor \"{{first}}\" wurde für eine bessere Lesbarkeit und der Vollständigkeit halber mit \"{{second}}\" getauscht.",
        "no colon after":"Bitte Benutze kein \":\" nach dem Token {{token}}.",
        "number -5 to 5":"Zahl zwischen -5 und 5 (außer 0) erwartet.",
        "one weekday constraint":"Du kannst höchstens einen beschränkten Wochentag in einer Monats-Spanne verwenden",
        "range constrained weekdays":"Du kannst keine Wochentags-Spanne als Beschränkung in einer Monats-Spanne verwenden",
        expected:"\"{{-symbol}}\" erwartet.",
        "range zero":"Du kannst keine {{type}}-Spanne mit Periode \"0\" verwenden.",
        "period one year+":"Bitte verwende keine {{type}}-Spannen mit Periode \"1\". Wenn du ausdrücken willst, das eine Einrichtung ab einem bestimmten Jahr immer offen ist, benutze bitte \"<year>+\".",
        "period one":"Bitte verwende keine {{type}}-Spannen mit Periode \"1\".",
        "month 31":"Die Tagesangabe für {{month}} muss zwischen 1 und 31 liegen.",
        "month 30":"Der Monat {{month}} hat keine 31 Tage. Der letzte Tag von {{month}} ist Tag 30.",
        "month feb":"\"Der Monat {{month}} hat entweder 28 oder 29 Tage (Schaltjahre).\"",
        "point in time":"Erwarte Bindestrich (-) oder offenes Ende (+) in der Zeitspanne {{calc}}. Um mit Zeitpunkten zu arbeiten, muss der Modus für  {{libraryname}} umgestellt werden. Vielleicht falsches OSM-tag verwendet?",
        calculation:"Berechnung",
        "time range continue":"Die Zeitspanne geht nicht wie erwartet weiter",
        "period continue":"Die Zeitspannen-Periode geht nicht wie erwartet weiter. Beispiel \"/01:30\".",
        "time range mode":"{{libraryname}} wurde im \"Zeitspannen-Modus\" aufgerufen. Zeitpunkt gefunden.",
        "time ranges":"Zeitspannen",
        "holiday ranges":"Feiertagen",
        "point in time mode":"{{libraryname}} wurde im \"Zeitpunkt-Modus\" aufgerufen. Zeitspanne gefunden.",
        "outside current day":"Zeitspanne beginnt außerhalb des aktuellen Tages",
        "two midnights":"Zeitspanne welche mehrmals Mitternacht beinhaltet wird nicht unterstützt",
        "without minutes":"Zeitspanne ohne Minutenangabe angegeben. Das ist nicht sehr eindeutig! Bitte verwende stattdessen folgende Syntax \"{{syntax}}\".",
        "outside day":"Die Zeitspanne beginnt außerhalb des aktuellen Tages",
        "zero calculation":"Das Hinzufügen von 0 in einer variablen Zeitberechnung ändert die variable Zeit nicht. Bitte entferne die Zeitberechnung (Beispiel: \"sunrise-(sunset-00:00)\").",
        "calculation syntax":"Berechnung mit variabler Zeit hat nicht die korrekte Syntax",
        "time offset hours only":"Zeitversatz muss im Format HH:MM angegeben werden, nicht nur Stunden. Meintest du \"{{suggestion}}\"?",
        missing:"Fehlendes \"{{symbol}}\"",
        "(time)":"(Zeit)",
        "bad range":"Ungültige Zeitspanne: {{from}}-{{to}}",
        "] or more numbers":"\"]\" oder weitere Zahlen erwartet.",
        "additional rule no sense":"Eine weitere Regel an dieser Stelle ergibt keinen Sinn. Benutze einfach \";\" als Trenner für Regeln. Siehe https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#explain:additional_rule_separator",
        "unexpected token weekday range":"Unerwartes Token in Tages-Spanne: {{token}}",
        "max differ":"Es sollte keinen Grund geben, mehr als {{maxdiffer}} Tage von einem {{name}} abzuweichen. Wenn nötig, teile uns dies bitte mit …",
        "adding 0":"Addition von 0 verändert das Datum nicht. Bitte weglassen.",
        "unexpected token holiday":"Unerwarteter Token (in Feiertags-Auswertung): {{token}}",
        "no holiday definition":"{{name}} ist für das Land {{cc}} nicht definiert.",
        "no holiday definition state":"{{name}} ist für das Land {{cc}} und Bundesland {{state}} nicht definiert.",
        "no country code":"Der Ländercode fehlt. Dieser wird benötigt um die korrekten Feiertage zu bestimmen (siehe in der README wie dieser anzugeben ist)",
        "no SH definition":"Die Schulferien {{name}}sind für das Jahr {{year}} nicht definiert",
        "movable no formula":"Der bewegliche Feiertag {{name}} kann nicht berechnet werden. Bitte füge eine entsprechende Formel hinzu.",
        "movable not in year":"Der bewegliche Feiertag {{name}} plus {{days}} Tage befindet sich nicht mehr im selben Jahr. Aktuell nicht unterstützt.",
        "year range one year":"Eine Jahres-Spanne mit gleichem Jahr als Beginn und Ende ergibt keinen Sinn. Bitte entferne das Ende-Jahr. zum Beispiel: \"{{year}} May 23\"",
        "year range reverse":"Eine Jahres-Spanne mit Beginn größer als Ende ergibt keinen Sinn. Bitte umdrehen.",
        "year past":"Das Jahr liegt in der Vergangenheit.",
        "unexpected token year range":"Unerwartetes Token in der Jahres-Spanne: {{token}}",
        "week range reverse":"Du hast eine Wochen-Spanne in umgekehrter Reihenfolge oder mehrere Jahre umfassende angegeben. Dies ist aktuell nicht unterstützt.",
        "week negative":"Du hast eine Kalenderwoche kleiner 1 angegeben. Korrekte Angaben sind 1-53.",
        "week exceed":"Du hast eine Kalenderwoche größer als 53 angegeben. Korrekte Angaben sind 1-53.",
        "week period less than 2":"Du hast eine Wochenperiode kleiner 2 angegeben. Wenn du die gesamte Spanne von {{weekfrom}} bis {{weekto}} angeben willst, lasse \"/{{period}}\" einfach weg.",
        "week period greater than 26":"Du hast eine Wochen-Periode größer als 26 angegeben. 26,5 ist die Hälfte des Maximums von 53 Wochen pro Jahr. Damit würde eine Periode größer als 26 nur einmal pro Jahr auftreten. Bitte gibt den Wochen-Selektor als \"week {{weekfrom}}\" an, wenn es das ist, was du ausdrücken möchtest.",
        "unexpected token week range":"Unerwartetes Token in Wochen-Spanne: {{token}}",
        "unexpected token month range":"Unerwartetes Token in Monats-Spanne: {{token}}",
        "day range reverse":"Zeitspanne in falscher Reihenfolge. Beginn ist größer als Ende.",
        "open end":"Angegeben als \"open end\". Schließzeit wurde geraten.",
        "date parameter needed":"Datumsparameter nötig.",
        "assuming ok for ko":"\"{{ko}}\" wird als \"{{ok}}\" interpretiert.",
        "please use ok for ko":"Bitte verwende \"{{-ok}}\" anstelle von \"{{-ko}}\".",
        "please use ok for similar looking ko":"Please use notation \"{{ok}}\" for \"{{ko}}\". Those characters look very similar but are not the same!",
        "rant degree sign used for zero":"Beachte das dies ein Gradzeichen ist, welches als (hochgestellte) Null missbraucht wurde. Eine hochgestellte Null ist in Unicode definiert (°) und wäre angebrachter/einheitlicher an dieser Stelle. Allerdings ist die Verwendung von nicht ASCII Ziffern nicht erlaubt.",
        "please use English written ok for ko":"Bitte benutze die englische Schreibweise \"{{ok}}\" für \"{{ko}}\".",
        "please use English abbreviation ok for ko":"Bitte benutze die englische Abkürzung \"{{ok}}\" für \"{{ko}}\".",
        "please use English abbreviation ok for so":"Bitte benutze die englische Abkürzung \"{{ok}}\" für \"{{ko}}\". Beachte das Samstag in Polnisch gemeint sein kann.",
        "please use off for ko":"Bitte benutze \"{{ok}}\" für \"{{ko}}\". Beispiel: \"Mo-Fr 08:00-12:00; Tu off\".",
        "please use ok for workday":"\"{{ko}}\" wird als \"{{ok}}\" interpretiert. Werktag sollte nicht verwendet werden. Siehe https://wiki.openstreetmap.org/wiki/Talk:Key:opening_hours#need_syntax_for_holidays_and_workingdays",
        "omit hour keyword":"Bitte lasse \"{{ko}}\" weg oder verwende einen Doppelpunkt. Beispiel: \"12:00-14:00\".",
        "omit ko":"Bitte verzichte auf \"{{ko}}\".",
        "omit tag key":"Bitte lasse \"{{ko}}\" weg. Der Tag Schlüssel darf nicht im Tag Wert sein.",
        "omit wrong keyword open end":"Bitte lasse \"{{ko}}\" weg. Falls du \"open end\" ausdrücken möchtest verwende bitte ein \"+\". Beispiel: \"12:00+\".",
        "assuming open end for ko":"\"{{ko}}\" wird als \"{{ok}}\" (\"open end\") interpretiert. Example: \"12:00+\".",
        "please use ok for uncertainty":"Bitte verwende \"{{ok}}\" für \"{{ko}}\". Falls der begründete Verdacht der Ungewissheit vorliegt ziehe die Verwendung eines Kommentars in Betracht. Beispiel: 12:00-14:00 \"only on sunshine\".",
        "please use fallback rule":"Bitte verwende \"{{ok}}\" (Fallback Regel) für \"{{ko}}\". Beispiel: Mo-Fr 12:00-14:00; PH off || \"nach Vereinbarung\"",
        "please use ok for missing data":"Bitte verwende eine FIXME Notiz.",
        "please use 24 hours time for ko":"Bitte verwende 24 Stunden Zeitangaben anstelle der veralteten 12 Stunden Variante. Falls die 12 Stunden Variante verwendet wird ist eventuelle eine Konvertierung notwendig.",
        "please use restriction comment time for ko":"Es sieht so aus also möchtest du zusätzliche Einschränkungen für eine Öffnungszeit geben. Falls sich dies nicht mit der Syntax ausdrücken lässt können Kommentare verwendet werden. Zusätzlich sollte eventuell das Schlüsselwort `open` benutzt werden. Beispiel: open \"Nur Frauen\".",
        "please use ok for typographically correct":"Bitte verwende \"{{-ok}}\" für \"{{ko}}\". Auch wenn \"{{ko}}\" typografisch korrekt ist, ist dies in der opening_hours Syntax nicht definiert. Korrekte Typographie sollte auf Anwendungsebene sichergestellt werden …" },
      pretty:{ off:"geschlossen",
        SH:"Schulferien",
        PH:"Feiertags" } } },
  eo:{ opening_hours:{ texts:{ "assuming ok for ko":"\"{{ko}}\" estas interpretita kiel \"{{ok}}\".",
        "please use ok for ko":"Bonvolu uzi la esprimon \"{{-ok}}\" anstataŭ \"{{ko}}\".",
        "please use English abbreviation ok for ko":"Bonvolu uzi la anglan mallongigon \"{{ok}}\" für \"{{ko}}\"." },
      pretty:{ off:"fermita",
        SH:"lernejaj ferioj",
        PH:"festotagoj" } } },
  fi:{ opening_hours:{ pretty:{ off:"suljettu",
        SH:"koululomat",
        PH:"lailliset vapaapäivät" } } },
  fr:{ opening_hours:{ texts:{ "assuming ok for ko":"suppose \"{{ok}}\" pour \"{{ko}}\".",
        "please use ok for ko":"S'il vous plaît utilisez \"{{ok}}\" pour \"{{ko}}\".",
        "please use English abbreviation ok for ko":"S'il vous plaît utiliseé l'abréviation \"{{ok}}\" pour \"{{ko}}\"." },
      pretty:{ off:"fermé",
        SH:"vacances scolaires",
        PH:"jours fériés" } } },
  nl:{ opening_hours:{ texts:{ "please use English abbreviation ok for ko":"Neem de engelse afkorting \"{{ok}}\" voor \"{{ko}}\" alstublieft." },
      pretty:{ off:"gesloten",
        SH:"schoolvakantie",
        PH:"feestdagen" } } },
  ru:{ opening_hours:{ pretty:{ off:"закрыто",
        SH:"каникулы",
        PH:"праздник" } } },
  it:{ opening_hours:{ pretty:{ off:"chiuso",
        SH:"festività scolastiche",
        PH:"festività" } } } };
data.en;
data.de;
data.eo;
data.fi;
data.fr;
data.nl;
data.ru;
data.it;

const resources = data;

// Simple i18n object compatible with the minimal features used in src/index.js
const i18n = {
    language: 'en',
    isInitialized: true,

    t: function(key, variables) {
        return this._translate(this.language, key, variables);
    },

    getFixedT: function(locale) {
        const self = this;
        return function(key, variables) {
            return self._translate(locale, key, variables);
        };
    },

    _translate: function(locale, key, variables) {
        // Handle array of keys (fallback mechanism)
        const keys = Array.isArray(key) ? key : [key];

        for (const k of keys) {
            // Parse namespace:path notation (e.g., "opening_hours:pretty.off")
            const parts = k.split(':');
            const namespace = parts.length > 1 ? parts[0] : 'opening_hours';
            const path = parts.length > 1 ? parts[1] : parts[0];

            // Try to get translation
            const translation = this._getNestedValue(resources, [locale, namespace, ...path.split('.')]);

            if (translation !== undefined) {
                // Replace variables like {{variable}} or {{-variable}}
                // The minus prefix means "don't escape HTML" (compatibility feature)
                if (typeof translation === 'string' && variables) {
                    return translation.replace(/{{-?([^{}]*)}}/g, function (match, varName) {
                        const trimmed = varName.trim();
                        return typeof variables[trimmed] !== 'undefined' ? variables[trimmed] : match;
                    });
                }
                return translation;
            }
        }

        // Fallback: return the last key if no translation found
        const lastKey = keys[keys.length - 1];
        return lastKey.includes(':') ? lastKey.split(':')[1] : lastKey;
    },

    _getNestedValue: function(obj, path) {
        let current = obj;
        for (const key of path) {
            if (current === undefined || current === null) return undefined;
            current = current[key];
        }
        return current;
    }
};

/*
 * SPDX-FileCopyrightText: © 2013 Robin Schneider <ypid@riseup.net>
 *
 * SPDX-License-Identifier: LGPL-3.0-only
 *
 * This file is based on work under the following copyright and
 * BSD-2-Clause permission notice:
 *
 *     SPDX-FileCopyrightText: © 2012 Dmitry Marakasov <amdmi3@amdmi3.ru>
 *     All rights reserved.
 *
 *     Redistribution and use in source and binary forms, with or without
 *     modification, are permitted provided that the following conditions are met:
 *
 *     1. Redistributions of source code must retain the above copyright notice, this
 *     list of conditions and the following disclaimer.
 *
 *     2. Redistributions in binary form must reproduce the above copyright notice,
 *     this list of conditions and the following disclaimer in the documentation
 *     and/or other materials provided with the distribution.
 *
 *     THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 *     ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *     WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 *     DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 *     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 *     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 *     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 *     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 *     OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 *     OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

function index(value, nominatim_object, optional_conf_parm) {
    // Short constants {{{
    const word_value_replacement = { // If the correct values can not be calculated.
        dawn    : 60 * 5 + 30,
        sunrise : 60 * 6,
        sunset  : 60 * 18,
        dusk    : 60 * 18 + 30,
    };
    const months   = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const weekdays = ['Su','Mo','Tu','We','Th','Fr','Sa'];
    const string_to_token_map = {
        'su': [ 0, 'weekday' ],
        'mo': [ 1, 'weekday' ],
        'tu': [ 2, 'weekday' ],
        'we': [ 3, 'weekday' ],
        'th': [ 4, 'weekday' ],
        'fr': [ 5, 'weekday' ],
        'sa': [ 6, 'weekday' ],
        'jan': [  0, 'month' ],
        'feb': [  1, 'month' ],
        'mar': [  2, 'month' ],
        'apr': [  3, 'month' ],
        'may': [  4, 'month' ],
        'jun': [  5, 'month' ],
        'jul': [  6, 'month' ],
        'aug': [  7, 'month' ],
        'sep': [  8, 'month' ],
        'oct': [  9, 'month' ],
        'nov': [ 10, 'month' ],
        'dec': [ 11, 'month' ],
        'day': [ 'day', 'calcday' ],
        'days': [ 'days', 'calcday' ],
        'sunrise': [ 'sunrise', 'timevar' ],
        'sunset': [ 'sunset', 'timevar' ],
        'dawn': [ 'dawn', 'timevar' ],
        'dusk': [ 'dusk', 'timevar' ],
        'easter': [ 'easter', 'event' ],
        'week': [ 'week', 'week' ],
        'open': [ 'open', 'state' ],
        'closed': [ 'closed', 'state' ],
        'off': [ 'off', 'state' ],
        'unknown': [ 'unknown', 'state' ],
    };

    const default_prettify_conf = {
        // Update README.md if changed.
        'zero_pad_hour': true,           // enforce ("%02d", hour)
        'one_zero_if_hour_zero': false,  // only one zero "0" if hour is zero "0"
        'leave_off_closed': true,        // leave keywords "off" and "closed" as is
        'keyword_for_off_closed': 'off', // use given keyword instead of "off" or "closed"
        'rule_sep_string': ' ',          // separate rules by string
        'print_semicolon': true,         // print token which separates normal rules
        'leave_weekday_sep_one_day_betw': true, // use the separator (either "," or "-" which is used to separate days which follow to each other like Sa,Su or Su-Mo
        'sep_one_day_between': ',',      // separator which should be used
        'zero_pad_month_and_week_numbers': true, // Format week (e.g. `week 01`) and month day numbers (e.g. `Jan 01`) with "%02d".
        'locale': 'en',                  // locale for translations (currently 'en' and 'de' are supported)
        'date_format': 'short'           // Use short or long date format (for day and month names)
    };

    const osm_tag_defaults = {
        'opening_hours'       :  { 'mode' :  0, 'warn_for_PH_missing' :  true, },
        'collection_times'    :  { 'mode' :  2, },
        /* oh_mode 2: "including the hyphen because there are post boxes which are
         * emptied several (undefined) times or one (undefined) time in a certain time
         * frame. This shall be covered also.".
         * Ref: https://wiki.openstreetmap.org/wiki/Key:collection_times */
        'opening_hours:.+'    :  { 'mode' :  0, },
        '.+:opening_hours'    :  { 'mode' :  0, },
        '.+:opening_hours:.+' :  { 'mode' :  0, },
        'smoking_hours'       :  { 'mode' :  0, },
        'service_times'       :  { 'mode' :  2, },
        'happy_hours'         :  { 'mode' :  0, },
        'lit'                 :  { 'mode' :  0,
            map: {
                'yes'      : 'sunset-sunrise open "specified as yes: At night (unknown time schedule or daylight detection)"',
                'automatic': 'unknown "specified as automatic: When someone enters the way the lights are turned on."',
                'no'       : 'off "specified as no: There are no lights installed."',
                'interval' : 'unknown "specified as interval"',
                'limited'  : 'unknown "specified as limited"',
            }
        },
    };

    const minutes_in_day = 60 * 24;
    const msec_in_day    = 1000 * 60 * minutes_in_day;
    // let msec_in_week   = msec_in_day * 7;

    const library_name   = 'opening_hours.js';
    const repository_url = 'https://github.com/opening-hours/' + library_name;
    // let issues_url     = repository_url + '/issues?state=open';
    /* }}} */

    /* Translation function {{{ */
    let locale = 'en'; // Default locale
    locale = i18n.language;

    const t = function(str, variables) {
        // Use i18n for German translations, fallback to built-in lang for others
        if (typeof locale === 'string' && ['de'].indexOf(locale) !== -1) {
            let translatorFunction;
            if (i18n.language !== locale) {
                translatorFunction = i18n.getFixedT(locale);
            } else {
                translatorFunction = i18n.t;
            }
            const text = translatorFunction('opening_hours:texts.' + str, variables);
            return text;
        }

        // Fallback for non-German locales
        let text = data$1[str];
        if (typeof text === 'undefined') {
            text = str;
        }
        return text.replace(/{{([^{}]*)}}/g, function (match, c) {
            return typeof variables[c] !== 'undefined'
                ? variables[c]
                : match
                ;
            }
        );
    };
    /* }}} */

    /* Optional constructor parameters {{{ */

    /* nominatim_object {{{
     *
     * Required to reasonably calculate 'sunrise' and holidays.
     */
    let location_cc, location_state, lat, lon;
    if (typeof nominatim_object === 'object' && nominatim_object !== null) {
        if (typeof nominatim_object.address === 'object') {
            if (typeof nominatim_object.address.country_code === 'string') {
                location_cc = nominatim_object.address.country_code;
            }
            if (typeof nominatim_object.address.state === 'string') {
                location_state = nominatim_object.address.state;
            } else if (typeof nominatim_object.address.county === 'string') {
                location_state = nominatim_object.address.county;
            }
        }

        if (typeof nominatim_object.lon === 'string' && typeof nominatim_object.lat === 'string') {
            lat = nominatim_object.lat;
            lon = nominatim_object.lon;
        }
    } else if (nominatim_object === null) {
        /* Set the location to some random value. This can be used if you don’t
         * care about correct opening hours for more complex opening_hours
         * values.
         */
        location_cc = 'de';
        location_state = 'Baden-W\u00fcrttemberg';
        lat = '49.5400039';
        lon = '9.7937133';
    } else if (typeof nominatim_object !== 'undefined') {
        throw 'The nominatim_object parameter is of unknown type.'
            + ' Given ' + typeof(nominatim_object)
            + ', expected object.';
    }
    /* }}} */

    /* mode, locale, warnings_severity, tag_key, map_value {{{
     *
     * 0: time ranges (default), tags: opening_hours, lit, …
     * 1: points in time
     * 2: both (time ranges and points in time), tags: collection_times, service_times
     */

    let warnings_severity = 4;
    /* Default, currently the highest severity supported.
     * This number is expected to be >= 4. This is not explicitly checked.
     */

    let oh_mode;
    let oh_map_value = false;
    let oh_key, oh_regex_key;

    if (typeof optional_conf_parm === 'number') {
        oh_mode = optional_conf_parm;
    } else if (typeof optional_conf_parm === 'object') {
        if (typeof optional_conf_parm['locale'] === 'string') {
            /* TODO: The split thing is obviously a workaround. */
            locale = optional_conf_parm['locale'].split('-')[0];
        }
        if (checkOptionalConfParm('mode', 'number')) {
            oh_mode = optional_conf_parm['mode'];
        }
        if (checkOptionalConfParm('warnings_severity', 'number')) {
            warnings_severity = optional_conf_parm['warnings_severity'];
            if ([ 0, 1, 2, 3, 4, 5, 6, 7 ].indexOf(warnings_severity) === -1) {
                throw t('warnings severity', { 'severity': warnings_severity, 'allowed': '[ 0, 1, 2, 3, 4, 5, 6, 7 ]' });
            }
        }
        if (checkOptionalConfParm('tag_key', 'string')) {
            oh_key = optional_conf_parm['tag_key'];
        }
        if (checkOptionalConfParm('map_value', 'boolean')) {
            oh_map_value = optional_conf_parm.map_value;
        }
    } else if (typeof optional_conf_parm !== 'undefined') {
        throw t('optional conf parm type', { 'given': typeof(optional_conf_parm) });
    }

    if (typeof oh_key === 'string') {
        oh_regex_key = getRegexKeyForKeyFromOsmDefaults(oh_key);

        if (oh_map_value
            && typeof osm_tag_defaults[oh_regex_key] === 'object'
            && typeof osm_tag_defaults[oh_regex_key]['map'] === 'object'
            && typeof osm_tag_defaults[oh_regex_key]['map'][value] === 'string'
            ) {

            value = osm_tag_defaults[oh_regex_key]['map'][value];
        }
    } else if (oh_map_value) {
        throw t('conf param tag key missing');
    }

    if (typeof oh_mode === 'undefined') {
        if (typeof oh_key === 'string' && osm_tag_defaults[oh_regex_key] !== undefined) {
            if (typeof osm_tag_defaults[oh_regex_key]['mode'] === 'number') {
                oh_mode = osm_tag_defaults[oh_regex_key]['mode'];
            } else {
                oh_mode = 0;
            }
        } else {
            oh_mode = 0;
        }
    } else if ([ 0, 1, 2 ].indexOf(oh_mode) === -1) {
        throw t('conf param mode invalid', { 'given': oh_mode, 'allowed': '[ 0, 1, 2 ]' });
    }

    /* }}} */
    /* }}} */

    // Tokenize value and generate selector functions. {{{
    if (typeof value !== 'string') {
        throw t('no string');
    }
    if (/^(?:\s*;?)+$/.test(value)) {
        throw t('nothing');
    }

    const parsing_warnings = []; // Elements are fed into function formatWarnErrorMessage(nrule, at, message)
    let done_with_warnings = false; // The functions which returns warnings can be called multiple times.
    let done_with_selector_reordering = false;
    let done_with_selector_reordering_warnings = false;
    // eslint-disable-next-line no-var
    var tokens = tokenize(value); // TODO: Figure out why tests fail if this is const or let.
    // console.log(JSON.stringify(tokens, null, '    '));
    let prettified_value = '';
    let week_stable = true;

    let rule, nrule;
    const rules = [];
    const rule_infos = {};
    /* Not reliable because tokens !== new_tokens */
    // for (var nrule = 0; nrule < tokens.length; nrule++) {
    //     rule_infos[nrule] = {};
    // }
    const new_tokens = [];

    for (nrule = 0; nrule < tokens.length; nrule++) {
        if (tokens[nrule][0].length === 0) {
            // Rule does contain nothing useful e.g. second rule of '10:00-12:00;' (empty) which needs to be handled.
            parsing_warnings.push([nrule, -1,
                t('nothing useful')
                + (nrule === tokens.length - 1 && nrule > 0 && !tokens[nrule][1] ?
                    ' ' + t('programmers joke') : '')
                ]);
            continue;
        }

        let continue_at = 0;
        let next_rule_is_additional = false;

        do {
            if (continue_at === tokens[nrule][0].length) {
                /* Additional rule does contain nothing useful e.g. second rule
                 * of '10:00-12:00,' (empty) which needs to be handled.
                  */
                break;
            }

            rule = {
                // Time selectors
                time: [],

                // Temporary array of selectors from time wrapped to the next day
                wraptime: [],

                // Date selectors
                weekday: [],
                holiday: [],
                week: [],
                month: [],
                monthday: [],
                year: [],

                // Array with non-empty date selector types, with most optimal ordering
                date: [],

                fallback: tokens[nrule][1],
                additional: continue_at ? true : false,
                meaning: true,
                unknown: false,
                comment: undefined,
                build_from_token_rule: undefined,
            };

            rule.build_from_token_rule = [ nrule, continue_at, new_tokens.length ];
            continue_at = parseGroup(tokens[nrule][0], continue_at, rule, nrule);
            if (typeof continue_at === 'object') {
                continue_at = continue_at[0];
            } else {
                continue_at = 0;
            }

            // console.log('Current tokens: ' + JSON.stringify(tokens[nrule], null, '    '));

            new_tokens.push(
                [
                    tokens[nrule][0].slice(
                        rule.build_from_token_rule[1],
                        continue_at === 0
                            ? tokens[nrule][0].length
                            : continue_at
                    ),
                    tokens[nrule][1],
                    tokens[nrule][2],
                ]
            );

            if (next_rule_is_additional && new_tokens.length > 1) {
                // Move 'rule separator' from last token of last rule to first token of this rule.
                new_tokens[new_tokens.length - 1][0].unshift(new_tokens[new_tokens.length - 2][0].pop());
            }

            next_rule_is_additional = continue_at === 0 ? false : true;

            const optimal_selector_order = ['year', 'holiday', 'month', 'monthday', 'week', 'weekday'];
            optimal_selector_order.forEach(function (element) {
                if (rule[element].length > 0) {
                    rule.date.push(rule[element]);
                    rule[element] = [];
                }
            });

            // console.log('Rule: ' + JSON.stringify(rule, null, '    '));
            rules.push(rule);

            /* This handles selectors with time ranges wrapping over midnight (e.g. 10:00-02:00).
             * It generates wrappers for all selectors and creates a new rule.
             */
            if (rule.wraptime.length > 0) {
                const wrapselectors = {
                    time: rule.wraptime,
                    date: [],

                    meaning: rule.meaning,
                    unknown: rule.unknown,
                    comment: rule.comment,

                    wrapped: true,
                    build_from_token_rule: rule.build_from_token_rule,
                };

                for (let dselg = 0; dselg < rule.date.length; dselg++) {
                    wrapselectors.date.push([]);
                    for (let dsel = 0; dsel < rule.date[dselg].length; dsel++) {
                        wrapselectors.date[wrapselectors.date.length-1].push(
                                generateDateShifter(rule.date[dselg][dsel], -msec_in_day)
                            );
                    }
                }

                rules.push(wrapselectors);
            }
        } while (continue_at);
    }
    // console.log(JSON.stringify(tokens, null, '    '));
    // console.log(JSON.stringify(new_tokens, null, '    '));
    /* }}} */

    /* Helper functions {{{ */
    /* Get regex string key from key osm_tag_defaults. {{{
     *
     * :param key: Tag key e.g. opening_hours:kitchen.
     * :returns: Regex key from osm_tag_defaults e.g. opening_hours:.*
     */
    function getRegexKeyForKeyFromOsmDefaults(key) {
        let regex_key;
        let exact_match = false;

        Object.keys(osm_tag_defaults).forEach(function (osm_key) {
            if (exact_match === true) {
                return;
            }
            if (key === osm_key) { // Exact match.
                regex_key = osm_key;
                // We can't just return here as some old browsers
                // don't interpret it as a final return (like a loop break)
                exact_match = true;
            } else if (new RegExp(osm_key).test(key)) {
                regex_key = osm_key;
            }
        });
        return regex_key;
    }
    /* }}} */

    /* Check given element in optional_conf_parm. {{{
     *
     * :param key: Key of optional_conf_parm.
     * :param expected_type: Expected `typeof()` the parameter.
     * :returns: True if the expected type matches the given type.
     */
    function checkOptionalConfParm(key, expected_type) {
        if (typeof optional_conf_parm[key] === expected_type) {
            return true;
        } else if (typeof optional_conf_parm[key] !== 'undefined') {
            throw t('conf param unknown type', { 'key': key, 'given': typeof(optional_conf_parm[key]), 'expected': expected_type });
        }
        return false;
    }
    /* }}} */
    /* }}} */

    /* Format warning or error message for the user. {{{
     *
     * :param nrule: Rule number starting with 0.
     * :param at: Token position at which the issue occurred.
     * :param message: Human readable string with the message.
     * :param tokens_to_use: List of token objects.
     * :returns: String with position of the warning or error marked for the user.
     */
    function formatWarnErrorMessage(nrule, at, message, tokens_to_use) {
        if (typeof tokens_to_use === 'undefined') {
            tokens_to_use = tokens;
        }
        // console.log(`Called formatWarnErrorMessage: ${nrule}, ${at}, ${message}`);
        // FIXME: Change to new_tokens.
        if (typeof nrule === 'number') {
            let pos = 0;
            if (nrule === -1) { // Usage of rule index not required because we do have access to value.length.
                pos = value.length - at;
            } else { // Issue occurred at a later time, position in string needs to be reconstructed.
                if (typeof tokens_to_use[nrule][0][at] === 'undefined') {
                    if (typeof tokens_to_use[nrule][0] !== 'undefined' && at === -1) {
                        pos = value.length;
                        if (typeof tokens_to_use[nrule+1] === 'object' && typeof tokens_to_use[nrule+1][2] === 'number') {
                            pos -= tokens_to_use[nrule+1][2];
                        } else if (typeof tokens_to_use[nrule][2] === 'number') {
                            pos -= tokens_to_use[nrule][2];
                        }
                    } else {
                        // Given position is invalid.
                        //
                        formatLibraryBugMessage('Bug in warning generation code which could not determine the exact position of the warning or error in value.');
                        pos = value.length;
                        if (typeof tokens_to_use[nrule][2] === 'number') {
                            // Fallback: Point to last token in the rule which caused the problem.
                            // Run real_test regularly to fix the problem before a user is confronted with it.
                            pos -= tokens_to_use[nrule][2];
                            console.warn('Last token for rule: ' + JSON.stringify(tokens_to_use[nrule]));
                        } else {
                            console.warn('tokens_to_use[nrule][2] is undefined. This is ok if nrule is the last rule.');
                        }
                    }
                } else {
                    pos = value.length;
                    if (typeof tokens_to_use[nrule][0][at+1] === 'object') {
                        pos -= tokens_to_use[nrule][0][at+1][2];
                    } else if (typeof tokens_to_use[nrule][2] === 'number') {
                        pos -= tokens_to_use[nrule][2];
                    }
                }
            }
            return value.substring(0, pos) + ' <--- (' + message + ')';
        } else if (typeof nrule === 'string') {
            return nrule.substring(0, at) + ' <--- (' + message + ')';
        }
    }
    /* }}} */

    /* Format internal library error message. {{{
     *
     * :param message: Human readable string with the error message.
     * :param text_template: Message template defined in the `lang` variable to use for the error message. Defaults to 'library bug'.
     * :returns: Error message for the user.
     */
    function formatLibraryBugMessage(message, text_template) {
        if (typeof message === 'undefined') {
            message = '';
        } else {
            message = ' ' + message;
        }
        if (typeof text_template !== 'string') {
            text_template = 'library bug';
        }

        message = t(text_template, { 'value': value, 'url': repository_url, 'message': message });
        console.error(message);
        return message;
    } /* }}} */

    /* Tokenize input stream {{{
     *
     * :param value: Raw opening_hours value.
     * :returns: Tokenized list object. Complex structure. Check the
     *        internal documentation in the docs/ directory for details.
     */
    function tokenize(value) {
        // Negative list approach: Match anything that's NOT punctuation, digits, or special chars
        // This automatically supports all Unicode letter categories without explicit enumeration
        const WORD_REGEX = /^([^\s\d\p{P}\p{S}\p{C}]{2,})(?=\s|$|[\s\d\p{P}\p{S}\p{C}])((?:[.]| before| after)?)/iu;

        const all_tokens     = [];
        let curr_rule_tokens = [];

        let last_rule_fallback_terminated = false;

        while (value !== '') {
            /* Ordered after likelihood of input for performance reasons.
             * Also, error tolerance is supposed to happen at the end.
             */
            // console.log("Parsing value: " + value);

            // First regex: Match international words (2+ characters) with optional suffixes
            // Pattern: word characters followed by word boundary, with optional ". before after" suffixes
            let tmp = value.match(WORD_REGEX);
            let token_from_map = undefined;
            if (tmp && tmp[2] === '') {
                token_from_map = string_to_token_map[tmp[1].toLowerCase()];
            }
            if (typeof token_from_map === 'object') {
                curr_rule_tokens.push(token_from_map.concat([value.length]));
                value = value.substr(tmp[1].length);
            } else if ((tmp = value.match(/^\s+/))) {
                // whitespace is ignored
                value = value.substr(tmp[0].length);
            } else if ((tmp = value.match(/^24\/7/))) {
                // Reserved keyword.
                curr_rule_tokens.push([tmp[0], tmp[0], value.length ]);
                value = value.substr(tmp[0].length);
            } else if (/^;/.test(value)) {
                // semicolon terminates rule.
                // Next token belong to a new rule.
                all_tokens.push([ curr_rule_tokens, last_rule_fallback_terminated, value.length ]);
                value = value.substr(1);

                curr_rule_tokens = [];
                last_rule_fallback_terminated = false;
            } else if (/^[:.]/.test(value)) {
                // Time separator (timesep).
                if (value[0] === '.' && !done_with_warnings) {
                    parsing_warnings.push([ -1, value.length - 1, t('hour min separator')]);
                }
                curr_rule_tokens.push([ ':', 'timesep', value.length ]);
                value = value.substr(1);
            } else if ((tmp = value.match(/^(?:PH|SH)/i))) {
                // special day name (holidays)
                curr_rule_tokens.push([tmp[0].toUpperCase(), 'holiday', value.length ]);
                value = value.substr(2);
            } else if ((tmp = value.match(/^[°\u2070-\u209F\u00B2\u00B3\u00B9]{1,2}/))) {
                const unicode_code_point_to_digit = {
                    176: 0,
                    0x2070: 0,
                    185: 1,
                    178: 2,
                    179: 3,
                };
                const regular_number = tmp[0].split('').map(function (ch) {
                    const code_point = ch.charCodeAt(0);
                    if (typeof unicode_code_point_to_digit[code_point] === 'number') {
                        return unicode_code_point_to_digit[code_point];
                    } else if (0x2074 <= code_point && code_point <= 0x2079) {
                        return code_point - 0x2070;
                    } else if (0x2080 <= code_point && code_point <= 0x2089) {
                        return code_point - 0x2080;
                    }
                }).join('');
                let ok = '';
                if (curr_rule_tokens.length > 0 && matchTokens(curr_rule_tokens, curr_rule_tokens.length-1, 'number')) {
                    ok += ':';
                }
                ok += regular_number;
                if (!done_with_warnings) {
                    for (let i = 0; i <= tmp[0].length; i++) {
                        if (value.charCodeAt(i) === 176) {
                            parsing_warnings.push([ -1, value.length - (1 + i),
                                    t('rant degree sign used for zero')]);
                        }
                    }
                    parsing_warnings.push([ -1, value.length - tmp[0].length,
                            t('please use ok for ko', {'ko': tmp[0], 'ok': ok})]);
                }
                value = ok + value.substr(tmp[0].length);
            } else if ((tmp = value.match(/^(&|_|→|–|−|—|ー|=|·|öffnungszeit(?:en)?:?|opening_hours\s*=|\?|~|～|：|always (?:open|closed)|24x7|24 hours 7 days a week|24 hours|7 ?days(?:(?: a |\/)week)?|7j?\/7|all days?|every day|(?:bis|till?|-|–)? ?(?:open ?end|late)|(?:(?:one )?day (?:before|after) )?(?:school|public) holidays?|days(?=\s|$|[^\p{L}_])|до|рм|ам|jours fériés|on work days?|sonntags?|(?:nur |an )?sonn-?(?:(?: und |\/)feiertag(?:s|en?)?)?|(?:an )?feiertag(?:s|en?)?|(?:nach|on|by) (?:appointments?|vereinbarung|absprache)|p\.m\.|a\.m\.|(?:[^\s\d\p{P}\p{S}\p{C}]|_)+(?=\s|$|[\s\d\p{Po}\p{Ps}\p{Pe}\p{Pd}\p{Pf}\p{Pi}\p{S}\p{C}])|à|á|mo|tu|we|th|fr|sa|su|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)(\.?)/iu))) {
                /* Handle all remaining words and specific other characters with error tolerance.
                 *
                 * à|á: Word boundary does not work with Unicode chars: 'test à test'.match(/\bà\b/i)
                 * https://stackoverflow.com/questions/10590098/javascript-regexp-word-boundaries-unicode-characters
                 * Order in the regular expression capturing group is important in some cases.
                 *
                 * mo|tu|we|th|fr|sa|su|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec: Prefer defended keywords
                 * if used in cases like 'mo12:00-14:00' (when keyword is followed by number).
                 */
                let correct_val = returnCorrectWordOrToken(tmp[1].toLowerCase(), value.length);
                // console.log('Error tolerance for string "' + tmp[1] + '" returned "' + correct_val + '".');
                if (typeof correct_val === 'object') {
                    curr_rule_tokens.push([ correct_val[0], correct_val[1], value.length ]);
                    value = value.substr(tmp[0].length);
                } else if (typeof correct_val === 'string') {
                    if (correct_val === 'am' || correct_val === 'pm') {
                        let hours_token_at = curr_rule_tokens.length - 1;
                        let hours_token;
                        if (hours_token_at >= 0) {
                            if (hours_token_at -2 >= 0 &&
                                    matchTokens(
                                        curr_rule_tokens, hours_token_at - 2,
                                        'number', 'timesep', 'number'
                                    )
                            ) {
                                hours_token_at -= 2;
                                hours_token = curr_rule_tokens[hours_token_at];
                            } else if (matchTokens(curr_rule_tokens, hours_token_at, 'number')) {
                                hours_token = curr_rule_tokens[hours_token_at];
                            }

                            if (typeof hours_token === 'object') {
                                if (correct_val === 'pm' && hours_token[0] < 12) {
                                    hours_token[0] += 12;
                                }
                                if (correct_val === 'am' && hours_token[0] === 12) {
                                    hours_token[0] = 0;
                                }
                                curr_rule_tokens[hours_token_at] = hours_token;
                            }
                        }
                        correct_val = '';
                    }
                    const correct_tokens = tokenize(correct_val)[0];
                    if (correct_tokens[1] === true) { // last_rule_fallback_terminated
                        throw formatLibraryBugMessage();
                    }
                    for (let i = 0; i < correct_tokens[0].length; i++) {
                        curr_rule_tokens.push([correct_tokens[0][i][0], correct_tokens[0][i][1], value.length]);
                        // value.length - tmp[0].length does not have the desired effect for all test cases.
                    }

                    value = value.substr(tmp[0].length);
                    // value = correct_val + value.substr(tmp[0].length);
                    // Does not work because it would generate the wrong length for formatWarnErrorMessage.
                } else {
                    // No correction available. Insert as single character token and let the parser handle the error.
                    curr_rule_tokens.push([value[0].toLowerCase(), value[0].toLowerCase(), value.length - 1 ]);
                    value = value.substr(1);
                }
                if (typeof tmp[2] === 'string' && tmp[2] !== '' && !done_with_warnings) {
                    parsing_warnings.push([ -1, value.length, t('omit ko', {'ko': tmp[2]})]);
                }
            } else if ((tmp = value.match(/^(\d+)(?:([.])([^\d]))?/))) {
                // number
                if (Number(tmp[1]) > 1900) { // Assumed to be a year number.
                    curr_rule_tokens.push([Number(tmp[1]), 'year', value.length ]);
                    if (Number(tmp[1]) >= 2100) // Probably an error
                        parsing_warnings.push([ -1, value.length - 1,
                                t('interpreted as year', {number:  Number(tmp[1])})
                        ]);
                } else {
                    curr_rule_tokens.push([Number(tmp[1]), 'number', value.length ]);
                }

                value = value.substr(tmp[1].length + (typeof tmp[2] === 'string' ? tmp[2].length : 0));
                if (typeof tmp[2] === 'string' && tmp[2] !== '' && !done_with_warnings) {
                    parsing_warnings.push([ -1, value.length, t('omit ko', {'ko': tmp[2]})]);
                }
            } else if (/^\|\|/.test(value)) {
                // || terminates rule.
                // Next token belong to a fallback rule.
                if (curr_rule_tokens.length === 0) {
                    throw formatWarnErrorMessage(-1, value.length - 2, t('rule before fallback empty'));
                }

                all_tokens.push([ curr_rule_tokens, last_rule_fallback_terminated, value.length ]);
                curr_rule_tokens = [];
                // curr_rule_tokens = [ [ '||', 'rule separator', value.length  ] ];
                // FIXME: Use this. Unknown bug needs to be solved in the process.
                value = value.substr(2);

                last_rule_fallback_terminated = true;
            } else if ((tmp = value.match(/^"([^"]+)"/))) {
                // Comment following the specification.
                // Any character is allowed inside the comment except " itself.
                curr_rule_tokens.push([tmp[1], 'comment', value.length ]);
                value = value.substr(tmp[0].length);
            } else if ((tmp = value.match(/^(["'„“‚‘’«「『])([^"'“”‘’»」』;|]*)(["'”“‘’»」』])/))) {
                // Comments with error tolerance.
                // The comments still have to be somewhat correct meaning
                // the start and end quote signs used have to be
                // appropriate. So “testing„ will not match as it is not a
                // quote but rather something unknown which the user should
                // fix first.
                // console.log('Matched: ' + JSON.stringify(tmp));
                for (let pos = 1; pos <= 3; pos += 2) {
                    // console.log('Pos: ' + pos + ', substring: ' + tmp[pos]);
                    const correct_val = returnCorrectWordOrToken(tmp[pos],
                        value.length - (pos === 3 ? tmp[1].length + tmp[2].length : 0)
                    );
                    if (typeof correct_val !== 'string' && tmp[pos] !== '"') {
                        throw formatLibraryBugMessage(
                            'A character for error tolerance was allowed in the regular expression'
                            + ' but is not covered by word_error_correction'
                            + ' which is needed to format a proper message for the user.'
                        );
                    }
                }
                curr_rule_tokens.push([tmp[2], 'comment', value.length ]);
                value = value.substr(tmp[0].length);
            } else if (/^(?:␣|\s)/.test(value)) {
                // Using "␣" as space is not expected to be a normal
                // mistake. Just ignore it to make using taginfo easier.
                value = value.substr(1);
            } else {
                // other single-character tokens
                curr_rule_tokens.push([value[0].toLowerCase(), value[0].toLowerCase(), value.length ]);
                value = value.substr(1);
            }
        }

        all_tokens.push([ curr_rule_tokens, last_rule_fallback_terminated ]);

        return all_tokens;
    }
    /* }}} */

    /* error correction/tolerance function {{{
     * Go through word_error_correction hash and get correct value back.
     *
     * :param word: Wrong word or character.
     * :param value_length: Current value_length (used for warnings).
     * :returns:
     *        * (valid) opening_hours sub string.
     *        * object with [ internal_value, token_name ] if value is correct.
     *        * undefined if word could not be found (and thus is not corrected).
     */
    function returnCorrectWordOrToken(word, value_length) {
        let correctWordOrToken;
        const token_from_map = string_to_token_map[word];
        if (typeof token_from_map === 'object') {
            return token_from_map;
        }

        // Check for ambiguous words first - show warning and provide default correction
        if (data$2['Ambiguous words'] && data$2['Ambiguous words'][word]) {
            if (!done_with_warnings) {
                const warningMessage = data$2['Ambiguous words'][word];
                parsing_warnings.push([
                    -1,
                    value_length - word.length,
                    warningMessage
                ]);
            }
            // For ambiguous words, extract the first possible correction from the warning message
            // and use it as a default to keep parsing working
            const warningText = data$2['Ambiguous words'][word];
            const match = warningText.match(/: (\w+) \(/);
            if (match && match[1]) {
                return match[1]; // Return the first suggested correction (e.g. "Nov" from "Nov (Czech)")
            }
            // Fallback: continue with normal processing
            return undefined;
        }

        // Standard processing for all other words using flat structure
        Object.keys(data$2).forEach(function (comment) {
            if (correctWordOrToken) {
                return;
            }
            // Skip the ambiguous words section for auto-correction
            if (comment === 'Ambiguous words') {
                return;
            }
            Object.keys(data$2[comment]).forEach(function (old_val) {
                if (correctWordOrToken) {
                    return;
                }
                if (new RegExp('^' + old_val + '$').test(word)) {
                    const val = data$2[comment][old_val];

                    if (!done_with_warnings) {
                        const warningMessage = t(comment, {'ko': word, 'ok': val});

                        parsing_warnings.push([
                            -1,
                            value_length - word.length,
                            warningMessage
                        ]);
                    }
                    correctWordOrToken = val;
                }
            });
        });

        return correctWordOrToken;
    }
    /* }}} */

    /* return warnings as list {{{
     *
     * :param it: Iterator object if available (optional).
     * :returns: Warnings as list with one warning per element.
     */
    function getWarnings(it) {
        if (warnings_severity < 4) {
            return [];
        }

        if (!done_with_warnings && typeof it === 'object') {
            /* getWarnings was called in a state without critical errors.
             * We can do extended tests.
             */

            /* Place all tests in this function if an additional (high
             * level) test is added and this does not require to rewrite
             * big parts of (sub) selector parsers only to get the
             * position. If that is the case, then rather place the test
             * code in the (sub) selector parser function directly.
             */

            const wide_range_selector_order = [ 'year', 'month', 'week', 'holiday' ];
            const small_range_selector_order = [ 'weekday', 'time', '24/7', 'state', 'comment'];

            // How many times was a selector_type used per rule? {{{
            const used_selectors = [];
            const used_selectors_types_array = [];
            const has_token = {};

            for (let nrule = 0; nrule < new_tokens.length; nrule++) {
                if (new_tokens[nrule][0].length === 0) continue;
                // Rule does contain nothing useful e.g. second rule of '10:00-12:00;' (empty) which needs to be handled.

                let selector_start_end_type = [ 0, 0, undefined ];
                // console.log(new_tokens[nrule][0]);

                used_selectors[nrule] = {};
                used_selectors_types_array[nrule] = [];

                do {
                    selector_start_end_type = getSelectorRange(new_tokens[nrule][0], selector_start_end_type[1]);
                    // console.log(selector_start_end_type, new_tokens[nrule][0].length);

                    for (let token_pos = 0; token_pos <= selector_start_end_type[1]; token_pos++) {
                        if (typeof new_tokens[nrule][0][token_pos] === 'object' && new_tokens[nrule][0][token_pos][0] === 'PH') {
                            has_token['PH'] = true;
                        }
                    }

                    if (selector_start_end_type[0] === selector_start_end_type[1] &&
                        new_tokens[nrule][0][selector_start_end_type[0]][0] === '24/7'
                        ) {
                            has_token['24/7'] = true;
                    }

                    if (typeof used_selectors[nrule][selector_start_end_type[2]] !== 'object') {
                        used_selectors[nrule][selector_start_end_type[2]] = [ selector_start_end_type[1] ];
                    } else {
                        used_selectors[nrule][selector_start_end_type[2]].push(selector_start_end_type[1]);
                    }
                    used_selectors_types_array[nrule].push(selector_start_end_type[2]);

                    selector_start_end_type[1]++;
                } while (selector_start_end_type[1] < new_tokens[nrule][0].length);
            }
            // console.log('used_selectors: ' + JSON.stringify(used_selectors, null, '    '));
            // console.log('used_selectors_types_array: ' + JSON.stringify(used_selectors_types_array, null, '    '));
            /* }}} */

            for (let nrule = 0; nrule < used_selectors.length; nrule++) {

                /* Check if more than one not connected selector of the same type is used in one rule {{{ */
                Object.keys(used_selectors[nrule]).forEach(function (selector_type) {
                    // console.log(selector_type + ' use at: ' + used_selectors[nrule][selector_type].length);
                    if (used_selectors[nrule][selector_type].length > 1) {
                        parsing_warnings.push([nrule, used_selectors[nrule][selector_type][used_selectors[nrule][selector_type].length - 1],
                            t('use multi', {
                                'count': used_selectors[nrule][selector_type].length,
                                'part2': (
                                    /^(?:comment|state)/.test(selector_type) ?
                                        t('selector multi 2a', {'what': (selector_type === 'state' ? t('selector state'): t('comments'))})
                                        :
                                        t('selector multi 2b', {'what': t(selector_type + (/^(?:month|weekday)$/.test(selector_type) ? 's' : ' ranges'))})
                                )
                            })]
                        );
                        done_with_selector_reordering = true; // Correcting the selector order makes no sense if this kind of issue exists.
                    }
                });
                /* }}} */
                /* Check if change default state rule is not the first rule {{{ */
                if (   typeof used_selectors[nrule].state === 'object'
                    && Object.keys(used_selectors[nrule]).length === 1
                ) {
                    if (nrule !== 0) {
                        parsing_warnings.push([nrule, new_tokens[nrule][0].length - 1, t('default state')]);
                    }
                /* }}} */
                /* Check if a rule (with state open) has no time selector {{{ */
                } else if (typeof used_selectors[nrule].time === 'undefined') {
                    if (    (       typeof used_selectors[nrule].state === 'object'
                                && new_tokens[nrule][0][used_selectors[nrule].state[0]][0] === 'open'
                                && typeof used_selectors[nrule].comment === 'undefined'
                            ) || ( typeof used_selectors[nrule].comment === 'undefined'
                                && typeof used_selectors[nrule].state === 'undefined'
                            ) &&
                            typeof used_selectors[nrule]['24/7'] === 'undefined'
                    ) {

                        parsing_warnings.push([nrule, new_tokens[nrule][0].length - 1, t('vague')]);
                    }
                }
                /* }}} */
                /* Check if empty comment was given {{{ */
                if (typeof used_selectors[nrule].comment === 'object'
                    && new_tokens[nrule][0][used_selectors[nrule].comment[0]][0].length === 0
                ) {

                    parsing_warnings.push([nrule, used_selectors[nrule].comment[0], t('empty comment')]);
                }
                /* }}} */
                /* Check for valid use of <separator_for_readability> {{{ */
                for (let i = 0; i < used_selectors_types_array[nrule].length - 1; i++) {
                    const selector_type = used_selectors_types_array[nrule][i];
                    const next_selector_type = used_selectors_types_array[nrule][i+1];
                    if (   (   wide_range_selector_order.indexOf(selector_type)       !== -1
                            && wide_range_selector_order.indexOf(next_selector_type)  !== -1
                        ) || ( small_range_selector_order.indexOf(selector_type)      !== -1
                            && small_range_selector_order.indexOf(next_selector_type) !== -1)
                        ) {

                        if (new_tokens[nrule][0][used_selectors[nrule][selector_type][0]][0] === ':') {
                            parsing_warnings.push([nrule, used_selectors[nrule][selector_type][0],
                                t('separator_for_readability')
                            ]);
                        }
                    }
                }
                /* }}} */
                /* Check for missing use of <additional_rule_separator> for time wrapping midnight {{{ */
                if (typeof rule_infos[nrule] === 'object'
                        && typeof rule_infos[nrule]['time_wraps_over_midnight'] === 'boolean'
                        && rule_infos[nrule]['time_wraps_over_midnight'] === true
                        && typeof used_selectors[nrule+1] === 'object'
                        && typeof used_selectors[nrule+1]['rule separator'] === 'undefined' // Not an additional rule
                        && new_tokens[nrule+1][1] === false // Not a fallback rule
                        ) {

                    const rules_too_complex = [ nrule, nrule+1 ].map(function (nrule){
                        for (let i = 0; i < wide_range_selector_order.length - 1; i++) {
                            if (typeof used_selectors[nrule][wide_range_selector_order[i]] === 'object') {
                                return true;
                            }
                        }
                        return false;
                    });
                    const rules_too_complex_count = rules_too_complex.filter(function (el){ return el; }).length;
                    let next_rule_selects_next_day = false;
                    if (
                            typeof rule_infos[nrule] === 'object'
                            && typeof rule_infos[nrule] === 'object'
                            && typeof rule_infos[nrule]['week_days'] === 'object'
                            && typeof rule_infos[nrule+1] === 'object'
                            && typeof rule_infos[nrule+1]['week_days'] === 'object'
                            ) {
                        for (let i = 0; i < rule_infos[nrule]['week_days'].length; i++) {
                            const week_day = rule_infos[nrule]['week_days'][i];
                                // console.log(rule_infos[nrule+1]['week_days']);
                                // console.log(week_day);
                            if (rule_infos[nrule+1]['week_days'].indexOf(week_day === 6 ? 0 : week_day+1) !== -1) {
                                next_rule_selects_next_day = true;
                                break;
                            }
                        }
                    } else {
                        next_rule_selects_next_day = true;
                    }
                    // console.log(rule_infos);
                    // console.log(next_rule_selects_next_day);
                    const additional_rule_separator_enabled = (optional_conf_parm||{}).additional_rule_separator !== false;
                    if (rules_too_complex_count < 2 && next_rule_selects_next_day && additional_rule_separator_enabled) {
                        parsing_warnings.push([nrule+1, new_tokens[nrule+1][0].length - 1,
                            t('additional_rule_separator not used after time wrapping midnight'),
                            new_tokens
                        ]);
                    }
                }
                /* }}} */
                /* Check if rule with closed|off modifier is additional {{{ */
                if (typeof new_tokens[nrule][0][0] === 'object'
                        && new_tokens[nrule][0][0][0] === ','
                        && new_tokens[nrule][0][0][1] === 'rule separator'
                        && typeof used_selectors[nrule].state === 'object'
                        && (
                               new_tokens[nrule][0][used_selectors[nrule].state[0]][0] === 'closed'
                            || new_tokens[nrule][0][used_selectors[nrule].state[0]][0] === 'off'
                           )
                ) {

                    parsing_warnings.push([nrule, new_tokens[nrule][0].length - 1,
                        t('additional rule which evaluates to closed'),
                        new_tokens
                    ]);
                }
                /* }}} */

            }

            /* Check if 24/7 is used and it does not mean 24/7 because there are other rules {{{ */
            const has_advanced = it.advance();

            if (has_advanced === true && has_token['24/7'] && !done_with_warnings) {
                parsing_warnings.push([ -1, 0,
                    // Probably because of: "24/7; 12:00-14:00 open", ". Needs extra testing.
                    t('strange 24/7')
                ]);
            }
            /* }}} */

            /* Check for missing PH. {{{ */
            if (    warnings_severity >= 5
                && !has_token['PH']
                && !has_token['24/7']
                && !done_with_warnings
                && (
                        (
                            typeof oh_key === 'string'
                            && osm_tag_defaults[oh_regex_key]['warn_for_PH_missing']
                        )
                        || (typeof oh_key !== 'string')
                   )
                ) {

                const keys_with_warn_for_PH_missing = [];
                Object.keys(osm_tag_defaults).forEach(function (key) {
                    if (osm_tag_defaults[key]['warn_for_PH_missing']) {
                        keys_with_warn_for_PH_missing.push(key);
                    }
                });
                parsing_warnings.push([ -1, 0,
                    t('public holiday', { 'part2': (typeof oh_key !== 'string'
                        ? t('public holiday part2', {'keys': keys_with_warn_for_PH_missing.join(', ')}) : '')})
                        // + '(see README how to provide it)' // UI of the evaluation tool does not allow to provide it (currently).
                ]);
            }
            /* }}} */

            /* Check if value consists of multiple rules each only using a time selector {{{ */
            if (used_selectors_types_array.length > 1
                    &&  used_selectors_types_array.filter(function (el){
                            return el.length === 1 && el[0] === 'time';
                        }).length === used_selectors_types_array.length
                    ) {
                parsing_warnings.push([ -1, 0,
                    t('combine rules', { 'ok': ',' }),
                ]);
            }
            /* }}} */

            prettifyValue();
        }
        done_with_warnings = true;

        const warnings = [];
        // FIXME: Sort based on parsing_warnings[1], tricky …
        for (let i = 0; i < parsing_warnings.length; i++) {
            warnings.push( formatWarnErrorMessage(parsing_warnings[i][0], parsing_warnings[i][1], parsing_warnings[i][2], parsing_warnings[i][3]) );
        }
        return warnings;
    }

    /* Helpers for getWarnings {{{ */

    /* Check if token is the begin of a selector and why. {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns:
     *        * false if the current token is not the begin of a selector.
     *        * Position in token array from where the decision was made that
     *          the token is the start of a selector.
     */
    function tokenIsTheBeginOfSelector(tokens, at) {
        if (typeof tokens[at][3] === 'string') {
            return 3;
        } else if (tokens[at][1] === 'comment'
                || tokens[at][1] === 'state'
                || tokens[at][1] === '24/7'
                || tokens[at][1] === 'rule separator'
            ){

            return 1;
        } else {
            return false;
        }
    }
    /* }}} */

    /* Get start and end position of a selector. {{{
     * For example this value 'Mo-We,Fr' will return the position of the
     * token lexeme 'Mo' and 'Fr' e.g. there indexes [ 0, 4 ] in the
     * selector array of tokens.
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Array:
     *            0. Index of first token in selector array of tokens.
     *            1. Index of last token in selector array of tokens.
     *            2. Selector type.
     */
    function getSelectorRange(tokens, at) {
        let selector_start = at,
            selector_end,
            pos_in_token_array;

        for (; selector_start >= 0; selector_start--) {
            pos_in_token_array = tokenIsTheBeginOfSelector(tokens, selector_start);
            if (pos_in_token_array) {
                break;
            }
        }
        selector_end = selector_start;

        if (pos_in_token_array === 1) {
            // Selector consists of a single token.

            // Include tailing colon.
            if (selector_end + 1 < tokens.length && tokens[selector_end + 1][0] === ':')
                selector_end++;

            return [ selector_start, selector_end, tokens[selector_start][pos_in_token_array] ];
        }

        for (selector_end++; selector_end < tokens.length ; selector_end++) {
            if (tokenIsTheBeginOfSelector(tokens, selector_end))
                return [ selector_start, selector_end - 1, tokens[selector_start][pos_in_token_array] ];
        }

        return [ selector_start, selector_end - 1, tokens[selector_start][pos_in_token_array] ];
    }
    /* }}} */
    /* }}} */
    /* }}} */

    /* Prettify raw value from user. {{{
     * The value is generated by putting the tokens back together to a string.
     *
     * :param argument_hash: Hash which can contain:
     *        'conf': Configuration hash.
     *        'get_internals: If true export internal data structures.
     *        'rule_index: Only prettify the rule with this index.
     * :returns: Prettified value string or object if get_internals is true.
     */
    function prettifyValue(argument_hash) {
        let user_conf = {};
        let get_internals = false;
        let rule_index;

        prettified_value = '';
        const prettified_value_array = [];

        if (typeof argument_hash === 'object') {
            if (typeof argument_hash.conf === 'object') {
                user_conf = argument_hash.conf;
            }

            if (typeof argument_hash.rule_index === 'number') {
                rule_index = argument_hash.rule_index;
            }

            if (argument_hash.get_internals === true) {
                get_internals = true;
            }

        }

        Object.keys(default_prettify_conf).forEach(function (key) {
            if (typeof user_conf[key] === 'undefined') {
                user_conf[key] = default_prettify_conf[key];
            }
        });

        // use months, weekdays for locales 'en' and 'all'
        // otherwise use Date.toLocaleString, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
        const _is_en_or_all = (user_conf['locale'] === 'en' || user_conf['locale'] === 'all') && user_conf['date_format'] === 'short';
        const months_local = _is_en_or_all ? months : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function(month) {
            return new Date(2018, month - 1, 1).toLocaleString(user_conf['locale'], {month: user_conf['date_format']});
        });
        const weekdays_local = _is_en_or_all ? weekdays : [1, 2, 3, 4, 5, 6, 7].map(function(weekday) {
            // 2017-01-01 is Sunday
            return new Date(2017, 0, weekday).toLocaleString(user_conf['locale'], {weekday: user_conf['date_format']});
        });

        for (let nrule = 0; nrule < new_tokens.length; nrule++) {
            if (new_tokens[nrule][0].length === 0) continue;
            // Rule does contain nothing useful e.g. second rule of '10:00-12:00;' (empty) which needs to be handled.

            if (typeof rule_index === 'number') {
                if (rule_index !== nrule) continue;
            } else {
                if (nrule !== 0)
                    prettified_value += (
                        new_tokens[nrule][1]
                            ? user_conf.rule_sep_string + '|| '
                            : (
                                new_tokens[nrule][0][0][1] === 'rule separator'
                                ? ','
                                : (
                                    user_conf.print_semicolon
                                    ? ';'
                                    : ''
                                )
                            ) +
                        user_conf.rule_sep_string);
            }

            let selector_start_end_type = [ 0, 0, undefined ];
            const prettified_group_value = [];
            let count = 0;
            // console.log(new_tokens[nrule][0]);

            do {
                selector_start_end_type = getSelectorRange(new_tokens[nrule][0], selector_start_end_type[1]);
                // console.log(selector_start_end_type, new_tokens[nrule][0].length, count);

                if (count > 50) {
                    throw formatLibraryBugMessage('Infinite loop.');
                }

                if (selector_start_end_type[2] !== 'rule separator') {
                    prettified_group_value.push(
                        [
                            selector_start_end_type,
                            prettifySelector(
                                new_tokens[nrule][0],
                                selector_start_end_type[0],
                                selector_start_end_type[1],
                                selector_start_end_type[2],
                                user_conf
                            ),
                        ]
                    );
                }

                selector_start_end_type[1]++;
                count++;
                // console.log(selector_start_end_type, new_tokens[nrule][0].length, count);
            } while (selector_start_end_type[1] < new_tokens[nrule][0].length);
            // console.log('Prettified value: ' + JSON.stringify(prettified_group_value, null, '    '));
            const not_sorted_prettified_group_value = prettified_group_value.slice();

            if (!done_with_selector_reordering) {
                prettified_group_value.sort(
                    function (a, b) {
                        const selector_order = [ 'year', 'month', 'week', 'holiday', 'weekday', 'time', '24/7', 'state', 'comment'];
                        return selector_order.indexOf(a[0][2]) - selector_order.indexOf(b[0][2]);
                    }
                );
            }
            const old_prettified_value_length = prettified_value.length;

            if (typeof user_conf['locale'] === 'string' && user_conf['locale'] !== 'en') {
                let translatorFunction;
                if (i18n.language !== user_conf['locale']) {
                    translatorFunction = i18n.getFixedT(user_conf['locale']);
                } else {
                    translatorFunction = i18n.t.bind(i18n);
                }
                for (let i = 0; i < prettified_group_value.length; i++) {
                    const type = prettified_group_value[i][0][2];
                    if (type === 'weekday') {
                        weekdays.forEach(function (weekday, key) {
                            prettified_group_value[i][1] = prettified_group_value[i][1].replace(new RegExp(weekday, 'g'), weekdays_local[key]);
                        });
                    } else if (type === 'month') {
                        months.forEach(function (month, key) {
                            prettified_group_value[i][1] = prettified_group_value[i][1].replace(new RegExp(month, 'g'), months_local[key]);
                        });
                    } else {
                        const prettifiedValueIsProbablyTranslatable = prettified_group_value[i][1].indexOf(':') === -1;
                        if (prettifiedValueIsProbablyTranslatable) {
                            prettified_group_value[i][1] = translatorFunction(['opening_hours:pretty.' + prettified_group_value[i][1], prettified_group_value[i][1]]);
                        }
                    }
                }
            }

            prettified_value += prettified_group_value.map(function (array) {
                return array[1];
            }).join(' ');

            prettified_value_array.push( prettified_group_value );

            if (!done_with_selector_reordering_warnings) {
                for (let i = 0, l = not_sorted_prettified_group_value.length; i < l; i++) {
                    if (not_sorted_prettified_group_value[i] !== prettified_group_value[i]) {
                        // console.log(i + ': ' + prettified_group_value[i][0][2]);
                        let length = i + old_prettified_value_length; // i: Number of spaces in string.
                        for (let x = 0; x <= i; x++) {
                            length += prettified_group_value[x][1].length;
                            // console.log('Length: ' + length + ' ' + prettified_group_value[x][1]);
                        }
                        // console.log(length);
                        parsing_warnings.push([ prettified_value, length, t('switched', {
                            'first': prettified_group_value[i][0][2],
                            'second': not_sorted_prettified_group_value[i][0][2]
                        })
                        ]);
                    }
                }
            }
        }

        done_with_selector_reordering_warnings = true;
        // console.log(JSON.stringify(prettified_value_array, null, '    '));

        if (get_internals) {
            return [ prettified_value_array, new_tokens ];
        } else {
            return prettified_value;
        }
    }
    /* }}} */

    /* Check selector array of tokens for specific token name pattern. {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position at which the matching should begin.
     * :param token_name(s): One or many token_name strings which have to match in that order.
     * :returns: true if token_name(s) match in order false otherwise.
     */
    function matchTokens(tokens, at /*, matches... */) {
        if (at + arguments.length - 2 > tokens.length)
            return false;
        for (let i = 0; i < arguments.length - 2; i++) {
            if (tokens[at + i][1] !== arguments[i + 2]) {
                return false;
            }
        }

        return true;
    }
    /* }}} */

    /* Generate selector wrapper with time offset {{{
     *
     * :param func: Generated selector code function.
     * :param shirt: Time to shift in milliseconds.
     * :param token_name(s): One or many token_name strings which have to match in that order.
     * :returns: See selector code.
     */
    function generateDateShifter(func, shift) {
        return function(date) {
            const res = func(new Date(date.getTime() + shift));

            if (typeof res[1] === 'undefined')
                return res;
            return [ res[0], new Date(res[1].getTime() - shift) ];
        };
    }
    /* }}} */

    /* Top-level parser {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param rule: Reference to rule object.
     * :param nrule: Rule number starting with 0.
     * :returns: See selector code.
     */
    function parseGroup(tokens, at, rule, nrule) {
        let rule_modifier_specified = false;

        // console.log(tokens); // useful for debugging of tokenize
        let last_selector = [];
        while (at < tokens.length) {
            // console.log('Parsing at position', at +':', tokens[at]);
            if (matchTokens(tokens, at, 'weekday')) {
                at = parseWeekdayRange(tokens, at, rule, undefined, nrule);
            } else if (matchTokens(tokens, at, '24/7')) {
                rule.time.push(function() { return [true]; });
                // Not needed. If there is no selector it automatically matches everything.
                // WRONG: This only works if there is no other selector in this selector group ...
                at++;
            } else if (matchTokens(tokens, at, 'holiday')) {
                if (matchTokens(tokens, at+1, ',')) {
                    at = parseHoliday(tokens, at, rule, true);
                } else {
                    at = parseHoliday(tokens, at, rule, false);
                }
                week_stable = false;
            } else if (matchTokens(tokens, at, 'month', 'number')
                    || matchTokens(tokens, at, 'month', 'weekday')
                    || matchTokens(tokens, at, 'year', 'month', 'number')
                    || matchTokens(tokens, at, 'year', 'event')
                    || matchTokens(tokens, at, 'event')) {

                at = parseMonthdayRange(tokens, at, nrule);
                week_stable = false;
            } else if (matchTokens(tokens, at, 'year')) {
                at = parseYearRange(tokens, at);
                week_stable = false;
            } else if (matchTokens(tokens, at, 'month')) {
                at = parseMonthRange(tokens, at);
                // week_stable = false; // Decided based on the actual value/tokens.
            } else if (matchTokens(tokens, at, 'week')) {
                tokens[at][3] = 'week';
                at = parseWeekRange(tokens, at);

            } else if (at !== 0 && at !== tokens.length - 1 && tokens[at][0] === ':'
                && !(typeof last_selector[1] === 'string' && last_selector[1] === 'time')) {
                /* Ignore colon if they appear somewhere else than as time separator.
                 * Except the start or end of the value.
                 * This provides compatibility with the syntax proposed by Netzwolf:
                 * https://wiki.openstreetmap.org/wiki/Key:opening_hours/specification#separator_for_readability
                 * Check for valid use of <separator_for_readability> is implemented in function getWarnings().
                 */

                if (!done_with_warnings && matchTokens(tokens, at-1, 'holiday')) {
                    parsing_warnings.push([nrule, at, t('no colon after', { 'token': tokens[at-1][1] })]);
                }

                at++;
            } else if (matchTokens(tokens, at, 'number', 'timesep')
                    || matchTokens(tokens, at, 'timevar')
                    || matchTokens(tokens, at, '(', 'timevar')
                    || matchTokens(tokens, at, 'number', '-')) {

                at = parseTimeRange(tokens, at, rule, false, nrule);
                last_selector = [ at, 'time' ];

            } else if (matchTokens(tokens, at, 'state')) {

                if (tokens[at][0] === 'open') {
                    rule.meaning = true;
                } else if (tokens[at][0] === 'closed' || tokens[at][0] === 'off') {
                    rule.meaning = false;
                } else {
                    rule.meaning = false;
                    rule.unknown = true;
                }

                rule_modifier_specified = true;
                at++;
                if (typeof tokens[at] === 'object' && tokens[at][0] === ',') // additional rule
                    at = [ at + 1 ];

            } else if (matchTokens(tokens, at, 'comment')) {
                rule.comment = tokens[at][0];
                if (!rule_modifier_specified) {
                    // Then it is unknown. Either with unknown explicitly
                    // specified or just a comment.
                    rule.meaning = false;
                    rule.unknown = true;
                }

                rule_modifier_specified = true;
                at++;
                if (typeof tokens[at] === 'object' && tokens[at][0] === ',') { // additional rule
                    at = [ at + 1 ];
                }
            } else if ((at === 0 || at === tokens.length - 1) && matchTokens(tokens, at, 'rule separator')) {
                at++;
                // console.log("value: " + nrule);
                // throw formatLibraryBugMessage('Not implemented yet.');
            } else {
                const warnings = getWarnings();
                throw formatWarnErrorMessage(nrule, at, t('unexpected token', {token: tokens[at][1] })) + (warnings ? (' ' + warnings.join('; ')) : '');
            }

            if (typeof at === 'object') { // additional rule
                tokens[at[0] - 1][1] = 'rule separator';
                break;
            }
            if (typeof last_selector[0] === 'number' && last_selector[0] !== at) {
                last_selector = [];
            }
        }

        return at;
    }

    /* Not used
    function get_last_token_pos_in_token_group(tokens, at, last_at) {
        for (at++; at < last_at; at++) {
            if (typeof tokens[at] === 'object') {
                if (typeof tokens[at][3] === 'string'
                        || tokens[at][1] === 'comment'
                        || tokens[at][1] === 'state'){

                        return at - 1;
                }
            }
        }
        return last_at;
    }
    */

    /* }}} */

    // helper functions for sub parser {{{

    /* For given date, returns date moved to the start of the day with an offset specified in minutes. {{{
     * For example, if date is 2014-05-19_18:17:12, dateAtDayMinutes would
     * return 2014-05-19_02:00:00 for minutes=120.
     *
     * :param date: Date object.
     * :param minutes: Minutes used as offset starting from midnight of current day.
     * :returns: Moved date object.
     */
    function dateAtDayMinutes(date, minutes) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, minutes);
    }
    /* }}} */

    /* For given date, returns date moved to the specific day of week {{{
     *
     * :param date: Date object.
     * :param weekday: Integer number for day of week. Starting with zero (Sunday).
     * :returns: Moved date object.
     */
    function dateAtNextWeekday(date, weekday) {
        const delta = weekday - date.getDay();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + delta + (delta < 0 ? 7 : 0));
    }
    /* }}} */

    /* Numeric list parser (1,2,3-4,-1) {{{
     * Used in weekday parser above.
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param func: Function func(from, to, at).
     * :returns: Position at which the token does not belong to the list any more.
     */
    function parseNumRange(tokens, at, func) {
        for (; at < tokens.length; at++) {
            if (matchTokens(tokens, at, 'number', '-', 'number')) {
                // Number range
                func(tokens[at][0], tokens[at+2][0], at);
                at += 3;
            } else if (matchTokens(tokens, at, '-', 'number')) {
                // Negative number
                func(-tokens[at+1][0], -tokens[at+1][0], at);
                at += 2;
            } else if (matchTokens(tokens, at, 'number')) {
                // Single number
                func(tokens[at][0], tokens[at][0], at);
                at++;
            } else {
                throw formatWarnErrorMessage(nrule, at + matchTokens(tokens, at, '-'),
                    'Unexpected token in number range: ' + tokens[at][1]);
            }

            if (!matchTokens(tokens, at, ','))
                break;
        }

        return at;
    }
    /* }}} */

    /* List parser for constrained weekdays in month range {{{
     * e.g. Su[-1] which selects the last Sunday of the month.
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Array:
     *            0. Constrained weekday number.
     *            1. Position at which the token does not belong to the list any more (after ']' token).
     */
    function getConstrainedWeekday(tokens, at) {
        let number = 0;
        const endat = parseNumRange(tokens, at, function(from, to, at) {

            // bad number
            if (from === 0 || from < -5 || from > 5)
                throw formatWarnErrorMessage(nrule, at,
                    t('number -5 to 5'));

            if (from === to) {
                if (number !== 0)
                    throw formatWarnErrorMessage(nrule, at,
                        t('one weekday constraint'));
                number = from;
            } else {
                throw formatWarnErrorMessage(nrule, at+2,
                    t('range constrained weekdays'));
            }
        });
        for (let i = at; i < endat; i++) {
            tokens[i][4] = 'positive_number';
        }

        if (!matchTokens(tokens, endat, ']'))
            throw formatWarnErrorMessage(nrule, endat, t('expected', {symbol: ']'}));

        return [ number, endat + 1 ];
    }
    /* }}} */

    // Check if period is ok. Period 0 or 1 don’t make much sense.
    function checkPeriod(at, period, period_type, parm_string) {
        if (done_with_warnings)
            return;

        if (period === 0) {
            throw formatWarnErrorMessage(nrule, at,
                t('range zero', { 'type': period_type }));
        } else if (period === 1) {
            if (typeof parm_string === 'string' && parm_string === 'no_end_year')
                parsing_warnings.push([nrule, at, t('period one year+', {'type': period_type})]);
            else
                parsing_warnings.push([nrule, at, t('period one', {'type': period_type})]);
        }
    }

    /* Get date moved to constrained weekday (and moved for add_days. {{{
     * E.g. used for 'Aug Su[-1] -1 day'.
     *
     * :param year: Year as integer.
     * :param month: Month as integer starting with zero.
     * :param weekday: Integer number for day of week. Starting with zero (Sunday).
     * :param constrained_weekday: Position where to start.
     * :returns: Date object.
     */
    function getDateForConstrainedWeekday(year, month, weekday, constrained_weekday, add_days) {
        const tmp_date = dateAtNextWeekday(
            new Date(year, month + (constrained_weekday[0] > 0 ? 0 : 1), 1), weekday);

        tmp_date.setDate(tmp_date.getDate() + (constrained_weekday[0] + (constrained_weekday[0] > 0 ? -1 : 0)) * 7);

        if (typeof add_days === 'object' && add_days[1])
            tmp_date.setDate(tmp_date.getDate() + add_days[0]);

        return tmp_date;
    }
    /* }}} */

    /* Check if date is valid. {{{
     *
     * :param month: Month as integer starting with zero.
     * :param date: Day of month as integer.
     * :param nrule: Rule number starting with 0.
     * :param at: Position at which the matching should begin.
     * :returns: undefined. There is no real return value. This function just throws an exception if something is wrong.
     */
    function checkIfDateIsValid(month, day, nrule, at) {
        // May use this instead. The problem is that this does not give feedback as precise as the code which is used in this function.
        // let testDate = new Date(year, month, day);
        // if (testDate.getDate() !== day || testDate.getMonth() !== month || testDate.getFullYear() !== year) {
        //     console.error('date not valid');
        // }

        // https://en.wikipedia.org/wiki/Month#Julian_and_Gregorian_calendars
        if (day < 1 || day > 31) {
            throw formatWarnErrorMessage(nrule, at, t('month 31', {'month': months[month]}));
        } else if ((month === 3 || month === 5 || month === 8 || month === 10) && day === 31) {
            throw formatWarnErrorMessage(nrule, at, t('month 30', {'month': months[month]}));
        } else if (month === 1 && day === 30) {
            throw formatWarnErrorMessage(nrule, at, t('month feb', {'month': months[month]}));
        }
    }
    /* }}} */
    /* }}} */

    /* Time range parser (10:00-12:00,14:00-16:00) {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param rule: Reference to rule object.
     * :param extended_open_end: Used for combined time range with open end.
     * :param nrule: Rule number starting with 0.
     * extended_open_end: <time> - <time> +
     *        parameter at is here A (if extended_open_end is true)
     * :returns: Position at which the token does not belong to the selector anymore.
     */
    function parseTimeRange(tokens, at, rule, extended_open_end, nrule) {
        if (!extended_open_end)
            tokens[at][3] = 'time';

        for (; at < tokens.length; at++) {
            const has_time_var_calc = [], has_normal_time = []; // element 0: start time, 1: end time
                has_normal_time[0]   = matchTokens(tokens, at, 'number', 'timesep', 'number');
                has_time_var_calc[0] = matchTokens(tokens, at, '(', 'timevar');
            let minutes_from,
                minutes_to,
                has_open_end = false; // default no open end
            if (has_normal_time[0] || matchTokens(tokens, at, 'timevar') || has_time_var_calc[0]) {
                // relying on the fact that always *one* of them is true

                let is_point_in_time = false; // default no time range
                const timevar_add    = [ 0, 0 ];
                let timevar_string   = [];    // capture timevar string like 'sunrise' to calculate it for the current date.
                let point_in_time_period;

                // minutes_from
                if (has_normal_time[0]) {
                    minutes_from = getMinutesByHoursMinutes(tokens, nrule, at+has_time_var_calc[0]);
                } else {
                    timevar_string[0] = tokens[at+has_time_var_calc[0]][0];
                    minutes_from = word_value_replacement[timevar_string[0]];

                    if (has_time_var_calc[0]) {
                        timevar_add[0] = parseTimevarCalc(tokens, at);
                        minutes_from += timevar_add[0];
                    }
                }

                const at_end_time = at+(has_normal_time[0] ? 3 : (has_time_var_calc[0] ? 7 : 1))+1; // after '-'
                if (!matchTokens(tokens, at_end_time - 1, '-')) { // not time range
                    if (matchTokens(tokens, at_end_time - 1, '+')) {
                        has_open_end = true;
                    } else {
                        if (oh_mode === 0) {
                            throw formatWarnErrorMessage(nrule,
                                at+(
                                    has_normal_time[0] ? (
                                        typeof tokens[at+3] === 'object' ? 3 : 2
                                    ) : (
                                        has_time_var_calc[0] ? 2 : (
                                                typeof tokens[at+1] === 'object' ? 1 : 0
                                            )
                                    )
                                ),
                                t('point in time', {
                                    'calc': (has_time_var_calc[0] ? t('calculation') + ' ' : ''),
                                    'libraryname': library_name
                                }));
                        } else {
                            minutes_to = minutes_from + 1;
                            is_point_in_time = true;
                        }
                    }
                }

                // minutes_to
                if (has_open_end) {
                    if (extended_open_end === 1) {
                        minutes_from += minutes_in_day;
                    }
                    if (minutes_from >= 22 * 60) {

                        minutes_to = minutes_from +  8 * 60;
                    } else if (minutes_from >= 17 * 60) {
                        minutes_to = minutes_from + 10 * 60;
                    } else {
                        minutes_to = minutes_in_day;
                    }
                } else if (!is_point_in_time) {
                    has_normal_time[1] = matchTokens(tokens, at_end_time, 'number', 'timesep', 'number');
                    has_time_var_calc[1]      = matchTokens(tokens, at_end_time, '(', 'timevar');
                    if (!has_normal_time[1] && !matchTokens(tokens, at_end_time, 'timevar') && !has_time_var_calc[1]) {
                        throw formatWarnErrorMessage(nrule, at_end_time - (typeof tokens[at_end_time] === 'object' ? 0 : 1),
                                t('time range continue'));
                    } else {
                        if (has_normal_time[1]) {
                            minutes_to = getMinutesByHoursMinutes(tokens, nrule, at_end_time);
                        } else {
                            timevar_string[1] = tokens[at_end_time+has_time_var_calc[1]][0];
                            minutes_to = word_value_replacement[timevar_string[1]];
                        }

                        if (has_time_var_calc[1]) {
                            timevar_add[1] = parseTimevarCalc(tokens, at_end_time);
                            minutes_to += timevar_add[1];
                        }
                    }
                }

                at = at_end_time + (is_point_in_time ? -1 :
                        (has_normal_time[1] ? 3 : (has_time_var_calc[1] ? 7 : !has_open_end))
                    );

                if (matchTokens(tokens, at, '/', 'number')) {
                    if (matchTokens(tokens, at + 2, 'timesep', 'number')) { // /hours:minutes
                        point_in_time_period = getMinutesByHoursMinutes(tokens, nrule, at + 1);
                        at += 4;
                    } else { // /minutes
                        point_in_time_period = tokens[at + 1][0];
                        at += 2;
                        if (matchTokens(tokens, at, 'timesep'))
                            throw formatWarnErrorMessage(nrule, at,
                                t('period continue'));
                    }

                    // Check at this later state in the if condition to get the correct position.
                    if (oh_mode === 0) {
                        throw formatWarnErrorMessage(nrule, at - 1,
                            t('time range mode', {'libraryname': library_name}));
                    }

                    is_point_in_time = true;
                } else if (matchTokens(tokens, at, '+')) {
                    parseTimeRange(tokens, at_end_time, rule, minutes_to < minutes_from ? 1 : true, nrule);
                    at++;
                } else if (oh_mode === 1 && !is_point_in_time) {
                    throw formatWarnErrorMessage(nrule, at_end_time,
                        t('point in time mode', {'libraryname': library_name}));
                }

                if (typeof lat === 'string') { // lon will also be defined (see above)
                    if (!has_normal_time[0] || !(has_normal_time[1] || has_open_end || is_point_in_time) ) {
                        week_stable = false;
                    }
                } else { // we can not calculate exact times so we use the already applied constants (word_value_replacement).
                    timevar_string = [];
                }

                // Normalize minutes into range.
                if (!extended_open_end && minutes_from >= minutes_in_day) {
                    throw formatWarnErrorMessage(nrule, at_end_time - 2,
                        t('outside current day'));
                }
                if (minutes_to < minutes_from || ((has_normal_time[0] && has_normal_time[1]) && minutes_from === minutes_to)) {
                    minutes_to += minutes_in_day;
                }
                if (minutes_to > minutes_in_day * 2) {
                    throw formatWarnErrorMessage(nrule, at_end_time + (has_normal_time[1] ? 4 : (has_time_var_calc[1] ? 7 : 1)) - 2,
                        t('two midnights'));
                }

                // This shortcut makes always-open range check faster.
                if (minutes_from === 0 && minutes_to === minutes_in_day) {
                    rule.time.push(function() { return [true]; });
                } else {
                    if (minutes_to > minutes_in_day) { // has_normal_time[1] must be true
                        rule.time.push(function(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period, extended_open_end) { return function(date) {
                            const ourminutes = date.getHours() * 60 + date.getMinutes();

                            if (timevar_string[0]) {
                                const date_from = SunCalc.getTimes(date, lat, lon)[timevar_string[0]];
                                minutes_from  = date_from.getHours() * 60 + date_from.getMinutes() + timevar_add[0];
                            }
                            if (timevar_string[1]) {
                                const date_to = SunCalc.getTimes(date, lat, lon)[timevar_string[1]];
                                minutes_to  = date_to.getHours() * 60 + date_to.getMinutes() + timevar_add[1];
                                minutes_to += minutes_in_day;
                                // Needs to be added because it was added by
                                // normal times: if (minutes_to < minutes_from)
                                // above the selector construction.
                            } else if (is_point_in_time && typeof point_in_time_period !== 'number') {
                                minutes_to = minutes_from + 1;
                            }

                            if (typeof point_in_time_period === 'number') {
                                if (ourminutes < minutes_from) {
                                    return [false, dateAtDayMinutes(date, minutes_from)];
                                } else if (ourminutes <= minutes_to) {
                                    for (let cur_min = minutes_from; ourminutes + point_in_time_period >= cur_min; cur_min += point_in_time_period) {
                                        if (cur_min === ourminutes) {
                                            return [true, dateAtDayMinutes(date, ourminutes + 1)];
                                        } else if (ourminutes < cur_min) {
                                            return [false, dateAtDayMinutes(date, cur_min)];
                                        }
                                    }
                                }
                                return [false, dateAtDayMinutes(date, minutes_in_day)];
                            } else {
                                if (ourminutes < minutes_from)
                                    return [false, dateAtDayMinutes(date, minutes_from)];
                                else
                                    return [true, dateAtDayMinutes(date, minutes_to), has_open_end, extended_open_end];
                            }
                        }}(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period, extended_open_end));

                        if (minutes_to - minutes_in_day > 0) {
                            if (typeof rule_infos[nrule] === 'undefined') {
                                rule_infos[nrule] = {};
                            }
                            rule_infos[nrule]['time_wraps_over_midnight'] = true;
                            rule.wraptime.push(function(minutes_to, timevar_string, timevar_add, has_open_end, point_in_time_period, extended_open_end) { return function(date) {
                                const ourminutes = date.getHours() * 60 + date.getMinutes();

                                if (timevar_string[1]) {
                                    const date_to = SunCalc.getTimes(date, lat, lon)[timevar_string[1]];
                                    minutes_to  = date_to.getHours() * 60 + date_to.getMinutes() + timevar_add[1];
                                    // minutes_in_day does not need to be added.
                                    // For normal times in it was added in: if (minutes_to < // minutes_from)
                                    // above the selector construction and
                                    // subtracted in the selector construction call
                                    // which returns the selector function.
                                }

                                if (typeof point_in_time_period === 'number') {
                                    if (ourminutes <= minutes_to) {
                                        for (let cur_min = 0; ourminutes + point_in_time_period >= cur_min; cur_min += point_in_time_period) {
                                            if (cur_min === ourminutes) {
                                                return [true, dateAtDayMinutes(date, ourminutes + 1)];
                                            } else if (ourminutes < cur_min) {
                                                return [false, dateAtDayMinutes(date, cur_min)];
                                            }
                                        }
                                    }
                                } else {
                                    if (ourminutes < minutes_to)
                                        return [true, dateAtDayMinutes(date, minutes_to), has_open_end, extended_open_end];
                                }
                                return [false, undefined];
                            }}(minutes_to - minutes_in_day, timevar_string, timevar_add, has_open_end, point_in_time_period, extended_open_end));
                        }
                    } else {
                        rule.time.push(function(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period) { return function(date) {
                            const ourminutes = date.getHours() * 60 + date.getMinutes();

                            if (timevar_string[0]) {
                                const date_from = SunCalc.getTimes(date, lat, lon)[timevar_string[0]];
                                minutes_from  = date_from.getHours() * 60 + date_from.getMinutes() + timevar_add[0];
                            }
                            if (timevar_string[1]) {
                                const date_to = SunCalc.getTimes(date, lat, lon)[timevar_string[1]];
                                minutes_to  = date_to.getHours() * 60 + date_to.getMinutes() + timevar_add[1];
                            } else if (is_point_in_time && typeof point_in_time_period !== 'number') {
                                minutes_to = minutes_from + 1;
                            }

                            if (typeof point_in_time_period === 'number') {
                                if (ourminutes < minutes_from) {
                                    return [false, dateAtDayMinutes(date, minutes_from)];
                                } else if (ourminutes <= minutes_to) {
                                    for (let cur_min = minutes_from; ourminutes + point_in_time_period >= cur_min; cur_min += point_in_time_period) {
                                        if (cur_min === ourminutes) {
                                            return [true, dateAtDayMinutes(date, ourminutes + 1)];
                                        } else if (ourminutes < cur_min) {
                                            return [false, dateAtDayMinutes(date, cur_min)];
                                        }
                                    }
                                }
                                return [false, dateAtDayMinutes(date, minutes_in_day)];
                            } else {
                                if (ourminutes < minutes_from)
                                    return [false, dateAtDayMinutes(date, minutes_from)];
                                else if (ourminutes < minutes_to)
                                    return [true, dateAtDayMinutes(date, minutes_to), has_open_end];
                                else
                                    return [false, dateAtDayMinutes(date, minutes_from + minutes_in_day)];
                            }
                        }}(minutes_from, minutes_to, timevar_string, timevar_add, has_open_end, is_point_in_time, point_in_time_period));
                    }
                }

            } else if (matchTokens(tokens, at, 'number', '-', 'number')) { // "Mo 09-18" (Please don’t use this) -> "Mo 09:00-18:00".
                minutes_from = tokens[at][0]   * 60;
                minutes_to   = tokens[at+2][0] * 60;
                if (!done_with_warnings) {
                    parsing_warnings.push([nrule, at + 2, t('without minutes', {
                        'syntax': (tokens[at][0]   < 10 ? '0' : '') + tokens[at][0]   + ':00-'
                                + (tokens[at+2][0] < 10 ? '0' : '') + tokens[at+2][0] + ':00'
                    })]);
                }

                if (minutes_from >= minutes_in_day)
                    throw formatWarnErrorMessage(nrule, at, t('outside day'));
                if (minutes_to < minutes_from)
                    minutes_to += minutes_in_day;
                if (minutes_to > minutes_in_day * 2)
                    throw formatWarnErrorMessage(nrule, at + 2, t('two midnights'));

                if (minutes_to > minutes_in_day) {
                    rule.time.push(function(minutes_from, minutes_to) { return function(date) {
                        const ourminutes = date.getHours() * 60 + date.getMinutes();

                        if (ourminutes < minutes_from)
                            return [false, dateAtDayMinutes(date, minutes_from)];
                        else
                            return [true, dateAtDayMinutes(date, minutes_to)];
                    }}(minutes_from, minutes_to));

                    if (minutes_to - minutes_in_day > 0) {
                        if (typeof rule_infos[nrule] === 'undefined') {
                            rule_infos[nrule] = {};
                        }
                        rule_infos[nrule]['time_wraps_over_midnight'] = true;
                        rule.wraptime.push(function(minutes_to) { return function(date) {
                            const ourminutes = date.getHours() * 60 + date.getMinutes();

                            if (ourminutes < minutes_to) {
                                return [true, dateAtDayMinutes(date, minutes_to)];
                            } else {
                                return [false, undefined];
                            }
                        }}(minutes_to - minutes_in_day));
                    }
                } else {
                    rule.time.push(function(minutes_from, minutes_to) { return function(date) {
                        const ourminutes = date.getHours() * 60 + date.getMinutes();

                        if (ourminutes < minutes_from)
                            return [false, dateAtDayMinutes(date, minutes_from)];
                        else if (ourminutes < minutes_to)
                            return [true, dateAtDayMinutes(date, minutes_to), has_open_end];
                        else
                            return [false, dateAtDayMinutes(date, minutes_from + minutes_in_day)];
                    }}(minutes_from, minutes_to));
                }

                at += 3;
            } else { // additional rule
                if (matchTokens(tokens, at, '('))
                    throw formatWarnErrorMessage(nrule, at, 'Missing variable time (e.g. sunrise) after: "' + tokens[at][1] + '"');
                if (matchTokens(tokens, at, 'number', 'timesep'))
                    throw formatWarnErrorMessage(nrule, at+1, 'Missing minutes in time range after: "' + tokens[at+1][1] + '"');
                if (matchTokens(tokens, at, 'number'))
                    throw formatWarnErrorMessage(nrule, at + (typeof tokens[at+1] === 'object' ? 1 : 0),
                            'Missing time separator in time range after: "' + tokens[at][1] + '"');
                return [ at ];
            }

            if (!matchTokens(tokens, at, ',')) {
                break;
            }

            if (typeof tokens[at+1] === 'undefined' && !done_with_warnings) {
                parsing_warnings.push([nrule, at, t('value ends with token', { 'token': tokens[at][1] }) ]);
            }
        }

        return at;
    }
    /* }}} */

    /* Helpers for time range parser {{{ */

    /* Get time in minutes from <hour>:<minute> (tokens). {{{
     * Only used if throwing an error is wanted.
     *
     * :param tokens: List of token objects.
     * :param nrule: Rule number starting with 0.
     * :param at: Position at which the time begins.
     * :returns: Time in minutes.
     */
    function getMinutesByHoursMinutes(tokens, nrule, at) {
        if (tokens[at+2][0] > 59)
            throw formatWarnErrorMessage(nrule, at+2,
                    'Minutes are greater than 59.');
        return tokens[at][0] * 60 + tokens[at+2][0];
    }
    /* }}} */

    /* Get time in minutes from "(sunrise-01:30)" {{{
     * Extract the added or subtracted time from "(sunrise-01:30)"
     * returns time in minutes e.g. -90.
     *
     * :param tokens: List of token objects.
     * :param at: Position where the specification for the point in time could be.
     * :returns: Time in minutes on suggest, throws an exception otherwise.
    */
    function parseTimevarCalc(tokens, at) {
        let error;
        if (matchTokens(tokens, at+2, '+') || matchTokens(tokens, at+2, '-')) {
            if (matchTokens(tokens, at+3, 'number', 'timesep', 'number')) {
                if (matchTokens(tokens, at+6, ')')) {
                    const add_or_subtract = tokens[at+2][0] === '+' ? '1' : '-1';
                    const minutes = getMinutesByHoursMinutes(tokens, nrule, at+3) * add_or_subtract;
                    if (minutes === 0)
                        parsing_warnings.push([ nrule, at+5, t('zero calculation') ]
                            );
                    return minutes;
                } else {
                    error = [ at+6, '. ' + t('missing', {'symbol': ')'}) + '.'];
                }
            } else if (matchTokens(tokens, at+3, 'number') && matchTokens(tokens, at+4, ')')) {
                // User likely meant hours without minutes, e.g. (sunset-1) instead of (sunset-01:00)
                const hours = ('0' + tokens[at+3][0]).slice(-2);
                const suggestion = '(' + tokens[at+1][0] + tokens[at+2][0] + hours + ':00)';
                throw formatWarnErrorMessage(nrule, at+3,
                    t('time offset hours only', { suggestion: suggestion }));
            } else {
                error = [ at+5, ' ' + t('(time)') + '.'];
            }
        } else {
            error = [ at+2, '. ' + t('expected', {'symbol': '+" or "-'})];
        }

        if (error)
            throw formatWarnErrorMessage(nrule, error[0],
                 t('calculation syntax')+ error[1]);
    }
    /* }}} */
    /* }}} */

    /* Weekday range parser (Mo,We-Fr,Sa[1-2,-1],PH). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where the weekday tokens could be.
     * :param rule: Reference to rule object.
     * :param nrule: Rule number starting with 0.
     * :returns: Position at which the token does not belong to the selector anymore.
     */
    function parseWeekdayRange(tokens, at, rule, in_holiday_selector, nrule) {
        if (!in_holiday_selector) {
            in_holiday_selector = true;
            tokens[at][3] = 'weekday';
        }

        for (; at < tokens.length; at++) {
            if (matchTokens(tokens, at, 'weekday', '[')) {
                // Conditional weekday (Mo[3])
                const numbers = [];

                // Get list of constraints
                const endat = parseNumRange(tokens, at+2, function(from, to, at) {

                    // bad number
                    if (from === 0 || from < -5 || from > 5)
                        throw formatWarnErrorMessage(nrule, at,
                            t('number -5 to 5'));

                    if (from === to) {
                        numbers.push(from);
                    } else if (from < to) {
                        for (let i = from; i <= to; i++) {
                            // bad number
                            if (i === 0 || i < -5 || i > 5)
                                throw formatWarnErrorMessage(nrule, at+2,
                                    t('number -5 to 5'));

                            numbers.push(i);
                        }
                    } else {
                        throw formatWarnErrorMessage(nrule, at+2,
                            t('bad range',{'from': from, 'to': to}));
                    }
                });

                if (!matchTokens(tokens, endat, ']')) {
                    throw formatWarnErrorMessage(
                        nrule,
                        endat + (typeof tokens[endat] === 'object' ? 0 : -1),
                        t('] or more numbers')
                    );
                }

                const add_days = getMoveDays(tokens, endat+1, 6, 'constrained weekdays');
                week_stable = false;

                // Create selector for each list element.
                for (let nnumber = 0; nnumber < numbers.length; nnumber++) {

                    rule.weekday.push(function(weekday, number, add_days) { return function(date) {
                        const date_num = getValueForDate(date, false); // Year not needed to distinguish.
                        const start_of_this_month = new Date(date.getFullYear(), date.getMonth(), 1);
                        const start_of_next_month = new Date(date.getFullYear(), date.getMonth() + 1, 1);

                        const target_day_this_month = getDateForConstrainedWeekday(date.getFullYear(), date.getMonth(), weekday, [ number ]);

                        let target_day_with_added_days_this_month = new Date(target_day_this_month.getFullYear(),
                            target_day_this_month.getMonth(), target_day_this_month.getDate() + add_days);

                        // The target day with added days can be before this month
                        if (target_day_with_added_days_this_month.getTime() < start_of_this_month.getTime()) {
                            // but in this case, the target day without the days added needs to be in this month
                            if (target_day_this_month.getTime() >= start_of_this_month.getTime()) {
                                // so we calculate it for the month
                                // following this month and hope that the
                                // target day will actually be this month.

                                target_day_with_added_days_this_month = dateAtNextWeekday(
                                    new Date(date.getFullYear(), date.getMonth() + (number > 0 ? 0 : 1) + 1, 1), weekday);
                                target_day_this_month.setDate(target_day_with_added_days_this_month.getDate()
                                    + (number + (number > 0 ? -1 : 0)) * 7 + add_days);
                            } else {
                                // Calculated target day is not inside this month
                                // therefore the specified weekday (e.g. fifth Sunday)
                                // does not exist this month. Try it next month.
                                return [false, start_of_next_month];
                            }
                        } else if (target_day_with_added_days_this_month.getTime() >= start_of_next_month.getTime()) {
                            // The target day is in the next month. If the target day without the added days is not in this month
                            if (target_day_this_month.getTime() >= start_of_next_month.getTime())
                                return [false, start_of_next_month];
                        }

                        let target_day_with_added_moved_days_this_month;
                        if (add_days > 0) {
                            target_day_with_added_moved_days_this_month = dateAtNextWeekday(
                                new Date(date.getFullYear(), date.getMonth() + (number > 0 ? 0 : 1) -1, 1), weekday);
                            target_day_with_added_moved_days_this_month.setDate(target_day_with_added_moved_days_this_month.getDate()
                                + (number + (number > 0 ? -1 : 0)) * 7 + add_days);

                            if (date_num === getValueForDate(target_day_with_added_moved_days_this_month, false))
                                return [true, dateAtDayMinutes(date, minutes_in_day)];
                        } else if (add_days < 0) {
                            target_day_with_added_moved_days_this_month = dateAtNextWeekday(
                                new Date(date.getFullYear(), date.getMonth() + (number > 0 ? 0 : 1) + 1, 1), weekday);
                            target_day_with_added_moved_days_this_month.setDate(target_day_with_added_moved_days_this_month.getDate()
                                + (number + (number > 0 ? -1 : 0)) * 7 + add_days);

                            if (target_day_with_added_moved_days_this_month.getTime() >= start_of_next_month.getTime()) {
                                if (target_day_with_added_days_this_month.getTime() >= start_of_next_month.getTime())
                                    return [false, target_day_with_added_moved_days_this_month];
                            } else {
                                if (target_day_with_added_days_this_month.getTime() < start_of_next_month.getTime()
                                    && getValueForDate(target_day_with_added_days_this_month, false) === date_num)
                                    return [true, dateAtDayMinutes(date, minutes_in_day)];

                                target_day_with_added_days_this_month = target_day_with_added_moved_days_this_month;
                            }
                        }

                        // we hit the target day
                        const currentDateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                        const targetDateOnly = new Date(target_day_with_added_days_this_month.getFullYear(), target_day_with_added_days_this_month.getMonth(), target_day_with_added_days_this_month.getDate());

                        if (currentDateOnly.getTime() === targetDateOnly.getTime()) {
                            return [true, dateAtDayMinutes(date, minutes_in_day)];
                        }

                        // we're before target day
                        if (currentDateOnly.getTime() < targetDateOnly.getTime()) {
                            return [false, target_day_with_added_days_this_month];
                        }

                        // we're after target day, set check date to next month
                        return [false, start_of_next_month];
                    }}(tokens[at][0], numbers[nnumber], add_days[0]));
                }

                at = endat + 1 + add_days[1];
            } else if (matchTokens(tokens, at, 'weekday')) {
                // Single weekday (Mo) or weekday range (Mo-Fr)
                const is_range = matchTokens(tokens, at+1, '-', 'weekday');

                let weekday_from = tokens[at][0];
                let weekday_to = is_range ? tokens[at+2][0] : weekday_from;

                let inside = true;

                // handle reversed range
                if (weekday_to < weekday_from) {
                    const tmp = weekday_to;
                    weekday_to = weekday_from - 1;
                    weekday_from = tmp + 1;
                    inside = false;
                }
                const weekday_list = Array.apply(0, Array(weekday_to - weekday_from + 1)).map(function (_, index) {
                    return index + weekday_to;
                });
                if (typeof rule_infos[nrule] === 'undefined') {
                    rule_infos[nrule] = {};
                }
                if (typeof rule_infos[nrule]['week_days'] === 'object') {
                    Array.prototype.push.apply(rule_infos[nrule]['week_days'], weekday_list);
                } else {
                    rule_infos[nrule]['week_days'] = weekday_list;
                }

                if (weekday_to < weekday_from) { // handle full range
                    rule.weekday.push(function() { return [true]; });
                    // Not needed. If there is no selector it automatically matches everything.
                    // WRONG: This only works if there is no other selector in this selector group ...
                } else {
                    rule.weekday.push(function(weekday_from, weekday_to, inside) { return function(date) {
                        const ourweekday = date.getDay();

                        if (ourweekday < weekday_from || ourweekday > weekday_to) {
                            return [!inside, dateAtNextWeekday(date, weekday_from)];
                        } else {
                            return [inside, dateAtNextWeekday(date, weekday_to + 1)];
                        }
                    }}(weekday_from, weekday_to, inside));
                }

                at += is_range ? 3 : 1;
            } else if (matchTokens(tokens, at, 'holiday')) {
                week_stable = false;
                return parseHoliday(tokens, at, rule, true, in_holiday_selector);
            } else if (matchTokens(tokens, at - 1, ',')) { // additional rule
                throw formatWarnErrorMessage(
                    nrule,
                    at - 1,
                    t('additional rule no sense'));
            } else {
                throw formatWarnErrorMessage(nrule, at, t('unexpected token weekday range', {'token': tokens[at][1]}));
            }

            if (!matchTokens(tokens, at, ',')) {
                break;
            }
        }

        return at;
    }
    /* }}} */

    /* Get the number of days a date should be moved (if any). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where the date moving tokens could be.
     * :param max_differ: Maximal number of days to move (could also be zero if there are no day move tokens).
     * :returns: Array:
     *            0. Days to add.
     *            1. How many tokens.
     */
    function getMoveDays(tokens, at, max_differ, name) {
        const add_days = [ 0, 0 ]; // [ 'days to add', 'how many tokens' ]
        add_days[0] = matchTokens(tokens, at, '+') || (matchTokens(tokens, at, '-') ? -1 : 0);
        if (add_days[0] !== 0 && matchTokens(tokens, at+1, 'number', 'calcday')) {
            // continues with '+ 5 days' or something like that
            if (tokens[at+1][0] > max_differ)
                throw formatWarnErrorMessage(nrule, at+2,
                    t('max differ',{'maxdiffer': max_differ, 'name': name}));
            add_days[0] *= tokens[at+1][0];
            if (add_days[0] === 0 && !done_with_warnings)
                parsing_warnings.push([ nrule, at+2, t('adding 0') ]);
            add_days[1] = 3;
        } else {
            add_days[0] = 0;
        }
        return add_days;
    }
    /* }}} */


    /* Parses a single holiday token (PH or SH) and adds the selector to the rule. {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position of the holiday token.
     * :param target_array: Array to push the selector to (rule.weekday or rule.holiday).
     * :returns: New token position after this holiday token.
     */
    function parseSingleHolidayToken(tokens, at, target_array) {
        const holiday_type = tokens[at][0];
        const applying_holidays = getMatchingHoliday(holiday_type);

        if (holiday_type === 'PH') {
            const add_days = getMoveDays(tokens, at + 1, 1, 'public holiday');
            const selector = createPublicHolidaySelector(applying_holidays, add_days);
            target_array.push(selector);
            return at + 1 + add_days[1];
        } else { // SH
            const selector = createSchoolHolidaySelector(applying_holidays);
            target_array.push(selector);
            return at + 1;
        }
    }
    /* }}} */


    /* Holiday parser for public and school holidays (PH,SH) {{{
     *
     * Handles holiday tokens followed by optional weekday selectors:
     * - "PH" → public holiday
     * - "PH,SH" → public holiday or school holiday
     * - "PH Mo-Fr" → public holiday that falls on Monday-Friday
     * - "SH" → school holiday periods
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param rule: Reference to rule object.
     * :param push_to_weekday: Will push the selector into the weekday selector array which has the desired side effect of working in conjunction with the weekday selectors (either the holiday match or the weekday), which is the normal and expected behavior.
     * :returns: Position at which the token does not belong to the selector anymore.
     */
    function parseHoliday(tokens, at, rule, push_to_weekday, in_holiday_selector) {
        if (!in_holiday_selector) {
            tokens[at][3] = push_to_weekday ? 'weekday' : 'holiday';
        }

        const target_array = push_to_weekday ? rule.weekday : rule.holiday;

        while (at < tokens.length) {
            if (matchTokens(tokens, at, 'holiday')) {
                at = parseSingleHolidayToken(tokens, at, target_array);
            } else if (matchTokens(tokens, at, 'weekday')) {
                return parseWeekdayRange(tokens, at, rule, true, nrule);
            } else if (matchTokens(tokens, at - 1, ',')) {
                throw formatWarnErrorMessage(
                    nrule,
                    at - 1,
                    t('additional rule no sense'));
            } else {
                throw formatWarnErrorMessage(nrule, at, t('unexpected token holiday', {'token': tokens[at][1]}));
            }

            // Continue only if followed by comma separator
            if (!matchTokens(tokens, at, ','))
                break;

            at++; // Skip comma
        }

        return at;
    }
    /* }}} */

    // Helpers for holiday parsers {{{

    /* Returns a number for a date which can then be used to compare just the dates (without the time). {{{
     *
     * This is necessary because a selector could be called for the middle of the day and we need to tell if it matches that day.
     * Example: Returns 20150015 for Jan 15 2015.
     *
     * :param date: Date object.
     * :param include_year: Boolean. If true include the year.
     * :returns: Number for the date.
     */
    function getValueForDate(date, include_year) {
        // Implicit because undefined evaluates to false.
        // include_year = typeof include_year !== 'undefined' ? include_year : false;

        return (include_year ? (date.getFullYear() * 10000) : 0) + (date.getMonth() * 100) + date.getDate();
    }
    /* }}} */

    /* Return the school holiday definition e.g. [ 5, 25, to 6, 5 ], for the specified year {{{
     *
     * :param SH_hash:
     * :param year: Year as integer.
     * :param fatal: Defines the behavior in case no definition is find. Throw an error if set to true. Return return undefined otherwise.
     * :returns: school holidays for the given year.
     */
    function getSHForYear(SH_hash, year, fatal) {

        let holiday = SH_hash[year];
        if (typeof holiday === 'undefined') {
            holiday = SH_hash['default']; // applies for any year without explicit definition
            if (typeof holiday === 'undefined') {
                {
                    return undefined;
                }
            }
        }
        return holiday;
    }
    /* }}} */

    /* Convert month and day to a comparable number (month * 100 + day). {{{
     * For example: Jan 15 -> 115, Dec 25 -> 1225
     *
     * :param month: Month as integer (1-12).
     * :param day: Day as integer (1-31).
     * :returns: Number for comparison.
     */
    function getDateNumber(month, day) {
        return (month - 1) * 100 + day;
    }
    /* }}} */

    /* Collect all school holiday ranges for a given year from multiple holiday definitions. {{{
     *
     * :param applying_holidays: Array of holiday definition objects.
     * :param year: Year as integer.
     * :returns: Array of range objects with from_month, from_day, to_month, to_day, name, holiday_obj.
     */
    function collectSHRangesForYear(applying_holidays, year) {
        const all_ranges = [];
        for (let i = 0; i < applying_holidays.length; i++) {
            const holiday = getSHForYear(applying_holidays[i], year);
            if (typeof holiday === 'undefined') {
                continue;
            }
            for (let h = 0; h < holiday.length; h += 4) {
                all_ranges.push({
                    from_month: holiday[0 + h],
                    from_day: holiday[1 + h],
                    to_month: holiday[2 + h],
                    to_day: holiday[3 + h],
                    name: applying_holidays[i].name,
                    holiday_obj: applying_holidays[i]
                });
            }
        }
        return all_ranges;
    }
    /* }}} */

    /* Sort holiday ranges by their start date (chronologically). {{{
     *
     * :param ranges: Array of range objects (will be sorted in-place).
     * :returns: The sorted ranges array.
     */
    function sortRangesByStartDate(ranges) {
        return ranges.sort((a, b) => {
            const a_from = getDateNumber(a.from_month, a.from_day);
            const b_from = getDateNumber(b.from_month, b.from_day);
            return a_from - b_from;
        });
    }
    /* }}} */

    /* Create a school holiday selector function for checking if a date falls within school holidays. {{{
     *
     * :param applying_holidays: Array of school holiday definition objects.
     * :returns: Selector function that checks if a date is within school holiday ranges.
     */
    function createSchoolHolidaySelector(applying_holidays) {
        return function(date) {
            const date_num = getValueForDate(date);
            const year = date.getFullYear();

            // Collect all holiday ranges from all holiday types for this year,
            // sorted chronologically by start date.
            const all_ranges = collectSHRangesForYear(applying_holidays, year);
            sortRangesByStartDate(all_ranges);

            // Check for holidays from last year spanning into this year
            for (let i = 0; i < applying_holidays.length; i++) {
                const last_year_holiday = getSHForYear(applying_holidays[i], year - 1);
                if (typeof last_year_holiday === 'object') {
                    // Check the last range of this holiday type from last year
                    const last_idx = last_year_holiday.length - 4;
                    const last_year_holiday_from = getDateNumber(last_year_holiday[last_idx], last_year_holiday[last_idx + 1]);
                    const last_year_holiday_to = getDateNumber(last_year_holiday[last_idx + 2], last_year_holiday[last_idx + 3]);

                    // If holiday spans into next year and we're still in that period
                    if (last_year_holiday_from > last_year_holiday_to && date_num <= last_year_holiday_to) {
                        return [true, new Date(year,
                            last_year_holiday[last_idx + 2] - 1,
                            last_year_holiday[last_idx + 3] + 1),
                            applying_holidays[i].name];
                    }
                }
            }

            // Check each holiday range
            for (let r = 0; r < all_ranges.length; r++) {
                const range = all_ranges[r];
                const holiday_from = getDateNumber(range.from_month, range.from_day);
                const holiday_to = getDateNumber(range.to_month, range.to_day);
                const holiday_ends_next_year = holiday_to < holiday_from;

                if (date_num < holiday_from) {
                    // Date is before this holiday range - return false with next holiday start
                    return [false, new Date(year, range.from_month - 1, range.from_day)];
                } else if (holiday_from <= date_num && (date_num <= holiday_to || holiday_ends_next_year)) {
                    // Date is within this holiday range
                    return [true, new Date(year + holiday_ends_next_year, range.to_month - 1, range.to_day + 1),
                        range.name];
                }
                // Date is after this holiday range - check next range
            }

            // Date is after all holidays this year - check next year's first holiday
            const next_year_ranges = [];
            for (let i = 0; i < applying_holidays.length; i++) {
                const holiday = getSHForYear(applying_holidays[i], year + 1);
                if (typeof holiday === 'undefined') {
                    continue;
                }
                next_year_ranges.push({
                    from_month: holiday[0],
                    from_day: holiday[1],
                    name: applying_holidays[i].name
                });
            }
            if (next_year_ranges.length > 0) {
                sortRangesByStartDate(next_year_ranges);
                return [false, new Date(year + 1, next_year_ranges[0].from_month - 1, next_year_ranges[0].from_day)];
            }

            throw formatLibraryBugMessage(t('no SH definition', {
                'name': '',
                'year': year,
            }), 'library bug PR only');
        };
    }
    /* }}} */

    /* Create a selector function for public holidays (PH). {{{
     *
     * :param applying_holidays: Array of holiday definition objects.
     * :param add_days: Array [days_to_add, token_count] from getMoveDays().
     * :returns: Selector function that checks if a date matches a public holiday.
     */
    function createPublicHolidaySelector(applying_holidays, add_days) {
        return function(date) {
            const holidays = getApplyingHolidaysForYear(applying_holidays, date.getFullYear(), add_days);
            // Needs to be calculated each time because of movable days.

            const date_num = getValueForDate(date, true);

            for (let i = 0; i < holidays.length; i++) {
                const next_holiday_date_num = getValueForDate(holidays[i][0], true);

                if (date_num < next_holiday_date_num) {

                    if (add_days[0] > 0) {
                        // Calculate the last holiday from previous year to tested against it.
                        const holidays_last_year = getApplyingHolidaysForYear(applying_holidays, date.getFullYear() - 1, add_days);
                        const last_holiday_last_year = holidays_last_year[holidays_last_year.length - 1];
                        const last_holiday_last_year_num = getValueForDate(last_holiday_last_year[0], true);

                        if (date_num < last_holiday_last_year_num ) {
                            return [ false, last_holiday_last_year[0] ];
                        } else if (date_num === last_holiday_last_year_num) {
                            return [true, dateAtDayMinutes(last_holiday_last_year[0], minutes_in_day),
                                'Day after ' +last_holiday_last_year[1] ];
                        }
                    }

                    return [ false, holidays[i][0] ];
                } else if (date_num === next_holiday_date_num) {
                    return [true, new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1),
                        (add_days[0] > 0 ? 'Day after ' : (add_days[0] < 0 ? 'Day before ' : '')) + holidays[i][1] ];
                }
            }

            if (add_days[0] < 0) {
                // Calculate the first holiday from next year to tested against it.
                const holidays_next_year = getApplyingHolidaysForYear(applying_holidays, date.getFullYear() + 1, add_days);
                const first_holidays_next_year = holidays_next_year[0];
                const first_holidays_next_year_num = getValueForDate(first_holidays_next_year[0], true);
                if (date_num === first_holidays_next_year_num) {
                    return [true, dateAtDayMinutes(first_holidays_next_year[0], minutes_in_day),
                        'Day before ' + first_holidays_next_year[1] ];
                }
            }

            // continue next year
            return [ false, new Date(holidays[0][0].getFullYear() + 1,
                    holidays[0][0].getMonth(),
                    holidays[0][0].getDate()) ];
        };
    }
    /* }}} */

    /* Return closest holiday definition available. {{{
     *
     * First try to get the state, if missing get the country wide holidays
     * (which can on it’s own be limited to some states).
     *
     * :param type_of_holidays: Choices: PH, SH.
     * :returns: Public or school holiday list.
     */
    function getMatchingHoliday(type_of_holidays) {
        if (typeof location_cc !== 'string') {
            /* We have no idea which holidays do apply because the country code was not provided. */
            throw t('no country code');
        }

        if (!holiday_definitions[location_cc]) {
            throw formatLibraryBugMessage(t('no holiday definition', {
                'name': type_of_holidays,
                'cc': location_cc,
            }), 'library bug PR only');
        }

        let matching_holiday = [];
        if (typeof location_state === 'string'
            && typeof holiday_definitions[location_cc][location_state] === 'object'
            && typeof holiday_definitions[location_cc][location_state][type_of_holidays] === 'object') {

            /* If holiday_definitions for the state are specified,
             * use it and ignore lesser specific ones (for the
             * country).
             */

            const country_holidays = holiday_definitions[location_cc][type_of_holidays] || [];
            const state_holidays = holiday_definitions[location_cc][location_state][type_of_holidays];
            if (type_of_holidays === 'PH') {
                matching_holiday = state_holidays;
            } else if (!country_holidays.length) {
                matching_holiday = state_holidays;
            } else {
                // Merge country and state holidays chronologically
                const country_holiday_names = country_holidays.map(function(country_holiday) {
                    return country_holiday.name;
                });
                matching_holiday.push.apply(matching_holiday, country_holidays);
                matching_holiday.push.apply(matching_holiday, state_holidays.filter(function is_not_a_country_holiday(state_holiday) {
                    return country_holiday_names.indexOf(state_holiday.name) === -1;
                }));
                matching_holiday.sort(function(h1, h2) {
                    const h1_year = Object.keys(h1).find(function(k) {return k !== 'name';});
                    const h2_year = Object.keys(h2).find(function(k) {return k !== 'name';});
                    const h1_date = h1[h1_year];
                    const h2_date = h2[h2_year];
                    // compare both months, or to break a tie both days
                    return (h1_date[0] - h2_date[0]) || (h1_date[1] - h2_date[1]);
                });
            }
        } else if (holiday_definitions[location_cc][type_of_holidays]) {
            /* Holidays are defined country wide. Some
             * countries only have country-wide holiday definitions
             * so that is ok too.
             */
            const applying_holidays_for_country = holiday_definitions[location_cc][type_of_holidays];

            switch (type_of_holidays) {
                case 'PH':
                    applying_holidays_for_country.forEach(function (holiday_item) {
                        /* Holidays in the country-wide scope can be limited to certain states. */
                        if ('only_states' in holiday_item) {
                            if (-1 === holiday_item.only_states.indexOf(location_state)) {
                                return;
                            }
                        }

                        matching_holiday.push(holiday_item);
                    });
                    break;
                case 'SH':
                    matching_holiday = applying_holidays_for_country;
                    break;
            }
        } else {
            throw formatLibraryBugMessage(t('no holiday definition state', {
                'name': type_of_holidays,
                'cc': location_cc,
                'state': location_state,
            }), 'library bug PR only');
        }

        if (matching_holiday.length === 0) {
            throw formatLibraryBugMessage(t('no holiday definition', {
                'name': type_of_holidays,
                'cc': location_cc,
            }), 'library bug PR only');
        }

        return matching_holiday;
    }
    /* }}} */

    /* Return variable dates used for holiday calculation. {{{
     *
     * :param year: Year as integer.
     * :returns: Hash of variables dates. Key is the name of the variable date. Value is the variable date date object.
     */
    function getMovableEventsForYear(year) {
        /* Calculate easter {{{ */
        const C = Math.floor(year/100);
        const N = year - 19*Math.floor(year/19);
        const K = Math.floor((C - 17)/25);
        let I = C - Math.floor(C/4) - Math.floor((C - K)/3) + 19*N + 15;
        I = I - 30*Math.floor((I/30));
        I = I - Math.floor(I/28)*(1 - Math.floor(I/28)*Math.floor(29/(I + 1))*Math.floor((21 - N)/11));
        let J = year + Math.floor(year/4) + I + 2 - C + Math.floor(C/4);
        J = J - 7*Math.floor(J/7);
        const L = I - J;
        const M = 3 + Math.floor((L + 40)/44);
        const D = L + 28 - 31*Math.floor(M/4);
        /* }}} */

        /* Calculate orthodox easter {{{ */
        const oA = year % 4;
        const oB = year % 7;
        const oC = year % 19;
        const oD = (19*oC + 15) % 30;
        const oE = (2*oA+4*oB - oD + 34) % 7;
        const oF = oD+oE;

        let oDate;
        if (oF < 9) {
            oDate = new Date(year, 4-1, oF+4);
        } else {
            if ((oF+4)<31) {
                oDate = new Date(year, 4-1, oF+4);
            } else {
                oDate = new Date(year, 5-1, oF-26);
            }
        }
        /* }}} */

        /* Calculate last Sunday in February {{{ */
        const lastFebruaryDay = new Date(year, 2, 0);
        const lastFebruarySunday = lastFebruaryDay.getDate() - lastFebruaryDay.getDay();
        /* }}} */

        /* Calculate Victoria Day. last Monday before or on May 24 {{{ */
        const may_24 = new Date(year, 4, 24);
        const victoriaDay = 24  - ((6 + may_24.getDay()) % 7);
        /* }}} */

        /* Calculate Canada Day. July 1st unless 1st is on Sunday, then July 2. {{{ */
        const july_1 = new Date(year, 6, 1);
        const canadaDay = july_1.getDay() === 0 ? 2 : 1;
        /* }}} */

        /* Calculation of the spring and autumnal equinoxes (for Public holidays in Japan). {{{ */
        function springEquinoxCalc(year){
            if(year >= 1900 && year <= 1923){
                if(year % 4 === 3) return new Date(year, 2, 22)
                else return new Date(year, 2, 21)
            } else if(year >= 1924 && year <= 1959){
                return new Date(year, 2, 21)
            } else if(year >= 1960 && year <= 1991){
                if(year % 4 === 0) return new Date(year, 2, 20)
                else return new Date(year, 2, 21)
            } else if(year >= 1992 && year <= 2023){
                if(year % 4 === 0 || year % 4 === 1) return new Date(year, 2, 20)
                else return new Date(year, 2, 21)
            } else if(year >= 2024 && year <= 2055){
                if(year % 4 === 3) return new Date(year, 2, 21)
                else return new Date(year, 2, 20)
            } else if(year >= 2056 && year <= 2091){
                return new Date(year, 2, 20)
            } else if(year >= 2092 && year <= 2099){
                if(year % 4 === 0) return new Date(year, 2, 19)
                else return new Date(year, 2, 20)
            }
        }

        function autumnalEquinoxCalc(year){
            if(year >= 1900 && year <= 1919){
                if(year % 4 === 0) return new Date(year, 8, 23)
                else return new Date(year, 8, 24)
            } else if(year >= 1920 && year <= 1947){
                if(year % 4 === 0 || year % 4 === 1) return new Date(year, 8, 23)
                else return new Date(year, 8, 24)
            } else if(year >= 1948 && year <= 1979){
                if(year % 4 === 3) return new Date(year, 8, 24)
                else return new Date(year, 8, 23)
            } else if(year >= 1980 && year <= 2011){
                return new Date(year, 8, 23)
            } else if(year >= 2012 && year <= 2043){
                if(year % 4 === 0) return new Date(year, 8, 22)
                else return new Date(year, 8, 23)
            }  else if(year >= 2044 && year <= 2075){
                if(year % 4 === 0 || year % 4 === 1) return new Date(year, 8, 22)
                else return new Date(year, 8, 23)
            } else if(year >= 2076 && year <= 2099){
                if(year % 4 === 3) return new Date(year, 8, 23)
                else return new Date(year, 8, 22)
            }
        }

        /* Helper functions {{{ */
        function firstWeekdayOfMonth(month, weekday){
            const first = new Date(year, month, 1);
            return 1 + ((7 + weekday - first.getDay()) % 7);
        }

        function lastWeekdayOfMonth(month, weekday){
            const last = new Date(year, month+1, 0);
            const offset = ((7 + last.getDay() - weekday) % 7);
            return last.getDate() - offset;
        }

        function getDateOfWeekdayInDateRange(weekday, start_date){
            let days_to_dest_date = weekday - start_date.getDay();
            if (days_to_dest_date < 0) {
                days_to_dest_date += 7;
            }
            start_date.setDate(start_date.getDate() + days_to_dest_date);
            return start_date;
        }

        /* Date of next weekday range. {{{
         *
         * :param first_weekday: First weekday in range of wanted weekday (1 is Mo).
         * :param last_weekday: Last weekday in range of wanted weekday (1 is Mo).
         * :param start_date: Earliest possible date to consider.
         * :returns: start_date if in weekday range, otherwise the next day which is in range.
         */
        function getDateOfNextWeekdayRange(first_weekday, last_weekday, start_date){
            if (first_weekday >= last_weekday) {
                throw formatLibraryBugMessage('Not implemented yet.');
            }

            if (first_weekday <= start_date.getDay() && start_date.getDay() <= last_weekday) {
                return start_date;
            } else {
                let days_to_dest_date = first_weekday - start_date.getDay();
                if (days_to_dest_date < 0) {
                    days_to_dest_date += 7;
                }
                start_date.setDate(start_date.getDate() + days_to_dest_date);
                return start_date;
            }

        }
        /* }}} */

        return {
            'easter'                : new Date(year, M - 1, D),
            'orthodox easter'       : oDate,
            'victoriaDay'           : new Date(year,  4, victoriaDay),
            'canadaDay'             : new Date(year,  6, canadaDay),
            'firstJanuaryMonday'    : new Date(year,  0, firstWeekdayOfMonth(0, 1)),
            'firstFebruaryMonday'   : new Date(year,  1, firstWeekdayOfMonth(1, 1)),
            'lastFebruarySunday'    : new Date(year,  1, lastFebruarySunday),
            'firstMarchMonday'      : new Date(year,  2, firstWeekdayOfMonth(2, 1)),
            'firstAprilMonday'      : new Date(year,  3, firstWeekdayOfMonth(3, 1)),
            'firstMayMonday'        : new Date(year,  4, firstWeekdayOfMonth(4, 1)),
            'firstJuneMonday'       : new Date(year,  5, firstWeekdayOfMonth(5, 1)),
            'firstJulyMonday'       : new Date(year,  6, firstWeekdayOfMonth(6, 1)),
            'firstAugustMonday'     : new Date(year,  7, firstWeekdayOfMonth(7, 1)),
            'firstSeptemberMonday'  : new Date(year,  8, firstWeekdayOfMonth(8, 1)),
            'firstSeptemberTuesday' : new Date(year,  8, firstWeekdayOfMonth(8, 2)),
            'firstSeptemberSunday'  : new Date(year,  8, firstWeekdayOfMonth(8, 0)),
            'firstOctoberMonday'    : new Date(year,  9, firstWeekdayOfMonth(9, 1)),
            'firstNovemberMonday'   : new Date(year, 10, firstWeekdayOfMonth(10, 1)),
            'firstNovemberTuesday'  : new Date(year, 10, firstWeekdayOfMonth(10, 2)),
            'firstMarchTuesday'     : new Date(year,  2, firstWeekdayOfMonth(2, 2)),
            'firstAugustTuesday'    : new Date(year,  7, firstWeekdayOfMonth(7, 2)),
            'firstAugustFriday'     : new Date(year,  7, firstWeekdayOfMonth(7, 5)),
            'firstNovemberThursday' : new Date(year, 10, firstWeekdayOfMonth(10, 4)),
            'lastMayMonday'         : new Date(year,  4, lastWeekdayOfMonth(4, 1)),
            'lastMarchMonday'       : new Date(year,  2, lastWeekdayOfMonth(2, 1)),
            'lastAprilMonday'       : new Date(year,  3, lastWeekdayOfMonth(3, 1)),
            'lastAprilFriday'       : new Date(year,  3, lastWeekdayOfMonth(3, 5)),
            'lastAugustMonday'      : new Date(year,  7, lastWeekdayOfMonth(7, 1)),
            'lastSeptemberMonday'   : new Date(year,  8, lastWeekdayOfMonth(8, 1)),
            'lastSeptemberFriday'   : new Date(year,  8, lastWeekdayOfMonth(8, 5)),
            'lastOctoberMonday'     : new Date(year,  9, lastWeekdayOfMonth(9, 1)),
            'lastOctoberFriday'     : new Date(year,  9, lastWeekdayOfMonth(9, 5)),
            'nextSaturday20Jun'     : getDateOfWeekdayInDateRange(6, new Date(year, 5, 20)),
            'nextSaturday31Oct'     : getDateOfWeekdayInDateRange(6, new Date(year, 9, 31)),
            'nextWednesday16Nov'    : getDateOfWeekdayInDateRange(3, new Date(year, 10, 16)),
            'nextMo-Fr17March'      : getDateOfNextWeekdayRange(1, 5, new Date(year, 2, 17)),
            'nextMo-Sa01May'        : getDateOfNextWeekdayRange(1, 6, new Date(year, 4, 1)),
            'nextMo-Fr12July'       : getDateOfNextWeekdayRange(1, 5, new Date(year, 6, 12)),
            'nextMo-Sa07August'     : getDateOfNextWeekdayRange(1, 6, new Date(year, 7, 7)),
            'nextMo-Fr30November'   : getDateOfNextWeekdayRange(1, 5, new Date(year, 10, 30)),
            'nextMo-Sa25December'   : getDateOfNextWeekdayRange(1, 6, new Date(year, 11, 25)),
            'springEquinox'         : springEquinoxCalc(year),
            'autumnalEquinox'       : autumnalEquinoxCalc(year),
        };
    }
    /* }}} */

    function getApplyingHolidaysForYear(applying_holidays, year, add_days) {
        const movableDays = getMovableEventsForYear(year);

        let sorted_holidays = [];
        let next_holiday;

        applying_holidays.forEach(function (holiday_item) {
            if ('fixed_date' in holiday_item) {
                next_holiday = new Date(year,
                        holiday_item.fixed_date[0] - 1,
                        holiday_item.fixed_date[1]
                    );
            } else if ('variable_date' in holiday_item) {
                const selected_movableDay = movableDays[holiday_item.variable_date];
                if (!selected_movableDay) {
                    throw t('movable no formula', {'name': holiday_item.name});
                }
                let date_offset = 0;
                if ('offset' in holiday_item) {
                    date_offset = holiday_item.offset;
                }
                next_holiday = new Date(selected_movableDay.getFullYear(),
                    selected_movableDay.getMonth(),
                    selected_movableDay.getDate() + date_offset
                );
                if (year !== next_holiday.getFullYear()) {
                    throw t('movable not in year', {
                        'name': holiday_item.variable_date, 'days': date_offset});
                }
            } else {
                throw formatLibraryBugMessage('Unexpected object: ' + JSON.stringify(holiday_item, null, '    '));
            }

            if (add_days[0]) {
                next_holiday.setDate(next_holiday.getDate() + add_days[0]);
            }

            sorted_holidays.push([ next_holiday, holiday_item.name ]);
        });

        sorted_holidays = sorted_holidays.sort(function(a,b){
            if (a[0].getTime() < b[0].getTime()) return -1;
            if (a[0].getTime() > b[0].getTime()) return 1;
            return 0;
        });

        return sorted_holidays;
    }
    /* }}} */
    /* }}} */

    /* Year range parser (2013,2016-2018,2020/2). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Position at which the token does not belong to the selector anymore.
     */
    function parseYearRange(tokens, at) {
        tokens[at][3] = 'year';
        for (; at < tokens.length; at++) {
            if (matchTokens(tokens, at, 'year')) {
                let is_range = false,
                    has_period,
                    period;
                if (matchTokens(tokens, at+1, '-', 'year', '/', 'number')) {
                    is_range   = true;
                    has_period = true;
                    period = parseInt(tokens[at+4][0]);
                    checkPeriod(at+4, period, 'year');
                } else {
                    is_range   = matchTokens(tokens, at+1, '-', 'year');
                    has_period = matchTokens(tokens, at+1, '/', 'number');
                    if (has_period) {
                        period = parseInt(tokens[at+2][0]);
                        checkPeriod(at+2, period, 'year', 'no_end_year');
                    } else if (matchTokens(tokens, at+1, '+')) {
                        period = 1;
                        has_period = 2;
                    }
                }

                const year_from = parseInt(tokens[at][0]);
                // error checking {{{
                    if (is_range && tokens[at+2][0] <= year_from) {
                        // handle reversed range
                        if (tokens[at+2][0] === year_from) {
                            throw formatWarnErrorMessage(nrule, at, t('year range one year', {'year': year_from }));
                        } else {
                            throw formatWarnErrorMessage(nrule, at, t('year range reverse'));
                        }
                    }
                    if (!is_range && year_from < new Date().getFullYear()) {
                        parsing_warnings.push([ nrule, at, t('year past') ]);
                    }
                    if (is_range && tokens[at+2][0] < new Date().getFullYear()) {
                        parsing_warnings.push([ nrule, at+2, t('year past') ]);
                    }
                /* }}} */

                rule.year.push(function(tokens, at, year_from, is_range, has_period, period) { return function(date) {
                    const ouryear = date.getFullYear();
                    const year_to = is_range ? parseInt(tokens[at+2][0]) : year_from;

                    if (ouryear < year_from ){
                        return [false, new Date(year_from, 0, 1)];
                    } else if (has_period) {
                        if (year_from <= ouryear) {
                            if (is_range && ouryear > year_to)
                                return [false];
                            if (period > 0) {
                                if ((ouryear - year_from) % period === 0) {
                                    return [true, new Date(ouryear + 1, 0, 1)];
                                } else {
                                    return [false, new Date(ouryear + period - 1, 0, 1)];
                                }
                            }
                        }
                    } else if (is_range) {
                        if (ouryear <= year_to)
                            return [true, new Date(year_to + 1, 0, 1)];
                    } else if (ouryear === year_from) {
                        return [true];
                    }

                    return [false];

                }}(tokens, at, year_from, is_range, has_period, period));

                at += 1 + (is_range ? 2 : 0) + (has_period ? (has_period === 2 ? 1 : 2) : 0);
            } else if (matchTokens(tokens, at - 1, ',')) { // additional rule
                throw formatWarnErrorMessage(nrule, at - 1, t('additional rule no sense'));
            } else {
                throw formatWarnErrorMessage(nrule, at, t('unexpected token year range', {'token': tokens[at][1]}));
            }

            if (!matchTokens(tokens, at, ','))
                break;
        }

        return at;
    }
    /* }}} */

    /* Week range parser (week 11-20, week 1-53/2). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :returns: Position at which the token does not belong to the selector anymore.
     */
    function parseWeekRange(tokens, at) {
        for (; at < tokens.length; at++) {
            if (matchTokens(tokens, at, 'week')) {
                at++;
            }
            if (matchTokens(tokens, at, 'number')) {
                const is_range = matchTokens(tokens, at+1, '-', 'number');
                let period = 0;
                const week_from = tokens[at][0];
                const week_to   = is_range ? tokens[at+2][0] : week_from;
                if (week_from > week_to) {
                    throw formatWarnErrorMessage(nrule, at+2, t('week range reverse'));
                }
                if (week_from < 1) {
                    throw formatWarnErrorMessage(nrule, at, t('week negative'));
                }
                if (week_to > 53) {
                    throw formatWarnErrorMessage(nrule, is_range ? at+2 : at, t('week exceed'));
                }
                if (is_range) {
                    period = matchTokens(tokens, at+3, '/', 'number');
                    if (period) {
                        period = tokens[at+4][0];
                        tokens[at+4][4] = 'positive_number';
                        if (period < 2) {
                            throw formatWarnErrorMessage(nrule, at+4, t('week period less than 2', {
                                'weekfrom': week_from, 'weekto': week_to, 'period': period}));
                        } else if (period > 26) {
                            throw formatWarnErrorMessage(nrule, at+4, t('week period greater than 26', {
                                'weekfrom': week_from
                            }));
                        }
                    }
                }

                if (week_stable && (!(week_from <= 1 && week_to >= 53) || period)) {
                    week_stable = false;
                }

                if (!period && week_from === 1 && week_to === 53) {
                    /* Shortcut and work around bug. */
                    rule.week.push(function() { return [true]; });
                } else {

                    rule.week.push(function(week_from, week_to, period) { return function(date) {
                        const ourweek = getWeekNumber(date);

                        // console.log("week_from: %s, week_to: %s", week_from, week_to);
                        // console.log("ourweek: %s, date: %s", ourweek, date);

                        // before range
                        if (ourweek < week_from) {
                            // console.log("Before: " + getNextDateOfISOWeek(week_from, date));
                            return [false, getNextDateOfISOWeek(week_from, date)];
                        }

                        // we're after range, set check date to next year
                        if (ourweek > week_to) {
                            // console.log("After");
                            return [false, getNextDateOfISOWeek(week_from, date)];
                        }

                        // we're in range
                        if (period) {
                            const in_period = (ourweek - week_from) % period === 0;
                            if (in_period) {
                                return [true, getNextDateOfISOWeek(ourweek + 1, date)];
                            } else {
                                // Calculate how many weeks we need to skip to land on the next period-aligned week
                                const weeks_until_next_match = period - ((ourweek - week_from) % period);
                                const next_matching_week = ourweek + weeks_until_next_match;
                                if (next_matching_week <= week_to) {
                                    return [false, getNextDateOfISOWeek(next_matching_week, date)];
                                } else {
                                    // No further match within the range; wrap to the first matching week in the next year
                                    return [false, getNextDateOfISOWeek(week_from, date)];
                                }
                            }
                        }

                        // console.log("Match");
                        return [true, getNextDateOfISOWeek(week_to === 53 ? 1 : week_to + 1, date)];
                    }}(week_from, week_to, period));
                }

                at += 1 + (is_range ? 2 : 0) + (period ? 2 : 0);
            } else if (matchTokens(tokens, at - 1, ',')) { // additional rule
                throw formatWarnErrorMessage(nrule, at - 1, t('additional rule no sense'));
            } else {
                throw formatWarnErrorMessage(nrule, at, t('unexpected token week range', {'token': tokens[at][1]}));
            }

            if (!matchTokens(tokens, at, ','))
                break;
        }

        return at;
    }

    // https://stackoverflow.com/a/6117889
    /* For a given date, get the ISO week number.
     *
     * Based on information at:
     *
     *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR
     *
     * Algorithm is to find nearest Thursday, it's year
     * is the year of the week number. Then get weeks
     * between that date and the first day of that year.
     *
     * Note that dates in one year can be weeks of previous
     * or next year, overlap is up to 3 days.
     *
     * e.g. 2014/12/29 is Monday in week  1 of 2015
     *      2012/1/1   is Sunday in week 52 of 2011
     */
    function getWeekNumber(d) {
        // Copy date so don't modify original
        d = new Date(+d);
        d.setHours(0,0,0,0);
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setDate(d.getDate() + 4 - (d.getDay()||7));
        // Get first day of year
        const yearStart = new Date(d.getFullYear(),0,1);
        // Calculate full weeks to nearest Thursday
        return Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7)
    }
    // https://stackoverflow.com/a/16591175
    function getDateOfISOWeek(w, year) {
        const simple = new Date(year, 0, 1 + (w - 1) * 7);
        const dow = simple.getDay();
        const ISOweekStart = simple;
        if (dow <= 4)
            ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        else
            ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
        return ISOweekStart;
    }
    function getNextDateOfISOWeek(week, date) {
        let next_date;
        for (let i = -1; i <= 1; i++) {
            next_date = getDateOfISOWeek(week, date.getFullYear() + i);
            if (next_date.getTime() > date.getTime()) {
                return next_date;
            }
        }
        throw formatLibraryBugMessage();
    }
    /* }}} */

    /* Month range parser (Jan,Feb-Mar). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param push_to_monthday: Will push the selector into the monthday selector array which has the desired side effect of working in conjunction with the monthday selectors (either the month match or the monthday).
     * :returns: Position at which the token does not belong to the selector anymore.
     */
    function parseMonthRange(tokens, at, push_to_monthday, in_selector) {
        if (!in_selector)
            tokens[at][3] = 'month';

        for (; at < tokens.length; at++) {
            // Use parseMonthdayRange if '<month> <daynum>' and not '<month> <hour>:<minute>'
            if (matchTokens(tokens, at, 'month', 'number') && !matchTokens(tokens, at+2, 'timesep', 'number')) {
                return parseMonthdayRange(tokens, at, nrule, true);
            } else if (matchTokens(tokens, at, 'month')) {
                // Single month (Jan) or month range (Feb-Mar)
                const is_range = matchTokens(tokens, at+1, '-', 'month');

                let month_from = tokens[at][0];
                let month_to = is_range ? tokens[at+2][0] : month_from;

                if (is_range && week_stable) {
                    if (month_from !== (month_to + 1) % 12)
                        week_stable = false;
                } else {
                    week_stable = false;
                }

                let inside = true;

                // handle reversed range
                if (month_to < month_from) {
                    const tmp = month_to;
                    month_to = month_from - 1;
                    month_from = tmp + 1;
                    inside = false;
                }

                const selector = function(month_from, month_to, inside) { return function(date) {
                    const ourmonth = date.getMonth();

                    if (month_to < month_from) {
                        /* Handle full range. */
                        return [!inside];
                    }

                    if (ourmonth < month_from || ourmonth > month_to) {
                        return [!inside, dateAtNextMonth(date, month_from)];
                    } else {
                        return [inside, dateAtNextMonth(date, month_to + 1)];
                    }
                }}(month_from, month_to, inside);

                if (push_to_monthday === true)
                    rule.monthday.push(selector);
                else
                    rule.month.push(selector);

                at += is_range ? 3 : 1;
            } else {
                throw formatWarnErrorMessage(nrule, at, t('unexpected token month range', {'token': tokens[at][1]}));
            }

            if (!matchTokens(tokens, at, ','))
                break;
        }

        return at;
    }

    function dateAtNextMonth(date, month) {
        return new Date(date.getFullYear(), month < date.getMonth() ? month + 12 : month);
    }
    /* }}} */

    /* Month day range parser (Jan 26-31; Jan 26-Feb 26). {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param nrule: Rule number starting with 0.
     * :param push_to_month: Will push the selector into the month selector array which has the desired side effect of working in conjunction with the month selectors (either the month match or the monthday).
     * :returns: Position at which the token does not belong to the selector anymore.
     */
    function parseMonthdayRange(tokens, at, nrule, push_to_month) {
        if (!push_to_month)
            tokens[at][3] = 'month';

        for (; at < tokens.length; at++) {
            let has_year = [];
            const has_month = [], has_event = [], has_calc = [], has_constrained_weekday = [];
            has_year[0]  = matchTokens(tokens, at, 'year');
            has_month[0] = matchTokens(tokens, at+has_year[0], 'month', 'number');
            has_event[0] = matchTokens(tokens, at+has_year[0], 'event');

            if (has_event[0])
                has_calc[0] = getMoveDays(tokens, at+has_year[0]+1, 200, 'event like easter');

            let at_range_sep;
            if (matchTokens(tokens, at+has_year[0], 'month', 'weekday', '[')) {
                has_constrained_weekday[0] = getConstrainedWeekday(tokens, at+has_year[0]+3);
                has_calc[0] = getMoveDays(tokens, has_constrained_weekday[0][1], 6, 'constrained weekdays');
                at_range_sep = has_constrained_weekday[0][1] + (typeof has_calc[0] === 'object' && has_calc[0][1] ? 3 : 0);
            } else {
                at_range_sep = at+has_year[0]
                    + (has_event[0]
                        ? (typeof has_calc[0] === 'object' && has_calc[0][1] ? 4 : 1)
                        : 2);
            }

            let at_sec_event_or_month;
            if ((has_month[0] || has_event[0] || has_constrained_weekday[0]) && matchTokens(tokens, at_range_sep, '-')) {
                has_year[1] = matchTokens(tokens, at_range_sep+1, 'year');
                at_sec_event_or_month = at_range_sep+1+has_year[1];
                has_month[1] = matchTokens(tokens, at_sec_event_or_month, 'month', 'number');
                if (!has_month[1]) {
                    has_event[1] = matchTokens(tokens, at_sec_event_or_month, 'event');
                    if (has_event[1]) {
                        has_calc[1] = getMoveDays(tokens, at_sec_event_or_month+1, 366, 'event like easter');
                    } else if (matchTokens(tokens, at_sec_event_or_month, 'month', 'weekday', '[')) {
                        has_constrained_weekday[1] = getConstrainedWeekday(tokens, at_sec_event_or_month+3);
                        has_calc[1] = getMoveDays(tokens, has_constrained_weekday[1][1], 6, 'constrained weekdays');
                    }
                }
            }

            // monthday range like Jan 26-Feb 26 {{{
            if (has_year[0] === has_year[1] && (has_month[1] || has_event[1] || has_constrained_weekday[1])) {

                if (has_month[0])
                    checkIfDateIsValid(tokens[at+has_year[0]][0], tokens[at+has_year[0]+1][0], nrule, at+has_year[0]+1);
                if (has_month[1])
                    checkIfDateIsValid(tokens[at_sec_event_or_month][0], tokens[at_sec_event_or_month+1][0], nrule, at_sec_event_or_month+1);

                const selector = function(tokens, at, nrule, has_year, has_event, has_calc, at_sec_event_or_month, has_constrained_weekday) { return function(date) {
                    const start_of_next_year = new Date(date.getFullYear() + 1, 0, 1);

                    let movableDays, from_date;
                    if (has_event[0]) {
                        movableDays = getMovableEventsForYear(has_year[0] ? parseInt(tokens[at][0]) : date.getFullYear());
                        from_date = movableDays[tokens[at+has_year[0]][0]];

                        if (typeof has_calc[0] === 'object' && has_calc[0][1]) {
                            const from_year_before_calc = from_date.getFullYear();
                            from_date.setDate(from_date.getDate() + has_calc[0][0]);
                            if (from_year_before_calc !== from_date.getFullYear())
                                throw formatWarnErrorMessage(nrule, at+has_year[0]+has_calc[0][1]*3,
                                    t('movable not in year', {'name': tokens[at+has_year[0]][0], 'days': has_calc[0][0]}));
                        }
                    } else if (has_constrained_weekday[0]) {
                        from_date = getDateForConstrainedWeekday((has_year[0] ? tokens[at][0] : date.getFullYear()), // year
                            tokens[at+has_year[0]][0], // month
                            tokens[at+has_year[0]+1][0], // weekday
                            has_constrained_weekday[0],
                            has_calc[0]);
                    } else {
                        from_date = new Date((has_year[0] ? tokens[at][0] : date.getFullYear()),
                            tokens[at+has_year[0]][0], tokens[at+has_year[0]+1][0]);
                    }

                    let to_date;
                    if (has_event[1]) {
                        movableDays = getMovableEventsForYear(has_year[1]
                                    ? parseInt(tokens[at_sec_event_or_month-1][0])
                                    : date.getFullYear());
                        to_date = movableDays[tokens[at_sec_event_or_month][0]];

                        if (typeof has_calc[1] === 'object' && has_calc[1][1]) {
                            const to_year_before_calc = to_date.getFullYear();
                            to_date.setDate(to_date.getDate() + has_calc[1][0]);
                            if (to_year_before_calc !== to_date.getFullYear()) {
                                throw formatWarnErrorMessage(nrule, at_sec_event_or_month+has_calc[1][1],
                                    t('movable not in year', {'name': tokens[at_sec_event_or_month][0], 'days':  has_calc[1][0] }));
                            }
                        }
                    } else if (has_constrained_weekday[1]) {
                        to_date = getDateForConstrainedWeekday((has_year[1] ? tokens[at_sec_event_or_month-1][0] : date.getFullYear()), // year
                            tokens[at_sec_event_or_month][0],   // month
                            tokens[at_sec_event_or_month+1][0], // weekday
                            has_constrained_weekday[1],
                            has_calc[1]);
                    } else {
                        to_date = new Date((has_year[1] ? tokens[at_sec_event_or_month-1][0] : date.getFullYear()),
                            tokens[at_sec_event_or_month][0], tokens[at_sec_event_or_month+1][0] + 1);
                    }

                    let inside = true;

                    if (to_date < from_date) {
                        const tmp = to_date;
                        to_date = from_date;
                        from_date = tmp;
                        inside = false;
                    }

                    if (date.getTime() < from_date.getTime()) {
                        return [!inside, from_date];
                    } else if (date.getTime() < to_date.getTime()) {
                        return [inside, to_date];
                    } else {
                        if (has_year[0]) {
                            return [!inside];
                        } else {
                            return [!inside, start_of_next_year];
                        }
                    }
                }}(tokens, at, nrule, has_year, has_event, has_calc, at_sec_event_or_month, has_constrained_weekday);

                if (push_to_month === true)
                    rule.month.push(selector);
                else
                    rule.monthday.push(selector);

                at = (has_constrained_weekday[1]
                        ? has_constrained_weekday[1][1]
                        : at_sec_event_or_month + (has_event[1] ? 1 : 2))
                    + (typeof has_calc[1] === 'object' ? has_calc[1][1] : 0);

                /* }}} */
                // Monthday range like Jan 26-31 {{{
            } else if (has_month[0]) {

                has_year = has_year[0];
                const year = tokens[at][0]; // Could be month if has no year. Tested later.
                const month = tokens[at+has_year][0];

                let first_round = true;
                let is_range;

                do {
                    const range_from = tokens[at+1 + has_year][0];
                    is_range = matchTokens(tokens, at+2+has_year, '-', 'number');
                    let period = undefined;
                    const range_to = tokens[at+has_year+(is_range ? 3 : 1)][0] + 1;
                    if (is_range && matchTokens(tokens, at+has_year+4, '/', 'number')) {
                        period = tokens[at+has_year+5][0];
                        tokens[at+has_year+5][4] = 'positive_number';
                        checkPeriod(at+has_year+5, period, 'day');
                    }

                    if (first_round) {
                        const at_timesep_if_monthRange = at + has_year + 1 // at month number
                            + (is_range ? 2 : 0) + (period ? 2 : 0)
                            + !(is_range || period); // if not range nor has period, add one

                        // Check for '<month> <timespan>'
                        if (matchTokens(tokens, at_timesep_if_monthRange, 'timesep', 'number')
                                && (matchTokens(tokens, at_timesep_if_monthRange+2, '+')
                                    || matchTokens(tokens, at_timesep_if_monthRange+2, '-')
                                    || oh_mode !== 0)
                            ) {
                                return parseMonthRange(tokens, at, true, true);
                        }
                    }

                    // error checking {{{
                    if (range_to < range_from)
                        throw formatWarnErrorMessage(nrule, at+has_year+3, t('day range reverse'));

                    checkIfDateIsValid(month, range_from, nrule, at+1 + has_year);
                    checkIfDateIsValid(month, range_to - 1 /* added previously */,
                        nrule, at+has_year+(is_range ? 3 : 1));
                    /* }}} */

                    const selector = function(year, has_year, month, range_from, range_to, period) { return function(date) {
                        const start_of_next_year = new Date(date.getFullYear() + 1, 0, 1);

                        const from_date = new Date(has_year ? year : date.getFullYear(),
                            month, range_from);
                        if (month === 1 && range_from !== from_date.getDate()) // Only on leap years does this day exist.
                            return [false]; // If day 29 does not exist,
                                            // then the date object adds one day to date
                                            // and this selector should not match.
                        const to_date   = new Date(from_date.getFullYear(),
                            month, range_to);
                        if (month === 1 && is_range && range_to !== to_date.getDate()) // Only on leap years does this day exist.
                            return [false];

                        if (date.getTime() < from_date.getTime())
                            return [false, from_date];
                        else if (date.getTime() >= to_date.getTime())
                            return [false, start_of_next_year];
                        else if (!period)
                            return [true, to_date];

                        const nday = Math.floor((date.getTime() - from_date.getTime()) / msec_in_day);
                        const in_period = nday % period;

                        if (in_period === 0)
                            return [true, new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)];
                        else
                            return [false, new Date(date.getFullYear(), date.getMonth(), date.getDate() + period - in_period)];

                    }}(year, has_year, month, range_from, range_to, period);

                    if (push_to_month === true)
                        rule.month.push(selector);
                    else
                        rule.monthday.push(selector);

                    at += 2 + has_year + (is_range ? 2 : 0) + (period ? 2 : 0);

                    first_round = false;
                }
                while (matchTokens(tokens, at, ',', 'number'))


                /* }}} */
                // Only event like easter {{{
            } else if (has_event[0]) {

                const selector = function(tokens, at, nrule, has_year, add_days) { return function(date) {

                    // console.log('enter selector with date: ' + date);
                    const movableDays = getMovableEventsForYear((has_year ? tokens[at][0] : date.getFullYear()));
                    const event_date = movableDays[tokens[at+has_year][0]];
                    if (!event_date)
                        throw t('movable no formula', {'name': tokens[at+has_year][0]});

                    if (add_days[0]) {
                        event_date.setDate(event_date.getDate() + add_days[0]);
                        if (date.getFullYear() !== event_date.getFullYear())
                            throw formatWarnErrorMessage(nrule, at+has_year+add_days[1], t('movable not in year', {
                                'name': tokens[at+has_year][0], 'days': add_days[0]}));
                    }

                    if (date.getTime() < event_date.getTime())
                        return [false, event_date];
                    // else if (date.getTime() < event_date.getTime() + msec_in_day) // does not work because of daylight saving times
                    else if (event_date.getMonth() * 100 + event_date.getDate() === date.getMonth() * 100 + date.getDate())
                        return [true, new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)];
                    else
                        return [false, new Date(date.getFullYear() + 1, 0, 1)];

                }}(tokens, at, nrule, has_year[0], has_calc[0]);

                if (push_to_month === true)
                    rule.month.push(selector);
                else
                    rule.monthday.push(selector);

                at += has_year[0] + has_event[0] + (typeof has_calc[0][1] === 'number' && has_calc[0][1] ? 3 : 0);
                /* }}} */
            } else if (has_constrained_weekday[0]) {
                at = parseMonthRange(tokens, at);
            } else if (matchTokens(tokens, at, 'month')) {
                return parseMonthRange(tokens, at, true, true);
            } else {
                // throw 'Unexpected token in monthday range: "' + tokens[at] + '"';
                return at;
            }

            if (!matchTokens(tokens, at, ','))
                break;
        }

        return at;
    }
    /* }}} */

    /* Main selector traversal function (return state array for date). {{{
     * Checks for given date which rule and those which state and comment applies.
     *
     * :param date: Date object.
     * :returns: Array:
     *            0. resultstate: State: true for 'open', false for 'closed'.
     *            1. changedate: Next change as date object.
     *            2. unknown: true if state open is not sure.
     *            3. comment: Comment which applies for this time range (from date to changedate).
     *            4. match_rule: Rule number starting with 0 (nrule).
     */
    this.getStatePair = function(date) {
        let resultstate = false;
        let changedate;
        let unknown = false;
        let comment;
        let match_rule;

        let date_matching_rules = [];

        /* Go though all date selectors and check if they return something
         * else than closed for the given date.
         */
        for (let nrule = 0; nrule < rules.length; nrule++) {
            let matching_date_rule = true;
            // console.log(nrule, 'length',  rules[nrule].date.length);

            /* Try each date selector type. */
            for (let ndateselector = 0; ndateselector < rules[nrule].date.length; ndateselector++) {
                const dateselectors = rules[nrule].date[ndateselector];
                // console.log(nrule, ndateselector);

                let has_matching_selector = false;
                for (let datesel = 0; datesel < dateselectors.length; datesel++) {
                    const res = dateselectors[datesel](date);
                    if (res[0]) {
                        has_matching_selector = true;

                        if (typeof res[2] === 'string') { // holiday name
                            comment = [ res[2], nrule ];
                        }

                    }
                    if (typeof changedate === 'undefined' || (typeof res[1] === 'object' && res[1].getTime() < changedate.getTime()))
                        changedate = res[1];
                }

                if (!has_matching_selector) {
                    matching_date_rule = false;
                    // We can ignore other date selectors, as the state won't change
                    // anyway until THIS selector matches (due to conjunction of date
                    // selectors of different types).
                    // This is also an optimization, if widest date selector types
                    // are checked first.
                    break;
                }
            }

            if (matching_date_rule) {
                /* The following lines implement date overwriting logic (e.g. for
                 * "Mo-Fr 10:00-20:00; We 10:00-16:00", We rule overrides Mo-Fr rule partly (We).
                 *
                 * This is the only way to be consistent. I thought about ("22:00-02:00; Tu 12:00-14:00") letting Th override 22:00-02:00 partly:
                 * Like: Th 00:00-02:00,12:00-14:00 but this would result in including 22:00-00:00 for Th which is probably not what you want.
                 */
                if ((rules[nrule].date.length > 0 || nrule > 0 && rules[nrule].meaning && rules[nrule-1].date.length === 0)
                        && (rules[nrule].meaning || rules[nrule].unknown)
                        && !rules[nrule].wrapped && !rules[nrule].additional && !rules[nrule].fallback
                    ) {

                    // let old_date_matching_rules = date_matching_rules;
                    date_matching_rules = [];
                    // for (var nrule = 0; nrule < old_date_matching_rules.length; nrule++) {
                    //     if (!rules[old_date_matching_rules[nrule]].wrapped)
                    //         date_matching_rules.push(nrule);
                    // }
                }
                date_matching_rules.push(nrule);
            }
        }

        // console.log(date_matching_rules);
        for (let nrule = 0; nrule < date_matching_rules.length; nrule++) {
            const rule = date_matching_rules[nrule];

            // console.log('Processing rule ' + rule + ': with date ' + date
                // + ' and ' + rules[rule].time.length + ' time selectors (comment: "' + rules[rule].comment + '").');

            /* There is no time specified, state applies to the whole day. */
            if (rules[rule].time.length === 0) {
                // console.log('there is no time', date);
                if (!rules[rule].fallback || (rules[rule].fallback && !(resultstate || unknown))) {
                    resultstate = rules[rule].meaning;
                    unknown     = rules[rule].unknown;
                    match_rule  = rule;

                    // if (rules[rule].fallback)
                        // break rule; // fallback rule matched, no need for checking the rest
                    // WRONG: What if closing rules follow?
                }
            }

            for (let timesel = 0; timesel < rules[rule].time.length; timesel++) {
                const res = rules[rule].time[timesel](date);

                // console.log('res:', res);
                if (res[0]) {
                    if (!rules[rule].fallback || (rules[rule].fallback && !(resultstate || unknown))) {
                        resultstate = rules[rule].meaning;
                        unknown     = rules[rule].unknown;
                        match_rule  = rule;

                        /* Reset open end comment */
                        if (typeof comment === 'object' && comment[0] === t('open end'))
                            comment = undefined;

                        // open end
                        if (res[2] === true && (resultstate || unknown)) {
                            comment = [ t('open end'), match_rule ];

                            resultstate = false;
                            unknown     = true;

                            /* Hack to make second rule in '07:00+,12:00-16:00; 16:00-24:00 closed "needed because of open end"' obsolete {{{ */
                            if (typeof rules[rule].time[timesel+1] === 'function') {

                                const next_res = rules[rule].time[timesel+1](date);
                                if (  !next_res[0]
                                    // && next_res[2]
                                    && typeof next_res[1] === 'object'
                                    // && getValueForDate(next_res[1], true) !== getValueForDate(date, true) // Just to be sure.
                                    && rules[rule].time[timesel](new Date(date.getTime() - 1))[0]
                                    /* To distinguish the following two values:
                                     *     'sunrise-14:00,14:00+',
                                     *   '07:00+,12:00-16:00',
                                     */
                                    ) {

                                    // console.log("07:00+,12:00-16:00 matched.");

                                    resultstate = false;
                                    unknown     = false;
                                }
                            }

                            /* Hack to handle '17:00+,13:00-02:00' {{{ */
                            /* Not enabled. To complicated, just don‘t use them …
                             * It gets even crazier …
                             * Time wrapping over midnight is
                             * stored in the next internal rule:
                             * '17:00-00:00 unknown "Specified as open end. Closing time was guessed.", 13:00-00:00 open' // First internal rule.
                             * + ', ' overwritten part: 00:00-03:00 open + '00:00-02:00 open', // Second internal rule.
                             */

                            /*
                            if (
                                    typeof rules[rule-1] === 'object'
                                    && rules[rule].build_from_token_rule.toString() === rules[rule-1].build_from_token_rule.toString()
                                    && typeof rules[rule] === 'object'
                                    && rules[rule].build_from_token_rule.toString() === rules[rule].build_from_token_rule.toString()
                                    ) {

                                let last_wrapping_time_selector = rules[rule].time[rules[rule].time.length - 1];
                                let last_w_res = last_wrapping_time_selector(new Date(date.getTime() - 1));
                                // console.log(last_w_res);

                                if (    last_w_res[0]
                                        &&  typeof last_w_res[2] === 'undefined'
                                        && (typeof last_w_res[2] === 'undefined' || last_w_res[2] === false) // Do not match for 'Tu 23:59-40:00+'
                                        &&  typeof last_w_res[1] === 'object'
                                        && date.getTime() === last_w_res[1].getTime()
                                    ) {

                                    // '05:00-06:00,17:00+,13:00-02:00',

                                    // console.log("17:00+,13:00-02:00 matched.");
                                    // console.log(JSON.stringify(rules, null, '    '));

                                    resultstate = false;
                                    unknown     = false;
                                }
                            }
                            /* }}} */
                        }

                        if (rules[rule].fallback) {
                            if (typeof changedate === 'undefined' || (typeof res[1] !== 'undefined' && res[1] < changedate)) {
                                // FIXME: Changing undefined does not break the test framework.
                                changedate = res[1];
                            }

                            // break rule; // Fallback rule matched, no need for checking the rest.
                            // WRONG: What if 'off' is used after fallback rule.
                        }
                    }
                }
                if (typeof changedate === 'undefined' || (typeof res[1] === 'object' && res[1] < changedate))
                    changedate = res[1];
            }
        }

        if (typeof rules[match_rule] === 'object' && typeof rules[match_rule].comment === 'string') {
            /* Only use comment if one is explicitly specified. */
            comment = rules[match_rule].comment;
        } else if (typeof comment === 'object') {
            if (comment[1] === match_rule) {
                comment = comment[0];
            } else {
                comment = undefined;
            }
        }

        // console.log('changedate', changedate, resultstate, comment, match_rule);
        return [ resultstate, changedate, unknown, comment, match_rule ];
    };
    /* }}} */

    /* Generate prettified value for selector based on tokens. {{{
     *
     * :param tokens: List of token objects.
     * :param at: Position where to start.
     * :param last_at: Position where to stop.
     * :param conf: Configuration options.
     * :returns: Prettified value.
     */
    function prettifySelector(tokens, selector_start, selector_end, selector_type, conf) {

        let prettified_value = '';
        let at = selector_start;
        // console.log(selector_type);
        while (at <= selector_end) {
            // console.log('At: ' + at + ', token: ' + tokens[at]);
            if (matchTokens(tokens, at, 'weekday')) {
                if (!conf.leave_weekday_sep_one_day_betw
                    && at - selector_start > 1 && (matchTokens(tokens, at-1, ',') || matchTokens(tokens, at-1, '-'))
                    && matchTokens(tokens, at-2, 'weekday')
                    && tokens[at][0] === (tokens[at-2][0] + 1) % 7) {
                        prettified_value = prettified_value.substring(0, prettified_value.length - 1) + conf.sep_one_day_between;
                }
                prettified_value += weekdays[tokens[at][0]];
            } else if (at - selector_start > 0 // e.g. '09:0' -> '09:00'
                    && selector_type === 'time'
                    && matchTokens(tokens, at-1, 'timesep')
                    && matchTokens(tokens, at, 'number')) {
                prettified_value += (tokens[at][0] < 10 ? '0' : '') + tokens[at][0].toString();
            } else if (selector_type === 'time' // e.g. '9:00' -> ' 09:00'
                    && conf.zero_pad_hour
                    && at !== tokens.length
                    && matchTokens(tokens, at, 'number')
                    && matchTokens(tokens, at+1, 'timesep')) {
                prettified_value += (
                        tokens[at][0] < 10 ?
                            (tokens[at][0] === 0 && conf.one_zero_if_hour_zero ?
                             '' : '0') :
                            '') + tokens[at][0].toString();
            } else if (selector_type === 'time' // e.g. '9-18' -> '09:00-18:00'
                    && at + 2 <= selector_end
                    && matchTokens(tokens, at, 'number')
                    && matchTokens(tokens, at+1, '-')
                    && matchTokens(tokens, at+2, 'number')) {
                prettified_value += (tokens[at][0] < 10 ?
                        (tokens[at][0] === 0 && conf.one_zero_if_hour_zero ? '' : '0')
                        : '') + tokens[at][0].toString();
                prettified_value += ':00-'
                    + (tokens[at+2][0] < 10 ? '0' : '') + tokens[at+2][0].toString()
                    + ':00';
                at += 2;
            } else if (matchTokens(tokens, at, 'comment')) {
                prettified_value += '"' + tokens[at][0].toString() + '"';
            } else if (matchTokens(tokens, at, 'closed')) {
                prettified_value += (conf.leave_off_closed ? tokens[at][0] : conf.keyword_for_off_closed);
            } else if (at - selector_start > 0 && matchTokens(tokens, at, 'number')
                    && (selector_type === 'month' || selector_type === 'week')) {
                prettified_value +=
                    (matchTokens(tokens, at-1, 'month') || matchTokens(tokens, at-1, 'week') ? ' ' : '')
                    + (conf.zero_pad_month_and_week_numbers && tokens[at][4] !== 'positive_number' && tokens[at][0] < 10 ? '0' : '')
                    + tokens[at][0];
            } else if (at - selector_start > 0 && matchTokens(tokens, at, 'month')
                    && matchTokens(tokens, at-1, 'year')) {
                prettified_value += ' ' + months[[tokens[at][0]]];
            } else if (at - selector_start > 0 && matchTokens(tokens, at, 'event')
                    && matchTokens(tokens, at-1, 'year')) {
                prettified_value += ' ' + tokens[at][0];
            } else if (matchTokens(tokens, at, 'month')) {
                prettified_value += months[[tokens[at][0]]];
                if (at + 1 <= selector_end && matchTokens(tokens, at+1, 'weekday'))
                    prettified_value += ' ';
            } else if (at + 2 <= selector_end
                    && (matchTokens(tokens, at, '-') || matchTokens(tokens, at, '+'))
                    && matchTokens(tokens, at+1, 'number', 'calcday')) {
                prettified_value += ' ' + tokens[at][0] + tokens[at+1][0] + ' day' + (Math.abs(tokens[at+1][0]) === 1 ? '' : 's');
                at += 2;
            } else if (at === selector_end
                    && selector_type === 'weekday'
                    && tokens[at][0] === ':') ; else if (at === selector_end
                    && selector_type === 'time'
                    && tokens[at][0] === ',') ; else {
                prettified_value += tokens[at][0].toString();
            }
            at++;
        }
        return prettified_value;
    }
    /* }}} */

    //======================================================================
    // Public interface {{{
    // All functions below are considered public.
    //======================================================================

    // Simple API {{{

    this.getState = function(date) {
        const it = this.getIterator(date);
        return it.getState();
    };

    this.getUnknown = function(date) {
        const it = this.getIterator(date);
        return it.getUnknown();
    };

    this.getStateString = function(date, past) {
        const it = this.getIterator(date);
        return it.getStateString(past);
    };

    this.getComment = function(date) {
        const it = this.getIterator(date);
        return it.getComment();
    };

    this.getMatchingRule = function(date) {
        const it = this.getIterator(date);
        return it.getMatchingRule();
    };

    /* Not available for iterator API {{{ */
    /* getWarnings: Get warnings, empty list if none {{{ */
    this.getWarnings = function() {
        const it = this.getIterator();
        return getWarnings(it);
    };
    /* }}} */

    /* prettifyValue: Get a nicely formated value {{{ */
    this.prettifyValue = function(argument_hash) {
        this.getWarnings();
        /* getWarnings has to be run before prettifyValue because some
         * decisions if certain aspects makes sense to prettify or not
         * are influenced by warnings.
         * Basically, both functions depend on each other in some way :(
         * See done_with_selector_reordering.
         */
        return prettifyValue(argument_hash);
    };
    /* }}} */

    /* getNextChange: Get time of next status change {{{ */
    this.getNextChange = function(date, maxdate) {
        const it = this.getIterator(date);
        if (!it.advance(maxdate))
            return undefined;
        return it.getDate();
    };
    /* }}} */

    /* isWeekStable: Checks whether open intervals are same for every week. {{{ */
    this.isWeekStable = function() {
        return week_stable;
    };
    /* }}} */

    /* isEqualTo: Check if this opening_hours object has the same meaning as the given opening_hours object. {{{ */
    this.isEqualTo = function(second_oh_object, start_date) {
        if (typeof start_date === 'undefined') {
            start_date = new Date();
        }
        let datelimit;

        if (this.isWeekStable() && second_oh_object.isWeekStable()) {
            datelimit = new Date(start_date.getTime() + msec_in_day * 10);
        // } else if (this.isWeekStable() !== second_oh_object.isWeekStable()) {
        //     return [ false,
        //         {
        //             'reason': 'isWeekStable do not match',
        //         }
        //     ];
        } else {
            datelimit = new Date(start_date.getTime() + msec_in_day * 366 * 5);
        }

        const first_it = this.getIterator(start_date);
        const second_it = second_oh_object.getIterator(start_date);

        while (first_it.advance(datelimit)) {
            second_it.advance(datelimit);

            const not_equal = [];

            if (first_it.getDate().getTime() !== second_it.getDate().getTime()) {
                not_equal.push('getDate');
            }

            if (first_it.getState() !== second_it.getState()) {
                not_equal.push('getState');
            }

            if (first_it.getUnknown() !== second_it.getUnknown()) {
                not_equal.push('getUnknown');
            }

            if (first_it.getComment() !== second_it.getComment()) {
                not_equal.push('getComment');
            }

            if (not_equal.length) {
                const deviation_for_time = {};
                deviation_for_time[first_it.getDate().getTime()] = not_equal;
                return [ false,
                    {
                        'matching_rule': first_it.getMatchingRule(),
                        'matching_rule_other': second_it.getMatchingRule(),
                        'deviation_for_time': deviation_for_time,
                    }
                ];
            }
        }

        return [ true ];
    };
    /* }}} */
    /* }}} */
    /* }}} */

    // High-level API {{{
    /* getOpenIntervals: Get array of open intervals between two dates {{{ */
    this.getOpenIntervals = function(from, to) {
        const res = [];

        const it = this.getIterator(from);

        if (it.getState() || it.getUnknown()) {
            res.push([from, undefined, it.getUnknown(), it.getComment()]);
        }

        while (it.advance(to)) {
            if (it.getState() || it.getUnknown()) {
                if (res.length !== 0 && typeof res[res.length - 1][1] === 'undefined') {
                    // last state was also open or unknown
                    res[res.length - 1][1] = it.getDate();
                }
                res.push([it.getDate(), undefined, it.getUnknown(), it.getComment()]);
            } else {
                if (res.length !== 0 && typeof res[res.length - 1][1] === 'undefined') {
                    // only use the first time as closing/change time and ignore closing times which might follow
                    res[res.length - 1][1] = it.getDate();
                }
            }
        }

        if (res.length > 0 && typeof res[res.length - 1][1] === 'undefined') {
            res[res.length - 1][1] = to;
        }

        return res;
    };
    /* }}} */

    /* getOpenDuration: Get total number of milliseconds a facility is open,unknown within a given date range {{{ */
    this.getOpenDuration = function(from, to) {

        let open    = 0;
        let unknown = 0;

        const it = this.getIterator(from);
        let prevdate    = (it.getState() || it.getUnknown()) ? from : undefined;
        let prevstate   = it.getState();
        let prevunknown = it.getUnknown();

        while (it.advance(to)) {
            if (it.getState() || it.getUnknown()) {

                if (typeof prevdate === 'object') {
                    // last state was also open or unknown
                    if (prevunknown) //
                        unknown += it.getDate().getTime() - prevdate.getTime();
                    else if (prevstate)
                        open    += it.getDate().getTime() - prevdate.getTime();
                }

                prevdate    = it.getDate();
                prevstate   = it.getState();
                prevunknown = it.getUnknown();
                // console.log('if', prevdate, open / (1000 * 60 * 60), unknown / (1000 * 60 * 60));
            } else {
                // console.log('else', prevdate);
                if (typeof prevdate === 'object') {
                    if (prevunknown)
                        unknown += it.getDate().getTime() - prevdate.getTime();
                    else
                        open    += it.getDate().getTime() - prevdate.getTime();
                    prevdate = undefined;
                }
            }
        }

        if (typeof prevdate === 'object') {
            if (prevunknown)
                unknown += to.getTime() - prevdate.getTime();
            else
                open    += to.getTime() - prevdate.getTime();
        }

        return [ open, unknown ];
    };
    /* }}} */
    /* }}} */

    // Iterator API {{{
    this.getIterator = function(date) {
        return new function(oh) {
            if (typeof date === 'undefined')
                date = new Date();

            let prevstate = [ undefined, date, undefined, undefined, undefined ];
            let state = oh.getStatePair(date);

            /* getDate {{{ */
            this.getDate = function() {
                return prevstate[1];
            };
            /* }}} */

            /* setDate {{{ */
            this.setDate = function(date) {
                if (typeof date !== 'object')
                    throw t('date parameter needed');

                prevstate = [ undefined, date, undefined, undefined, undefined ];
                state     = oh.getStatePair(date);
            };
            /* }}} */

            /* getState: Check whether facility is `open' {{{ */
            this.getState = function() {
                return state[0];
            };
            /* }}} */

            /* getUnknown: Checks whether the opening state is conditional or unknown {{{ */
            this.getUnknown = function() {
                return state[2];
            };
            /* }}} */

            /* getStateString: Get state string. Either 'open', 'unknown' or 'closed' {{{ */
            this.getStateString = function(past) {
                return (state[0] ? 'open' : (state[2] ? 'unknown' : (past ? 'closed' : 'close')));
            };
            /* }}} */

            /* getComment: Get the comment, undefined in none {{{ */
            this.getComment = function() {
                return state[3];
            };
            /* }}} */

            /* getMatchingRule: Get the rule which matched thus deterrents the current state {{{ */
            this.getMatchingRule = function() {
                if (typeof state[4] === 'undefined')
                    return undefined;

                return rules[state[4]].build_from_token_rule[2];
            };
            /* }}} */

            /* advance: Advances to the next position {{{ */
            this.advance = function(datelimit) {
                if (typeof datelimit === 'undefined') {
                    datelimit = new Date(prevstate[1].getTime() + msec_in_day * 366 * 5);
                } else if (datelimit.getTime() <= prevstate[1].getTime()) {
                    return false; /* The limit for advance needs to be after the current time. */
                }

                do {
                    if (typeof state[1] === 'undefined') {
                        return false; /* open range, we won't be able to advance */
                    }

                    // console.log('\n' + 'previous check time:', prevstate[1]
                    //     + ', current check time:',
                    //     state[1],
                    //     (state[0] ? 'open' : (state[2] ? 'unknown' : 'closed'))
                    //     + ', comment:', state[3]
                    //     + ', match_rule:', state[4]);

                    if (state[1].getTime() <= prevstate[1].getTime()) {
                        /* We're going backwards or staying at the same time.
                         * This most likely indicates an error in a selector code.
                         */
                        throw 'Fatal: infinite loop in nextChange';
                    }

                    if (state[1].getTime() >= datelimit.getTime()) {
                        /* Don't advance beyond limits. */
                        return false;
                    }

                    // do advance
                    prevstate = state;
                    state = oh.getStatePair(prevstate[1]);
                    // console.log(state);
                } while (state[0] === prevstate[0] && state[2] === prevstate[2] && state[3] === prevstate[3]);
                return true;
            };
            /* }}} */
        }(this);
    };
    /* }}} */

    /* }}} */
}

/* vim: set ts=4 sw=4 tw=0 et foldmarker={{{,}}} foldlevel=0 foldmethod=marker : */

export { index as default };
//# sourceMappingURL=opening_hours.esm.mjs.map
